/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  AstroDecimal: { input: any; output: any; }
  AstroQueryBuilderQuery: { input: any; output: any; }
  /** The `BigInt` scalar type represents non-fractional signed whole numeric values. */
  BigInt: { input: any; output: any; }
  CaclDecimal: { input: any; output: any; }
  CaclQueryBuilderQuery: { input: any; output: any; }
  Coordinates: { input: any; output: any; }
  /** A date string, such as 2007-12-03, compliant with the `full-date` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Date: { input: any; output: any; }
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: { input: any; output: any; }
  /** Decimal (fixed-point) */
  Decimal: { input: any; output: any; }
  EdgeCursor: { input: any; output: any; }
  /** A field whose value conforms to the standard internet email address format as specified in HTML Spec: https://html.spec.whatwg.org/multipage/input.html#valid-e-mail-address. */
  EmailAddress: { input: any; output: any; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: Record<string, any>; output: Record<string, any>; }
  /** A field whose value is a valid decimal degrees latitude number (53.471): https://en.wikipedia.org/wiki/Latitude */
  Latitude: { input: any; output: any; }
  /** A field whose value is a valid decimal degrees longitude number (53.471): https://en.wikipedia.org/wiki/Longitude */
  Longitude: { input: any; output: any; }
  /** Integers that will have a value of 0 or more. */
  NonNegativeInt: { input: any; output: any; }
  ObjMap: { input: any; output: any; }
  SvbrgDecimal: { input: any; output: any; }
  SvbrgQueryBuilderQuery: { input: any; output: any; }
  Time: { input: any; output: any; }
  TlscpDecimal: { input: any; output: any; }
  TlscpQueryBuilderQuery: { input: any; output: any; }
  TsrctDecimal: { input: any; output: any; }
  TsrctQueryBuilderQuery: { input: any; output: any; }
  /** A field whose value conforms to the standard URL format as specified in RFC3986: https://www.ietf.org/rfc/rfc3986.txt. */
  URL: { input: any; output: any; }
  /** A field whose value is a generic Universally Unique Identifier: https://en.wikipedia.org/wiki/Universally_unique_identifier. */
  UUID: { input: any; output: any; }
  /** Represents NULL values */
  Void: { input: any; output: any; }
  jsonb: { input: any; output: any; }
  timestamp: { input: any; output: any; }
  timestamptz: { input: any; output: any; }
  uuid: { input: any; output: any; }
};

/** Access keys grouped by effective action. */
export type AccessKeysResponse = {
  __typename?: 'AccessKeysResponse';
  assign?: Maybe<Assign>;
  autocomplete?: Maybe<Autocomplete>;
  read?: Maybe<Read>;
  write?: Maybe<Write>;
};

export type Address = {
  __typename?: 'Address';
  city?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
};

export type Assign = {
  __typename?: 'Assign';
  String?: Maybe<Scalars['String']['output']>;
  Void?: Maybe<Scalars['Void']['output']>;
};

export type AstroAbsence = {
  __typename?: 'AstroAbsence';
  end: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  start: Scalars['Date']['output'];
};

export type AstroAbsenceDeleteInput = {
  id: Scalars['UUID']['input'];
};

export type AstroAbsenceInput = {
  end: Scalars['Date']['input'];
  id: Scalars['UUID']['input'];
  start: Scalars['Date']['input'];
};

export type AstroAbsenceListItem = {
  __typename?: 'AstroAbsenceListItem';
  end: Scalars['Date']['output'];
  id: Scalars['UUID']['output'];
  start: Scalars['Date']['output'];
};

export type AstroAbsenceListItemConnection = {
  __typename?: 'AstroAbsenceListItemConnection';
  nodes: Array<AstroAbsenceListItem>;
  totalCount: Scalars['Int']['output'];
};

export type AstroAbsenceListWhereInput = {
  from?: InputMaybe<Scalars['Date']['input']>;
};

export type AstroAbsenceMutations = {
  __typename?: 'AstroAbsenceMutations';
  delete?: Maybe<Scalars['Void']['output']>;
  upsert: AstroAbsence;
};


export type AstroAbsenceMutationsdeleteArgs = {
  data: AstroAbsenceDeleteInput;
};


export type AstroAbsenceMutationsupsertArgs = {
  data: AstroAbsenceInput;
};

export enum AstroAvailabilityStatus {
  HIGH = 'HIGH',
  LOW = 'LOW',
  MEDIUM = 'MEDIUM'
}

export type AstroDateRangeInput = {
  from: Scalars['Date']['input'];
  to: Scalars['Date']['input'];
};

export enum AstroLanguage {
  AA = 'AA',
  AB = 'AB',
  AE = 'AE',
  AF = 'AF',
  AK = 'AK',
  AM = 'AM',
  AN = 'AN',
  AR = 'AR',
  AS = 'AS',
  AV = 'AV',
  AY = 'AY',
  AZ = 'AZ',
  BA = 'BA',
  BE = 'BE',
  BG = 'BG',
  BI = 'BI',
  BM = 'BM',
  BN = 'BN',
  BO = 'BO',
  BR = 'BR',
  BS = 'BS',
  CA = 'CA',
  CE = 'CE',
  CH = 'CH',
  CO = 'CO',
  CR = 'CR',
  CS = 'CS',
  CU = 'CU',
  CV = 'CV',
  CY = 'CY',
  DA = 'DA',
  DE = 'DE',
  DV = 'DV',
  DZ = 'DZ',
  EE = 'EE',
  EL = 'EL',
  EN = 'EN',
  EO = 'EO',
  ES = 'ES',
  ET = 'ET',
  EU = 'EU',
  FA = 'FA',
  FF = 'FF',
  FI = 'FI',
  FJ = 'FJ',
  FO = 'FO',
  FR = 'FR',
  FY = 'FY',
  GA = 'GA',
  GD = 'GD',
  GL = 'GL',
  GN = 'GN',
  GU = 'GU',
  GV = 'GV',
  HA = 'HA',
  HE = 'HE',
  HI = 'HI',
  HO = 'HO',
  HR = 'HR',
  HT = 'HT',
  HU = 'HU',
  HY = 'HY',
  HZ = 'HZ',
  IA = 'IA',
  ID = 'ID',
  IE = 'IE',
  IG = 'IG',
  II = 'II',
  IK = 'IK',
  IO = 'IO',
  IS = 'IS',
  IT = 'IT',
  IU = 'IU',
  JA = 'JA',
  JV = 'JV',
  KA = 'KA',
  KG = 'KG',
  KI = 'KI',
  KJ = 'KJ',
  KK = 'KK',
  KL = 'KL',
  KM = 'KM',
  KN = 'KN',
  KO = 'KO',
  KR = 'KR',
  KS = 'KS',
  KU = 'KU',
  KV = 'KV',
  KW = 'KW',
  KY = 'KY',
  LA = 'LA',
  LB = 'LB',
  LG = 'LG',
  LI = 'LI',
  LN = 'LN',
  LO = 'LO',
  LT = 'LT',
  LU = 'LU',
  LV = 'LV',
  MG = 'MG',
  MH = 'MH',
  MI = 'MI',
  MK = 'MK',
  ML = 'ML',
  MN = 'MN',
  MR = 'MR',
  MS = 'MS',
  MT = 'MT',
  MY = 'MY',
  NA = 'NA',
  NB = 'NB',
  ND = 'ND',
  NE = 'NE',
  NG = 'NG',
  NL = 'NL',
  NN = 'NN',
  NO = 'NO',
  NR = 'NR',
  NV = 'NV',
  NY = 'NY',
  OC = 'OC',
  OJ = 'OJ',
  OM = 'OM',
  OR = 'OR',
  OS = 'OS',
  PA = 'PA',
  PI = 'PI',
  PL = 'PL',
  PS = 'PS',
  PT = 'PT',
  QU = 'QU',
  RM = 'RM',
  RN = 'RN',
  RO = 'RO',
  RU = 'RU',
  RW = 'RW',
  SA = 'SA',
  SC = 'SC',
  SD = 'SD',
  SE = 'SE',
  SG = 'SG',
  SH = 'SH',
  SI = 'SI',
  SK = 'SK',
  SL = 'SL',
  SM = 'SM',
  SN = 'SN',
  SO = 'SO',
  SQ = 'SQ',
  SR = 'SR',
  SS = 'SS',
  ST = 'ST',
  SU = 'SU',
  SV = 'SV',
  SW = 'SW',
  TA = 'TA',
  TE = 'TE',
  TG = 'TG',
  TH = 'TH',
  TI = 'TI',
  TK = 'TK',
  TL = 'TL',
  TN = 'TN',
  TO = 'TO',
  TR = 'TR',
  TS = 'TS',
  TT = 'TT',
  TW = 'TW',
  TY = 'TY',
  UG = 'UG',
  UK = 'UK',
  UR = 'UR',
  UZ = 'UZ',
  VE = 'VE',
  VI = 'VI',
  VO = 'VO',
  WA = 'WA',
  WO = 'WO',
  XH = 'XH',
  YI = 'YI',
  YO = 'YO',
  ZA = 'ZA',
  ZF = 'ZF',
  ZH = 'ZH'
}

export type AstroResponsibleUserItem = {
  __typename?: 'AstroResponsibleUserItem';
  availabilityStatus: AstroAvailabilityStatus;
  demandCount: Scalars['Int']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isRecommended: Scalars['Boolean']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  primarySourceReference: Scalars['ID']['output'];
  profilePicture?: Maybe<Scalars['String']['output']>;
};

export type AstroSmartLink = {
  __typename?: 'AstroSmartLink';
  description?: Maybe<Scalars['String']['output']>;
  domain: AstroSmartLinkDomain;
  external: Scalars['Boolean']['output'];
  hidden: Scalars['Boolean']['output'];
  id: Scalars['UUID']['output'];
  sequence: Scalars['Int']['output'];
  shared: Scalars['Boolean']['output'];
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  url: Scalars['String']['output'];
  variant: AstroSmartLinkVariant;
};

export enum AstroSmartLinkDomain {
  ANALYTICS = 'ANALYTICS',
  BASE = 'BASE',
  RISK = 'RISK',
  SETTINGS = 'SETTINGS',
  TOOLS_1 = 'TOOLS_1',
  TOOLS_2 = 'TOOLS_2',
  TOOLS_3 = 'TOOLS_3'
}

export type AstroSmartLinkInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  domain: AstroSmartLinkDomain;
  external?: InputMaybe<Scalars['Boolean']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['UUID']['input'];
  sequence: Scalars['Int']['input'];
  title: Scalars['String']['input'];
  url: Scalars['URL']['input'];
  variant: AstroSmartLinkVariant;
};

export type AstroSmartLinkMutations = {
  __typename?: 'AstroSmartLinkMutations';
  remove: AstroSmartLink;
  upsert: Array<AstroSmartLink>;
};


export type AstroSmartLinkMutationsremoveArgs = {
  id: Scalars['UUID']['input'];
};


export type AstroSmartLinkMutationsupsertArgs = {
  data: Array<AstroSmartLinkInput>;
};

export enum AstroSmartLinkVariant {
  OTHER = 'OTHER',
  POWER_BI = 'POWER_BI'
}

export enum AstroSortDirection {
  asc = 'asc',
  desc = 'desc'
}

export enum AstroUserAvailabilityFilterField {
  id = 'id',
  userPrimarySourceReference = 'userPrimarySourceReference'
}

export type AstroUserAvailabilityListColumn = {
  __typename?: 'AstroUserAvailabilityListColumn';
  weekEnd: Scalars['Date']['output'];
  weekStart: Scalars['Date']['output'];
};

export type AstroUserAvailabilityListItem = {
  __typename?: 'AstroUserAvailabilityListItem';
  availabilityPerWeek: Array<AstroUserAvailabilityPerWeek>;
  id: Scalars['UUID']['output'];
  user: AstroUserAvailabilityUser;
};

export type AstroUserAvailabilityListItemConnection = {
  __typename?: 'AstroUserAvailabilityListItemConnection';
  columns: Array<AstroUserAvailabilityListColumn>;
  nodes: Array<AstroUserAvailabilityListItem>;
  totalCount: Scalars['BigInt']['output'];
};

export type AstroUserAvailabilityOrder = {
  field: AstroUserAvailabilityOrderField;
  sort?: InputMaybe<AstroSortDirection>;
};

export enum AstroUserAvailabilityOrderField {
  id = 'id',
  userFirstName = 'userFirstName',
  userLastName = 'userLastName'
}

export type AstroUserAvailabilityPerWeek = {
  __typename?: 'AstroUserAvailabilityPerWeek';
  availability: Scalars['Float']['output'];
  weekStart: Scalars['Date']['output'];
};

export type AstroUserAvailabilityUser = {
  __typename?: 'AstroUserAvailabilityUser';
  email?: Maybe<Scalars['EmailAddress']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  pictureId?: Maybe<Scalars['UUID']['output']>;
  workingHours?: Maybe<Scalars['Int']['output']>;
};

export type AstroUserDetails = {
  __typename?: 'AstroUserDetails';
  absences: AstroAbsenceListItemConnection;
  id: Scalars['UUID']['output'];
  primarySourceReference: Scalars['UUID']['output'];
  profile: AstroUserProfile;
};


export type AstroUserDetailsabsencesArgs = {
  where?: InputMaybe<AstroAbsenceListWhereInput>;
};

export type AstroUserMutations = {
  __typename?: 'AstroUserMutations';
  absence: AstroAbsenceMutations;
  profile: AstroUserProfileMutations;
};

export type AstroUserProfile = {
  __typename?: 'AstroUserProfile';
  accountingAreaId?: Maybe<Scalars['UUID']['output']>;
  capabilityIds: Array<Scalars['UUID']['output']>;
  commodityGroupIds: Array<Scalars['UUID']['output']>;
  costCenterId?: Maybe<Scalars['UUID']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currency: Currency;
  deliveryLocationId?: Maybe<Scalars['UUID']['output']>;
  email?: Maybe<Scalars['EmailAddress']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  jobTitle?: Maybe<Scalars['String']['output']>;
  language?: Maybe<AstroLanguage>;
  lastName?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['UUID']['output']>;
  pictureId?: Maybe<Scalars['UUID']['output']>;
  primarySourceReference?: Maybe<Scalars['UUID']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  workingHours?: Maybe<Scalars['Float']['output']>;
};

export type AstroUserProfileInput = {
  accountingAreaId?: InputMaybe<Scalars['UUID']['input']>;
  capabilityIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  commodityGroupIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  costCenterId?: InputMaybe<Scalars['UUID']['input']>;
  currency?: InputMaybe<Currency>;
  deliveryLocationId?: InputMaybe<Scalars['UUID']['input']>;
  email?: InputMaybe<Scalars['EmailAddress']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<AstroLanguage>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['UUID']['input']>;
  pictureId?: InputMaybe<Scalars['UUID']['input']>;
  workingHours?: InputMaybe<Scalars['Float']['input']>;
};

export type AstroUserProfileMutations = {
  __typename?: 'AstroUserProfileMutations';
  update: AstroUserProfile;
};


export type AstroUserProfileMutationsupdateArgs = {
  data: AstroUserProfileInput;
};

export type Autocomplete = {
  __typename?: 'Autocomplete';
  String?: Maybe<Scalars['String']['output']>;
  Void?: Maybe<Scalars['Void']['output']>;
};

/** Generic autocomplete request payload. */
export type AutocompleteRequest_Input = {
  limit?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  offset?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};

/** Autocomplete response for scopes. */
export type AutocompleteResponse = {
  __typename?: 'AutocompleteResponse';
  nodes: Array<Maybe<TreeNode>>;
  totalCount: Scalars['Int']['output'];
};

export type BooleanFilterInput = {
  _eq?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type Boolean_comparison_exp = {
  _eq?: InputMaybe<Scalars['Boolean']['input']>;
  _gt?: InputMaybe<Scalars['Boolean']['input']>;
  _gte?: InputMaybe<Scalars['Boolean']['input']>;
  _in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Boolean']['input']>;
  _lte?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Scalars['Boolean']['input']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']['input']>>;
};

export type CaclCategoryScore = {
  __typename?: 'CaclCategoryScore';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  score: CaclRiskScore;
};

export type CaclCountry = {
  __typename?: 'CaclCountry';
  area: Scalars['JSON']['output'];
  id: CountryCode;
  riskScores: Scalars['JSON']['output'];
};

export type CaclCountryReport = {
  __typename?: 'CaclCountryReport';
  description?: Maybe<Scalars['String']['output']>;
  dimensions: Array<CaclCountryReportDimension>;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  values: Array<CaclCountryReportDimensionValue>;
};

export type CaclCountryReportDimension = {
  __typename?: 'CaclCountryReportDimension';
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
};

export type CaclCountryReportDimensionValue = {
  __typename?: 'CaclCountryReportDimensionValue';
  countryCode: CountryCode;
  dimensionId: Scalars['UUID']['output'];
  value: Scalars['CaclDecimal']['output'];
};

export type CaclCountryReportListItem = {
  __typename?: 'CaclCountryReportListItem';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum CaclLanguageCode {
  DE = 'DE',
  EN = 'EN',
  ES = 'ES',
  FR = 'FR',
  IT = 'IT'
}

export type CaclRisk = {
  __typename?: 'CaclRisk';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  suppliers?: Maybe<Array<CaclSupplierBase>>;
};

export type CaclRiskCategory = {
  __typename?: 'CaclRiskCategory';
  createdBy?: Maybe<Scalars['UUID']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  risks?: Maybe<Array<CaclRisk>>;
};

export type CaclRiskCategoryInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type CaclRiskInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  language: CaclLanguageCode;
  name: Scalars['String']['input'];
  riskCategoryId: Scalars['String']['input'];
};

export enum CaclRiskScore {
  HIGH = 'HIGH',
  LOW = 'LOW',
  MEDIUM = 'MEDIUM',
  UNKNOWN = 'UNKNOWN'
}

export type CaclSupplier = {
  __typename?: 'CaclSupplier';
  categories: Array<CaclCategoryScore>;
  id: Scalars['UUID']['output'];
  risks: Array<CaclSupplierRisk>;
  score: CaclRiskScore;
  status: Scalars['String']['output'];
};

export type CaclSupplierBase = {
  __typename?: 'CaclSupplierBase';
  id: Scalars['UUID']['output'];
  score: CaclRiskScore;
  status: Scalars['String']['output'];
};

export type CaclSupplierRisk = {
  __typename?: 'CaclSupplierRisk';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  riskCategoryId: Scalars['UUID']['output'];
  score: CaclRiskScore;
};

/** OpenFGA Check API response schema. */
export type CheckResponse = {
  __typename?: 'CheckResponse';
  allowed?: Maybe<Scalars['Boolean']['output']>;
  resolution?: Maybe<Resolution>;
};

/** Children response for one node. */
export type ChildrenResponse = {
  __typename?: 'ChildrenResponse';
  children: Array<Maybe<Scalars['String']['output']>>;
  /** The requested entity id */
  key: Scalars['String']['output'];
};

export type Commodity = Node & {
  __typename?: 'Commodity';
  commodityGroupCount: Scalars['Int']['output'];
  commodityGroupList: Array<CommodityGroupNode>;
  contractCount: Scalars['Int']['output'];
  contractList: Array<ContractNode>;
  correctOrderPercentage: Scalars['Float']['output'];
  deliveryOnTimePercentage: Scalars['Float']['output'];
  description?: Maybe<Scalars['String']['output']>;
  deviatingPricePercentage: Scalars['Float']['output'];
  deviatingPriceQuantityPercentage: Scalars['Float']['output'];
  deviatingQuantityPercentage: Scalars['Float']['output'];
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  leadTime: Scalars['Int']['output'];
  links: Array<ExternalLink>;
  name: Scalars['String']['output'];
  orderCount: Scalars['Int']['output'];
  orderCountYear: Scalars['Int']['output'];
  orderVolume: Scalars['Float']['output'];
  orderVolumeYear: Scalars['Float']['output'];
  primaryCommodityGroup?: Maybe<Scalars['String']['output']>;
  supplierCount: Scalars['Int']['output'];
  supplierList: Array<SupplierNode>;
};

export type CommodityConnection = {
  __typename?: 'CommodityConnection';
  nodes: Array<Commodity>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** FilterField */
export enum CommodityFilterField {
  commodityGroupCount = 'commodityGroupCount',
  commodityGroupId = 'commodityGroupId',
  contractCount = 'contractCount',
  contractId = 'contractId',
  correctOrderPercentage = 'correctOrderPercentage',
  deliveryOnTimePercentage = 'deliveryOnTimePercentage',
  description = 'description',
  deviatingPricePercentage = 'deviatingPricePercentage',
  deviatingPriceQuantityPercentage = 'deviatingPriceQuantityPercentage',
  deviatingQuantityPercentage = 'deviatingQuantityPercentage',
  externalId = 'externalId',
  id = 'id',
  leadTime = 'leadTime',
  name = 'name',
  orderCount = 'orderCount',
  orderCountYear = 'orderCountYear',
  orderVolume = 'orderVolume',
  orderVolumeYear = 'orderVolumeYear',
  primaryCommodityGroupId = 'primaryCommodityGroupId',
  sourceSystemId = 'sourceSystemId',
  supplierCount = 'supplierCount',
  supplierId = 'supplierId'
}

export type CommodityGroup = Node & {
  __typename?: 'CommodityGroup';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  orderCountCurrentYear: Scalars['Float']['output'];
  orderCountLast12Months: Scalars['Float']['output'];
  orderCountLastYear: Scalars['Float']['output'];
  orderVolumeCumulativeCurrentYear?: Maybe<Scalars['Float']['output']>;
  orderVolumeCumulativeLast12Months?: Maybe<Scalars['Float']['output']>;
  orderVolumeCumulativeLastYear?: Maybe<Scalars['Float']['output']>;
  orderVolumeCurrentYear: Scalars['Float']['output'];
  orderVolumeLast12Months: Scalars['Float']['output'];
  orderVolumeLastYear: Scalars['Float']['output'];
  orderVolumeShareCurrentYear?: Maybe<Scalars['Float']['output']>;
  orderVolumeShareLast12Months?: Maybe<Scalars['Float']['output']>;
  orderVolumeShareLastYear?: Maybe<Scalars['Float']['output']>;
};

export type CommodityGroupConnection = {
  __typename?: 'CommodityGroupConnection';
  nodes: Array<CommodityGroup>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export enum CommodityGroupFilterField {
  description = 'description',
  id = 'id',
  name = 'name',
  orderCountCurrentYear = 'orderCountCurrentYear',
  orderCountLast12Months = 'orderCountLast12Months',
  orderCountLastYear = 'orderCountLastYear',
  orderVolumeCumulativeCurrentYear = 'orderVolumeCumulativeCurrentYear',
  orderVolumeCumulativeLast12Months = 'orderVolumeCumulativeLast12Months',
  orderVolumeCumulativeLastYear = 'orderVolumeCumulativeLastYear',
  orderVolumeCurrentYear = 'orderVolumeCurrentYear',
  orderVolumeLast12Months = 'orderVolumeLast12Months',
  orderVolumeLastYear = 'orderVolumeLastYear',
  orderVolumeShareCurrentYear = 'orderVolumeShareCurrentYear',
  orderVolumeShareLast12Months = 'orderVolumeShareLast12Months',
  orderVolumeShareLastYear = 'orderVolumeShareLastYear',
  sourceSystemId = 'sourceSystemId'
}

export type CommodityGroupNode = {
  __typename?: 'CommodityGroupNode';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  pathLength: Scalars['Int']['output'];
};

/** Ways in which lists of commodity group can be ordered upon return. */
export type CommodityGroupOrder = {
  /** The direction in which to order packages by the specified field. */
  direction?: InputMaybe<OrderDirection>;
  /** The field in which to order packages by. */
  field?: InputMaybe<CommodityGroupOrderField>;
};

/** Properties by which commodity connections can be ordered. */
export enum CommodityGroupOrderField {
  description = 'description',
  name = 'name',
  orderCountCurrentYear = 'orderCountCurrentYear',
  orderCountLast12Months = 'orderCountLast12Months',
  orderCountLastYear = 'orderCountLastYear',
  orderVolumeCumulativeCurrentYear = 'orderVolumeCumulativeCurrentYear',
  orderVolumeCumulativeLast12Months = 'orderVolumeCumulativeLast12Months',
  orderVolumeCumulativeLastYear = 'orderVolumeCumulativeLastYear',
  orderVolumeCurrentYear = 'orderVolumeCurrentYear',
  orderVolumeLast12Months = 'orderVolumeLast12Months',
  orderVolumeLastYear = 'orderVolumeLastYear',
  orderVolumeShareCurrentYear = 'orderVolumeShareCurrentYear',
  orderVolumeShareLast12Months = 'orderVolumeShareLast12Months',
  orderVolumeShareLastYear = 'orderVolumeShareLastYear'
}

export type CommodityGroupSortOrder = {
  /** The field in which to order packages by. */
  field?: InputMaybe<CommodityGroupOrderField>;
  /** The sort direction in which to order packages by the specified field. */
  sort?: InputMaybe<SortDirection>;
};

export type CommodityNode = NamedNode & {
  __typename?: 'CommodityNode';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

/** Ways in which lists of commodities can be ordered upon return. */
export type CommodityOrder = {
  /** The direction in which to order packages by the specified field. */
  direction?: InputMaybe<OrderDirection>;
  /** The field in which to order packages by. */
  field?: InputMaybe<CommodityOrderField>;
};

/** Properties by which commodity connections can be ordered. */
export enum CommodityOrderField {
  commodityGroupCount = 'commodityGroupCount',
  contractCount = 'contractCount',
  correctOrderPercentage = 'correctOrderPercentage',
  deliveryOnTimePercentage = 'deliveryOnTimePercentage',
  description = 'description',
  deviatingPricePercentage = 'deviatingPricePercentage',
  deviatingPriceQuantityPercentage = 'deviatingPriceQuantityPercentage',
  deviatingQuantityPercentage = 'deviatingQuantityPercentage',
  externalId = 'externalId',
  leadTime = 'leadTime',
  name = 'name',
  orderCount = 'orderCount',
  orderCountYear = 'orderCountYear',
  orderVolume = 'orderVolume',
  orderVolumeYear = 'orderVolumeYear',
  supplierCount = 'supplierCount'
}

export type CommoditySortOrder = {
  /** The field in which to order packages by. */
  field?: InputMaybe<CommodityOrderField>;
  /** The sort direction in which to order packages by the specified field. */
  sort?: InputMaybe<SortDirection>;
};

export enum CommodityType {
  PRODUCT = 'PRODUCT',
  SERVICE = 'SERVICE'
}

export type CommodityUndercoverage = {
  __typename?: 'CommodityUndercoverage';
  commodityGroupId?: Maybe<Scalars['ID']['output']>;
  commodityId: Scalars['ID']['output'];
  currency: Currency;
  description?: Maybe<Scalars['String']['output']>;
  minimumOrderQuantity: Scalars['Decimal']['output'];
  organizationId: Scalars['ID']['output'];
  priceUnit: Scalars['Decimal']['output'];
  qualifiedSupplierIds: Array<Scalars['ID']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  undercoveredQuantity: Scalars['Decimal']['output'];
  unitId: Scalars['ID']['output'];
  validFrom: Scalars['DateTime']['output'];
  validTo: Scalars['DateTime']['output'];
};

export type CommodityUndercoverageConnection = {
  __typename?: 'CommodityUndercoverageConnection';
  id: Scalars['ID']['output'];
  pageSize?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
  undercoverages: Array<CommodityUndercoverage>;
};

export type Contact = {
  __typename?: 'Contact';
  email?: Maybe<Scalars['String']['output']>;
  fax?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

export type Contract = Node & {
  __typename?: 'Contract';
  commodityGroupCount: Scalars['Int']['output'];
  commodityGroupList: Array<CommodityGroupNode>;
  contractActive?: Maybe<Scalars['Boolean']['output']>;
  contractAverageValueContribution: Scalars['Float']['output'];
  contractCreationDate: Scalars['DateTime']['output'];
  contractProductCategoryCount: Scalars['Int']['output'];
  contractProductCategoryList: Array<ProductCategoryNode>;
  contractProductCount: Scalars['Int']['output'];
  contractProductList: Array<ProductNode>;
  contractReceivedProposalsCount?: Maybe<Scalars['Int']['output']>;
  contractServiceCount: Scalars['Int']['output'];
  contractServiceList: Array<ServiceNode>;
  contractValidFrom?: Maybe<Scalars['DateTime']['output']>;
  contractValidTo?: Maybe<Scalars['DateTime']['output']>;
  contractVolume?: Maybe<Scalars['Float']['output']>;
  externalId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  links: Array<ExternalLink>;
  name: Scalars['String']['output'];
  orderCount?: Maybe<Scalars['Int']['output']>;
  orderCountYear?: Maybe<Scalars['Int']['output']>;
  orderLastDate?: Maybe<Scalars['DateTime']['output']>;
  orderVolume?: Maybe<Scalars['Float']['output']>;
  orderVolumeYear?: Maybe<Scalars['Float']['output']>;
  primaryCommodityGroup?: Maybe<Scalars['String']['output']>;
  representativeCount: Scalars['Int']['output'];
  representativeList: Array<SupplierRepresentative>;
  supplierAddress: Address;
  supplierEmployeeCount: Scalars['Int']['output'];
  supplierExternalId: Scalars['String']['output'];
  supplierId: Scalars['String']['output'];
  supplierIndustry: SupplierIndustryNode;
  supplierLegalType: SupplierLegalTypeNode;
  supplierName: Scalars['String']['output'];
};

export type ContractConnection = {
  __typename?: 'ContractConnection';
  nodes: Array<Contract>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export enum ContractFilterField {
  commodityGroupCount = 'commodityGroupCount',
  commodityGroupId = 'commodityGroupId',
  contractActive = 'contractActive',
  contractAverageValueContribution = 'contractAverageValueContribution',
  contractCreationDate = 'contractCreationDate',
  contractProductCategoryCount = 'contractProductCategoryCount',
  contractProductCount = 'contractProductCount',
  contractProductId = 'contractProductId',
  contractReceivedProposalsCount = 'contractReceivedProposalsCount',
  contractServiceCount = 'contractServiceCount',
  contractServiceId = 'contractServiceId',
  contractValidFrom = 'contractValidFrom',
  contractValidTo = 'contractValidTo',
  contractVolume = 'contractVolume',
  externalId = 'externalId',
  id = 'id',
  name = 'name',
  orderCount = 'orderCount',
  orderCountYear = 'orderCountYear',
  orderLastDate = 'orderLastDate',
  orderVolume = 'orderVolume',
  orderVolumeYear = 'orderVolumeYear',
  primaryCommodityGroupId = 'primaryCommodityGroupId',
  representativeCount = 'representativeCount',
  sourceSystemId = 'sourceSystemId',
  supplierEmployeeCount = 'supplierEmployeeCount',
  supplierExternalId = 'supplierExternalId',
  supplierId = 'supplierId',
  supplierIndustryId = 'supplierIndustryId'
}

export type ContractNode = NamedNode & {
  __typename?: 'ContractNode';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

/** Ways in which lists of contracts can be ordered upon return. */
export type ContractOrder = {
  /** The direction in which to order packages by the specified field. */
  direction?: InputMaybe<OrderDirection>;
  /** The field in which to order packages by. */
  field?: InputMaybe<ContractOrderField>;
};

/** Properties by which contract connections can be ordered. */
export enum ContractOrderField {
  commodityGroupCount = 'commodityGroupCount',
  contractActive = 'contractActive',
  contractAverageValueContribution = 'contractAverageValueContribution',
  contractCreationDate = 'contractCreationDate',
  contractProductCategoryCount = 'contractProductCategoryCount',
  contractProductCount = 'contractProductCount',
  contractReceivedProposalsCount = 'contractReceivedProposalsCount',
  contractServiceCount = 'contractServiceCount',
  contractValidFrom = 'contractValidFrom',
  contractValidTo = 'contractValidTo',
  externalId = 'externalId',
  orderCountYear = 'orderCountYear',
  orderLastDate = 'orderLastDate',
  orderVolumeYear = 'orderVolumeYear',
  representativeCount = 'representativeCount',
  supplierEmployeeCount = 'supplierEmployeeCount',
  supplierExternalId = 'supplierExternalId',
  supplierIndustry = 'supplierIndustry',
  supplierLegalType = 'supplierLegalType',
  supplierName = 'supplierName'
}

export type ContractSortOrder = {
  /** The field in which to order packages by. */
  field?: InputMaybe<ContractOrderField>;
  /** The sort direction in which to order packages by the specified field. */
  sort?: InputMaybe<SortDirection>;
};

export enum CountryCode {
  AD = 'AD',
  AE = 'AE',
  AF = 'AF',
  AG = 'AG',
  AI = 'AI',
  AL = 'AL',
  AM = 'AM',
  AN = 'AN',
  AO = 'AO',
  AQ = 'AQ',
  AR = 'AR',
  AS = 'AS',
  AT = 'AT',
  AU = 'AU',
  AW = 'AW',
  AX = 'AX',
  AZ = 'AZ',
  BA = 'BA',
  BB = 'BB',
  BD = 'BD',
  BE = 'BE',
  BF = 'BF',
  BG = 'BG',
  BH = 'BH',
  BI = 'BI',
  BJ = 'BJ',
  BL = 'BL',
  BM = 'BM',
  BN = 'BN',
  BO = 'BO',
  BQ = 'BQ',
  BR = 'BR',
  BS = 'BS',
  BT = 'BT',
  BV = 'BV',
  BW = 'BW',
  BY = 'BY',
  BZ = 'BZ',
  CA = 'CA',
  CC = 'CC',
  CD = 'CD',
  CF = 'CF',
  CG = 'CG',
  CH = 'CH',
  CI = 'CI',
  CK = 'CK',
  CL = 'CL',
  CM = 'CM',
  CN = 'CN',
  CO = 'CO',
  CR = 'CR',
  CS = 'CS',
  CU = 'CU',
  CV = 'CV',
  CW = 'CW',
  CX = 'CX',
  CY = 'CY',
  CZ = 'CZ',
  DE = 'DE',
  DJ = 'DJ',
  DK = 'DK',
  DM = 'DM',
  DO = 'DO',
  DZ = 'DZ',
  EC = 'EC',
  EE = 'EE',
  EG = 'EG',
  EH = 'EH',
  ER = 'ER',
  ES = 'ES',
  ET = 'ET',
  FI = 'FI',
  FJ = 'FJ',
  FK = 'FK',
  FM = 'FM',
  FO = 'FO',
  FR = 'FR',
  GA = 'GA',
  GB = 'GB',
  GD = 'GD',
  GE = 'GE',
  GF = 'GF',
  GG = 'GG',
  GH = 'GH',
  GI = 'GI',
  GL = 'GL',
  GM = 'GM',
  GN = 'GN',
  GP = 'GP',
  GQ = 'GQ',
  GR = 'GR',
  GS = 'GS',
  GT = 'GT',
  GU = 'GU',
  GW = 'GW',
  GY = 'GY',
  HK = 'HK',
  HM = 'HM',
  HN = 'HN',
  HR = 'HR',
  HT = 'HT',
  HU = 'HU',
  ID = 'ID',
  IE = 'IE',
  IL = 'IL',
  IM = 'IM',
  IN = 'IN',
  IO = 'IO',
  IQ = 'IQ',
  IR = 'IR',
  IS = 'IS',
  IT = 'IT',
  JE = 'JE',
  JM = 'JM',
  JO = 'JO',
  JP = 'JP',
  KE = 'KE',
  KG = 'KG',
  KH = 'KH',
  KI = 'KI',
  KM = 'KM',
  KN = 'KN',
  KP = 'KP',
  KR = 'KR',
  KW = 'KW',
  KY = 'KY',
  KZ = 'KZ',
  LA = 'LA',
  LB = 'LB',
  LC = 'LC',
  LI = 'LI',
  LK = 'LK',
  LR = 'LR',
  LS = 'LS',
  LT = 'LT',
  LU = 'LU',
  LV = 'LV',
  LY = 'LY',
  MA = 'MA',
  MC = 'MC',
  MD = 'MD',
  ME = 'ME',
  MF = 'MF',
  MG = 'MG',
  MH = 'MH',
  MK = 'MK',
  ML = 'ML',
  MM = 'MM',
  MN = 'MN',
  MO = 'MO',
  MP = 'MP',
  MQ = 'MQ',
  MR = 'MR',
  MS = 'MS',
  MT = 'MT',
  MU = 'MU',
  MV = 'MV',
  MW = 'MW',
  MX = 'MX',
  MY = 'MY',
  MZ = 'MZ',
  NA = 'NA',
  NC = 'NC',
  NE = 'NE',
  NF = 'NF',
  NG = 'NG',
  NI = 'NI',
  NL = 'NL',
  NO = 'NO',
  NP = 'NP',
  NR = 'NR',
  NU = 'NU',
  NZ = 'NZ',
  OM = 'OM',
  PA = 'PA',
  PE = 'PE',
  PF = 'PF',
  PG = 'PG',
  PH = 'PH',
  PK = 'PK',
  PL = 'PL',
  PM = 'PM',
  PN = 'PN',
  PR = 'PR',
  PS = 'PS',
  PT = 'PT',
  PW = 'PW',
  PY = 'PY',
  QA = 'QA',
  RE = 'RE',
  RO = 'RO',
  RS = 'RS',
  RU = 'RU',
  RW = 'RW',
  SA = 'SA',
  SB = 'SB',
  SC = 'SC',
  SD = 'SD',
  SE = 'SE',
  SG = 'SG',
  SH = 'SH',
  SI = 'SI',
  SJ = 'SJ',
  SK = 'SK',
  SL = 'SL',
  SM = 'SM',
  SN = 'SN',
  SO = 'SO',
  SR = 'SR',
  SS = 'SS',
  ST = 'ST',
  SV = 'SV',
  SX = 'SX',
  SY = 'SY',
  SZ = 'SZ',
  TC = 'TC',
  TD = 'TD',
  TF = 'TF',
  TG = 'TG',
  TH = 'TH',
  TJ = 'TJ',
  TK = 'TK',
  TL = 'TL',
  TM = 'TM',
  TN = 'TN',
  TO = 'TO',
  TR = 'TR',
  TT = 'TT',
  TV = 'TV',
  TW = 'TW',
  TZ = 'TZ',
  UA = 'UA',
  UG = 'UG',
  UM = 'UM',
  US = 'US',
  UY = 'UY',
  UZ = 'UZ',
  VA = 'VA',
  VC = 'VC',
  VE = 'VE',
  VG = 'VG',
  VI = 'VI',
  VN = 'VN',
  VU = 'VU',
  WF = 'WF',
  WS = 'WS',
  XK = 'XK',
  YE = 'YE',
  YT = 'YT',
  YU = 'YU',
  ZA = 'ZA',
  ZF = 'ZF',
  ZM = 'ZM',
  ZW = 'ZW'
}

export enum Currency {
  ADP = 'ADP',
  AED = 'AED',
  AFA = 'AFA',
  AFN = 'AFN',
  ALK = 'ALK',
  ALL = 'ALL',
  AMD = 'AMD',
  ANG = 'ANG',
  AOA = 'AOA',
  AOK = 'AOK',
  AON = 'AON',
  AOR = 'AOR',
  ARA = 'ARA',
  ARP = 'ARP',
  ARS = 'ARS',
  ATS = 'ATS',
  AUD = 'AUD',
  AWG = 'AWG',
  AZM = 'AZM',
  AZN = 'AZN',
  BAD = 'BAD',
  BAM = 'BAM',
  BBD = 'BBD',
  BDT = 'BDT',
  BEF = 'BEF',
  BGF = 'BGF',
  BGJ = 'BGJ',
  BGK = 'BGK',
  BGL = 'BGL',
  BGN = 'BGN',
  BHD = 'BHD',
  BIF = 'BIF',
  BMD = 'BMD',
  BND = 'BND',
  BOB = 'BOB',
  BOP = 'BOP',
  BOV = 'BOV',
  BRB = 'BRB',
  BRC = 'BRC',
  BRE = 'BRE',
  BRL = 'BRL',
  BRN = 'BRN',
  BRR = 'BRR',
  BSD = 'BSD',
  BTC = 'BTC',
  BTN = 'BTN',
  BWP = 'BWP',
  BYB = 'BYB',
  BYN = 'BYN',
  BYR = 'BYR',
  BZD = 'BZD',
  CAD = 'CAD',
  CDF = 'CDF',
  CHE = 'CHE',
  CHF = 'CHF',
  CHW = 'CHW',
  CLF = 'CLF',
  CLP = 'CLP',
  CNH = 'CNH',
  CNX = 'CNX',
  CNY = 'CNY',
  COP = 'COP',
  COU = 'COU',
  CRC = 'CRC',
  CSD = 'CSD',
  CSJ = 'CSJ',
  CSK = 'CSK',
  CUC = 'CUC',
  CUP = 'CUP',
  CVE = 'CVE',
  CYP = 'CYP',
  CZK = 'CZK',
  DDM = 'DDM',
  DEM = 'DEM',
  DJF = 'DJF',
  DKK = 'DKK',
  DOP = 'DOP',
  DZD = 'DZD',
  ECS = 'ECS',
  ECV = 'ECV',
  EEK = 'EEK',
  EGP = 'EGP',
  ERN = 'ERN',
  ESA = 'ESA',
  ESB = 'ESB',
  ESP = 'ESP',
  ETB = 'ETB',
  EUR = 'EUR',
  FIM = 'FIM',
  FJD = 'FJD',
  FKP = 'FKP',
  FRF = 'FRF',
  GBP = 'GBP',
  GEL = 'GEL',
  GGP = 'GGP',
  GHC = 'GHC',
  GHP = 'GHP',
  GHS = 'GHS',
  GIP = 'GIP',
  GMD = 'GMD',
  GNF = 'GNF',
  GNS = 'GNS',
  GQE = 'GQE',
  GRD = 'GRD',
  GTQ = 'GTQ',
  GWP = 'GWP',
  GYD = 'GYD',
  HKD = 'HKD',
  HNL = 'HNL',
  HRD = 'HRD',
  HRK = 'HRK',
  HTG = 'HTG',
  HUF = 'HUF',
  IDR = 'IDR',
  IEP = 'IEP',
  ILP = 'ILP',
  ILR = 'ILR',
  ILS = 'ILS',
  IMP = 'IMP',
  INR = 'INR',
  IQD = 'IQD',
  IRR = 'IRR',
  ISJ = 'ISJ',
  ISK = 'ISK',
  ITL = 'ITL',
  JEP = 'JEP',
  JMD = 'JMD',
  JOD = 'JOD',
  JPY = 'JPY',
  KES = 'KES',
  KGS = 'KGS',
  KHR = 'KHR',
  KMF = 'KMF',
  KPW = 'KPW',
  KRW = 'KRW',
  KWD = 'KWD',
  KYD = 'KYD',
  KZT = 'KZT',
  LAJ = 'LAJ',
  LAK = 'LAK',
  LBP = 'LBP',
  LKR = 'LKR',
  LRD = 'LRD',
  LSL = 'LSL',
  LTL = 'LTL',
  LUF = 'LUF',
  LVL = 'LVL',
  LYD = 'LYD',
  MAD = 'MAD',
  MCF = 'MCF',
  MDL = 'MDL',
  MGA = 'MGA',
  MGF = 'MGF',
  MKD = 'MKD',
  MKN = 'MKN',
  MLF = 'MLF',
  MMK = 'MMK',
  MNT = 'MNT',
  MOP = 'MOP',
  MRO = 'MRO',
  MRU = 'MRU',
  MTL = 'MTL',
  MUR = 'MUR',
  MVQ = 'MVQ',
  MVR = 'MVR',
  MWK = 'MWK',
  MXN = 'MXN',
  MXP = 'MXP',
  MXV = 'MXV',
  MYR = 'MYR',
  MZM = 'MZM',
  MZN = 'MZN',
  NAD = 'NAD',
  NGN = 'NGN',
  NIC = 'NIC',
  NIO = 'NIO',
  NLG = 'NLG',
  NOK = 'NOK',
  NPR = 'NPR',
  NRP = 'NRP',
  NZD = 'NZD',
  OMR = 'OMR',
  PAB = 'PAB',
  PEH = 'PEH',
  PEI = 'PEI',
  PEN = 'PEN',
  PES = 'PES',
  PGK = 'PGK',
  PHP = 'PHP',
  PKR = 'PKR',
  PLN = 'PLN',
  PLZ = 'PLZ',
  PTE = 'PTE',
  PYG = 'PYG',
  QAR = 'QAR',
  ROL = 'ROL',
  RON = 'RON',
  RSD = 'RSD',
  RUB = 'RUB',
  RUR = 'RUR',
  RWF = 'RWF',
  SAR = 'SAR',
  SBD = 'SBD',
  SCR = 'SCR',
  SDD = 'SDD',
  SDG = 'SDG',
  SDP = 'SDP',
  SEK = 'SEK',
  SGD = 'SGD',
  SHP = 'SHP',
  SIT = 'SIT',
  SKK = 'SKK',
  SLE = 'SLE',
  SLL = 'SLL',
  SML = 'SML',
  SOS = 'SOS',
  SRD = 'SRD',
  SRG = 'SRG',
  SSP = 'SSP',
  STD = 'STD',
  STN = 'STN',
  SUR = 'SUR',
  SVC = 'SVC',
  SYP = 'SYP',
  SZL = 'SZL',
  THB = 'THB',
  TJS = 'TJS',
  TMM = 'TMM',
  TMT = 'TMT',
  TND = 'TND',
  TOP = 'TOP',
  TPE = 'TPE',
  TRL = 'TRL',
  TRY = 'TRY',
  TTD = 'TTD',
  TWD = 'TWD',
  TZS = 'TZS',
  UAH = 'UAH',
  UGS = 'UGS',
  UGW = 'UGW',
  UGX = 'UGX',
  USD = 'USD',
  UYI = 'UYI',
  UYN = 'UYN',
  UYP = 'UYP',
  UYU = 'UYU',
  UYW = 'UYW',
  UZS = 'UZS',
  VAL = 'VAL',
  VEB = 'VEB',
  VES = 'VES',
  VNC = 'VNC',
  VND = 'VND',
  VUV = 'VUV',
  WST = 'WST',
  XAF = 'XAF',
  XAG = 'XAG',
  XAU = 'XAU',
  XBA = 'XBA',
  XBB = 'XBB',
  XBC = 'XBC',
  XBD = 'XBD',
  XCD = 'XCD',
  XCG = 'XCG',
  XDR = 'XDR',
  XEU = 'XEU',
  XFO = 'XFO',
  XFU = 'XFU',
  XIR = 'XIR',
  XOF = 'XOF',
  XPD = 'XPD',
  XPF = 'XPF',
  XPT = 'XPT',
  XSU = 'XSU',
  XTS = 'XTS',
  XUA = 'XUA',
  XXX = 'XXX',
  YDD = 'YDD',
  YER = 'YER',
  YUD = 'YUD',
  YUF = 'YUF',
  YUG = 'YUG',
  YUM = 'YUM',
  YUN = 'YUN',
  YUO = 'YUO',
  YUR = 'YUR',
  ZAL = 'ZAL',
  ZAR = 'ZAR',
  ZMK = 'ZMK',
  ZMW = 'ZMW',
  ZRN = 'ZRN',
  ZRZ = 'ZRZ',
  ZWC = 'ZWC',
  ZWD = 'ZWD',
  ZWL = 'ZWL',
  ZWN = 'ZWN'
}

export type DateRangeFilterInput = {
  /** start of the date-range */
  from: Scalars['Date']['input'];
  /** end of the date-range */
  to: Scalars['Date']['input'];
};

export type DateTimeReferenceValue = {
  __typename?: 'DateTimeReferenceValue';
  changeRate: Scalars['Float']['output'];
  current: Scalars['DateTime']['output'];
  date?: Maybe<Scalars['DateTime']['output']>;
  reference: Scalars['DateTime']['output'];
  status?: Maybe<Status>;
};

/** Simple error payload for route-level authorization failures. */
export type ErrorDetailResponse = {
  __typename?: 'ErrorDetailResponse';
  detail: Scalars['String']['output'];
};

/** System event */
export type Event = Node & {
  __typename?: 'Event';
  /** date of the event */
  date: Scalars['DateTime']['output'];
  /** details about what happened */
  description: Scalars['String']['output'];
  /** ID of the object. */
  id: Scalars['ID']['output'];
  /** ID of the object */
  objectId: Scalars['String']['output'];
  /** status of the operation */
  status?: Maybe<Status>;
  /** description of the status */
  statusText?: Maybe<Scalars['String']['output']>;
  /** short title */
  title: Scalars['String']['output'];
  /** the type of the event */
  type: EventType;
};

export type EventAction = {
  __typename?: 'EventAction';
  url: Scalars['String']['output'];
};

export type EventConnection = {
  __typename?: 'EventConnection';
  nodes: Array<Event>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Ways in which to filter lists of events. */
export type EventFilterInput = {
  or?: InputMaybe<Array<EventFilterInput>>;
  type?: InputMaybe<EventTypeFilterInput>;
};

export enum EventType {
  CONTRACT_CREATED = 'CONTRACT_CREATED',
  GOODSRECEIPT_CREATED = 'GOODSRECEIPT_CREATED',
  INVOICE_CREATED = 'INVOICE_CREATED',
  ORDER_CREATED = 'ORDER_CREATED',
  PAYMENT_CREATED = 'PAYMENT_CREATED',
  SUPPLIER_CREATED = 'SUPPLIER_CREATED'
}

export type EventTypeFilterInput = {
  equals?: InputMaybe<EventType>;
  in?: InputMaybe<Array<EventType>>;
  not?: InputMaybe<EventType>;
  notIn?: InputMaybe<Array<EventType>>;
};

export type ExternalLink = {
  __typename?: 'ExternalLink';
  sourceSystemId: Scalars['String']['output'];
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type FeatureCollection = {
  __typename?: 'FeatureCollection';
  features?: Maybe<Array<Maybe<PointObject>>>;
  type: Scalars['String']['output'];
};

export type FloatFilterInput = {
  _eq?: InputMaybe<Scalars['Float']['input']>;
};

export type FloatReferenceValue = {
  __typename?: 'FloatReferenceValue';
  changeRate: Scalars['Float']['output'];
  current: Scalars['Float']['output'];
  date?: Maybe<Scalars['DateTime']['output']>;
  reference: Scalars['Float']['output'];
  status?: Maybe<Status>;
};

export type FloatTrendData = {
  __typename?: 'FloatTrendData';
  /** current vs. previous percentage */
  changeRate?: Maybe<Scalars['Float']['output']>;
  /** aggregated value for specified date-range */
  current: Scalars['Float']['output'];
  /** aggregated value for the preceding date-range */
  previous?: Maybe<Scalars['Float']['output']>;
  /** segments based on date-range */
  segments: Array<FloatTrendDataSegment>;
  /** status value */
  status?: Maybe<Status>;
};

export type FloatTrendDataSegment = {
  __typename?: 'FloatTrendDataSegment';
  /** name of the data point (e.g. month/quarter) */
  key?: Maybe<Scalars['String']['output']>;
  /** value of the data-point */
  value: Scalars['Float']['output'];
};

export enum HTTPMethod {
  CONNECT = 'CONNECT',
  DELETE = 'DELETE',
  GET = 'GET',
  HEAD = 'HEAD',
  OPTIONS = 'OPTIONS',
  PATCH = 'PATCH',
  POST = 'POST',
  PUT = 'PUT',
  TRACE = 'TRACE'
}

export type HTTPValidationError = {
  __typename?: 'HTTPValidationError';
  detail?: Maybe<Array<Maybe<ValidationError>>>;
};

export type IDFilterInput = {
  _eq?: InputMaybe<Scalars['ID']['input']>;
};

export type IntFilterInput = {
  _eq?: InputMaybe<Scalars['Int']['input']>;
};

export type IntReferenceValue = {
  __typename?: 'IntReferenceValue';
  changeRate: Scalars['Float']['output'];
  current: Scalars['Int']['output'];
  date?: Maybe<Scalars['DateTime']['output']>;
  reference: Scalars['Int']['output'];
  status?: Maybe<Status>;
};

export type IntTrendData = {
  __typename?: 'IntTrendData';
  /** current vs. previous percentage */
  changeRate?: Maybe<Scalars['Float']['output']>;
  /** aggregated value for specified date-range */
  current: Scalars['Int']['output'];
  /** aggregated value for the preceding date-range */
  previous?: Maybe<Scalars['Int']['output']>;
  /** segments based on date-range */
  segments: Array<IntTrendDataSegment>;
  /** status value */
  status?: Maybe<Status>;
};

export type IntTrendDataSegment = {
  __typename?: 'IntTrendDataSegment';
  /** name of the data point (e.g. month/quarter) */
  key?: Maybe<Scalars['String']['output']>;
  /** value of the data-point */
  value: Scalars['Int']['output'];
};

export enum Language {
  AA = 'AA',
  AB = 'AB',
  AE = 'AE',
  AF = 'AF',
  AK = 'AK',
  AM = 'AM',
  AN = 'AN',
  AR = 'AR',
  AS = 'AS',
  AV = 'AV',
  AY = 'AY',
  AZ = 'AZ',
  BA = 'BA',
  BE = 'BE',
  BG = 'BG',
  BI = 'BI',
  BM = 'BM',
  BN = 'BN',
  BO = 'BO',
  BR = 'BR',
  BS = 'BS',
  CA = 'CA',
  CE = 'CE',
  CH = 'CH',
  CO = 'CO',
  CR = 'CR',
  CS = 'CS',
  CU = 'CU',
  CV = 'CV',
  CY = 'CY',
  DA = 'DA',
  DE = 'DE',
  DV = 'DV',
  DZ = 'DZ',
  EE = 'EE',
  EL = 'EL',
  EN = 'EN',
  EO = 'EO',
  ES = 'ES',
  ET = 'ET',
  EU = 'EU',
  FA = 'FA',
  FF = 'FF',
  FI = 'FI',
  FJ = 'FJ',
  FO = 'FO',
  FR = 'FR',
  FY = 'FY',
  GA = 'GA',
  GD = 'GD',
  GL = 'GL',
  GN = 'GN',
  GU = 'GU',
  GV = 'GV',
  HA = 'HA',
  HE = 'HE',
  HI = 'HI',
  HO = 'HO',
  HR = 'HR',
  HT = 'HT',
  HU = 'HU',
  HY = 'HY',
  HZ = 'HZ',
  IA = 'IA',
  ID = 'ID',
  IE = 'IE',
  IG = 'IG',
  II = 'II',
  IK = 'IK',
  IO = 'IO',
  IS = 'IS',
  IT = 'IT',
  IU = 'IU',
  JA = 'JA',
  JV = 'JV',
  KA = 'KA',
  KG = 'KG',
  KI = 'KI',
  KJ = 'KJ',
  KK = 'KK',
  KL = 'KL',
  KM = 'KM',
  KN = 'KN',
  KO = 'KO',
  KR = 'KR',
  KS = 'KS',
  KU = 'KU',
  KV = 'KV',
  KW = 'KW',
  KY = 'KY',
  LA = 'LA',
  LB = 'LB',
  LG = 'LG',
  LI = 'LI',
  LN = 'LN',
  LO = 'LO',
  LT = 'LT',
  LU = 'LU',
  LV = 'LV',
  MG = 'MG',
  MH = 'MH',
  MI = 'MI',
  MK = 'MK',
  ML = 'ML',
  MN = 'MN',
  MR = 'MR',
  MS = 'MS',
  MT = 'MT',
  MY = 'MY',
  NA = 'NA',
  NB = 'NB',
  ND = 'ND',
  NE = 'NE',
  NG = 'NG',
  NL = 'NL',
  NN = 'NN',
  NO = 'NO',
  NR = 'NR',
  NV = 'NV',
  NY = 'NY',
  OC = 'OC',
  OJ = 'OJ',
  OM = 'OM',
  OR = 'OR',
  OS = 'OS',
  PA = 'PA',
  PI = 'PI',
  PL = 'PL',
  PS = 'PS',
  PT = 'PT',
  QU = 'QU',
  RM = 'RM',
  RN = 'RN',
  RO = 'RO',
  RU = 'RU',
  RW = 'RW',
  SA = 'SA',
  SC = 'SC',
  SD = 'SD',
  SE = 'SE',
  SG = 'SG',
  SH = 'SH',
  SI = 'SI',
  SK = 'SK',
  SL = 'SL',
  SM = 'SM',
  SN = 'SN',
  SO = 'SO',
  SQ = 'SQ',
  SR = 'SR',
  SS = 'SS',
  ST = 'ST',
  SU = 'SU',
  SV = 'SV',
  SW = 'SW',
  TA = 'TA',
  TE = 'TE',
  TG = 'TG',
  TH = 'TH',
  TI = 'TI',
  TK = 'TK',
  TL = 'TL',
  TN = 'TN',
  TO = 'TO',
  TR = 'TR',
  TS = 'TS',
  TT = 'TT',
  TW = 'TW',
  TY = 'TY',
  UG = 'UG',
  UK = 'UK',
  UR = 'UR',
  UZ = 'UZ',
  VE = 'VE',
  VI = 'VI',
  VO = 'VO',
  WA = 'WA',
  WO = 'WO',
  XH = 'XH',
  YI = 'YI',
  YO = 'YO',
  ZA = 'ZA',
  ZF = 'ZF',
  ZH = 'ZH'
}

export type LatLng = {
  __typename?: 'LatLng';
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

export type LocationGroupNode = NamedNode & {
  __typename?: 'LocationGroupNode';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type LocationGroupProps = {
  __typename?: 'LocationGroupProps';
  description?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type LocationGroupsFeatureCollection = {
  __typename?: 'LocationGroupsFeatureCollection';
  features?: Maybe<Array<Maybe<LocationGroupsFeatureObject>>>;
  type: Scalars['String']['output'];
};

export type LocationGroupsFeatureObject = {
  __typename?: 'LocationGroupsFeatureObject';
  geometry?: Maybe<PointGeometry>;
  properties?: Maybe<LocationGroupProps>;
  type: Scalars['String']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  astronaut: astronautMutation;
  cmdi: cmdiMutation;
  createSaving: Saving;
  /** Create a SCIM group resource. */
  create_group_scim_v2_Groups_post?: Maybe<Scalars['JSON']['output']>;
  /** Create a new SCIM user resource. */
  create_user_scim_v2_Users_post?: Maybe<Scalars['JSON']['output']>;
  deleteSaving: Scalars['Boolean']['output'];
  /** delete data from the table: "appConfig" */
  delete_appConfig?: Maybe<appConfig_mutation_response>;
  /** delete single row from the table: "appConfig" */
  delete_appConfig_by_pk?: Maybe<appConfig>;
  /** delete data from the table: "baseColumnConfig" */
  delete_baseColumnConfig?: Maybe<baseColumnConfig_mutation_response>;
  /** delete single row from the table: "baseColumnConfig" */
  delete_baseColumnConfig_by_pk?: Maybe<baseColumnConfig>;
  /** delete data from the table: "dashboardConfig" */
  delete_dashboardConfig?: Maybe<dashboardConfig_mutation_response>;
  /** delete single row from the table: "dashboardConfig" */
  delete_dashboardConfig_by_pk?: Maybe<dashboardConfig>;
  /** delete data from the table: "filters" */
  delete_filters?: Maybe<filters_mutation_response>;
  /** delete single row from the table: "filters" */
  delete_filters_by_pk?: Maybe<filters>;
  /** Delete a SCIM group resource. */
  delete_group_scim_v2_Groups__group_id__delete?: Maybe<HTTPValidationError>;
  /** delete data from the table: "queries" */
  delete_queries?: Maybe<queries_mutation_response>;
  /** delete single row from the table: "queries" */
  delete_queries_by_pk?: Maybe<queries>;
  /** Delete a SCIM user and remove group memberships. */
  delete_user_scim_v2_Users__user_id__delete?: Maybe<HTTPValidationError>;
  /** delete data from the table: "users" */
  delete_users?: Maybe<users_mutation_response>;
  /** delete single row from the table: "users" */
  delete_users_by_pk?: Maybe<users>;
  /** insert data into the table: "appConfig" */
  insert_appConfig?: Maybe<appConfig_mutation_response>;
  /** insert a single row into the table: "appConfig" */
  insert_appConfig_one?: Maybe<appConfig>;
  /** insert data into the table: "baseColumnConfig" */
  insert_baseColumnConfig?: Maybe<baseColumnConfig_mutation_response>;
  /** insert a single row into the table: "baseColumnConfig" */
  insert_baseColumnConfig_one?: Maybe<baseColumnConfig>;
  /** insert data into the table: "dashboardConfig" */
  insert_dashboardConfig?: Maybe<dashboardConfig_mutation_response>;
  /** insert a single row into the table: "dashboardConfig" */
  insert_dashboardConfig_one?: Maybe<dashboardConfig>;
  /** insert data into the table: "filters" */
  insert_filters?: Maybe<filters_mutation_response>;
  /** insert a single row into the table: "filters" */
  insert_filters_one?: Maybe<filters>;
  /** insert data into the table: "queries" */
  insert_queries?: Maybe<queries_mutation_response>;
  /** insert a single row into the table: "queries" */
  insert_queries_one?: Maybe<queries>;
  /** insert data into the table: "users" */
  insert_users?: Maybe<users_mutation_response>;
  /** insert a single row into the table: "users" */
  insert_users_one?: Maybe<users>;
  pasaGraphql: pasaGraphqlMutation;
  /** Patch an existing SCIM group resource. */
  patch_group_scim_v2_Groups__group_id__patch?: Maybe<HTTPValidationError>;
  /** Patch an existing SCIM user resource. */
  patch_user_scim_v2_Users__user_id__patch?: Maybe<HTTPValidationError>;
  /** Replace an existing SCIM group resource. */
  replace_group_scim_v2_Groups__group_id__put?: Maybe<HTTPValidationError>;
  /** Replace an existing SCIM user resource. */
  replace_user_scim_v2_Users__user_id__put?: Maybe<HTTPValidationError>;
  resolveTask?: Maybe<TaskItem>;
  /** Returns scope nodes visible to the authenticated user filtered by `query`, with pagination via `limit` and `offset`. For a specific authenticated user, only scopes that user can access are returned. Language is selected from `Accept-Language` and falls back to the configured default language. Send `Cache-Control: no-cache` to bypass endpoint caching. */
  scopeAutocomplete?: Maybe<scopeAutocomplete_response>;
  /** Returns translated metadata for requested scope `keys` that are visible to the authenticated user. For a specific authenticated user, keys the user cannot access are omitted from the response map. Language is selected from `Accept-Language` and falls back to the configured default language when a translation is unavailable. Send `Cache-Control: no-cache` to bypass endpoint caching. */
  scopeTranslation?: Maybe<scopeTranslation_response>;
  /** Search SCIM groups using SCIM SearchRequest payload. */
  search_groups_scim_v2_Groups__search_post?: Maybe<Scalars['JSON']['output']>;
  /** Search SCIM users using SCIM SearchRequest payload. */
  search_users_scim_v2_Users__search_post?: Maybe<Scalars['JSON']['output']>;
  sevenbridges: sevenbridgesMutation;
  /** Returns team nodes visible to the authenticated user filtered by `query`, with pagination via `limit` and `offset`. Language is selected from `Accept-Language`. Send `Cache-Control: no-cache` to bypass endpoint caching. */
  teamAutocomplete?: Maybe<teamAutocomplete_response>;
  /** Returns team metadata for requested team `keys` that exist. Teams are not localized, so the `name` value is returned for any requested language. Language is selected from `Accept-Language`. Send `Cache-Control: no-cache` to bypass endpoint caching. */
  teamTranslation?: Maybe<teamTranslation_response>;
  tesseract: tesseractMutation;
  updateSaving?: Maybe<Saving>;
  /** update data of the table: "appConfig" */
  update_appConfig?: Maybe<appConfig_mutation_response>;
  /** update single row of the table: "appConfig" */
  update_appConfig_by_pk?: Maybe<appConfig>;
  /** update multiples rows of table: "appConfig" */
  update_appConfig_many?: Maybe<Array<Maybe<appConfig_mutation_response>>>;
  /** update data of the table: "baseColumnConfig" */
  update_baseColumnConfig?: Maybe<baseColumnConfig_mutation_response>;
  /** update single row of the table: "baseColumnConfig" */
  update_baseColumnConfig_by_pk?: Maybe<baseColumnConfig>;
  /** update multiples rows of table: "baseColumnConfig" */
  update_baseColumnConfig_many?: Maybe<Array<Maybe<baseColumnConfig_mutation_response>>>;
  /** update data of the table: "dashboardConfig" */
  update_dashboardConfig?: Maybe<dashboardConfig_mutation_response>;
  /** update single row of the table: "dashboardConfig" */
  update_dashboardConfig_by_pk?: Maybe<dashboardConfig>;
  /** update multiples rows of table: "dashboardConfig" */
  update_dashboardConfig_many?: Maybe<Array<Maybe<dashboardConfig_mutation_response>>>;
  /** update data of the table: "filters" */
  update_filters?: Maybe<filters_mutation_response>;
  /** update single row of the table: "filters" */
  update_filters_by_pk?: Maybe<filters>;
  /** update multiples rows of table: "filters" */
  update_filters_many?: Maybe<Array<Maybe<filters_mutation_response>>>;
  /** update data of the table: "queries" */
  update_queries?: Maybe<queries_mutation_response>;
  /** update single row of the table: "queries" */
  update_queries_by_pk?: Maybe<queries>;
  /** update multiples rows of table: "queries" */
  update_queries_many?: Maybe<Array<Maybe<queries_mutation_response>>>;
  /** update data of the table: "users" */
  update_users?: Maybe<users_mutation_response>;
  /** update single row of the table: "users" */
  update_users_by_pk?: Maybe<users>;
  /** update multiples rows of table: "users" */
  update_users_many?: Maybe<Array<Maybe<users_mutation_response>>>;
};


export type MutationcreateSavingArgs = {
  input: SavingInput;
};


export type MutationdeleteSavingArgs = {
  id: Scalars['ID']['input'];
};


export type Mutationdelete_appConfigArgs = {
  where: appConfig_bool_exp;
};


export type Mutationdelete_appConfig_by_pkArgs = {
  id: Scalars['uuid']['input'];
};


export type Mutationdelete_baseColumnConfigArgs = {
  where: baseColumnConfig_bool_exp;
};


export type Mutationdelete_baseColumnConfig_by_pkArgs = {
  id: Scalars['uuid']['input'];
};


export type Mutationdelete_dashboardConfigArgs = {
  where: dashboardConfig_bool_exp;
};


export type Mutationdelete_dashboardConfig_by_pkArgs = {
  id: Scalars['uuid']['input'];
};


export type Mutationdelete_filtersArgs = {
  where: filters_bool_exp;
};


export type Mutationdelete_filters_by_pkArgs = {
  id: Scalars['uuid']['input'];
};


export type Mutationdelete_group_scim_v2_Groups__group_id__deleteArgs = {
  group_id: Scalars['UUID']['input'];
};


export type Mutationdelete_queriesArgs = {
  where: queries_bool_exp;
};


export type Mutationdelete_queries_by_pkArgs = {
  id: Scalars['uuid']['input'];
};


export type Mutationdelete_user_scim_v2_Users__user_id__deleteArgs = {
  user_id: Scalars['UUID']['input'];
};


export type Mutationdelete_usersArgs = {
  where: users_bool_exp;
};


export type Mutationdelete_users_by_pkArgs = {
  id: Scalars['uuid']['input'];
};


export type Mutationinsert_appConfigArgs = {
  objects: Array<appConfig_insert_input>;
  on_conflict?: InputMaybe<appConfig_on_conflict>;
};


export type Mutationinsert_appConfig_oneArgs = {
  object: appConfig_insert_input;
  on_conflict?: InputMaybe<appConfig_on_conflict>;
};


export type Mutationinsert_baseColumnConfigArgs = {
  objects: Array<baseColumnConfig_insert_input>;
  on_conflict?: InputMaybe<baseColumnConfig_on_conflict>;
};


export type Mutationinsert_baseColumnConfig_oneArgs = {
  object: baseColumnConfig_insert_input;
  on_conflict?: InputMaybe<baseColumnConfig_on_conflict>;
};


export type Mutationinsert_dashboardConfigArgs = {
  objects: Array<dashboardConfig_insert_input>;
  on_conflict?: InputMaybe<dashboardConfig_on_conflict>;
};


export type Mutationinsert_dashboardConfig_oneArgs = {
  object: dashboardConfig_insert_input;
  on_conflict?: InputMaybe<dashboardConfig_on_conflict>;
};


export type Mutationinsert_filtersArgs = {
  objects: Array<filters_insert_input>;
  on_conflict?: InputMaybe<filters_on_conflict>;
};


export type Mutationinsert_filters_oneArgs = {
  object: filters_insert_input;
  on_conflict?: InputMaybe<filters_on_conflict>;
};


export type Mutationinsert_queriesArgs = {
  objects: Array<queries_insert_input>;
  on_conflict?: InputMaybe<queries_on_conflict>;
};


export type Mutationinsert_queries_oneArgs = {
  object: queries_insert_input;
  on_conflict?: InputMaybe<queries_on_conflict>;
};


export type Mutationinsert_usersArgs = {
  objects: Array<users_insert_input>;
  on_conflict?: InputMaybe<users_on_conflict>;
};


export type Mutationinsert_users_oneArgs = {
  object: users_insert_input;
  on_conflict?: InputMaybe<users_on_conflict>;
};


export type Mutationpatch_group_scim_v2_Groups__group_id__patchArgs = {
  group_id: Scalars['UUID']['input'];
};


export type Mutationpatch_user_scim_v2_Users__user_id__patchArgs = {
  user_id: Scalars['UUID']['input'];
};


export type Mutationreplace_group_scim_v2_Groups__group_id__putArgs = {
  group_id: Scalars['UUID']['input'];
};


export type Mutationreplace_user_scim_v2_Users__user_id__putArgs = {
  user_id: Scalars['UUID']['input'];
};


export type MutationresolveTaskArgs = {
  id: Scalars['ID']['input'];
};


export type MutationscopeAutocompleteArgs = {
  Cache_control?: InputMaybe<Scalars['JSON']['input']>;
  accept_language?: InputMaybe<Scalars['JSON']['input']>;
  input?: InputMaybe<AutocompleteRequest_Input>;
};


export type MutationscopeTranslationArgs = {
  Cache_control?: InputMaybe<Scalars['JSON']['input']>;
  accept_language?: InputMaybe<Scalars['JSON']['input']>;
  input?: InputMaybe<TranslationRequest_Input>;
};


export type MutationteamAutocompleteArgs = {
  Cache_control?: InputMaybe<Scalars['JSON']['input']>;
  accept_language?: InputMaybe<Scalars['JSON']['input']>;
  input?: InputMaybe<AutocompleteRequest_Input>;
};


export type MutationteamTranslationArgs = {
  Cache_control?: InputMaybe<Scalars['JSON']['input']>;
  accept_language?: InputMaybe<Scalars['JSON']['input']>;
  input?: InputMaybe<TranslationRequest_Input>;
};


export type MutationupdateSavingArgs = {
  id: Scalars['ID']['input'];
  input: SavingInput;
};


export type Mutationupdate_appConfigArgs = {
  _set?: InputMaybe<appConfig_set_input>;
  where: appConfig_bool_exp;
};


export type Mutationupdate_appConfig_by_pkArgs = {
  _set?: InputMaybe<appConfig_set_input>;
  pk_columns: appConfig_pk_columns_input;
};


export type Mutationupdate_appConfig_manyArgs = {
  updates: Array<appConfig_updates>;
};


export type Mutationupdate_baseColumnConfigArgs = {
  _append?: InputMaybe<baseColumnConfig_append_input>;
  _delete_at_path?: InputMaybe<baseColumnConfig_delete_at_path_input>;
  _delete_elem?: InputMaybe<baseColumnConfig_delete_elem_input>;
  _delete_key?: InputMaybe<baseColumnConfig_delete_key_input>;
  _prepend?: InputMaybe<baseColumnConfig_prepend_input>;
  _set?: InputMaybe<baseColumnConfig_set_input>;
  where: baseColumnConfig_bool_exp;
};


export type Mutationupdate_baseColumnConfig_by_pkArgs = {
  _append?: InputMaybe<baseColumnConfig_append_input>;
  _delete_at_path?: InputMaybe<baseColumnConfig_delete_at_path_input>;
  _delete_elem?: InputMaybe<baseColumnConfig_delete_elem_input>;
  _delete_key?: InputMaybe<baseColumnConfig_delete_key_input>;
  _prepend?: InputMaybe<baseColumnConfig_prepend_input>;
  _set?: InputMaybe<baseColumnConfig_set_input>;
  pk_columns: baseColumnConfig_pk_columns_input;
};


export type Mutationupdate_baseColumnConfig_manyArgs = {
  updates: Array<baseColumnConfig_updates>;
};


export type Mutationupdate_dashboardConfigArgs = {
  _append?: InputMaybe<dashboardConfig_append_input>;
  _delete_at_path?: InputMaybe<dashboardConfig_delete_at_path_input>;
  _delete_elem?: InputMaybe<dashboardConfig_delete_elem_input>;
  _delete_key?: InputMaybe<dashboardConfig_delete_key_input>;
  _prepend?: InputMaybe<dashboardConfig_prepend_input>;
  _set?: InputMaybe<dashboardConfig_set_input>;
  where: dashboardConfig_bool_exp;
};


export type Mutationupdate_dashboardConfig_by_pkArgs = {
  _append?: InputMaybe<dashboardConfig_append_input>;
  _delete_at_path?: InputMaybe<dashboardConfig_delete_at_path_input>;
  _delete_elem?: InputMaybe<dashboardConfig_delete_elem_input>;
  _delete_key?: InputMaybe<dashboardConfig_delete_key_input>;
  _prepend?: InputMaybe<dashboardConfig_prepend_input>;
  _set?: InputMaybe<dashboardConfig_set_input>;
  pk_columns: dashboardConfig_pk_columns_input;
};


export type Mutationupdate_dashboardConfig_manyArgs = {
  updates: Array<dashboardConfig_updates>;
};


export type Mutationupdate_filtersArgs = {
  _set?: InputMaybe<filters_set_input>;
  where: filters_bool_exp;
};


export type Mutationupdate_filters_by_pkArgs = {
  _set?: InputMaybe<filters_set_input>;
  pk_columns: filters_pk_columns_input;
};


export type Mutationupdate_filters_manyArgs = {
  updates: Array<filters_updates>;
};


export type Mutationupdate_queriesArgs = {
  _append?: InputMaybe<queries_append_input>;
  _delete_at_path?: InputMaybe<queries_delete_at_path_input>;
  _delete_elem?: InputMaybe<queries_delete_elem_input>;
  _delete_key?: InputMaybe<queries_delete_key_input>;
  _prepend?: InputMaybe<queries_prepend_input>;
  _set?: InputMaybe<queries_set_input>;
  where: queries_bool_exp;
};


export type Mutationupdate_queries_by_pkArgs = {
  _append?: InputMaybe<queries_append_input>;
  _delete_at_path?: InputMaybe<queries_delete_at_path_input>;
  _delete_elem?: InputMaybe<queries_delete_elem_input>;
  _delete_key?: InputMaybe<queries_delete_key_input>;
  _prepend?: InputMaybe<queries_prepend_input>;
  _set?: InputMaybe<queries_set_input>;
  pk_columns: queries_pk_columns_input;
};


export type Mutationupdate_queries_manyArgs = {
  updates: Array<queries_updates>;
};


export type Mutationupdate_usersArgs = {
  _set?: InputMaybe<users_set_input>;
  where: users_bool_exp;
};


export type Mutationupdate_users_by_pkArgs = {
  _set?: InputMaybe<users_set_input>;
  pk_columns: users_pk_columns_input;
};


export type Mutationupdate_users_manyArgs = {
  updates: Array<users_updates>;
};

export type NamedNode = {
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type News = Node & {
  __typename?: 'News';
  /** date of the news item */
  date: Scalars['DateTime']['output'];
  /** ID of the object. */
  id: Scalars['ID']['output'];
  /** source */
  source: ExternalLink;
  /** details about what happened */
  title: Scalars['String']['output'];
  /** source url */
  url: Scalars['URL']['output'];
};

export type NewsConnection = {
  __typename?: 'NewsConnection';
  nodes: Array<News>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An object with an ID. */
export type Node = {
  /** ID of the object. */
  id: Scalars['ID']['output'];
};

export type Order = Node & {
  __typename?: 'Order';
  commodityGroupCount: Scalars['Int']['output'];
  commodityGroupList: Array<CommodityGroupNode>;
  contractAverageValueContribution?: Maybe<Scalars['Float']['output']>;
  contractCreationDate?: Maybe<Scalars['DateTime']['output']>;
  contractExternalId?: Maybe<Scalars['String']['output']>;
  contractReceivedProposalsCount?: Maybe<Scalars['Int']['output']>;
  contractValidFrom?: Maybe<Scalars['DateTime']['output']>;
  contractValidTo?: Maybe<Scalars['DateTime']['output']>;
  externalId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  links: Array<ExternalLink>;
  orderCreationDate: Scalars['DateTime']['output'];
  orderProductCategoryCount?: Maybe<Scalars['Int']['output']>;
  orderProductCategoryList: Array<ProductCategoryNode>;
  orderProductCount?: Maybe<Scalars['Int']['output']>;
  orderProductList: Array<ProductNode>;
  orderServiceCount?: Maybe<Scalars['Int']['output']>;
  orderServiceList: Array<ServiceNode>;
  orderVolume: Scalars['Float']['output'];
  primaryCommodityGroup?: Maybe<Scalars['String']['output']>;
  representativeCount?: Maybe<Scalars['Int']['output']>;
  representativeList?: Maybe<Array<SupplierRepresentative>>;
  supplierAddress?: Maybe<Address>;
  supplierEmployeeCount?: Maybe<Scalars['Int']['output']>;
  supplierExternalId?: Maybe<Scalars['String']['output']>;
  supplierId?: Maybe<Scalars['String']['output']>;
  supplierIndustry?: Maybe<SupplierIndustryNode>;
  supplierLegalType?: Maybe<SupplierLegalTypeNode>;
  supplierName?: Maybe<Scalars['String']['output']>;
};

export type OrderAggregate = OrderAggregateFields & {
  __typename?: 'OrderAggregate';
  name: Scalars['String']['output'];
  spend: Scalars['Float']['output'];
  supplierCount: Scalars['Int']['output'];
};

export type OrderAggregateByDate = OrderAggregateFields & {
  __typename?: 'OrderAggregateByDate';
  byCategory: Array<OrderAggregate>;
  byCommodity: Array<OrderAggregate>;
  name: Scalars['String']['output'];
  spend: Scalars['Float']['output'];
  supplierCount: Scalars['Int']['output'];
};

export type OrderAggregateFields = {
  name: Scalars['String']['output'];
  spend: Scalars['Float']['output'];
  supplierCount: Scalars['Int']['output'];
};

export type OrderAggregates = {
  __typename?: 'OrderAggregates';
  byCategory: Array<OrderAggregate>;
  byCommodity: Array<OrderAggregate>;
  byDate: Array<OrderAggregateByDate>;
};

export type OrderConnection = {
  __typename?: 'OrderConnection';
  nodes: Array<Order>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type OrderDetail = Node & {
  __typename?: 'OrderDetail';
  externalId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  links: Array<ExternalLink>;
};

/** Possible directions in which to order a list of items when provided an `orderBy` argument. */
export enum OrderDirection {
  /** Specifies an ascending order for a given `orderBy` argument. */
  ASC = 'ASC',
  /** Specifies a descending order for a given `orderBy` argument. */
  DESC = 'DESC'
}

export enum OrderFilterField {
  commodityGroupCount = 'commodityGroupCount',
  commodityGroupId = 'commodityGroupId',
  contractAverageValueContribution = 'contractAverageValueContribution',
  contractCreationDate = 'contractCreationDate',
  contractId = 'contractId',
  contractReceivedProposalsCount = 'contractReceivedProposalsCount',
  contractValidFrom = 'contractValidFrom',
  contractValidTo = 'contractValidTo',
  externalId = 'externalId',
  id = 'id',
  orderCreationDate = 'orderCreationDate',
  orderLineItemsCount = 'orderLineItemsCount',
  orderProductCategoryCount = 'orderProductCategoryCount',
  orderProductCategoryId = 'orderProductCategoryId',
  orderProductCount = 'orderProductCount',
  orderProductId = 'orderProductId',
  orderServiceCount = 'orderServiceCount',
  orderServiceId = 'orderServiceId',
  orderVolume = 'orderVolume',
  primaryCommodityGroupId = 'primaryCommodityGroupId',
  representativeCount = 'representativeCount',
  sourceSystemId = 'sourceSystemId',
  supplierEmployeeCount = 'supplierEmployeeCount',
  supplierExternalId = 'supplierExternalId',
  supplierId = 'supplierId',
  supplierIndustryId = 'supplierIndustryId'
}

/** Ways in which to filter lists of orders. */
export type OrderFilterInput = {
  id?: InputMaybe<IDFilterInput>;
  or?: InputMaybe<Array<OrderFilterInput>>;
};

export type OrderNode = NamedNode & {
  __typename?: 'OrderNode';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

/** Ways in which lists of orders can be ordered upon return. */
export type OrderOrder = {
  /** The direction in which to order packages by the specified field. */
  direction?: InputMaybe<OrderDirection>;
  /** The field in which to order packages by. */
  field?: InputMaybe<OrderOrderField>;
};

/** Properties by which order connections can be ordered. */
export enum OrderOrderField {
  commodityGroupCount = 'commodityGroupCount',
  contractAverageValueContribution = 'contractAverageValueContribution',
  contractCreationDate = 'contractCreationDate',
  contractExternalId = 'contractExternalId',
  contractReceivedProposalsCount = 'contractReceivedProposalsCount',
  contractValidFrom = 'contractValidFrom',
  contractValidTo = 'contractValidTo',
  externalId = 'externalId',
  id = 'id',
  orderCreationDate = 'orderCreationDate',
  orderLineItemsCount = 'orderLineItemsCount',
  orderProductCategoryCount = 'orderProductCategoryCount',
  orderProductCount = 'orderProductCount',
  orderServiceCount = 'orderServiceCount',
  orderVolume = 'orderVolume',
  representativeCount = 'representativeCount',
  supplierEmployeeCount = 'supplierEmployeeCount',
  supplierExternalId = 'supplierExternalId',
  supplierIndustry = 'supplierIndustry',
  supplierLegalType = 'supplierLegalType',
  supplierName = 'supplierName'
}

export type OrderSortOrder = {
  /** The field in which to order packages by. */
  field?: InputMaybe<OrderOrderField>;
  /** The sort direction in which to order packages by the specified field. */
  sort?: InputMaybe<SortDirection>;
};

/**
 *  A Connection (relay) used for cursor based navigation
 *
 * Information about pagination in a Connection
 *
 * Follows Relay Connection Specification
 * https://facebook.github.io/relay/graphql/connections.htm#sec-undefined.PageInfo
 */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['EdgeCursor']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['EdgeCursor']['output']>;
};

export type PasaDeleteTeamPayload = {
  __typename?: 'PasaDeleteTeamPayload';
  id: Scalars['ID']['output'];
};

export type PasaTeamChildAssignment = {
  __typename?: 'PasaTeamChildAssignment';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type PasaTeamMemberInput = {
  memberType: PasaTeamMemberType;
  teamId?: InputMaybe<Scalars['UUID']['input']>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

export enum PasaTeamMemberType {
  TEAM = 'TEAM',
  USER = 'USER'
}

export type PasaTeamPayload = {
  __typename?: 'PasaTeamPayload';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  scopeIds: Array<Scalars['String']['output']>;
  teamMemberIds: Array<Scalars['ID']['output']>;
  userMemberIds: Array<Scalars['ID']['output']>;
};

export type PasaTeamQueryResult = {
  __typename?: 'PasaTeamQueryResult';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  scopes: Array<PasaTeamScopeAssignment>;
  teams: Array<PasaTeamChildAssignment>;
  users: Array<PasaTeamUserAssignment>;
};

export type PasaTeamScopeAssignment = {
  __typename?: 'PasaTeamScopeAssignment';
  id: Scalars['ID']['output'];
};

export type PasaTeamUserAssignment = {
  __typename?: 'PasaTeamUserAssignment';
  displayName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  userName: Scalars['String']['output'];
};

export type PasaUpsertTeamInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  members?: Array<PasaTeamMemberInput>;
  name: Scalars['String']['input'];
  scopeIds?: Array<Scalars['String']['input']>;
};

/** Permissions response. */
export type Permissions = {
  __typename?: 'Permissions';
  permissions: Array<Maybe<Scalars['String']['output']>>;
};

export type PointGeometry = {
  __typename?: 'PointGeometry';
  coordinates: Scalars['Coordinates']['output'];
  type: Scalars['String']['output'];
};

export type PointObject = {
  __typename?: 'PointObject';
  geometry?: Maybe<PointGeometry>;
  properties?: Maybe<SupplierPointProps>;
  type: Scalars['String']['output'];
};

export type ProductCategoryNode = NamedNode & {
  __typename?: 'ProductCategoryNode';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type ProductNode = NamedNode & {
  __typename?: 'ProductNode';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type PurchaseRequisition = Node & {
  __typename?: 'PurchaseRequisition';
  commodityGroupCount: Scalars['Int']['output'];
  commodityGroupList: Array<CommodityGroupNode>;
  description?: Maybe<Scalars['String']['output']>;
  externalId: Scalars['String']['output'];
  fixedSuppliersCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  isBlocked: Scalars['Boolean']['output'];
  lineItemsCount: Scalars['Int']['output'];
  links: Array<ExternalLink>;
  preferredSuppliersCount: Scalars['Int']['output'];
  primaryCommodityGroup?: Maybe<Scalars['String']['output']>;
  totalValue: Scalars['Float']['output'];
  type: Scalars['String']['output'];
};

export type PurchaseRequisitionConnection = {
  __typename?: 'PurchaseRequisitionConnection';
  nodes: Array<PurchaseRequisition>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export enum PurchaseRequisitionFilterField {
  commodityGroupCount = 'commodityGroupCount',
  commodityGroupId = 'commodityGroupId',
  description = 'description',
  externalId = 'externalId',
  fixedSuppliersCount = 'fixedSuppliersCount',
  id = 'id',
  isBlocked = 'isBlocked',
  lineItemsCount = 'lineItemsCount',
  preferredSuppliersCount = 'preferredSuppliersCount',
  primaryCommodityGroupId = 'primaryCommodityGroupId',
  sourceSystemId = 'sourceSystemId',
  totalValue = 'totalValue'
}

/** Ways in which lists of purchase requisitions can be ordered upon return. */
export type PurchaseRequisitionOrder = {
  /** The direction in which to order packages by the specified field. */
  direction?: InputMaybe<OrderDirection>;
  /** The field in which to order packages by. */
  field?: InputMaybe<PurchaseRequisitionOrderField>;
};

/** Properties by which purchase requisition connections can be ordered. */
export enum PurchaseRequisitionOrderField {
  commodityGroupCount = 'commodityGroupCount',
  description = 'description',
  externalId = 'externalId',
  fixedSuppliersCount = 'fixedSuppliersCount',
  id = 'id',
  isBlocked = 'isBlocked',
  lineItemsCount = 'lineItemsCount',
  preferredSuppliersCount = 'preferredSuppliersCount',
  totalValue = 'totalValue',
  type = 'type'
}

export type PurchaseRequisitionSortOrder = {
  /** The field in which to order packages by. */
  field?: InputMaybe<PurchaseRequisitionOrderField>;
  /** The sort direction in which to order packages by the specified field. */
  sort?: InputMaybe<SortDirection>;
};

export type Query = {
  __typename?: 'Query';
  /** fetch data from the table: "appConfig" */
  appConfig: Array<appConfig>;
  /** fetch aggregated fields from the table: "appConfig" */
  appConfig_aggregate: appConfig_aggregate;
  /** fetch data from the table: "appConfig" using primary key columns */
  appConfig_by_pk?: Maybe<appConfig>;
  astronaut: astronautQuery;
  /** fetch data from the table: "baseColumnConfig" */
  baseColumnConfig: Array<baseColumnConfig>;
  /** fetch aggregated fields from the table: "baseColumnConfig" */
  baseColumnConfig_aggregate: baseColumnConfig_aggregate;
  /** fetch data from the table: "baseColumnConfig" using primary key columns */
  baseColumnConfig_by_pk?: Maybe<baseColumnConfig>;
  cataclysm: cataclysmQuery;
  /** Check if provided user is allowed to access provided object. */
  checkDataPermission?: Maybe<checkDataPermission_response>;
  /**
   * Check if a new data permission creation is finished already.
   *
   * This endpoint is intended to be used after a new resource creation event
   * was published to the message bus. Usually, after the creation of a new
   * resource (e.g. a new contract demand), the user gets redirected to the
   * detail page of the newly created resource. The detail page requires the
   * user to have the appropriate permissions to view/Modify the resource.
   * However, the permission creation IS eventually consistent and there
   * might be race conditions where the user gets redirected to the detail page
   * before the permission creation is finished.
   *
   * This endpoint allows to poll for the permission creation until it is
   * finished and only then redirect the user to the detail page.
   *
   * By using bypass_cache=True, we ensure that we always check the latest
   * state of the permission in OpenFGA. Without this parameter, the downstream
   * fetching function caches the first negative response for 300 seconds
   * (default setting), which would delay the permission availability check
   * for way too long.
   */
  checkDataPermissionCreated?: Maybe<checkDataPermissionCreated_response>;
  /** Check if provided user is allowed to access provided feature. */
  checkFeaturePermission?: Maybe<checkFeaturePermission_response>;
  cmdi: cmdiQuery;
  /** A list of commodities */
  commodities: CommodityConnection;
  commodity?: Maybe<Commodity>;
  /** Look up a single commodity group by its id */
  commodityGroup: CommodityGroup;
  /** A list of commodity groups */
  commodityGroups: CommodityGroupConnection;
  commodityUndercoverages: CommodityUndercoverageConnection;
  contract?: Maybe<Contract>;
  /** A list of contracts */
  contracts: ContractConnection;
  /** fetch data from the table: "dashboardConfig" */
  dashboardConfig: Array<dashboardConfig>;
  /** fetch aggregated fields from the table: "dashboardConfig" */
  dashboardConfig_aggregate: dashboardConfig_aggregate;
  /** fetch data from the table: "dashboardConfig" using primary key columns */
  dashboardConfig_by_pk?: Maybe<dashboardConfig>;
  /** fetch data from the table: "filters" */
  filters: Array<filters>;
  /** fetch aggregated fields from the table: "filters" */
  filters_aggregate: filters_aggregate;
  /** fetch data from the table: "filters" using primary key columns */
  filters_by_pk?: Maybe<filters>;
  /**
   * Return access keys for requested actions within an active scope.
   *
   * Active scope resolution order:
   * 1. ``active-scope`` query parameter
   * 2. ``x-scope-id`` request header
   * 3. ``pai-scope-root`` default
   *
   * Action semantics:
   * - read/assign/write are user-specific data-access actions based on the
   *   authenticated user's entitlements.
   * - These actions follow a hierarchy: WRITE > ASSIGN > READ.
   *   - read includes keys granted with READ, ASSIGN, or WRITE
   *   - assign includes keys granted with ASSIGN or WRITE
   *   - write includes keys granted with WRITE only
   * - All data-access action responses include the global access key.
   *
   * Autocomplete semantics:
   * - autocomplete requires the user to be entitled for the active scope itself.
   *   If not entitled, it returns the global access key only.
   * - When entitled, it returns:
   *   - user's read access keys for the active scope context
   *   - lineage keys from the active scope up to ``PAI_SCOPE_ROOT``
   *
   * Performance/caching:
   * - Data actions and autocomplete are resolved via separate TTL caches.
   * - Only the query paths needed for the requested actions are executed.
   * - Cache keys differ: data actions are cached by (user_id, active_scope),
   *   autocomplete by active_scope.
   */
  getAccessKeys?: Maybe<getAccessKeys_response>;
  /** Get a list of permitted features for provided user. */
  getPermissions?: Maybe<Permissions>;
  /** Return a SCIM group by ID. */
  get_group_scim_v2_Groups__group_id__get?: Maybe<HTTPValidationError>;
  /** Return a single SCIM resource type by name. */
  get_resource_type_scim_v2_ResourceTypes__name__get?: Maybe<HTTPValidationError>;
  /** Return a SCIM schema by ID. */
  get_schema_scim_v2_Schemas__schema_id__get?: Maybe<HTTPValidationError>;
  /** Return a SCIM user by ID. */
  get_user_scim_v2_Users__user_id__get?: Maybe<HTTPValidationError>;
  /** List SCIM groups with pagination and simple `eq` filtering. */
  list_groups_scim_v2_Groups_get?: Maybe<HTTPValidationError>;
  /** Return available SCIM resource types. */
  list_resource_types_scim_v2_ResourceTypes_get?: Maybe<Scalars['JSON']['output']>;
  /** Return SCIM schemas exposed by this service. */
  list_schemas_scim_v2_Schemas_get?: Maybe<Scalars['JSON']['output']>;
  /** List SCIM users with pagination and simple `eq` filtering. */
  list_users_scim_v2_Users_get?: Maybe<HTTPValidationError>;
  /** geo json resonse */
  locationGroups?: Maybe<LocationGroupsFeatureCollection>;
  order: Order;
  /** A list of orders */
  orders: OrderConnection;
  pasaGraphql: pasaGraphqlQuery;
  purchaseRequisition?: Maybe<PurchaseRequisition>;
  /** A list of purchase requisitions */
  purchaseRequisitions: PurchaseRequisitionConnection;
  /** fetch data from the table: "queries" */
  queries: Array<queries>;
  /** fetch aggregated fields from the table: "queries" */
  queries_aggregate: queries_aggregate;
  /** fetch data from the table: "queries" using primary key columns */
  queries_by_pk?: Maybe<queries>;
  saving?: Maybe<Saving>;
  savings: Array<Saving>;
  /** List direct child scope IDs for one visible scope. */
  scopeChildren?: Maybe<scopeChildren_response>;
  /** Return SCIM service provider capabilities. */
  service_provider_config_scim_v2_ServiceProviderConfig_get?: Maybe<Scalars['JSON']['output']>;
  sevenbridges: sevenbridgesQuery;
  /** Look up a single supplier by its id */
  supplier: SupplierDetail;
  /** A list of suppliers */
  suppliers: SupplierConnection;
  /** geo json resonse */
  suppliersGeo?: Maybe<FeatureCollection>;
  tasks: TaskItemConnection;
  /** List direct child team IDs. */
  teamChildren?: Maybe<teamChildren_response>;
  telescope: telescopeQuery;
  tesseract: tesseractQuery;
  /** fetch data from the table: "users" */
  users: Array<users>;
  /** fetch aggregated fields from the table: "users" */
  users_aggregate: users_aggregate;
  /** fetch data from the table: "users" using primary key columns */
  users_by_pk?: Maybe<users>;
};


export type QueryappConfigArgs = {
  distinct_on?: InputMaybe<Array<appConfig_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<appConfig_order_by>>;
  where?: InputMaybe<appConfig_bool_exp>;
};


export type QueryappConfig_aggregateArgs = {
  distinct_on?: InputMaybe<Array<appConfig_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<appConfig_order_by>>;
  where?: InputMaybe<appConfig_bool_exp>;
};


export type QueryappConfig_by_pkArgs = {
  id: Scalars['uuid']['input'];
};


export type QuerybaseColumnConfigArgs = {
  distinct_on?: InputMaybe<Array<baseColumnConfig_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<baseColumnConfig_order_by>>;
  where?: InputMaybe<baseColumnConfig_bool_exp>;
};


export type QuerybaseColumnConfig_aggregateArgs = {
  distinct_on?: InputMaybe<Array<baseColumnConfig_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<baseColumnConfig_order_by>>;
  where?: InputMaybe<baseColumnConfig_bool_exp>;
};


export type QuerybaseColumnConfig_by_pkArgs = {
  id: Scalars['uuid']['input'];
};


export type QuerycheckDataPermissionArgs = {
  objectId: Scalars['String']['input'];
  objectType: Scalars['String']['input'];
  relation: Scalars['String']['input'];
};


export type QuerycheckDataPermissionCreatedArgs = {
  objectId: Scalars['String']['input'];
  objectType: Scalars['String']['input'];
  relation: Scalars['String']['input'];
};


export type QuerycheckFeaturePermissionArgs = {
  feature: Scalars['String']['input'];
};


export type QuerycommoditiesArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  filterBy?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<CommoditySortOrder>>;
};


export type QuerycommodityArgs = {
  id: Scalars['ID']['input'];
};


export type QuerycommodityGroupArgs = {
  id: Scalars['ID']['input'];
};


export type QuerycommodityGroupsArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  filterBy?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<CommodityGroupSortOrder>>;
};


export type QuerycommodityUndercoveragesArgs = {
  commodityGroupIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  commodityIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  languageCode: Language;
  maxResults?: InputMaybe<Scalars['Int']['input']>;
  organizationIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  timeframeFrom: Scalars['DateTime']['input'];
  timeframeTo: Scalars['DateTime']['input'];
};


export type QuerycontractArgs = {
  id: Scalars['ID']['input'];
};


export type QuerycontractsArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  filterBy?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ContractSortOrder>>;
};


export type QuerydashboardConfigArgs = {
  distinct_on?: InputMaybe<Array<dashboardConfig_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<dashboardConfig_order_by>>;
  where?: InputMaybe<dashboardConfig_bool_exp>;
};


export type QuerydashboardConfig_aggregateArgs = {
  distinct_on?: InputMaybe<Array<dashboardConfig_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<dashboardConfig_order_by>>;
  where?: InputMaybe<dashboardConfig_bool_exp>;
};


export type QuerydashboardConfig_by_pkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryfiltersArgs = {
  distinct_on?: InputMaybe<Array<filters_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<filters_order_by>>;
  where?: InputMaybe<filters_bool_exp>;
};


export type Queryfilters_aggregateArgs = {
  distinct_on?: InputMaybe<Array<filters_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<filters_order_by>>;
  where?: InputMaybe<filters_bool_exp>;
};


export type Queryfilters_by_pkArgs = {
  id: Scalars['uuid']['input'];
};


export type QuerygetAccessKeysArgs = {
  actions?: InputMaybe<Scalars['JSON']['input']>;
  active_scope?: InputMaybe<Scalars['JSON']['input']>;
  x_scope_id?: InputMaybe<Scalars['JSON']['input']>;
};


export type Queryget_group_scim_v2_Groups__group_id__getArgs = {
  group_id: Scalars['UUID']['input'];
};


export type Queryget_resource_type_scim_v2_ResourceTypes__name__getArgs = {
  name: Scalars['String']['input'];
};


export type Queryget_schema_scim_v2_Schemas__schema_id__getArgs = {
  schema_id: Scalars['String']['input'];
};


export type Queryget_user_scim_v2_Users__user_id__getArgs = {
  user_id: Scalars['UUID']['input'];
};


export type Querylist_groups_scim_v2_Groups_getArgs = {
  count?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<Scalars['JSON']['input']>;
  startIndex?: InputMaybe<Scalars['Int']['input']>;
};


export type Querylist_users_scim_v2_Users_getArgs = {
  count?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<Scalars['JSON']['input']>;
  startIndex?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerylocationGroupsArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  filterBy?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryorderArgs = {
  id: Scalars['ID']['input'];
};


export type QueryordersArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  filterBy?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<OrderSortOrder>>;
};


export type QuerypurchaseRequisitionArgs = {
  id: Scalars['ID']['input'];
};


export type QuerypurchaseRequisitionsArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  filterBy?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<PurchaseRequisitionSortOrder>>;
};


export type QueryqueriesArgs = {
  distinct_on?: InputMaybe<Array<queries_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<queries_order_by>>;
  where?: InputMaybe<queries_bool_exp>;
};


export type Queryqueries_aggregateArgs = {
  distinct_on?: InputMaybe<Array<queries_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<queries_order_by>>;
  where?: InputMaybe<queries_bool_exp>;
};


export type Queryqueries_by_pkArgs = {
  id: Scalars['uuid']['input'];
};


export type QuerysavingArgs = {
  id: Scalars['ID']['input'];
};


export type QuerysavingsArgs = {
  query?: InputMaybe<SavingQueryInput>;
};


export type QueryscopeChildrenArgs = {
  Cache_control?: InputMaybe<Scalars['JSON']['input']>;
  scopeId: Scalars['String']['input'];
};


export type QuerysupplierArgs = {
  id: Scalars['ID']['input'];
};


export type QuerysuppliersArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  filterBy?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<SupplierSortOrder>>;
};


export type QuerysuppliersGeoArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  filterBy?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerytasksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TasksFilterInput>;
};


export type QueryteamChildrenArgs = {
  Cache_control?: InputMaybe<Scalars['JSON']['input']>;
  teamId: Scalars['String']['input'];
};


export type QueryusersArgs = {
  distinct_on?: InputMaybe<Array<users_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<users_order_by>>;
  where?: InputMaybe<users_bool_exp>;
};


export type Queryusers_aggregateArgs = {
  distinct_on?: InputMaybe<Array<users_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<users_order_by>>;
  where?: InputMaybe<users_bool_exp>;
};


export type Queryusers_by_pkArgs = {
  id: Scalars['uuid']['input'];
};

export enum QueryCombinator {
  AND = 'AND',
  OR = 'OR'
}

export enum QueryOperator {
  BETWEEN = 'BETWEEN',
  EQUALS = 'EQUALS',
  GREATER_THAN = 'GREATER_THAN',
  GREATER_THAN_OR_EQUAL = 'GREATER_THAN_OR_EQUAL',
  IN = 'IN',
  IN_EQUALS = 'IN_EQUALS',
  IS_EMPTY = 'IS_EMPTY',
  IS_NOT_EMPTY = 'IS_NOT_EMPTY',
  LESS_THAN = 'LESS_THAN',
  LESS_THAN_OR_EQUAL = 'LESS_THAN_OR_EQUAL',
  NOT_BETWEEN = 'NOT_BETWEEN',
  NOT_EQUALS = 'NOT_EQUALS',
  NOT_IN = 'NOT_IN',
  NOT_IN_EQUALS = 'NOT_IN_EQUALS'
}

export enum QueryOrder {
  ASC = 'ASC',
  DESC = 'DESC'
}

export type Read = {
  __typename?: 'Read';
  String?: Maybe<Scalars['String']['output']>;
  Void?: Maybe<Scalars['Void']['output']>;
};

export type Resolution = {
  __typename?: 'Resolution';
  String?: Maybe<Scalars['String']['output']>;
  Void?: Maybe<Scalars['Void']['output']>;
};

export type Saving = {
  __typename?: 'Saving';
  baselinePrice?: Maybe<Scalars['Decimal']['output']>;
  baselineQuantity?: Maybe<Scalars['Decimal']['output']>;
  costAllocation: Array<SavingCostAllocation>;
  createdAt: Scalars['DateTime']['output'];
  currency?: Maybe<Currency>;
  description?: Maybe<Scalars['String']['output']>;
  fkAccountingArea?: Maybe<Scalars['ID']['output']>;
  fkBuyer?: Maybe<Scalars['ID']['output']>;
  fkCommodityGroup?: Maybe<Scalars['ID']['output']>;
  fkCreatedBy?: Maybe<Scalars['ID']['output']>;
  fkOrganization?: Maybe<Scalars['ID']['output']>;
  fkProcurementOrganization?: Maybe<Scalars['ID']['output']>;
  fkPurchasingGroup?: Maybe<Scalars['ID']['output']>;
  fkSupplier?: Maybe<Scalars['ID']['output']>;
  fkUnit?: Maybe<Scalars['ID']['output']>;
  fkUpdatedBy?: Maybe<Scalars['ID']['output']>;
  freeTextCommodity?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  multiYearSaving: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  newPrice?: Maybe<Scalars['Decimal']['output']>;
  newPriceQuantity?: Maybe<Scalars['Decimal']['output']>;
  newQuantity?: Maybe<Scalars['Decimal']['output']>;
  originalPriceQuantity?: Maybe<Scalars['Decimal']['output']>;
  reductionType?: Maybe<SavingReductionType>;
  savingType: SavingType;
  sourceReferences: Array<SourceReference>;
  status: SavingStatus;
  updatedAt: Scalars['DateTime']['output'];
  validFrom?: Maybe<Scalars['DateTime']['output']>;
  validTo?: Maybe<Scalars['DateTime']['output']>;
};

export type SavingCostAllocation = {
  __typename?: 'SavingCostAllocation';
  allocationValue?: Maybe<Scalars['String']['output']>;
  distributionType: SavingCostAllocationDistributionType;
  fkAccountAssignment?: Maybe<Scalars['ID']['output']>;
  fkAccountAssignmentCategory?: Maybe<Scalars['ID']['output']>;
  fkGeneralLedgerAccount?: Maybe<Scalars['ID']['output']>;
};

export enum SavingCostAllocationDistributionType {
  PERCENTAGE = 'PERCENTAGE',
  QUANTITY = 'QUANTITY'
}

export type SavingCostAllocationInput = {
  allocationValue?: InputMaybe<Scalars['String']['input']>;
  distributionType: SavingCostAllocationDistributionType;
  fkAccountAssignment?: InputMaybe<Scalars['ID']['input']>;
  fkAccountAssignmentCategory?: InputMaybe<Scalars['ID']['input']>;
  fkGeneralLedgerAccount?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type SavingInput = {
  baselinePrice?: InputMaybe<Scalars['Decimal']['input']>;
  baselineQuantity?: InputMaybe<Scalars['Decimal']['input']>;
  costAllocation?: InputMaybe<Array<SavingCostAllocationInput>>;
  currency?: InputMaybe<Currency>;
  description?: InputMaybe<Scalars['String']['input']>;
  fkAccountingArea?: InputMaybe<Scalars['ID']['input']>;
  fkBuyer?: InputMaybe<Scalars['ID']['input']>;
  fkCommodityGroup?: InputMaybe<Scalars['ID']['input']>;
  fkCreatedBy?: InputMaybe<Scalars['ID']['input']>;
  fkOrganization?: InputMaybe<Scalars['ID']['input']>;
  fkProcurementOrganization?: InputMaybe<Scalars['ID']['input']>;
  fkPurchasingGroup?: InputMaybe<Scalars['ID']['input']>;
  fkSupplier?: InputMaybe<Scalars['ID']['input']>;
  fkUnit?: InputMaybe<Scalars['ID']['input']>;
  fkUpdatedBy?: InputMaybe<Scalars['ID']['input']>;
  freeTextCommodity?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  newPrice?: InputMaybe<Scalars['Decimal']['input']>;
  newPriceQuantity?: InputMaybe<Scalars['Decimal']['input']>;
  newQuantity?: InputMaybe<Scalars['Decimal']['input']>;
  originalPriceQuantity?: InputMaybe<Scalars['Decimal']['input']>;
  reductionType?: InputMaybe<SavingReductionType>;
  savingType: SavingType;
  sourceReferences?: InputMaybe<Array<SourceReferenceInput>>;
  status: SavingStatus;
  validFrom?: InputMaybe<Scalars['DateTime']['input']>;
  validTo?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SavingQueryFilterInput = {
  combinator?: QueryCombinator;
  not?: Scalars['Boolean']['input'];
  rules: Array<SavingQueryRuleInput>;
};

export type SavingQueryInput = {
  filter?: InputMaybe<SavingQueryFilterInput>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  order?: QueryOrder;
  orderBy?: Array<SavingSortByInput>;
};

export type SavingQueryRuleInput = {
  field: Scalars['String']['input'];
  operator: QueryOperator;
  value?: InputMaybe<Scalars['JSON']['input']>;
};

export enum SavingReductionType {
  AUTOMATED_NEGOTIATION = 'AUTOMATED_NEGOTIATION',
  CATALOG = 'CATALOG',
  NEGOTIATION = 'NEGOTIATION'
}

export type SavingSortByInput = {
  field: Scalars['String']['input'];
  sort?: QueryOrder;
};

export enum SavingStatus {
  COMPLETED = 'COMPLETED',
  DRAFT = 'DRAFT'
}

export enum SavingType {
  AUTO = 'AUTO',
  MANUAL = 'MANUAL'
}

export type ServiceCategoryNode = NamedNode & {
  __typename?: 'ServiceCategoryNode';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type ServiceNode = NamedNode & {
  __typename?: 'ServiceNode';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

/** Possible directions in which to order a list of items when provided an `order` argument. */
export enum SortDirection {
  /** Specifies an ascending order for a given `order` argument. */
  asc = 'asc',
  /** Specifies a descending order for a given `order` argument. */
  desc = 'desc'
}

export type SourceReference = {
  __typename?: 'SourceReference';
  fkSourceSystem: Scalars['String']['output'];
  isPrimary: Scalars['Boolean']['output'];
  sourceContext?: Maybe<Scalars['String']['output']>;
  sourceReference: Scalars['String']['output'];
  sourceReferenceItem?: Maybe<Scalars['String']['output']>;
  synchronizedAt: Scalars['DateTime']['output'];
};

export type SourceReferenceInput = {
  fkSourceSystem: Scalars['String']['input'];
  isPrimary?: Scalars['Boolean']['input'];
  sourceContext?: InputMaybe<Scalars['String']['input']>;
  sourceReference: Scalars['String']['input'];
  sourceReferenceItem?: InputMaybe<Scalars['String']['input']>;
  synchronizedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Status for values (will be colorized accodingly in the UI) */
export enum Status {
  ERROR = 'ERROR',
  NEUTRAL = 'NEUTRAL',
  SUCCESS = 'SUCCESS',
  WARNING = 'WARNING'
}

export type StringFilterInput = {
  _eq?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_comparison_exp = {
  _eq?: InputMaybe<Scalars['String']['input']>;
  _gt?: InputMaybe<Scalars['String']['input']>;
  _gte?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']['input']>;
  _in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']['input']>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']['input']>;
  _lt?: InputMaybe<Scalars['String']['input']>;
  _lte?: InputMaybe<Scalars['String']['input']>;
  _neq?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']['input']>;
  _nin?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']['input']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  /** fetch data from the table: "appConfig" */
  appConfig: Array<appConfig>;
  /** fetch aggregated fields from the table: "appConfig" */
  appConfig_aggregate: appConfig_aggregate;
  /** fetch data from the table: "appConfig" using primary key columns */
  appConfig_by_pk?: Maybe<appConfig>;
  /** fetch data from the table in a streaming manner: "appConfig" */
  appConfig_stream: Array<appConfig>;
  /** fetch data from the table: "baseColumnConfig" */
  baseColumnConfig: Array<baseColumnConfig>;
  /** fetch aggregated fields from the table: "baseColumnConfig" */
  baseColumnConfig_aggregate: baseColumnConfig_aggregate;
  /** fetch data from the table: "baseColumnConfig" using primary key columns */
  baseColumnConfig_by_pk?: Maybe<baseColumnConfig>;
  /** fetch data from the table in a streaming manner: "baseColumnConfig" */
  baseColumnConfig_stream: Array<baseColumnConfig>;
  cmdi: cmdiSubscription;
  /** fetch data from the table: "dashboardConfig" */
  dashboardConfig: Array<dashboardConfig>;
  /** fetch aggregated fields from the table: "dashboardConfig" */
  dashboardConfig_aggregate: dashboardConfig_aggregate;
  /** fetch data from the table: "dashboardConfig" using primary key columns */
  dashboardConfig_by_pk?: Maybe<dashboardConfig>;
  /** fetch data from the table in a streaming manner: "dashboardConfig" */
  dashboardConfig_stream: Array<dashboardConfig>;
  /** fetch data from the table: "filters" */
  filters: Array<filters>;
  /** fetch aggregated fields from the table: "filters" */
  filters_aggregate: filters_aggregate;
  /** fetch data from the table: "filters" using primary key columns */
  filters_by_pk?: Maybe<filters>;
  /** fetch data from the table in a streaming manner: "filters" */
  filters_stream: Array<filters>;
  /** fetch data from the table: "queries" */
  queries: Array<queries>;
  /** fetch aggregated fields from the table: "queries" */
  queries_aggregate: queries_aggregate;
  /** fetch data from the table: "queries" using primary key columns */
  queries_by_pk?: Maybe<queries>;
  /** fetch data from the table in a streaming manner: "queries" */
  queries_stream: Array<queries>;
  sevenbridges: sevenbridgesSubscription;
  tesseract: tesseractSubscription;
  /** fetch data from the table: "users" */
  users: Array<users>;
  /** fetch aggregated fields from the table: "users" */
  users_aggregate: users_aggregate;
  /** fetch data from the table: "users" using primary key columns */
  users_by_pk?: Maybe<users>;
  /** fetch data from the table in a streaming manner: "users" */
  users_stream: Array<users>;
};


export type SubscriptionappConfigArgs = {
  distinct_on?: InputMaybe<Array<appConfig_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<appConfig_order_by>>;
  where?: InputMaybe<appConfig_bool_exp>;
};


export type SubscriptionappConfig_aggregateArgs = {
  distinct_on?: InputMaybe<Array<appConfig_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<appConfig_order_by>>;
  where?: InputMaybe<appConfig_bool_exp>;
};


export type SubscriptionappConfig_by_pkArgs = {
  id: Scalars['uuid']['input'];
};


export type SubscriptionappConfig_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<appConfig_stream_cursor_input>>;
  where?: InputMaybe<appConfig_bool_exp>;
};


export type SubscriptionbaseColumnConfigArgs = {
  distinct_on?: InputMaybe<Array<baseColumnConfig_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<baseColumnConfig_order_by>>;
  where?: InputMaybe<baseColumnConfig_bool_exp>;
};


export type SubscriptionbaseColumnConfig_aggregateArgs = {
  distinct_on?: InputMaybe<Array<baseColumnConfig_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<baseColumnConfig_order_by>>;
  where?: InputMaybe<baseColumnConfig_bool_exp>;
};


export type SubscriptionbaseColumnConfig_by_pkArgs = {
  id: Scalars['uuid']['input'];
};


export type SubscriptionbaseColumnConfig_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<baseColumnConfig_stream_cursor_input>>;
  where?: InputMaybe<baseColumnConfig_bool_exp>;
};


export type SubscriptiondashboardConfigArgs = {
  distinct_on?: InputMaybe<Array<dashboardConfig_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<dashboardConfig_order_by>>;
  where?: InputMaybe<dashboardConfig_bool_exp>;
};


export type SubscriptiondashboardConfig_aggregateArgs = {
  distinct_on?: InputMaybe<Array<dashboardConfig_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<dashboardConfig_order_by>>;
  where?: InputMaybe<dashboardConfig_bool_exp>;
};


export type SubscriptiondashboardConfig_by_pkArgs = {
  id: Scalars['uuid']['input'];
};


export type SubscriptiondashboardConfig_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<dashboardConfig_stream_cursor_input>>;
  where?: InputMaybe<dashboardConfig_bool_exp>;
};


export type SubscriptionfiltersArgs = {
  distinct_on?: InputMaybe<Array<filters_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<filters_order_by>>;
  where?: InputMaybe<filters_bool_exp>;
};


export type Subscriptionfilters_aggregateArgs = {
  distinct_on?: InputMaybe<Array<filters_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<filters_order_by>>;
  where?: InputMaybe<filters_bool_exp>;
};


export type Subscriptionfilters_by_pkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscriptionfilters_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<filters_stream_cursor_input>>;
  where?: InputMaybe<filters_bool_exp>;
};


export type SubscriptionqueriesArgs = {
  distinct_on?: InputMaybe<Array<queries_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<queries_order_by>>;
  where?: InputMaybe<queries_bool_exp>;
};


export type Subscriptionqueries_aggregateArgs = {
  distinct_on?: InputMaybe<Array<queries_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<queries_order_by>>;
  where?: InputMaybe<queries_bool_exp>;
};


export type Subscriptionqueries_by_pkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscriptionqueries_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<queries_stream_cursor_input>>;
  where?: InputMaybe<queries_bool_exp>;
};


export type SubscriptionusersArgs = {
  distinct_on?: InputMaybe<Array<users_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<users_order_by>>;
  where?: InputMaybe<users_bool_exp>;
};


export type Subscriptionusers_aggregateArgs = {
  distinct_on?: InputMaybe<Array<users_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<users_order_by>>;
  where?: InputMaybe<users_bool_exp>;
};


export type Subscriptionusers_by_pkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscriptionusers_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<users_stream_cursor_input>>;
  where?: InputMaybe<users_bool_exp>;
};

export type Supplier = Node & {
  __typename?: 'Supplier';
  /** Active contracts count */
  activeContractCount: Scalars['Int']['output'];
  /** Active contracts list */
  activeContractList: Array<ContractNode>;
  /** Address */
  address: Address;
  /** commodity groups */
  commodityGroupCount: Scalars['Int']['output'];
  commodityGroupList: Array<CommodityGroupNode>;
  /** Contact */
  contact: Contact;
  /** date of creation */
  dateCreated: Scalars['DateTime']['output'];
  /** date of last update */
  dateUpdated: Scalars['DateTime']['output'];
  /** EBIT past financial year */
  ebit: Scalars['Float']['output'];
  /** Number of employees */
  employeeCount: Scalars['Int']['output'];
  /** External Supplier ID (i.e. SAP no) */
  externalId: Scalars['String']['output'];
  /** ID of the object. */
  id: Scalars['ID']['output'];
  /** Industry */
  industry: SupplierIndustryNode;
  /** Legal type of the company */
  legalType: SupplierLegalTypeNode;
  /** links */
  links: Array<ExternalLink>;
  /** Geo location */
  location?: Maybe<LatLng>;
  /** Location Group */
  locationGroupList: Array<LocationGroupNode>;
  /** Supplier name */
  name: Scalars['String']['output'];
  /** Total number of orders */
  orderCount: Scalars['Int']['output'];
  /** Total number of orders past 12 months */
  orderCountYear: Scalars['Int']['output'];
  /** date of the last order */
  orderLastDate?: Maybe<Scalars['DateTime']['output']>;
  /** Total order volume (in EUR) */
  orderVolume: Scalars['Float']['output'];
  orderVolumeCumulative?: Maybe<Scalars['Float']['output']>;
  orderVolumeCumulativeYear?: Maybe<Scalars['Float']['output']>;
  orderVolumeShare?: Maybe<Scalars['Float']['output']>;
  orderVolumeShareYear?: Maybe<Scalars['Float']['output']>;
  /** Total order volume past 12 months (in EUR) */
  orderVolumeYear: Scalars['Float']['output'];
  /** Ordered Products count */
  orderedProductCount: Scalars['Int']['output'];
  /** Categegories orders were in count */
  orderedProductInCategoryCount: Scalars['Int']['output'];
  /** Categegories orders were in list */
  orderedProductInCategoryList: Array<ProductCategoryNode>;
  /** Ordered Products list */
  orderedProductList: Array<ProductNode>;
  /** Ordered Services count */
  orderedServiceCount: Scalars['Int']['output'];
  /** Categegories orders were in count */
  orderedServiceInCategoryCount: Scalars['Int']['output'];
  /** Categegories orders were in list */
  orderedServiceInCategoryList: Array<ServiceCategoryNode>;
  /** Ordered Services list */
  orderedServiceList: Array<ServiceNode>;
  /** P/E ratio (in %) */
  peRatio: Scalars['Float']['output'];
  /** Prequalification Business Level Conditions */
  prequalificationLevel: prequalificationLevelType;
  /** Prequalification Trade plus Status List */
  prequalificationTrades: Array<SupplierPrequalification>;
  /** Received quotations count */
  quotationCount: Scalars['Int']['output'];
  /** Success rate in proposals (in %) */
  quotationSuccessRate: Scalars['Float']['output'];
  /** strategic relationship */
  relationship: SupplierRelationshipType;
  /** Representative count */
  representativeCount: Scalars['Int']['output'];
  /** Representative list */
  representativeList: Array<SupplierRepresentative>;
  /** Revenue past financial year */
  revenue: Scalars['Float']['output'];
  tagCount: Scalars['Int']['output'];
  /** tags */
  tagList: Array<TagNode>;
};

export type SupplierConnection = {
  __typename?: 'SupplierConnection';
  nodes: Array<Supplier>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type SupplierDetail = Node & {
  __typename?: 'SupplierDetail';
  /** Address */
  address: Address;
  /** Contact */
  contact: Contact;
  /** ID of the object. */
  id: Scalars['ID']['output'];
  /** Income */
  income: FloatReferenceValue;
  /** Industry */
  industry: SupplierIndustryNode;
  /** links */
  links: Array<ExternalLink>;
  /** Location Group */
  locationGroup?: Maybe<LocationGroupNode>;
  /** supplier name */
  name: Scalars['String']['output'];
  /** A list of news */
  news: NewsConnection;
  /** Prequalification Business Level Conditions */
  prequalificationLevel: prequalificationLevelType;
  /** Prequalification Trade plus Status List */
  prequalificationTrades: Array<SupplierPrequalification>;
  /** strategic relationship */
  relationship: SupplierRelationshipType;
  /** Revenue */
  revenue: FloatReferenceValue;
  /** Share Price */
  sharePrice: FloatReferenceValue;
  tagCount: Scalars['Int']['output'];
  /** tags */
  tagList: Array<TagNode>;
};


export type SupplierDetailnewsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export enum SupplierFilterField {
  activeContractCount = 'activeContractCount',
  addressCity = 'addressCity',
  addressCountry = 'addressCountry',
  commodityGroupCount = 'commodityGroupCount',
  commodityGroupId = 'commodityGroupId',
  dateCreated = 'dateCreated',
  dateUpdated = 'dateUpdated',
  ebit = 'ebit',
  employeeCount = 'employeeCount',
  externalId = 'externalId',
  id = 'id',
  industryId = 'industryId',
  lastContractDate = 'lastContractDate',
  legalType = 'legalType',
  locationRadius = 'locationRadius',
  orderCount = 'orderCount',
  orderCountYear = 'orderCountYear',
  orderLastDate = 'orderLastDate',
  orderVolume = 'orderVolume',
  orderVolumeCumulative = 'orderVolumeCumulative',
  orderVolumeCumulativeYear = 'orderVolumeCumulativeYear',
  orderVolumeShare = 'orderVolumeShare',
  orderVolumeShareYear = 'orderVolumeShareYear',
  orderVolumeYear = 'orderVolumeYear',
  orderedProductCount = 'orderedProductCount',
  orderedProductId = 'orderedProductId',
  orderedProductInCategoryCount = 'orderedProductInCategoryCount',
  orderedProductInCategoryId = 'orderedProductInCategoryId',
  orderedServiceCount = 'orderedServiceCount',
  orderedServiceId = 'orderedServiceId',
  orderedServiceInCategoryCount = 'orderedServiceInCategoryCount',
  orderedServiceInCategoryId = 'orderedServiceInCategoryId',
  peRatio = 'peRatio',
  prequalificationLevel = 'prequalificationLevel',
  prequalificationTradeId = 'prequalificationTradeId',
  relationship = 'relationship',
  representativeCount = 'representativeCount',
  revenue = 'revenue',
  sourceSystemId = 'sourceSystemId',
  tagCount = 'tagCount'
}

export type SupplierIndustryNode = NamedNode & {
  __typename?: 'SupplierIndustryNode';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type SupplierLegalTypeNode = NamedNode & {
  __typename?: 'SupplierLegalTypeNode';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type SupplierNode = NamedNode & {
  __typename?: 'SupplierNode';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

/** Ways in which lists of suppliers can be ordered upon return. */
export type SupplierOrder = {
  /** The direction in which to order packages by the specified field. */
  direction?: InputMaybe<OrderDirection>;
  /** The field in which to order packages by. */
  field?: InputMaybe<SupplierOrderField>;
};

export type SupplierOrderAccuracy = {
  __typename?: 'SupplierOrderAccuracy';
  asOrdered: Scalars['Int']['output'];
  bothDeviating: Scalars['Int']['output'];
  deviatingPrice: Scalars['Int']['output'];
  deviatingQuantity: Scalars['Int']['output'];
  status: Status;
  total: Scalars['Int']['output'];
};

/** Properties by which supplier connections can be ordered. */
export enum SupplierOrderField {
  activeContractCount = 'activeContractCount',
  commodityGroupCount = 'commodityGroupCount',
  dateCreated = 'dateCreated',
  dateUpdated = 'dateUpdated',
  ebit = 'ebit',
  employeeCount = 'employeeCount',
  externalId = 'externalId',
  id = 'id',
  industry = 'industry',
  legalType = 'legalType',
  locationGroup = 'locationGroup',
  name = 'name',
  orderCount = 'orderCount',
  orderCountYear = 'orderCountYear',
  orderLastDate = 'orderLastDate',
  orderVolume = 'orderVolume',
  orderVolumeCumulative = 'orderVolumeCumulative',
  orderVolumeCumulativeYear = 'orderVolumeCumulativeYear',
  orderVolumeShare = 'orderVolumeShare',
  orderVolumeShareYear = 'orderVolumeShareYear',
  orderVolumeYear = 'orderVolumeYear',
  orderedProductCount = 'orderedProductCount',
  orderedProductInCategoryCount = 'orderedProductInCategoryCount',
  orderedServiceCount = 'orderedServiceCount',
  orderedServiceInCategoryCount = 'orderedServiceInCategoryCount',
  peRatio = 'peRatio',
  prequalificationLevel = 'prequalificationLevel',
  quotationCount = 'quotationCount',
  quotationSuccessRate = 'quotationSuccessRate',
  relationship = 'relationship',
  representativeCount = 'representativeCount',
  revenue = 'revenue',
  tagCount = 'tagCount'
}

export type SupplierPointProps = {
  __typename?: 'SupplierPointProps';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  relationship: Scalars['String']['output'];
};

export type SupplierPrequalification = {
  __typename?: 'SupplierPrequalification';
  name: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

/** Type of the supplier */
export enum SupplierRelationshipType {
  known = 'known',
  partner = 'partner',
  unknown = 'unknown'
}

export type SupplierRepresentative = {
  __typename?: 'SupplierRepresentative';
  address?: Maybe<Address>;
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type SupplierSortOrder = {
  /** The field in which to order packages by. */
  field?: InputMaybe<SupplierOrderField>;
  /** The sort direction in which to order packages by the specified field. */
  sort?: InputMaybe<SortDirection>;
};

export type SupplierSpeed = {
  __typename?: 'SupplierSpeed';
  /** average lead time for the supplier */
  leadTime: FloatReferenceValue;
  /** average time the supplier needs to respond to order changes */
  respondToOrderChange: FloatReferenceValue;
  /** average time the supplier needs to respond to quotations */
  respondToQuotation: FloatReferenceValue;
};

export type SupplierSpendAnalysis = {
  __typename?: 'SupplierSpendAnalysis';
  id: Scalars['ID']['output'];
  labels: Array<Scalars['String']['output']>;
  segments: Array<SupplierSpendAnalysisSegment>;
  title: Scalars['String']['output'];
};

export type SupplierSpendAnalysisSegment = {
  __typename?: 'SupplierSpendAnalysisSegment';
  data: Array<Scalars['Float']['output']>;
  key: Scalars['String']['output'];
};

export enum SupplierSpendAnalysisSource {
  orderCount = 'orderCount',
  orderCountTop5 = 'orderCountTop5',
  orderVolume = 'orderVolume',
  orderVolumeTop5 = 'orderVolumeTop5'
}

export type SupplierTimeliness = {
  __typename?: 'SupplierTimeliness';
  cancelled: Scalars['Int']['output'];
  delayed: Scalars['Int']['output'];
  onTime: Scalars['Int']['output'];
  status: Status;
  total: Scalars['Int']['output'];
};

export enum SvbrgAgentId {
  buyerAssistant = 'buyerAssistant',
  catalogueSearchAgent = 'catalogueSearchAgent',
  companyGraphSupplierSearchAgent = 'companyGraphSupplierSearchAgent',
  contractComparisonAgent = 'contractComparisonAgent',
  conversationalAgent = 'conversationalAgent',
  frontdeskAgent = 'frontdeskAgent',
  policyCheckerAgent = 'policyCheckerAgent',
  procurementItemsAgent = 'procurementItemsAgent',
  procurementKnowledgeAgent = 'procurementKnowledgeAgent',
  quoteComparisonAgent = 'quoteComparisonAgent',
  requesterAssistant = 'requesterAssistant',
  sourcerAgent = 'sourcerAgent',
  webSearchAgent = 'webSearchAgent'
}

export type SvbrgAgentMessage = {
  __typename?: 'SvbrgAgentMessage';
  content?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  parts: Array<Scalars['JSON']['output']>;
  role: Scalars['String']['output'];
};

export enum SvbrgAllTools {
  askCatalogueSearchAgent = 'askCatalogueSearchAgent',
  askExternalSourcer = 'askExternalSourcer',
  askInternalSourcer = 'askInternalSourcer',
  askProcurementKnowledgeAgent = 'askProcurementKnowledgeAgent',
  askSourcerAgent = 'askSourcerAgent',
  askWebSearch = 'askWebSearch',
  bingSearch = 'bingSearch',
  checkAgainstPolicies = 'checkAgainstPolicies',
  contractComparator = 'contractComparator',
  contractConverter = 'contractConverter',
  extendedLineItemsCheck = 'extendedLineItemsCheck',
  extractContents = 'extractContents',
  extractQuoteDetails = 'extractQuoteDetails',
  extractSupplierRequest = 'extractSupplierRequest',
  fileSummary = 'fileSummary',
  generateStatementOfWork = 'generateStatementOfWork',
  geolocationResolver = 'geolocationResolver',
  googleSearch = 'googleSearch',
  handoverToRoute = 'handoverToRoute',
  identifyCommodityGroup = 'identifyCommodityGroup',
  quoteComparator = 'quoteComparator',
  quoteConverter = 'quoteConverter',
  readDemandInformation = 'readDemandInformation',
  readIntakeRequest = 'readIntakeRequest',
  runCheckQuoteRisk = 'runCheckQuoteRisk',
  runCheckQuoteRiskFromDemand = 'runCheckQuoteRiskFromDemand',
  runContractItemDiscovery = 'runContractItemDiscovery',
  runReadAttachments = 'runReadAttachments',
  runSourceSuppliers = 'runSourceSuppliers',
  runSupplierDiscovery = 'runSupplierDiscovery',
  searchCatalogue = 'searchCatalogue',
  searchCommodityGroup = 'searchCommodityGroup',
  searchContract = 'searchContract',
  searchContractItem = 'searchContractItem',
  searchMaterial = 'searchMaterial',
  searchProcurementKnowledge = 'searchProcurementKnowledge',
  searchPurchaseOrderItem = 'searchPurchaseOrderItem',
  searchPurchaseRequisitionItem = 'searchPurchaseRequisitionItem',
  searchSourcingProjectLotItem = 'searchSourcingProjectLotItem',
  searchSupplier = 'searchSupplier',
  supplierStructuredSearch = 'supplierStructuredSearch',
  supplierText2Cypher = 'supplierText2Cypher',
  updateIntakeRequest = 'updateIntakeRequest',
  userMessageSuggestions = 'userMessageSuggestions',
  vetSuppliers = 'vetSuppliers'
}

export type SvbrgAttachment = {
  __typename?: 'SvbrgAttachment';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  isVisible: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type SvbrgAttachmentDeleteInput = {
  chatSessionId: Scalars['UUID']['input'];
  fileId: Scalars['UUID']['input'];
};

export type SvbrgAttachmentFile = {
  fileId: Scalars['UUID']['input'];
  name: Scalars['String']['input'];
};

export enum SvbrgAttachmentMutationAction {
  DELETE = 'DELETE',
  NEW = 'NEW',
  NOOP = 'NOOP',
  UPDATE = 'UPDATE'
}

export type SvbrgAttachmentMutations = {
  __typename?: 'SvbrgAttachmentMutations';
  add: SvbrgAttachment;
  addMany: Array<SvbrgAttachment>;
  next: SvbrgIntakeRequest;
  remove: SvbrgAttachment;
  update: Array<SvbrgAttachment>;
};


export type SvbrgAttachmentMutationsaddArgs = {
  data: SvbrgAttachmentUploadInput;
};


export type SvbrgAttachmentMutationsaddManyArgs = {
  data: SvbrgAttachmentUploadManyInput;
};


export type SvbrgAttachmentMutationsnextArgs = {
  data: SvbrgAttachmentNextInput;
};


export type SvbrgAttachmentMutationsremoveArgs = {
  data: SvbrgAttachmentDeleteInput;
};


export type SvbrgAttachmentMutationsupdateArgs = {
  data: SvbrgAttachmentUpdateInput;
};

export type SvbrgAttachmentNextInput = {
  chatSessionId: Scalars['UUID']['input'];
};

export type SvbrgAttachmentUpdateInput = {
  attachments: Array<SvbrgAttachmentUpdateItemInput>;
  chatSessionId: Scalars['UUID']['input'];
};

export type SvbrgAttachmentUpdateItemInput = {
  action: SvbrgAttachmentMutationAction;
  fileId: Scalars['UUID']['input'];
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SvbrgAttachmentUploadInput = {
  chatSessionId: Scalars['UUID']['input'];
  fileId: Scalars['UUID']['input'];
  name: Scalars['String']['input'];
};

export type SvbrgAttachmentUploadManyInput = {
  chatSessionId: Scalars['UUID']['input'];
  files: Array<SvbrgAttachmentFile>;
};

export enum SvbrgBackgroundJobStatus {
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  IN_PROGRESS = 'IN_PROGRESS'
}

export type SvbrgBudgetMutations = {
  __typename?: 'SvbrgBudgetMutations';
  next: SvbrgIntakeRequest;
};


export type SvbrgBudgetMutationsnextArgs = {
  data: SvbrgRequestBudgetInput;
};

export type SvbrgCatalogueFilter = {
  __typename?: 'SvbrgCatalogueFilter';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  values: Scalars['JSON']['output'];
};

export type SvbrgCatalogueItem = {
  __typename?: 'SvbrgCatalogueItem';
  currency: Scalars['String']['output'];
  deliveryTime: Scalars['Float']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  inStock?: Maybe<Scalars['Boolean']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  previewImage?: Maybe<Scalars['String']['output']>;
  price: Scalars['Float']['output'];
  punchoutUrl?: Maybe<Scalars['String']['output']>;
  shippingCosts: Scalars['Float']['output'];
};

export enum SvbrgCategoryType {
  CONVERSATION = 'CONVERSATION',
  INTAKE = 'INTAKE',
  SOURCING = 'SOURCING'
}

export type SvbrgChatMessage = {
  __typename?: 'SvbrgChatMessage';
  chatSessionId: Scalars['UUID']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  message?: Maybe<Scalars['String']['output']>;
  role: SvbrgChatMessageRole;
  sequence: Scalars['Int']['output'];
  status: SvbrgChatMessageStatus;
  variant: SvbrgChatMessageVariant;
};

export type SvbrgChatMessageCreateInput = {
  chatSessionId: Scalars['UUID']['input'];
  sequence?: InputMaybe<Scalars['Int']['input']>;
  variant: SvbrgChatMessageVariant;
};

export enum SvbrgChatMessageRole {
  AI = 'AI',
  USER = 'USER'
}

export type SvbrgChatMessageStateUpdateInput = {
  id: Scalars['UUID']['input'];
  status: SvbrgChatMessageStatus;
};

export enum SvbrgChatMessageStatus {
  COMPLETED = 'COMPLETED',
  PENDING = 'PENDING',
  PROCEED = 'PROCEED'
}

export enum SvbrgChatMessageVariant {
  ATTACHMENTS = 'ATTACHMENTS',
  CHAT_REQUEST_DESCRIPTION = 'CHAT_REQUEST_DESCRIPTION',
  CHAT_REQUEST_MESSAGE = 'CHAT_REQUEST_MESSAGE',
  EXTENDED_LINE_ITEMS_CHECK = 'EXTENDED_LINE_ITEMS_CHECK',
  QUOTE = 'QUOTE',
  QUOTE_COMPLIANCE = 'QUOTE_COMPLIANCE',
  QUOTE_SUPPLIER_CONFIRMATION = 'QUOTE_SUPPLIER_CONFIRMATION',
  QUOTE_UPLOAD = 'QUOTE_UPLOAD',
  REQUEST_BUDGET = 'REQUEST_BUDGET',
  REQUEST_COMPLEX = 'REQUEST_COMPLEX',
  REQUEST_DESCRIPTION = 'REQUEST_DESCRIPTION',
  REQUEST_DETAILS = 'REQUEST_DETAILS',
  REQUEST_INTENT_SELECTION = 'REQUEST_INTENT_SELECTION',
  REQUEST_LINE_ITEMS = 'REQUEST_LINE_ITEMS',
  REQUEST_NUCLEAR_COMPLIANCE_FORM = 'REQUEST_NUCLEAR_COMPLIANCE_FORM',
  REQUEST_SOW_GENERATION = 'REQUEST_SOW_GENERATION',
  REQUEST_SUBMIT = 'REQUEST_SUBMIT',
  REQUEST_SUPPLIER_SELECTION = 'REQUEST_SUPPLIER_SELECTION',
  REQUEST_TACTICAL_SOURCING_SELECTION = 'REQUEST_TACTICAL_SOURCING_SELECTION',
  REQUIREMENTS_UPLOAD = 'REQUIREMENTS_UPLOAD',
  SUPPLIER_SOURCING = 'SUPPLIER_SOURCING'
}

export type SvbrgChatRequestMessage = {
  __typename?: 'SvbrgChatRequestMessage';
  id: Scalars['UUID']['output'];
};

export type SvbrgChatRequestMessageInput = {
  chatSessionId: Scalars['UUID']['input'];
  language: SvbrgLanguage;
  text: Scalars['String']['input'];
};

export type SvbrgChatRequestMessageMutations = {
  __typename?: 'SvbrgChatRequestMessageMutations';
  generate: SvbrgChatRequestMessage;
};


export type SvbrgChatRequestMessageMutationsgenerateArgs = {
  data: SvbrgChatRequestMessageInput;
};

export type SvbrgChatSession = {
  __typename?: 'SvbrgChatSession';
  conversationMessages?: Maybe<Array<SvbrgAgentMessage>>;
  conversationSettings?: Maybe<SvbrgConversationSettings>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['UUID']['output']>;
  demandId?: Maybe<Scalars['UUID']['output']>;
  demandResponsibleUsers?: Maybe<Array<Scalars['UUID']['output']>>;
  demandSequenceNumber?: Maybe<Scalars['BigInt']['output']>;
  id: Scalars['UUID']['output'];
  sequenceNumber: Scalars['BigInt']['output'];
  status?: Maybe<SvbrgIntakeStatus>;
  summary?: Maybe<Scalars['String']['output']>;
  variant: SvbrgChatSessionVariant;
};

export type SvbrgChatSessionCreateInput = {
  variant: SvbrgChatSessionVariant;
};

export type SvbrgChatSessionInput = {
  id: Scalars['UUID']['input'];
};

export type SvbrgChatSessionMutations = {
  __typename?: 'SvbrgChatSessionMutations';
  attachment: SvbrgAttachmentMutations;
  budget: SvbrgBudgetMutations;
  cancel: SvbrgChatSession;
  chatRequestMessage: SvbrgChatRequestMessageMutations;
  create: SvbrgChatSession;
  discard: SvbrgChatSession;
  extendedLineItemsCheck: SvbrgExtendedLineItemCheckMutations;
  quote: SvbrgQuoteAnalysisMutations;
  quoteCompliance: SvbrgQuoteComplianceCheckMutations;
  request: SvbrgRequestDetailsMutations;
  requestDescription: SvbrgRequestDescriptionMutations;
  requirementsExtraction: SvbrgRequirementsExtractionMutations;
  reset: SvbrgChatSession;
  selectIntent: SvbrgChatSession;
  statementOfWork: SvbrgStatementOfWorkMutations;
  supplierSelection: SvbrgSupplierSelectionMutations;
  tacticalSourcing: SvbrgTacticalSourcingMutations;
};


export type SvbrgChatSessionMutationscancelArgs = {
  data: SvbrgChatSessionInput;
};


export type SvbrgChatSessionMutationscreateArgs = {
  data?: InputMaybe<SvbrgChatSessionCreateInput>;
};


export type SvbrgChatSessionMutationsdiscardArgs = {
  data: SvbrgChatSessionInput;
};


export type SvbrgChatSessionMutationsresetArgs = {
  data: SvbrgChatSessionInput;
};


export type SvbrgChatSessionMutationsselectIntentArgs = {
  data: SvbrgChatSessionSelectIntentInput;
};

export type SvbrgChatSessionQueries = {
  __typename?: 'SvbrgChatSessionQueries';
  analysis?: Maybe<SvbrgQuoteAnalysis>;
  attachments: Array<SvbrgAttachment>;
  chatMessages: Array<SvbrgChatMessage>;
  conversationSettings?: Maybe<SvbrgConversationSettings>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['UUID']['output']>;
  currentStep: SvbrgChatMessage;
  demandId?: Maybe<Scalars['UUID']['output']>;
  demandResponsibleUsers?: Maybe<Array<Scalars['UUID']['output']>>;
  demandSequenceNumber?: Maybe<Scalars['BigInt']['output']>;
  extendedLineItemChecks: Array<SvbrgExtendedLineItemsCheck>;
  id: Scalars['UUID']['output'];
  jobStructureRequest?: Maybe<SvbrgJobStructureRequest>;
  quote?: Maybe<SvbrgQuote>;
  quoteAnalysisId?: Maybe<Scalars['UUID']['output']>;
  quoteCompliance?: Maybe<SvbrgQuoteComplianceCheck>;
  request?: Maybe<SvbrgIntakeRequest>;
  requestDescription?: Maybe<SvbrgRequestDescription>;
  requirementsExtraction?: Maybe<SvbrgRequirementsExtraction>;
  sequenceNumber: Scalars['BigInt']['output'];
  statementsOfWork: Array<SvbrgStatementOfWork>;
  status?: Maybe<SvbrgIntakeStatus>;
  suppliers?: Maybe<Array<SvbrgIntakeRequestSupplier>>;
  tacticalSourcing?: Maybe<SvbrgTacticalSourcing>;
  variant: SvbrgChatSessionVariant;
};

export type SvbrgChatSessionSelectIntentInput = {
  id: Scalars['UUID']['input'];
  intent: SvbrgChatSessionVariant;
};

export type SvbrgChatSessionStatusUpdateEvent = {
  __typename?: 'SvbrgChatSessionStatusUpdateEvent';
  id: Scalars['UUID']['output'];
};

export enum SvbrgChatSessionVariant {
  CHAT = 'CHAT',
  REQUEST_CHAT = 'REQUEST_CHAT',
  REQUEST_DLR = 'REQUEST_DLR',
  REQUEST_FORM = 'REQUEST_FORM',
  REQUEST_FORM_COMPLEX = 'REQUEST_FORM_COMPLEX',
  REQUEST_INTAKE_NUCLEAR_FORM = 'REQUEST_INTAKE_NUCLEAR_FORM',
  REQUEST_INTAKE_NUCLEAR_QUOTE = 'REQUEST_INTAKE_NUCLEAR_QUOTE',
  REQUEST_INTENT_SELECTION = 'REQUEST_INTENT_SELECTION',
  REQUEST_INTENT_SELECTION_COMPLEX = 'REQUEST_INTENT_SELECTION_COMPLEX',
  REQUEST_QUOTE = 'REQUEST_QUOTE',
  SOURCING_DEMAND = 'SOURCING_DEMAND'
}

export type SvbrgChatSessionWithConversationSettingsCreateInput = {
  entityId: Scalars['UUID']['input'];
  entityVariant: SvbrgConversationEntityVariant;
};

export type SvbrgCheckAgainstPoliciesInput = {
  fileId: Scalars['String']['input'];
  fileName?: InputMaybe<Scalars['String']['input']>;
  type: SvbrgPolicyVerificationType;
};

export type SvbrgCheckAgainstPoliciesOutput = {
  __typename?: 'SvbrgCheckAgainstPoliciesOutput';
  parts: Array<SvbrgPolicyCompliancePart>;
  summary: Scalars['String']['output'];
};

export type SvbrgCheckResults = {
  __typename?: 'SvbrgCheckResults';
  catalogueItems: Array<SvbrgCatalogueItem>;
  contractItems: Array<SvbrgContractItem>;
};

export type SvbrgCommodityGroupQueryGroup = {
  __typename?: 'SvbrgCommodityGroupQueryGroup';
  foundCount: Scalars['Int']['output'];
  items: Array<SvbrgCommodityGroupSearchResult>;
  query: Scalars['String']['output'];
};

export type SvbrgCommodityGroupSearchResult = {
  __typename?: 'SvbrgCommodityGroupSearchResult';
  displayCode?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  sapSourceReference?: Maybe<Scalars['String']['output']>;
};

export type SvbrgCompanyResult = {
  __typename?: 'SvbrgCompanyResult';
  companyAddress?: Maybe<Scalars['String']['output']>;
  directors: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  legalForm?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  northDataUrl?: Maybe<Scalars['String']['output']>;
  similarityScore?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
};

export enum SvbrgComplianceStatus {
  compliant = 'compliant',
  conflict = 'conflict',
  risk = 'risk'
}

export type SvbrgContract = {
  __typename?: 'SvbrgContract';
  currency?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  plannedValueFloat?: Maybe<Scalars['Float']['output']>;
  supplierId?: Maybe<Scalars['String']['output']>;
};

export type SvbrgContractComparatorInput = {
  fileIds: Array<Scalars['String']['input']>;
};

export type SvbrgContractComparatorOutput = {
  __typename?: 'SvbrgContractComparatorOutput';
  bestOption: Scalars['String']['output'];
  comparisonCriteria: Array<SvbrgContractComparisonCriteria>;
  contracts: Array<SvbrgContractWithMetadata>;
  productGroups: Array<SvbrgContractComparatorProductGroup>;
  rationale: Scalars['String']['output'];
  risks?: Maybe<Array<SvbrgContractRisk>>;
};

export type SvbrgContractComparatorProductGroup = {
  __typename?: 'SvbrgContractComparatorProductGroup';
  productGroup: Scalars['String']['output'];
  products: Array<Scalars['String']['output']>;
};

export type SvbrgContractComparisonCriteria = {
  __typename?: 'SvbrgContractComparisonCriteria';
  bestContract: Scalars['String']['output'];
  criterion: Scalars['String']['output'];
  explanation: Scalars['String']['output'];
};

export type SvbrgContractConverterInput = {
  fileId: Scalars['String']['input'];
};

export type SvbrgContractConverterOutput = {
  __typename?: 'SvbrgContractConverterOutput';
  confidentiality?: Maybe<Array<Scalars['String']['output']>>;
  contractDuration?: Maybe<Scalars['Float']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  legal?: Maybe<Array<Scalars['String']['output']>>;
  ordering?: Maybe<SvbrgContractOrdering>;
  paymentTerms?: Maybe<SvbrgContractPaymentTerms>;
  pricing?: Maybe<SvbrgContractPricing>;
  products?: Maybe<Array<SvbrgContractProduct>>;
  qualityControl?: Maybe<SvbrgContractQualityControl>;
  qualityStandards?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
  supplierAddress?: Maybe<Scalars['String']['output']>;
  supplierName?: Maybe<Scalars['String']['output']>;
  termination?: Maybe<SvbrgContractTermination>;
};

export type SvbrgContractItem = {
  __typename?: 'SvbrgContractItem';
  contract: SvbrgContract;
  createdAtTimestamp: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  plannedQuantityFloat?: Maybe<Scalars['Float']['output']>;
  pricePerUnitFloat: Scalars['Float']['output'];
  title: Scalars['String']['output'];
};

export type SvbrgContractItemGroup = {
  __typename?: 'SvbrgContractItemGroup';
  foundCount: Scalars['Int']['output'];
  items: Array<SvbrgContractItem>;
  query: Scalars['String']['output'];
};

export type SvbrgContractOrdering = {
  __typename?: 'SvbrgContractOrdering';
  deliveryLocation?: Maybe<Scalars['String']['output']>;
  deliveryTimeDays?: Maybe<Scalars['Float']['output']>;
  lateDeliveryPenaltyPercent?: Maybe<Scalars['Float']['output']>;
  stockBufferPercent?: Maybe<Scalars['Float']['output']>;
};

export type SvbrgContractPaymentTerms = {
  __typename?: 'SvbrgContractPaymentTerms';
  dueDays?: Maybe<Scalars['Float']['output']>;
  earlyPaymentDiscountPercent?: Maybe<Scalars['Float']['output']>;
  latePaymentInterestPercent?: Maybe<Scalars['Float']['output']>;
};

export type SvbrgContractPricing = {
  __typename?: 'SvbrgContractPricing';
  volumeDiscountPercent?: Maybe<Scalars['Float']['output']>;
  volumeDiscountThreshold?: Maybe<Scalars['Float']['output']>;
};

export type SvbrgContractProduct = {
  __typename?: 'SvbrgContractProduct';
  commodity: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type SvbrgContractQualityControl = {
  __typename?: 'SvbrgContractQualityControl';
  auditFrequency?: Maybe<Scalars['String']['output']>;
  defectiveProductPolicy?: Maybe<Scalars['String']['output']>;
  warrantyYears?: Maybe<Scalars['Float']['output']>;
};

export type SvbrgContractRisk = {
  __typename?: 'SvbrgContractRisk';
  contractId: Scalars['ID']['output'];
  risk: Scalars['String']['output'];
  severity: SvbrgRiskSeverity;
};

export type SvbrgContractTermination = {
  __typename?: 'SvbrgContractTermination';
  immediateTerminationConditions?: Maybe<Array<Scalars['String']['output']>>;
  standardNoticeDays?: Maybe<Scalars['Float']['output']>;
};

export type SvbrgContractWithMetadata = {
  __typename?: 'SvbrgContractWithMetadata';
  contract: SvbrgContractConverterOutput;
  fileId: Scalars['ID']['output'];
  fileName: Scalars['String']['output'];
  policyCheck: SvbrgCheckAgainstPoliciesOutput;
};

export enum SvbrgConversationEntityVariant {
  DEMAND = 'DEMAND'
}

export type SvbrgConversationSettings = {
  __typename?: 'SvbrgConversationSettings';
  createdAt: Scalars['DateTime']['output'];
  entityId: Scalars['UUID']['output'];
  entityVariant: SvbrgConversationEntityVariant;
  id: Scalars['UUID']['output'];
  quickActions: Array<SvbrgQuickActions>;
  tools: Array<SvbrgConversationSettingsTools>;
  updatedAt: Scalars['DateTime']['output'];
};

export enum SvbrgConversationSettingsAvailableTools {
  askExternalSourcer = 'askExternalSourcer',
  askInternalSourcer = 'askInternalSourcer',
  askWebSearch = 'askWebSearch',
  extractQuoteDetails = 'extractQuoteDetails',
  identifyCommodityGroup = 'identifyCommodityGroup',
  readDemandInformation = 'readDemandInformation',
  runCheckQuoteRisk = 'runCheckQuoteRisk',
  runCheckQuoteRiskFromDemand = 'runCheckQuoteRiskFromDemand',
  runContractItemDiscovery = 'runContractItemDiscovery',
  runReadAttachments = 'runReadAttachments',
  runSourceSuppliers = 'runSourceSuppliers',
  runSupplierDiscovery = 'runSupplierDiscovery',
  searchCatalogue = 'searchCatalogue',
  searchContractItem = 'searchContractItem',
  searchPurchaseOrderItem = 'searchPurchaseOrderItem',
  searchSupplier = 'searchSupplier'
}

export type SvbrgConversationSettingsCreateMutation = {
  chatSessionId?: InputMaybe<Scalars['UUID']['input']>;
  entityId: Scalars['UUID']['input'];
  entityVariant: SvbrgConversationEntityVariant;
  quickActions: Array<SvbrgConversationSettingsQuickActionInput>;
  tools: Array<SvbrgConversationSettingsToolsInput>;
};

export type SvbrgConversationSettingsMutations = {
  __typename?: 'SvbrgConversationSettingsMutations';
  create: SvbrgConversationSettings;
  update: SvbrgConversationSettings;
};


export type SvbrgConversationSettingsMutationscreateArgs = {
  data: SvbrgConversationSettingsCreateMutation;
};


export type SvbrgConversationSettingsMutationsupdateArgs = {
  data: SvbrgConversationSettingsUpdateMutation;
};

export type SvbrgConversationSettingsQuickActionInput = {
  isConversationStarter: Scalars['Boolean']['input'];
  prompt: Scalars['String']['input'];
  translations?: InputMaybe<Array<SvbrgQuickActionTranslationsInput>>;
};

export enum SvbrgConversationSettingsToolId {
  askCatalogueSearchAgent = 'askCatalogueSearchAgent',
  askExternalSourcer = 'askExternalSourcer',
  askInternalSourcer = 'askInternalSourcer',
  askProcurementKnowledgeAgent = 'askProcurementKnowledgeAgent',
  askSourcerAgent = 'askSourcerAgent',
  askWebSearch = 'askWebSearch',
  bingSearch = 'bingSearch',
  checkAgainstPolicies = 'checkAgainstPolicies',
  contractComparator = 'contractComparator',
  contractConverter = 'contractConverter',
  extendedLineItemsCheck = 'extendedLineItemsCheck',
  extractContents = 'extractContents',
  extractQuoteDetails = 'extractQuoteDetails',
  extractSupplierRequest = 'extractSupplierRequest',
  fileSummary = 'fileSummary',
  generateStatementOfWork = 'generateStatementOfWork',
  geolocationResolver = 'geolocationResolver',
  googleSearch = 'googleSearch',
  handoverToRoute = 'handoverToRoute',
  identifyCommodityGroup = 'identifyCommodityGroup',
  quoteComparator = 'quoteComparator',
  quoteConverter = 'quoteConverter',
  readDemandInformation = 'readDemandInformation',
  readIntakeRequest = 'readIntakeRequest',
  runCheckQuoteRisk = 'runCheckQuoteRisk',
  runCheckQuoteRiskFromDemand = 'runCheckQuoteRiskFromDemand',
  runContractItemDiscovery = 'runContractItemDiscovery',
  runReadAttachments = 'runReadAttachments',
  runSourceSuppliers = 'runSourceSuppliers',
  runSupplierDiscovery = 'runSupplierDiscovery',
  searchCatalogue = 'searchCatalogue',
  searchCommodityGroup = 'searchCommodityGroup',
  searchContract = 'searchContract',
  searchContractItem = 'searchContractItem',
  searchMaterial = 'searchMaterial',
  searchProcurementKnowledge = 'searchProcurementKnowledge',
  searchPurchaseOrderItem = 'searchPurchaseOrderItem',
  searchPurchaseRequisitionItem = 'searchPurchaseRequisitionItem',
  searchSourcingProjectLotItem = 'searchSourcingProjectLotItem',
  searchSupplier = 'searchSupplier',
  supplierStructuredSearch = 'supplierStructuredSearch',
  supplierText2Cypher = 'supplierText2Cypher',
  updateIntakeRequest = 'updateIntakeRequest',
  userMessageSuggestions = 'userMessageSuggestions',
  vetSuppliers = 'vetSuppliers'
}

export type SvbrgConversationSettingsTools = {
  __typename?: 'SvbrgConversationSettingsTools';
  id: SvbrgConversationSettingsAvailableTools;
  isEnabled: Scalars['Boolean']['output'];
};

export type SvbrgConversationSettingsToolsInput = {
  id: SvbrgConversationSettingsAvailableTools;
  isEnabled: Scalars['Boolean']['input'];
};

export type SvbrgConversationSettingsUpdateMutation = {
  chatSessionId?: InputMaybe<Scalars['UUID']['input']>;
  entityId: Scalars['UUID']['input'];
  entityVariant: SvbrgConversationEntityVariant;
  id: Scalars['UUID']['input'];
  quickActions: Array<SvbrgConversationSettingsQuickActionInput>;
  tools: Array<SvbrgConversationSettingsToolsInput>;
};

export type SvbrgDemand = {
  __typename?: 'SvbrgDemand';
  createdAtTimestamp?: Maybe<Scalars['Float']['output']>;
  demand_requests__v1?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  impactScore?: Maybe<Scalars['Float']['output']>;
  negotiation_cases__v1?: Maybe<Scalars['JSON']['output']>;
  priority?: Maybe<Scalars['Int']['output']>;
  processingMode?: Maybe<Scalars['String']['output']>;
  semanticContent?: Maybe<Scalars['String']['output']>;
  sequenceNumber?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAtTimestamp?: Maybe<Scalars['Float']['output']>;
};

export type SvbrgDocument = {
  __typename?: 'SvbrgDocument';
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  fileId: Scalars['UUID']['output'];
  fileName?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  language: SvbrgLanguage;
  mimeType: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
  variant: SvbrgDocumentVariant;
};

export type SvbrgDocumentChunk = {
  __typename?: 'SvbrgDocumentChunk';
  content: Scalars['String']['output'];
  documentUrl?: Maybe<Scalars['String']['output']>;
  fileId: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  title: Scalars['String']['output'];
};

export type SvbrgDocumentFind = {
  query: Scalars['String']['input'];
  similarityThreshold?: InputMaybe<Scalars['Float']['input']>;
  topK?: InputMaybe<Scalars['Int']['input']>;
};

export type SvbrgDocumentList = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type SvbrgDocumentListConnection = {
  __typename?: 'SvbrgDocumentListConnection';
  nodes: Array<SvbrgDocumentListItem>;
  totalCount: Scalars['BigInt']['output'];
};

export enum SvbrgDocumentListFilterField {
  fileName = 'fileName',
  title = 'title',
  updatedAt = 'updatedAt',
  variant = 'variant'
}

export type SvbrgDocumentListItem = {
  __typename?: 'SvbrgDocumentListItem';
  /** Creation date time of the document. */
  createdAt: Scalars['DateTime']['output'];
  /** Description of the document. */
  description?: Maybe<Scalars['String']['output']>;
  /** File ID of the document. */
  fileId: Scalars['UUID']['output'];
  /** File name of the document. */
  fileName?: Maybe<Scalars['String']['output']>;
  /** Internal ID of the document. */
  id: Scalars['UUID']['output'];
  /** Language of the document. */
  language: SvbrgLanguage;
  /** MIME type of the document. */
  mimeType: Scalars['String']['output'];
  /** Title of the document. */
  title: Scalars['String']['output'];
  /** Update date time of the document. */
  updatedAt: Scalars['DateTime']['output'];
  /** URL of the document. */
  url?: Maybe<Scalars['String']['output']>;
  variant: SvbrgDocumentVariant;
};

export type SvbrgDocumentListOrder = {
  field: SvbrgDocumentListOrderField;
  sort?: InputMaybe<SvbrgSortDirection>;
};

export enum SvbrgDocumentListOrderField {
  description = 'description',
  fileName = 'fileName',
  id = 'id',
  mimeType = 'mimeType',
  title = 'title',
  updatedAt = 'updatedAt',
  variant = 'variant'
}

export type SvbrgDocumentMutations = {
  __typename?: 'SvbrgDocumentMutations';
  delete: Array<SvbrgDocument>;
  updateMetadata: SvbrgDocument;
  upload: SvbrgDocument;
};


export type SvbrgDocumentMutationsdeleteArgs = {
  id: Scalars['UUID']['input'];
};


export type SvbrgDocumentMutationsupdateMetadataArgs = {
  data: SvbrgDocumentUpdateMetadata;
};


export type SvbrgDocumentMutationsuploadArgs = {
  data: SvbrgDocumentUpload;
};

export enum SvbrgDocumentType {
  other = 'other',
  quote = 'quote',
  service_description = 'service_description'
}

export type SvbrgDocumentUpdateMetadata = {
  content?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  language: SvbrgLanguage;
  title: Scalars['String']['input'];
  url?: InputMaybe<Scalars['String']['input']>;
  variant: SvbrgDocumentVariant;
};

export type SvbrgDocumentUpload = {
  content?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fileId: Scalars['UUID']['input'];
  id: Scalars['UUID']['input'];
  language: SvbrgLanguage;
  title: Scalars['String']['input'];
  url?: InputMaybe<Scalars['String']['input']>;
  variant: SvbrgDocumentVariant;
};

export enum SvbrgDocumentVariant {
  OTHER = 'OTHER',
  PROCUREMENT_POLICY = 'PROCUREMENT_POLICY',
  SUPPLIER_TERMS = 'SUPPLIER_TERMS'
}

export type SvbrgDynamicFacetFilter = {
  bucketIds?: InputMaybe<Array<Scalars['String']['input']>>;
  facetId: Scalars['String']['input'];
};

export type SvbrgEnrichedLineItem = {
  __typename?: 'SvbrgEnrichedLineItem';
  catalogueItems: Array<SvbrgCatalogueItem>;
  commodityGroupId?: Maybe<Scalars['String']['output']>;
  contractItems: Array<SvbrgContractItem>;
  description?: Maybe<Scalars['String']['output']>;
  earlyDeliveryAt?: Maybe<Scalars['String']['output']>;
  lateDeliveryAt?: Maybe<Scalars['String']['output']>;
  position: Scalars['String']['output'];
  pricePerUnit?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  unitId?: Maybe<Scalars['String']['output']>;
};

export enum SvbrgEntityName {
  Address = 'Address',
  City = 'City',
  Company = 'Company',
  Offering = 'Offering',
  Person = 'Person',
  SegmentCode = 'SegmentCode',
  TextEmbedding = 'TextEmbedding'
}

export type SvbrgExtendedLineItemCheckMutations = {
  __typename?: 'SvbrgExtendedLineItemCheckMutations';
  checkLineItems: SvbrgExtendedLineItemsCheckResult;
  next: SvbrgIntakeRequest;
};


export type SvbrgExtendedLineItemCheckMutationscheckLineItemsArgs = {
  data: SvbrgExtendedLineItemsCheckInput;
};


export type SvbrgExtendedLineItemCheckMutationsnextArgs = {
  data: SvbrgExtendedLineItemsCheckNextInput;
};

export type SvbrgExtendedLineItemForCheckInput = {
  commodityGroupId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  earlyDeliveryAt?: InputMaybe<Scalars['DateTime']['input']>;
  lateDeliveryAt?: InputMaybe<Scalars['DateTime']['input']>;
  position: Scalars['String']['input'];
  pricePerUnit?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  unitId?: InputMaybe<Scalars['String']['input']>;
};

export type SvbrgExtendedLineItemsCheck = {
  __typename?: 'SvbrgExtendedLineItemsCheck';
  chatSessionId: Scalars['UUID']['output'];
  checkResults?: Maybe<SvbrgCheckResults>;
  commodityGroupId?: Maybe<Scalars['UUID']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  earlyDeliveryAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  lateDeliveryAt?: Maybe<Scalars['DateTime']['output']>;
  position: Scalars['String']['output'];
  pricePerUnit?: Maybe<Scalars['SvbrgDecimal']['output']>;
  quantity?: Maybe<Scalars['SvbrgDecimal']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  unitId?: Maybe<Scalars['UUID']['output']>;
};

export type SvbrgExtendedLineItemsCheckInput = {
  chatSessionId: Scalars['UUID']['input'];
  /** Instead of inferring the line items from the quote via the chat session ID , the list of line items can also be provided directly. */
  lineItems?: InputMaybe<Array<SvbrgLineItemForCheckInput>>;
};

export type SvbrgExtendedLineItemsCheckNextInput = {
  chatSessionId: Scalars['UUID']['input'];
  /** Line items to upsert into the intake request. */
  lineItems: Array<SvbrgLineItemForCheckInput>;
};

export type SvbrgExtendedLineItemsCheckOutput = {
  __typename?: 'SvbrgExtendedLineItemsCheckOutput';
  enrichedLineItems: Array<SvbrgEnrichedLineItem>;
  error?: Maybe<Scalars['String']['output']>;
};

export type SvbrgExtendedLineItemsCheckResult = {
  __typename?: 'SvbrgExtendedLineItemsCheckResult';
  chatSessionId: Scalars['String']['output'];
  checks: Array<SvbrgExtendedLineItemsCheck>;
};

export type SvbrgExtendedLineItemsCheckToolInput = {
  lineItems: Array<SvbrgExtendedLineItemForCheckInput>;
};

export type SvbrgExternalSourcerOutput = {
  __typename?: 'SvbrgExternalSourcerOutput';
  filterSummary?: Maybe<Scalars['String']['output']>;
  response: Scalars['String']['output'];
  suppliers?: Maybe<Array<SvbrgExternalSupplierFindings>>;
};

export type SvbrgExternalSourcerPurchaseRequisitionInput = {
  description: Scalars['String']['input'];
  geographicFilter?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  primarySearchTerms: Array<Scalars['String']['input']>;
  secondarySearchTerms: Array<Scalars['String']['input']>;
};

export type SvbrgExternalSupplierFindings = {
  __typename?: 'SvbrgExternalSupplierFindings';
  businessDescription: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  location: Scalars['String']['output'];
  name: Scalars['String']['output'];
  website: Scalars['String']['output'];
};

export type SvbrgExtractSupplierRequestInput = {
  fileIds: Array<Scalars['String']['input']>;
};

export type SvbrgExtractSupplierRequestOutput = {
  __typename?: 'SvbrgExtractSupplierRequestOutput';
  allLineItems: Array<SvbrgExtractedLineItem>;
  crossDocumentSummary: Scalars['String']['output'];
  documents: Array<SvbrgExtractedDocument>;
};

export type SvbrgExtractedDocument = {
  __typename?: 'SvbrgExtractedDocument';
  documentSummary: Scalars['String']['output'];
  documentType: SvbrgDocumentType;
  fileId: Scalars['ID']['output'];
  lineItems: Array<SvbrgExtractedLineItem>;
  supplierName?: Maybe<Scalars['String']['output']>;
  totalValue?: Maybe<Scalars['Float']['output']>;
};

export type SvbrgExtractedLineItem = {
  __typename?: 'SvbrgExtractedLineItem';
  commodityCategory?: Maybe<Scalars['String']['output']>;
  intent?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  title: Scalars['String']['output'];
  totalPrice?: Maybe<Scalars['Float']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  unitPrice?: Maybe<Scalars['Float']['output']>;
};

export type SvbrgExtractedRequirements = {
  __typename?: 'SvbrgExtractedRequirements';
  /** Extracted requirements data structured for the specified form step */
  data?: Maybe<Scalars['JSON']['output']>;
  /** Whether extracted data is available for this step */
  hasData: Scalars['Boolean']['output'];
  stepType: SvbrgFormStepType;
};

export type SvbrgFacetFilter = {
  bucketIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SvbrgFilterInput = {
  entityField: Scalars['String']['input'];
  entityName: SvbrgEntityName;
  operation: SvbrgFilterOperation;
  value: Scalars['JSON']['input'];
};

export enum SvbrgFilterOperation {
  cityRadius = 'cityRadius',
  contains = 'contains',
  eq = 'eq',
  gt = 'gt',
  gte = 'gte',
  lt = 'lt',
  lte = 'lte',
  ne = 'ne',
  semantic = 'semantic'
}

export enum SvbrgFormStepType {
  REQUEST_DESCRIPTION = 'REQUEST_DESCRIPTION',
  REQUEST_DETAILS = 'REQUEST_DETAILS',
  REQUEST_LINE_ITEMS = 'REQUEST_LINE_ITEMS',
  REQUEST_SUPPLIER_SELECTION = 'REQUEST_SUPPLIER_SELECTION'
}

export type SvbrgGetExtractedRequirementsInput = {
  chatSessionId: Scalars['UUID']['input'];
  stepType: SvbrgFormStepType;
};

export type SvbrgHandoverToRouteInput = {
  intent?: InputMaybe<SvbrgHandoverToRouteIntent>;
  query: Scalars['String']['input'];
  reason: Scalars['String']['input'];
};

export enum SvbrgHandoverToRouteIntent {
  REQUEST_FROM_FORM = 'REQUEST_FROM_FORM',
  REQUEST_FROM_QUOTE = 'REQUEST_FROM_QUOTE'
}

export type SvbrgHandoverToRouteOutput = {
  __typename?: 'SvbrgHandoverToRouteOutput';
  chatSessionId?: Maybe<Scalars['ID']['output']>;
};

export type SvbrgIntakeRequest = {
  __typename?: 'SvbrgIntakeRequest';
  accountingAreaId?: Maybe<Scalars['UUID']['output']>;
  budget?: Maybe<Scalars['SvbrgDecimal']['output']>;
  commodityGroupId?: Maybe<Scalars['UUID']['output']>;
  complianceFormData?: Maybe<Scalars['JSON']['output']>;
  costCenterId?: Maybe<Scalars['UUID']['output']>;
  currency?: Maybe<Currency>;
  deliveryLocationId?: Maybe<Scalars['UUID']['output']>;
  id: Scalars['UUID']['output'];
  lineItems: Array<SvbrgIntakeRequestLineItem>;
  organizationId?: Maybe<Scalars['UUID']['output']>;
};

export type SvbrgIntakeRequestComplexInput = {
  accountingAreaId?: InputMaybe<Scalars['UUID']['input']>;
  budget?: InputMaybe<Scalars['SvbrgDecimal']['input']>;
  chatSessionId: Scalars['UUID']['input'];
  commodityGroupId?: InputMaybe<Scalars['UUID']['input']>;
  costCenterId?: InputMaybe<Scalars['UUID']['input']>;
  currency?: InputMaybe<Currency>;
  deliveryLocationId?: InputMaybe<Scalars['UUID']['input']>;
  lineItems: Array<SvbrgIntakeRequestLineItemInput>;
  organizationId?: InputMaybe<Scalars['UUID']['input']>;
  summary?: InputMaybe<SvbrgSummaryInput>;
};

export type SvbrgIntakeRequestInput = {
  accountingAreaId?: InputMaybe<Scalars['UUID']['input']>;
  budget?: InputMaybe<Scalars['SvbrgDecimal']['input']>;
  chatSessionId: Scalars['UUID']['input'];
  commodityGroupId?: InputMaybe<Scalars['UUID']['input']>;
  costCenterId?: InputMaybe<Scalars['UUID']['input']>;
  currency?: InputMaybe<Currency>;
  deliveryLocationId?: InputMaybe<Scalars['UUID']['input']>;
  organizationId?: InputMaybe<Scalars['UUID']['input']>;
};

export type SvbrgIntakeRequestLineItem = {
  __typename?: 'SvbrgIntakeRequestLineItem';
  commodityGroupId?: Maybe<Scalars['UUID']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  earlyDeliveryAt?: Maybe<Scalars['DateTime']['output']>;
  expectedPricePerUnit?: Maybe<Scalars['SvbrgDecimal']['output']>;
  id: Scalars['UUID']['output'];
  lateDeliveryAt?: Maybe<Scalars['DateTime']['output']>;
  position: Scalars['String']['output'];
  quantity?: Maybe<Scalars['SvbrgDecimal']['output']>;
  sequence: Scalars['Int']['output'];
  title?: Maybe<Scalars['String']['output']>;
  unitId?: Maybe<Scalars['UUID']['output']>;
};

export type SvbrgIntakeRequestLineItemInput = {
  commodityGroupId?: InputMaybe<Scalars['UUID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  earlyDeliveryAt?: InputMaybe<Scalars['DateTime']['input']>;
  expectedPricePerUnit?: InputMaybe<Scalars['SvbrgDecimal']['input']>;
  id: Scalars['UUID']['input'];
  lateDeliveryAt?: InputMaybe<Scalars['DateTime']['input']>;
  position: Scalars['String']['input'];
  quantity: Scalars['SvbrgDecimal']['input'];
  sequence: Scalars['Int']['input'];
  title: Scalars['String']['input'];
  unitId: Scalars['UUID']['input'];
};

export type SvbrgIntakeRequestLineItemNextInput = {
  chatSessionId: Scalars['UUID']['input'];
  lineItems: Array<SvbrgIntakeRequestLineItemInput>;
};

export type SvbrgIntakeRequestReleaseInput = {
  chatSessionId: Scalars['UUID']['input'];
};

export type SvbrgIntakeRequestSupplier = {
  __typename?: 'SvbrgIntakeRequestSupplier';
  contact: SvbrgIntakeRequestSupplierContact;
  id: Scalars['UUID']['output'];
  internalId: Scalars['UUID']['output'];
  isQuoted: Scalars['Boolean']['output'];
  location: SvbrgIntakeRequestSupplierLocation;
  reason?: Maybe<Scalars['String']['output']>;
  source?: Maybe<SvbrgIntakeSupplierSource>;
};

export type SvbrgIntakeRequestSupplierAddContactInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  internalId?: InputMaybe<Scalars['UUID']['input']>;
  language: SvbrgLanguage;
  lastName: Scalars['String']['input'];
  mobile?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type SvbrgIntakeRequestSupplierAddInput = {
  chatSessionId: Scalars['UUID']['input'];
  contact?: InputMaybe<SvbrgIntakeRequestSupplierAddContactInput>;
  internalId: Scalars['UUID']['input'];
  isQuoted: Scalars['Boolean']['input'];
  location?: InputMaybe<SvbrgIntakeRequestSupplierAddLocationInput>;
};

export type SvbrgIntakeRequestSupplierAddLocationInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<CountryCode>;
  internalId?: InputMaybe<Scalars['UUID']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
};

export type SvbrgIntakeRequestSupplierContact = {
  __typename?: 'SvbrgIntakeRequestSupplierContact';
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  internalId?: Maybe<Scalars['UUID']['output']>;
  language?: Maybe<SvbrgLanguage>;
  lastName?: Maybe<Scalars['String']['output']>;
  mobile?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type SvbrgIntakeRequestSupplierDeleteInput = {
  id: Scalars['UUID']['input'];
};

export type SvbrgIntakeRequestSupplierInput = {
  contact: SvbrgIntakeRequestSupplierAddContactInput;
  internalId: Scalars['UUID']['input'];
  isQuoted: Scalars['Boolean']['input'];
  location: SvbrgIntakeRequestSupplierAddLocationInput;
  reason?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<SvbrgIntakeSupplierSource>;
};

export type SvbrgIntakeRequestSupplierLocation = {
  __typename?: 'SvbrgIntakeRequestSupplierLocation';
  address?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<CountryCode>;
  internalId?: Maybe<Scalars['UUID']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
};

export type SvbrgIntakeRequestSupplierNext = {
  chatSessionId: Scalars['UUID']['input'];
  suppliers: Array<SvbrgIntakeRequestSupplierInput>;
};

export enum SvbrgIntakeStatus {
  BLOCKED = 'BLOCKED',
  CANCELLED = 'CANCELLED',
  COMPLETED = 'COMPLETED',
  DRAFT = 'DRAFT',
  IN_PROGRESS = 'IN_PROGRESS',
  RELEASED = 'RELEASED'
}

export type SvbrgIntakeSubmitComplianceFormDataInput = {
  chatSessionId: Scalars['UUID']['input'];
  complianceFormData: Scalars['JSON']['input'];
};

export enum SvbrgIntakeSupplierSource {
  EXTERNAL = 'EXTERNAL',
  INTERNAL = 'INTERNAL',
  QUOTE = 'QUOTE',
  WEB_SEARCH = 'WEB_SEARCH'
}

export type SvbrgJobStructureRequest = {
  __typename?: 'SvbrgJobStructureRequest';
  completedAt?: Maybe<Scalars['Date']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['UUID']['output'];
  status: SvbrgBackgroundJobStatus;
};

export enum SvbrgLanguage {
  AA = 'AA',
  AB = 'AB',
  AE = 'AE',
  AF = 'AF',
  AK = 'AK',
  AM = 'AM',
  AN = 'AN',
  AR = 'AR',
  AS = 'AS',
  AV = 'AV',
  AY = 'AY',
  AZ = 'AZ',
  BA = 'BA',
  BE = 'BE',
  BG = 'BG',
  BI = 'BI',
  BM = 'BM',
  BN = 'BN',
  BO = 'BO',
  BR = 'BR',
  BS = 'BS',
  CA = 'CA',
  CE = 'CE',
  CH = 'CH',
  CO = 'CO',
  CR = 'CR',
  CS = 'CS',
  CU = 'CU',
  CV = 'CV',
  CY = 'CY',
  DA = 'DA',
  DE = 'DE',
  DV = 'DV',
  DZ = 'DZ',
  EE = 'EE',
  EL = 'EL',
  EN = 'EN',
  EO = 'EO',
  ES = 'ES',
  ET = 'ET',
  EU = 'EU',
  FA = 'FA',
  FF = 'FF',
  FI = 'FI',
  FJ = 'FJ',
  FO = 'FO',
  FR = 'FR',
  FY = 'FY',
  GA = 'GA',
  GD = 'GD',
  GL = 'GL',
  GN = 'GN',
  GU = 'GU',
  GV = 'GV',
  HA = 'HA',
  HE = 'HE',
  HI = 'HI',
  HO = 'HO',
  HR = 'HR',
  HT = 'HT',
  HU = 'HU',
  HY = 'HY',
  HZ = 'HZ',
  IA = 'IA',
  ID = 'ID',
  IE = 'IE',
  IG = 'IG',
  II = 'II',
  IK = 'IK',
  IO = 'IO',
  IS = 'IS',
  IT = 'IT',
  IU = 'IU',
  JA = 'JA',
  JV = 'JV',
  KA = 'KA',
  KG = 'KG',
  KI = 'KI',
  KJ = 'KJ',
  KK = 'KK',
  KL = 'KL',
  KM = 'KM',
  KN = 'KN',
  KO = 'KO',
  KR = 'KR',
  KS = 'KS',
  KU = 'KU',
  KV = 'KV',
  KW = 'KW',
  KY = 'KY',
  LA = 'LA',
  LB = 'LB',
  LG = 'LG',
  LI = 'LI',
  LN = 'LN',
  LO = 'LO',
  LT = 'LT',
  LU = 'LU',
  LV = 'LV',
  MG = 'MG',
  MH = 'MH',
  MI = 'MI',
  MK = 'MK',
  ML = 'ML',
  MN = 'MN',
  MR = 'MR',
  MS = 'MS',
  MT = 'MT',
  MY = 'MY',
  NA = 'NA',
  NB = 'NB',
  ND = 'ND',
  NE = 'NE',
  NG = 'NG',
  NL = 'NL',
  NN = 'NN',
  NO = 'NO',
  NR = 'NR',
  NV = 'NV',
  NY = 'NY',
  OC = 'OC',
  OJ = 'OJ',
  OM = 'OM',
  OR = 'OR',
  OS = 'OS',
  PA = 'PA',
  PI = 'PI',
  PL = 'PL',
  PS = 'PS',
  PT = 'PT',
  QU = 'QU',
  RM = 'RM',
  RN = 'RN',
  RO = 'RO',
  RU = 'RU',
  RW = 'RW',
  SA = 'SA',
  SC = 'SC',
  SD = 'SD',
  SE = 'SE',
  SG = 'SG',
  SH = 'SH',
  SI = 'SI',
  SK = 'SK',
  SL = 'SL',
  SM = 'SM',
  SN = 'SN',
  SO = 'SO',
  SQ = 'SQ',
  SR = 'SR',
  SS = 'SS',
  ST = 'ST',
  SU = 'SU',
  SV = 'SV',
  SW = 'SW',
  TA = 'TA',
  TE = 'TE',
  TG = 'TG',
  TH = 'TH',
  TI = 'TI',
  TK = 'TK',
  TL = 'TL',
  TN = 'TN',
  TO = 'TO',
  TR = 'TR',
  TS = 'TS',
  TT = 'TT',
  TW = 'TW',
  TY = 'TY',
  UG = 'UG',
  UK = 'UK',
  UR = 'UR',
  UZ = 'UZ',
  VE = 'VE',
  VI = 'VI',
  VO = 'VO',
  WA = 'WA',
  WO = 'WO',
  XH = 'XH',
  YI = 'YI',
  YO = 'YO',
  ZA = 'ZA',
  ZF = 'ZF',
  ZH = 'ZH'
}

export type SvbrgLineItemForCheckInput = {
  commodityGroupId?: InputMaybe<Scalars['UUID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  earlyDeliveryAt?: InputMaybe<Scalars['DateTime']['input']>;
  lateDeliveryAt?: InputMaybe<Scalars['DateTime']['input']>;
  position: Scalars['String']['input'];
  pricePerUnit?: InputMaybe<Scalars['SvbrgDecimal']['input']>;
  quantity?: InputMaybe<Scalars['SvbrgDecimal']['input']>;
  supplierId?: InputMaybe<Scalars['UUID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  unitId?: InputMaybe<Scalars['UUID']['input']>;
};

export type SvbrgMatchedDocumentChunk = {
  __typename?: 'SvbrgMatchedDocumentChunk';
  chunkId: Scalars['UUID']['output'];
  content: Scalars['String']['output'];
  documentId: Scalars['UUID']['output'];
  similarity: Scalars['Float']['output'];
};

export type SvbrgMaterial = {
  __typename?: 'SvbrgMaterial';
  commodityGroupId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  displayCode?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  sapMaterialNumber?: Maybe<Scalars['String']['output']>;
  sapSourceSystem?: Maybe<Scalars['String']['output']>;
  unitId: Scalars['String']['output'];
};

export type SvbrgMaterialQueryGroup = {
  __typename?: 'SvbrgMaterialQueryGroup';
  foundCount: Scalars['Int']['output'];
  items: Array<SvbrgMaterial>;
  query: Scalars['String']['output'];
};

export type SvbrgOrderByInput = {
  direction?: InputMaybe<SvbrgSortDirection>;
  entityField: Scalars['String']['input'];
  entityName: Scalars['String']['input'];
};

export type SvbrgPolicyCompliancePart = {
  __typename?: 'SvbrgPolicyCompliancePart';
  details: Scalars['String']['output'];
  section?: Maybe<Scalars['String']['output']>;
  sourceFileName?: Maybe<Scalars['String']['output']>;
  status: SvbrgComplianceStatus;
};

export enum SvbrgPolicyVerificationType {
  contract = 'contract',
  quote = 'quote',
  terms = 'terms'
}

export type SvbrgPriceFilter = {
  lowerBound?: InputMaybe<Scalars['Float']['input']>;
  upperBound?: InputMaybe<Scalars['Float']['input']>;
};

export type SvbrgProcurementKnowledgeSource = {
  __typename?: 'SvbrgProcurementKnowledgeSource';
  document: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  score: Scalars['Float']['output'];
  vector: Array<Scalars['Float']['output']>;
};

export type SvbrgPurchaseRequisition = {
  __typename?: 'SvbrgPurchaseRequisition';
  createdAtTimestamp?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  sourceReference?: Maybe<Scalars['String']['output']>;
  sourceSystem?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
};

export type SvbrgPurchaseRequisitionGroup = {
  __typename?: 'SvbrgPurchaseRequisitionGroup';
  createdAtTimestamp?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  items: Array<SvbrgPurchaseRequisitionItem>;
  sourceReference?: Maybe<Scalars['String']['output']>;
  sourceSystem?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
};

export type SvbrgPurchaseRequisitionItem = {
  __typename?: 'SvbrgPurchaseRequisitionItem';
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  parent?: Maybe<SvbrgPurchaseRequisition>;
  pricePerUnitFloat?: Maybe<Scalars['Float']['output']>;
  quantityFloat?: Maybe<Scalars['Float']['output']>;
  supplierId?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  valueFloat?: Maybe<Scalars['Float']['output']>;
};

export type SvbrgQuickActionTranslation = {
  __typename?: 'SvbrgQuickActionTranslation';
  id: Scalars['ID']['output'];
  language: SvbrgLanguage;
  text: Scalars['String']['output'];
  variant: SvbrgQuickActionTranslationVariant;
};

export enum SvbrgQuickActionTranslationVariant {
  HELP_TEXT = 'HELP_TEXT',
  TITLE = 'TITLE'
}

export type SvbrgQuickActionTranslationsInput = {
  language: SvbrgLanguage;
  text: Scalars['String']['input'];
  variant: SvbrgQuickActionTranslationVariant;
};

export type SvbrgQuickActions = {
  __typename?: 'SvbrgQuickActions';
  id: Scalars['UUID']['output'];
  isConversationStarter: Scalars['Boolean']['output'];
  prompt: Scalars['String']['output'];
  translations: Array<SvbrgQuickActionTranslation>;
};

export type SvbrgQuote = {
  __typename?: 'SvbrgQuote';
  analysis: SvbrgQuoteAnalysis;
  currency: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  lineItems: Array<SvbrgQuoteLineItem>;
  quoteReference?: Maybe<Scalars['String']['output']>;
  quotedValue: Scalars['SvbrgDecimal']['output'];
};


export type SvbrgQuoteanalysisArgs = {
  id: Scalars['UUID']['input'];
};

export type SvbrgQuoteAnalysis = {
  __typename?: 'SvbrgQuoteAnalysis';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  fileId: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  quote?: Maybe<SvbrgQuote>;
  quoteId?: Maybe<Scalars['UUID']['output']>;
  status: SvbrgBackgroundJobStatus;
};

export type SvbrgQuoteAnalysisInput = {
  chatSessionId?: InputMaybe<Scalars['UUID']['input']>;
  fileId: Scalars['UUID']['input'];
  fileName: Scalars['String']['input'];
};

export type SvbrgQuoteAnalysisMutations = {
  __typename?: 'SvbrgQuoteAnalysisMutations';
  analyse: SvbrgQuoteAnalysis;
  next: SvbrgQuote;
  skip?: Maybe<Scalars['Void']['output']>;
};


export type SvbrgQuoteAnalysisMutationsanalyseArgs = {
  data: SvbrgQuoteAnalysisInput;
};


export type SvbrgQuoteAnalysisMutationsnextArgs = {
  data: SvbrgQuoteDraftInput;
};


export type SvbrgQuoteAnalysisMutationsskipArgs = {
  data: SvbrgChatSessionInput;
};

export type SvbrgQuoteComparatorInput = {
  fileIds: Array<Scalars['String']['input']>;
};

export type SvbrgQuoteComparatorLineItemGroup = {
  __typename?: 'SvbrgQuoteComparatorLineItemGroup';
  lineItemGroup: Scalars['String']['output'];
  lineItems: Array<Scalars['String']['output']>;
};

export type SvbrgQuoteComparatorOutput = {
  __typename?: 'SvbrgQuoteComparatorOutput';
  bestOption: Scalars['String']['output'];
  lineItemGroups: Array<SvbrgQuoteComparatorLineItemGroup>;
  quotes: Array<SvbrgQuoteWithMetadata>;
  rationale: Scalars['String']['output'];
};

export type SvbrgQuoteComplianceCheck = {
  __typename?: 'SvbrgQuoteComplianceCheck';
  chatSessionId: Scalars['UUID']['output'];
  complianceData?: Maybe<SvbrgCheckAgainstPoliciesOutput>;
  id: Scalars['UUID']['output'];
  quoteId: Scalars['UUID']['output'];
  score: SvbrgRiskScore;
  userComment?: Maybe<Scalars['String']['output']>;
  userReason?: Maybe<SvbrgRiskResolutionReason>;
};

export type SvbrgQuoteComplianceCheckMutations = {
  __typename?: 'SvbrgQuoteComplianceCheckMutations';
  next: SvbrgQuoteComplianceCheck;
};


export type SvbrgQuoteComplianceCheckMutationsnextArgs = {
  data: SvbrgQuoteComplianceNextInput;
};

export type SvbrgQuoteComplianceCheckUpsertInput = {
  chatSessionId: Scalars['UUID']['input'];
  fileId: Scalars['String']['input'];
  quoteId: Scalars['UUID']['input'];
  userResolution?: InputMaybe<SvbrgQuoteComplianceCheckUserResolution>;
};

export type SvbrgQuoteComplianceCheckUserResolution = {
  comment?: InputMaybe<Scalars['String']['input']>;
  reason: SvbrgRiskResolutionReason;
};

export type SvbrgQuoteComplianceNextInput = {
  chatSessionId: Scalars['UUID']['input'];
  language?: InputMaybe<SvbrgLanguage>;
};

export type SvbrgQuoteConverterInput = {
  fileId: Scalars['String']['input'];
};

export type SvbrgQuoteConverterLineItem = {
  __typename?: 'SvbrgQuoteConverterLineItem';
  name: Scalars['String']['output'];
  quantity: Scalars['Float']['output'];
  totalPrice: Scalars['Float']['output'];
  unit: Scalars['String']['output'];
  unitPrice: Scalars['Float']['output'];
};

export type SvbrgQuoteConverterOutput = {
  __typename?: 'SvbrgQuoteConverterOutput';
  date: Scalars['String']['output'];
  lineItems: Array<SvbrgQuoteConverterLineItem>;
  supplier: Scalars['String']['output'];
  terms: Array<SvbrgQuoteConverterTerms>;
  totalPrice: Scalars['Float']['output'];
};

export type SvbrgQuoteConverterTerms = {
  __typename?: 'SvbrgQuoteConverterTerms';
  type: SvbrgQuoteTermsType;
  value: Scalars['String']['output'];
};

export type SvbrgQuoteDraftInput = {
  chatSessionId: Scalars['UUID']['input'];
  id: Scalars['UUID']['input'];
  lineItems: Array<SvbrgQuoteLineItemDraftInput>;
  quoteReference?: InputMaybe<Scalars['String']['input']>;
  supplierId?: InputMaybe<Scalars['UUID']['input']>;
};

export type SvbrgQuoteLineItem = {
  __typename?: 'SvbrgQuoteLineItem';
  commodityGroupId?: Maybe<Scalars['UUID']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  earlyDeliveryAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  lateDeliveryAt?: Maybe<Scalars['DateTime']['output']>;
  position: Scalars['String']['output'];
  pricePerUnit?: Maybe<Scalars['SvbrgDecimal']['output']>;
  quantity?: Maybe<Scalars['SvbrgDecimal']['output']>;
  sequence: Scalars['Int']['output'];
  title?: Maybe<Scalars['String']['output']>;
  unitId?: Maybe<Scalars['UUID']['output']>;
};

export type SvbrgQuoteLineItemDraftInput = {
  commodityGroupId?: InputMaybe<Scalars['UUID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  earlyDeliveryAt?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['UUID']['input'];
  lateDeliveryAt?: InputMaybe<Scalars['DateTime']['input']>;
  position: Scalars['String']['input'];
  pricePerUnit?: InputMaybe<Scalars['SvbrgDecimal']['input']>;
  quantity?: InputMaybe<Scalars['SvbrgDecimal']['input']>;
  sequence: Scalars['Int']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  unitId?: InputMaybe<Scalars['UUID']['input']>;
};

export enum SvbrgQuoteTermsType {
  DELIVERY_TIME = 'DELIVERY_TIME',
  LIABILITY = 'LIABILITY',
  OTHERS = 'OTHERS',
  PAYMENT_TERMS = 'PAYMENT_TERMS',
  REFUND_POLICY = 'REFUND_POLICY'
}

export type SvbrgQuoteWithMetadata = {
  __typename?: 'SvbrgQuoteWithMetadata';
  fileId: Scalars['ID']['output'];
  fileName: Scalars['String']['output'];
  policyCheck: SvbrgCheckAgainstPoliciesOutput;
  quote: SvbrgQuoteConverterOutput;
};

export type SvbrgReadDemandInformationInput = {
  /** filter by the demand id */
  demandId?: InputMaybe<Scalars['String']['input']>;
  /** title/description query for demand request items */
  query?: InputMaybe<Scalars['String']['input']>;
};

export type SvbrgReadDemandInformationOutput = {
  __typename?: 'SvbrgReadDemandInformationOutput';
  demand?: Maybe<SvbrgDemand>;
  error?: Maybe<Scalars['String']['output']>;
};

export type SvbrgRequestBudgetInput = {
  budget?: InputMaybe<Scalars['SvbrgDecimal']['input']>;
  chatSessionId: Scalars['UUID']['input'];
};

export type SvbrgRequestDescription = {
  __typename?: 'SvbrgRequestDescription';
  id: Scalars['UUID']['output'];
  language: SvbrgLanguage;
  text: Scalars['String']['output'];
};

export type SvbrgRequestDescriptionInput = {
  chatSessionId: Scalars['UUID']['input'];
  language: SvbrgLanguage;
  text: Scalars['String']['input'];
};

export type SvbrgRequestDescriptionMutations = {
  __typename?: 'SvbrgRequestDescriptionMutations';
  createInChat: SvbrgRequestDescription;
  generate: SvbrgRequestDescription;
  next: SvbrgRequestDescription;
};


export type SvbrgRequestDescriptionMutationscreateInChatArgs = {
  data: SvbrgRequestDescriptionInput;
};


export type SvbrgRequestDescriptionMutationsgenerateArgs = {
  data: SvbrgRequestDescriptionInput;
};


export type SvbrgRequestDescriptionMutationsnextArgs = {
  data: SvbrgRequestDescriptionInput;
};

export type SvbrgRequestDetailsMutations = {
  __typename?: 'SvbrgRequestDetailsMutations';
  release?: Maybe<Scalars['Void']['output']>;
  requestNext: SvbrgIntakeRequest;
  requestNextComplex: SvbrgIntakeRequest;
  requestNextLineItems: SvbrgIntakeRequest;
  resubmit?: Maybe<Scalars['Void']['output']>;
  submitComplianceFormData: SvbrgIntakeRequest;
};


export type SvbrgRequestDetailsMutationsreleaseArgs = {
  data: SvbrgIntakeRequestReleaseInput;
};


export type SvbrgRequestDetailsMutationsrequestNextArgs = {
  data: SvbrgIntakeRequestInput;
};


export type SvbrgRequestDetailsMutationsrequestNextComplexArgs = {
  data: SvbrgIntakeRequestComplexInput;
};


export type SvbrgRequestDetailsMutationsrequestNextLineItemsArgs = {
  data: SvbrgIntakeRequestLineItemNextInput;
};


export type SvbrgRequestDetailsMutationsresubmitArgs = {
  data: SvbrgIntakeRequestReleaseInput;
};


export type SvbrgRequestDetailsMutationssubmitComplianceFormDataArgs = {
  chatSessionId: Scalars['UUID']['input'];
  complianceFormData: Scalars['JSON']['input'];
};

export type SvbrgRequirementsExtraction = {
  __typename?: 'SvbrgRequirementsExtraction';
  chatSessionId: Scalars['UUID']['output'];
  createdAt: Scalars['DateTime']['output'];
  enhancedData?: Maybe<Scalars['JSON']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  extractedData?: Maybe<Scalars['JSON']['output']>;
  fileIds?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['UUID']['output'];
  processingStatus: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type SvbrgRequirementsExtractionMutations = {
  __typename?: 'SvbrgRequirementsExtractionMutations';
  next?: Maybe<SvbrgRequirementsExtraction>;
  skip: SvbrgRequirementsExtraction;
  uploadDcoument: SvbrgRequirementsExtraction;
};


export type SvbrgRequirementsExtractionMutationsnextArgs = {
  data: SvbrgRequirementsExtractionNextInput;
};


export type SvbrgRequirementsExtractionMutationsskipArgs = {
  data: SvbrgRequirementsExtractionSkipInput;
};


export type SvbrgRequirementsExtractionMutationsuploadDcoumentArgs = {
  data: SvbrgRequirementsExtractionUpsertInput;
};

export type SvbrgRequirementsExtractionNextInput = {
  chatSessionId: Scalars['UUID']['input'];
};

export type SvbrgRequirementsExtractionSkipInput = {
  chatSessionId: Scalars['UUID']['input'];
};

export type SvbrgRequirementsExtractionUpsertInput = {
  chatSessionId: Scalars['UUID']['input'];
  fileIds: Array<Scalars['String']['input']>;
};

export enum SvbrgRiskResolutionReason {
  OTHER = 'OTHER',
  SYSTEM_MISTAKE = 'SYSTEM_MISTAKE',
  URGENCY = 'URGENCY'
}

export enum SvbrgRiskScore {
  HIGH = 'HIGH',
  LOW = 'LOW',
  MEDIUM = 'MEDIUM',
  UNKNOWN = 'UNKNOWN'
}

export enum SvbrgRiskSeverity {
  HIGH = 'HIGH',
  LOW = 'LOW',
  MEDIUM = 'MEDIUM'
}

export type SvbrgSearchCatalogueInput = {
  dynamicFacetFilters?: InputMaybe<Array<SvbrgDynamicFacetFilter>>;
  manufacturerFilter?: InputMaybe<SvbrgFacetFilter>;
  priceFilter?: InputMaybe<SvbrgPriceFilter>;
  query: Scalars['String']['input'];
  sortDirection?: InputMaybe<Scalars['String']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
};

export type SvbrgSearchCatalogueOutput = {
  __typename?: 'SvbrgSearchCatalogueOutput';
  error?: Maybe<Scalars['String']['output']>;
  filters: Array<SvbrgCatalogueFilter>;
  items: Array<SvbrgCatalogueItem>;
  searchUrl: Scalars['String']['output'];
  total: Scalars['Int']['output'];
};

export type SvbrgSearchCommodityGroupInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query: Array<Scalars['String']['input']>;
};

export type SvbrgSearchCommodityGroupOutput = {
  __typename?: 'SvbrgSearchCommodityGroupOutput';
  error?: Maybe<Scalars['String']['output']>;
  groupedItems: Array<SvbrgCommodityGroupQueryGroup>;
  message?: Maybe<Scalars['String']['output']>;
  status: SvbrgSearchCommodityGroupStatus;
};

export enum SvbrgSearchCommodityGroupStatus {
  no_sap_access = 'no_sap_access',
  ok = 'ok'
}

export type SvbrgSearchContractItemFilters = {
  supplierId?: InputMaybe<Scalars['String']['input']>;
};

export type SvbrgSearchContractItemInput = {
  filters?: InputMaybe<SvbrgSearchContractItemFilters>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  query: Scalars['String']['input'];
  searchMode?: InputMaybe<SvbrgSearchModes>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
};

export type SvbrgSearchContractItemOutput = {
  __typename?: 'SvbrgSearchContractItemOutput';
  error?: Maybe<Scalars['String']['output']>;
  groupedItems: Array<SvbrgContractItemGroup>;
};

export type SvbrgSearchMaterialInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query: Array<Scalars['String']['input']>;
};

export type SvbrgSearchMaterialOutput = {
  __typename?: 'SvbrgSearchMaterialOutput';
  error?: Maybe<Scalars['String']['output']>;
  groupedItems: Array<SvbrgMaterialQueryGroup>;
  message?: Maybe<Scalars['String']['output']>;
  status: SvbrgSearchMaterialStatus;
};

export enum SvbrgSearchMaterialStatus {
  no_sap_access = 'no_sap_access',
  ok = 'ok'
}

export enum SvbrgSearchModes {
  keyword = 'keyword',
  semantic = 'semantic'
}

export type SvbrgSearchProcurementKnowledgeInput = {
  queryText: Scalars['String']['input'];
  topK?: Scalars['Int']['input'];
};

export type SvbrgSearchProcurementKnowledgeOutput = {
  __typename?: 'SvbrgSearchProcurementKnowledgeOutput';
  allSources: Array<SvbrgProcurementKnowledgeSource>;
};

export type SvbrgSearchPurchaseOrder = {
  __typename?: 'SvbrgSearchPurchaseOrder';
  id: Scalars['ID']['output'];
  sourceReference?: Maybe<Scalars['String']['output']>;
  sourceSystem?: Maybe<Scalars['String']['output']>;
  supplierId: Scalars['String']['output'];
};

export type SvbrgSearchPurchaseOrderFilters = {
  commodityGroupIds?: InputMaybe<Array<Scalars['String']['input']>>;
  lastThreeMonthsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  sourceReference?: InputMaybe<Scalars['String']['input']>;
  supplierIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SvbrgSearchPurchaseOrderHeader = {
  __typename?: 'SvbrgSearchPurchaseOrderHeader';
  currency?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lineItemCount: Scalars['Int']['output'];
  orderedAt: Scalars['DateTime']['output'];
  orderedAtTimestamp: Scalars['Float']['output'];
  purchaseOrderReference: Scalars['String']['output'];
  supplierId: Scalars['String']['output'];
  supplierName?: Maybe<Scalars['String']['output']>;
  totalValue: Scalars['Float']['output'];
};

export type SvbrgSearchPurchaseOrderInput = {
  filters?: InputMaybe<SvbrgSearchPurchaseOrderFilters>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
};

export type SvbrgSearchPurchaseOrderItem = {
  __typename?: 'SvbrgSearchPurchaseOrderItem';
  commodityGroupId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdAtTimestamp: Scalars['Float']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  parent: SvbrgSearchPurchaseOrder;
  pricePerUnitFloat?: Maybe<Scalars['Float']['output']>;
  quantityFloat?: Maybe<Scalars['Float']['output']>;
  semanticContent?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  valueFloat: Scalars['Float']['output'];
};

export type SvbrgSearchPurchaseOrderItemFilters = {
  commodityGroupIds?: InputMaybe<Array<Scalars['String']['input']>>;
  lastThreeMonthsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  supplierIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SvbrgSearchPurchaseOrderItemInput = {
  filters?: InputMaybe<SvbrgSearchPurchaseOrderItemFilters>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  searchMode?: InputMaybe<SvbrgSearchModes>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
};

export type SvbrgSearchPurchaseOrderItemOutput = {
  __typename?: 'SvbrgSearchPurchaseOrderItemOutput';
  error?: Maybe<Scalars['String']['output']>;
  items: Array<SvbrgSearchPurchaseOrderItem>;
};

export type SvbrgSearchPurchaseOrderOutput = {
  __typename?: 'SvbrgSearchPurchaseOrderOutput';
  error?: Maybe<Scalars['String']['output']>;
  orders: Array<SvbrgSearchPurchaseOrderHeader>;
};

export type SvbrgSearchPurchaseRequisitionItemFilters = {
  purchaseRequisitionId?: InputMaybe<Scalars['String']['input']>;
};

export type SvbrgSearchPurchaseRequisitionItemInput = {
  filters?: InputMaybe<SvbrgSearchPurchaseRequisitionItemFilters>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
};

export type SvbrgSearchPurchaseRequisitionItemOutput = {
  __typename?: 'SvbrgSearchPurchaseRequisitionItemOutput';
  error?: Maybe<Scalars['String']['output']>;
  found?: Maybe<Scalars['Int']['output']>;
  purchaseRequisitions: Array<SvbrgPurchaseRequisitionGroup>;
};

export type SvbrgSearchSourcingProjectLotItemFilters = {
  lastThreeMonthsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  supplierIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SvbrgSearchSourcingProjectLotItemInput = {
  filters?: InputMaybe<SvbrgSearchSourcingProjectLotItemFilters>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  query: Scalars['String']['input'];
  searchMode?: InputMaybe<SvbrgSearchModes>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
};

export type SvbrgSearchSourcingProjectLotItemOutput = {
  __typename?: 'SvbrgSearchSourcingProjectLotItemOutput';
  error?: Maybe<Scalars['String']['output']>;
  items: Array<SvbrgSourcingProjectLotItem>;
};

export type SvbrgSearchSupplierInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  supplierIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SvbrgSearchSupplierOutput = {
  __typename?: 'SvbrgSearchSupplierOutput';
  error?: Maybe<Scalars['String']['output']>;
  suppliers: Array<SvbrgSupplier>;
};

export enum SvbrgSortDirection {
  asc = 'asc',
  desc = 'desc'
}

export type SvbrgSourceReference = {
  __typename?: 'SvbrgSourceReference';
  isPrimary: Scalars['Boolean']['output'];
  sourceReference: Scalars['String']['output'];
  sourceSystem: Scalars['String']['output'];
};

export type SvbrgSourcerPurchaseRequisitionInput = {
  /** Maximum number of suppliers to return, defaults to 15 */
  limit?: InputMaybe<Scalars['Int']['input']>;
  searchQuery: Scalars['String']['input'];
};

export type SvbrgSourcerPurchaseRequisitionOutput = {
  __typename?: 'SvbrgSourcerPurchaseRequisitionOutput';
  filterSummary?: Maybe<Scalars['String']['output']>;
  response: Scalars['String']['output'];
  suppliersByContracts: Array<SvbrgSupplierFindings>;
  suppliersByPurchaseOrders: Array<SvbrgSupplierFindings>;
  suppliersBySourcingProjects: Array<SvbrgSupplierFindings>;
};

export type SvbrgSourcingProject = {
  __typename?: 'SvbrgSourcingProject';
  createdAtTimestamp?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  status?: Maybe<Scalars['String']['output']>;
  supplierIds?: Maybe<Array<Scalars['String']['output']>>;
  title: Scalars['String']['output'];
  variant?: Maybe<Scalars['String']['output']>;
};

export type SvbrgSourcingProjectLot = {
  __typename?: 'SvbrgSourcingProjectLot';
  description?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type SvbrgSourcingProjectLotItem = {
  __typename?: 'SvbrgSourcingProjectLotItem';
  createdAtTimestamp?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  parent?: Maybe<SvbrgSourcingProjectLot>;
  semanticContent?: Maybe<Scalars['String']['output']>;
  sourceReference?: Maybe<Scalars['String']['output']>;
  sourceSystem?: Maybe<Scalars['String']['output']>;
  sourcingProject?: Maybe<SvbrgSourcingProject>;
  title: Scalars['String']['output'];
  updatedAtTimestamp?: Maybe<Scalars['Float']['output']>;
};

export type SvbrgStatementOfWork = {
  __typename?: 'SvbrgStatementOfWork';
  chatSessionId: Scalars['UUID']['output'];
  id: Scalars['ID']['output'];
  language: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type SvbrgStatementOfWorkMutations = {
  __typename?: 'SvbrgStatementOfWorkMutations';
  next?: Maybe<Scalars['Void']['output']>;
  upsert: SvbrgStatementOfWork;
};


export type SvbrgStatementOfWorkMutationsnextArgs = {
  data: SvbrgStatementOfWorkNextInput;
};


export type SvbrgStatementOfWorkMutationsupsertArgs = {
  data: SvbrgStatementOfWorkUpsertInput;
};

export type SvbrgStatementOfWorkNextInput = {
  chatSessionId: Scalars['UUID']['input'];
};

export type SvbrgStatementOfWorkUpsertInput = {
  chatSessionId: Scalars['UUID']['input'];
  language: SvbrgLanguage;
  text: Scalars['String']['input'];
};

export type SvbrgSummaryInput = {
  language: SvbrgLanguage;
  text: Scalars['String']['input'];
};

export type SvbrgSupplier = {
  __typename?: 'SvbrgSupplier';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  sourceReferences: Array<SvbrgSourceReference>;
};

export type SvbrgSupplierFindings = {
  __typename?: 'SvbrgSupplierFindings';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  performanceSummary: Scalars['JSON']['output'];
  relationshipDetails: Scalars['JSON']['output'];
};

export type SvbrgSupplierSelectionMutations = {
  __typename?: 'SvbrgSupplierSelectionMutations';
  confirmQuotedSupplier: Array<SvbrgIntakeRequestSupplier>;
  delete: SvbrgIntakeRequestSupplier;
  next: Array<SvbrgIntakeRequestSupplier>;
};


export type SvbrgSupplierSelectionMutationsconfirmQuotedSupplierArgs = {
  data: SvbrgIntakeRequestSupplierAddInput;
};


export type SvbrgSupplierSelectionMutationsdeleteArgs = {
  id: Scalars['UUID']['input'];
};


export type SvbrgSupplierSelectionMutationsnextArgs = {
  data: SvbrgIntakeRequestSupplierNext;
};

export type SvbrgSupplierStructuredSearchInput = {
  filters?: InputMaybe<Array<SvbrgFilterInput>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SvbrgOrderByInput>>;
};

export type SvbrgSupplierStructuredSearchOutput = {
  __typename?: 'SvbrgSupplierStructuredSearchOutput';
  error?: Maybe<Scalars['String']['output']>;
  executionTime: Scalars['Int']['output'];
  radiusMetadata?: Maybe<SvbrgSupplierStructuredSearchRadiusMetadata>;
  results: Array<SvbrgCompanyResult>;
  success: Scalars['Boolean']['output'];
  totalResults: Scalars['Int']['output'];
};

export type SvbrgSupplierStructuredSearchRadiusMetadata = {
  __typename?: 'SvbrgSupplierStructuredSearchRadiusMetadata';
  centroidLatitude: Scalars['Float']['output'];
  centroidLongitude: Scalars['Float']['output'];
  city: Scalars['String']['output'];
  companiesWithCoordinates: Scalars['Int']['output'];
  country?: Maybe<Scalars['String']['output']>;
  radiusKm: Scalars['Float']['output'];
};

export type SvbrgSupplierText2CypherInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  parameters?: InputMaybe<Scalars['JSON']['input']>;
  query: Scalars['String']['input'];
  timeout?: InputMaybe<Scalars['Int']['input']>;
};

export type SvbrgSupplierText2CypherMetadata = {
  __typename?: 'SvbrgSupplierText2CypherMetadata';
  executionTime: Scalars['Int']['output'];
  query: Scalars['String']['output'];
  rowCount: Scalars['Int']['output'];
  truncated: Scalars['Boolean']['output'];
};

export type SvbrgSupplierText2CypherOutput = {
  __typename?: 'SvbrgSupplierText2CypherOutput';
  error?: Maybe<Scalars['String']['output']>;
  metadata: SvbrgSupplierText2CypherMetadata;
  results: Scalars['JSON']['output'];
};

export type SvbrgSupplierView = {
  __typename?: 'SvbrgSupplierView';
  activeContractCount: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  purchaseOrderCount12m: Scalars['Float']['output'];
  purchaseOrderValueSum12m: Scalars['Float']['output'];
};

export type SvbrgTacticalSourcing = {
  __typename?: 'SvbrgTacticalSourcing';
  isSkipped: Scalars['Boolean']['output'];
};

export type SvbrgTacticalSourcingInput = {
  chatSessionId: Scalars['UUID']['input'];
};

export type SvbrgTacticalSourcingMutations = {
  __typename?: 'SvbrgTacticalSourcingMutations';
  skip?: Maybe<Scalars['Void']['output']>;
  start?: Maybe<Scalars['Void']['output']>;
};


export type SvbrgTacticalSourcingMutationsskipArgs = {
  data: SvbrgTacticalSourcingInput;
};


export type SvbrgTacticalSourcingMutationsstartArgs = {
  data: SvbrgTacticalSourcingInput;
};

export type SvbrgThread = {
  __typename?: 'SvbrgThread';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  messages: Array<SvbrgAgentMessage>;
  metadata?: Maybe<Scalars['JSON']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type SvbrgThreadConnection = {
  __typename?: 'SvbrgThreadConnection';
  nodes: Array<SvbrgThreadItem>;
  totalCount: Scalars['BigInt']['output'];
};

export type SvbrgThreadCreateInput = {
  agentId: SvbrgAgentId;
  language: SvbrgLanguage;
  title?: InputMaybe<Scalars['String']['input']>;
};

export enum SvbrgThreadFilterField {
  createdAt = 'createdAt',
  createdBy = 'createdBy',
  demandId = 'demandId',
  id = 'id',
  sequenceNumber = 'sequenceNumber',
  status = 'status',
  summary = 'summary',
  variant = 'variant'
}

export type SvbrgThreadItem = {
  __typename?: 'SvbrgThreadItem';
  conversationSettingsEntityId?: Maybe<Scalars['UUID']['output']>;
  conversationSettingsEntityVariant?: Maybe<SvbrgConversationEntityVariant>;
  /** Creation date of the request. */
  createdAt: Scalars['DateTime']['output'];
  /** Internal ID of the creator of the request. */
  createdBy?: Maybe<Scalars['UUID']['output']>;
  /** Internal ID of the demand. */
  demandId?: Maybe<Scalars['UUID']['output']>;
  /** Internal ID of the responsible users of the demand. */
  demandResponsibleUsers?: Maybe<Array<Scalars['UUID']['output']>>;
  /** Sequence number of the demand. */
  demandSequenceNumber?: Maybe<Scalars['BigInt']['output']>;
  /** Internal ID of the thread. */
  id: Scalars['UUID']['output'];
  /** Sequence number of the request. */
  sequenceNumber: Scalars['BigInt']['output'];
  /** Status of the request. */
  status?: Maybe<SvbrgIntakeStatus>;
  summary: Scalars['String']['output'];
  variant: SvbrgChatSessionVariant;
};

export type SvbrgThreadMutations = {
  __typename?: 'SvbrgThreadMutations';
  create: SvbrgThread;
};


export type SvbrgThreadMutationscreateArgs = {
  data: SvbrgThreadCreateInput;
};

export type SvbrgThreadOrder = {
  field: SvbrgThreadOrderField;
  sort?: InputMaybe<SvbrgSortDirection>;
};

export enum SvbrgThreadOrderField {
  createdAt = 'createdAt',
  demandId = 'demandId',
  id = 'id',
  sequenceNumber = 'sequenceNumber',
  status = 'status'
}

export type SvbrgVetSuppliersInput = {
  supplierIds: Array<Scalars['String']['input']>;
};

export type SvbrgVetSuppliersOutput = {
  __typename?: 'SvbrgVetSuppliersOutput';
  suppliersResult: Array<SvbrgSupplierView>;
};

export type SvbrgWebSearchInput = {
  geographicFilter?: InputMaybe<Scalars['String']['input']>;
  searchQueries: Array<Scalars['String']['input']>;
};

export type SvbrgWebSearchOutput = {
  __typename?: 'SvbrgWebSearchOutput';
  groundingMetadata?: Maybe<Scalars['JSON']['output']>;
  sources: Array<SvbrgWebSearchSource>;
  text: Scalars['String']['output'];
};

export type SvbrgWebSearchSource = {
  __typename?: 'SvbrgWebSearchSource';
  id?: Maybe<Scalars['ID']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type TagNode = NamedNode & {
  __typename?: 'TagNode';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type TaskItem = Node & {
  __typename?: 'TaskItem';
  id: Scalars['ID']['output'];
  message?: Maybe<TaskMessage>;
  relatedResources: Array<TaskRelatedResource>;
  status: TaskStatus;
  variant: TaskVariant;
};

export type TaskItemConnection = {
  __typename?: 'TaskItemConnection';
  nodes: Array<TaskItem>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type TaskMessage = {
  __typename?: 'TaskMessage';
  details?: Maybe<Scalars['JSON']['output']>;
  variant: Scalars['String']['output'];
};

export type TaskRelatedResource = {
  __typename?: 'TaskRelatedResource';
  project: Scalars['String']['output'];
  reference: Scalars['ID']['output'];
  variant: Scalars['String']['output'];
};

export enum TaskStatus {
  DONE = 'DONE',
  OPEN = 'OPEN'
}

export type TaskStatusFilterInput = {
  _eq?: InputMaybe<TaskStatus>;
};

export enum TaskVariant {
  ISSUE = 'ISSUE',
  TODO = 'TODO'
}

export type TaskVariantFilterInput = {
  _eq?: InputMaybe<TaskVariant>;
};

export type TasksFilterInput = {
  messageType?: InputMaybe<StringFilterInput>;
  relatedResourcesProject?: InputMaybe<StringFilterInput>;
  relatedResourcesReference?: InputMaybe<IDFilterInput>;
  relatedResourcesVariant?: InputMaybe<StringFilterInput>;
  status?: InputMaybe<TaskStatusFilterInput>;
  variant?: InputMaybe<TaskVariantFilterInput>;
};

export type TimeReferenceValue = {
  __typename?: 'TimeReferenceValue';
  changeRate: Scalars['Float']['output'];
  current: Scalars['Time']['output'];
  date?: Maybe<Scalars['DateTime']['output']>;
  reference: Scalars['Time']['output'];
  status?: Maybe<Status>;
};

export enum TlscpEntityVariant {
  CONTRACT_DEMAND = 'CONTRACT_DEMAND',
  DEMAND = 'DEMAND',
  FLOW = 'FLOW',
  NEGOTIATION_CASE = 'NEGOTIATION_CASE',
  PURCHASE_REQUISITION = 'PURCHASE_REQUISITION',
  RECOMMENDATION = 'RECOMMENDATION',
  SAVING = 'SAVING',
  SOURCING_CASE = 'SOURCING_CASE'
}

export type TlscpLogEntry = {
  __typename?: 'TlscpLogEntry';
  actorId?: Maybe<Scalars['UUID']['output']>;
  actorVariant: Scalars['String']['output'];
  context: Scalars['JSON']['output'];
  createdAt: Scalars['DateTime']['output'];
  entityId: Scalars['UUID']['output'];
  entityVariant: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  parentId?: Maybe<Scalars['UUID']['output']>;
  parentVariant?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  template: Scalars['String']['output'];
};

export type TlscpLogEntryConnection = {
  __typename?: 'TlscpLogEntryConnection';
  nodes: Array<TlscpLogEntry>;
  totalCount: Scalars['BigInt']['output'];
};

export enum TlscpSortOrder {
  asc = 'asc',
  desc = 'desc'
}

/** Translation request payload for scope IDs. */
export type TranslationRequest_Input = {
  keys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** Autocomplete and metadata node payload. */
export type TreeNode = {
  __typename?: 'TreeNode';
  entity: TreeNodeEntity;
  key: Scalars['String']['output'];
  language: Language;
  value: Scalars['String']['output'];
};

/** Tree-specific metadata for a node. */
export type TreeNodeEntity = {
  __typename?: 'TreeNodeEntity';
  childrenCount?: Maybe<Scalars['Int']['output']>;
  parent?: Maybe<Scalars['String']['output']>;
  path?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

/** Ordered tree node response. */
export type TreeNodesResponse = {
  __typename?: 'TreeNodesResponse';
  nodes: Array<Maybe<TreeNode>>;
};

export type TsrctAttachment = {
  __typename?: 'TsrctAttachment';
  classification?: Maybe<TsrctAttachmentClassification>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  parent: TsrctAttachmentParentObjectRef;
  updatedAt: Scalars['DateTime']['output'];
  uploadedBy: TsrctAttachmentUploadedByObjectRef;
  visibilities: Array<TsrctAttachmentParentObjectRef>;
};

export enum TsrctAttachmentClassification {
  ATTACHMENT = 'ATTACHMENT',
  CONTRACT = 'CONTRACT',
  INVOICE = 'INVOICE',
  ORDER_CONFIRMATION = 'ORDER_CONFIRMATION',
  OTHER = 'OTHER',
  PROFILE_PICTURE = 'PROFILE_PICTURE',
  PURCHASE_ORDER = 'PURCHASE_ORDER',
  QUOTE = 'QUOTE',
  STATEMENT_OF_WORK = 'STATEMENT_OF_WORK',
  TECHNICAL_SCHEMATICS = 'TECHNICAL_SCHEMATICS'
}

export type TsrctAttachmentFilterInput = {
  uploadedByVariants?: InputMaybe<Array<TsrctUploadedByVariant>>;
};

export enum TsrctAttachmentMutationAction {
  DELETE = 'DELETE',
  NEW = 'NEW',
  NOOP = 'NOOP',
  UPDATE = 'UPDATE'
}

export type TsrctAttachmentMutationInput = {
  attachments: Array<TsrctAttachmentMutationItemInput>;
  parent: TsrctAttachmentMutationParentInput;
};

export type TsrctAttachmentMutationItemInput = {
  action: TsrctAttachmentMutationAction;
  classification?: InputMaybe<TsrctAttachmentClassification>;
  fileId: Scalars['UUID']['input'];
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TsrctAttachmentMutationParentInput = {
  id: Scalars['UUID']['input'];
  variant: TsrctAttachmentParentVariant;
};

export type TsrctAttachmentMutationPayload = {
  __typename?: 'TsrctAttachmentMutationPayload';
  attachments: Array<TsrctAttachment>;
  parent: TsrctAttachmentParentObjectRef;
};

export type TsrctAttachmentMutations = {
  __typename?: 'TsrctAttachmentMutations';
  update: TsrctAttachmentMutationPayload;
};


export type TsrctAttachmentMutationsupdateArgs = {
  data: TsrctAttachmentMutationInput;
};

export type TsrctAttachmentParentInput = {
  id: Scalars['UUID']['input'];
  variant: TsrctAttachmentParentVariant;
};

export type TsrctAttachmentParentObjectRef = {
  __typename?: 'TsrctAttachmentParentObjectRef';
  id: Scalars['UUID']['output'];
  variant: TsrctAttachmentParentVariant;
};

export enum TsrctAttachmentParentVariant {
  CONTRACT_DEMAND = 'CONTRACT_DEMAND',
  DEMAND = 'DEMAND',
  NEGOTIATION_CASE = 'NEGOTIATION_CASE',
  SOURCING_CASE = 'SOURCING_CASE'
}

export type TsrctAttachmentUploadedByObjectRef = {
  __typename?: 'TsrctAttachmentUploadedByObjectRef';
  variant: TsrctUploadedByVariant;
};

export type TsrctAutoAcceptHoliday = {
  __typename?: 'TsrctAutoAcceptHoliday';
  country: Scalars['String']['output'];
  state?: Maybe<Scalars['String']['output']>;
};

export type TsrctAutoAcceptHolidayInput = {
  country: Scalars['String']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
};

export enum TsrctAutoAcceptTimingSource {
  OVERRIDE = 'OVERRIDE',
  RULE = 'RULE'
}

export enum TsrctAutoAcceptTimingVariant {
  NEGOTIATION_CASE = 'NEGOTIATION_CASE',
  SOURCING_CASE = 'SOURCING_CASE'
}

export enum TsrctAutoAcceptWorkingDay {
  FRI = 'FRI',
  MON = 'MON',
  SAT = 'SAT',
  SUN = 'SUN',
  THU = 'THU',
  TUE = 'TUE',
  WED = 'WED'
}

export type TsrctAutoAcceptWorkingHours = {
  __typename?: 'TsrctAutoAcceptWorkingHours';
  end: Scalars['String']['output'];
  start: Scalars['String']['output'];
};

export type TsrctAutoAcceptWorkingHoursInput = {
  end: Scalars['String']['input'];
  start: Scalars['String']['input'];
};

export type TsrctAutomaticAcceptanceTimingConfiguration = {
  __typename?: 'TsrctAutomaticAcceptanceTimingConfiguration';
  holiday?: Maybe<TsrctAutoAcceptHoliday>;
  reactionMaxMinutes: Scalars['Int']['output'];
  reactionMinMinutes: Scalars['Int']['output'];
  timezone: Scalars['String']['output'];
  workingDays: Array<TsrctAutoAcceptWorkingDay>;
  workingHours: TsrctAutoAcceptWorkingHours;
};

export type TsrctAutomaticAcceptanceTimingInput = {
  holiday?: InputMaybe<TsrctAutoAcceptHolidayInput>;
  reactionMaxMinutes: Scalars['Int']['input'];
  reactionMinMinutes: Scalars['Int']['input'];
  timezone: Scalars['String']['input'];
  workingDays: Array<TsrctAutoAcceptWorkingDay>;
  workingHours: TsrctAutoAcceptWorkingHoursInput;
};

export type TsrctAutomaticAcceptanceTimingResult = {
  __typename?: 'TsrctAutomaticAcceptanceTimingResult';
  plannedAt?: Maybe<Scalars['DateTime']['output']>;
  source: TsrctAutoAcceptTimingSource;
  targetId: Scalars['UUID']['output'];
  timing: TsrctAutomaticAcceptanceTimingConfiguration;
  variant: TsrctAutoAcceptTimingVariant;
};

export type TsrctAwardedSupplierInput = {
  informSupplier: Scalars['Boolean']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
};

export type TsrctAwardingConfigurationMutations = {
  __typename?: 'TsrctAwardingConfigurationMutations';
  update?: Maybe<TsrctDemandAwardingRuleConfiguration>;
};


export type TsrctAwardingConfigurationMutationsupdateArgs = {
  data: TsrctDemandAwardingRuleConfigurationInput;
};

export enum TsrctAwardingStatusEntityVariant {
  LINE_ITEM = 'LINE_ITEM',
  QUOTE = 'QUOTE'
}

export enum TsrctAwardingStatusField {
  quotedTotalValue = 'quotedTotalValue',
  shipmentTerms = 'shipmentTerms',
  totalDiscountedValue = 'totalDiscountedValue'
}

export type TsrctAwardingStatusItem = {
  __typename?: 'TsrctAwardingStatusItem';
  entityId: Scalars['UUID']['output'];
  entityVariant: TsrctAwardingStatusEntityVariant;
  field: TsrctAwardingStatusField;
  status: TsrctStatus;
};

export type TsrctBestOfferLineItem = {
  __typename?: 'TsrctBestOfferLineItem';
  id: Scalars['UUID']['output'];
};

export type TsrctBuyerReply = {
  __typename?: 'TsrctBuyerReply';
  text?: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
};

export enum TsrctCaseCancellationReason {
  AWARDED_OUTSIDE_PLATFORM = 'AWARDED_OUTSIDE_PLATFORM',
  BUDGET_CONSTRAINT = 'BUDGET_CONSTRAINT',
  DUPLICATE_CASE = 'DUPLICATE_CASE',
  NO_LONGER_NEEDED = 'NO_LONGER_NEEDED',
  OTHER = 'OTHER',
  REQUIREMENTS_CHANGED = 'REQUIREMENTS_CHANGED',
  SUPPLIER_UNAVAILABLE = 'SUPPLIER_UNAVAILABLE',
  SYSTEM_COMPETITIVE_DEADLINE_REACHED = 'SYSTEM_COMPETITIVE_DEADLINE_REACHED',
  SYSTEM_OTHER = 'SYSTEM_OTHER',
  SYSTEM_REMINDER_EXPIRED = 'SYSTEM_REMINDER_EXPIRED',
  SYSTEM_UPSTREAM_CANCELLED = 'SYSTEM_UPSTREAM_CANCELLED'
}

export type TsrctComment = {
  __typename?: 'TsrctComment';
  authorId: Scalars['UUID']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  message: Scalars['String']['output'];
  parent: TsrctCommentParentObjectRef;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type TsrctCommentInput = {
  id: Scalars['UUID']['input'];
  message: Scalars['String']['input'];
  parent: TsrctCommentParent;
};

export type TsrctCommentMutations = {
  __typename?: 'TsrctCommentMutations';
  create: TsrctComment;
  delete: TsrctDeletedComment;
  edit: TsrctComment;
};


export type TsrctCommentMutationscreateArgs = {
  data: TsrctCommentInput;
};


export type TsrctCommentMutationsdeleteArgs = {
  id: Scalars['UUID']['input'];
};


export type TsrctCommentMutationseditArgs = {
  data: TsrctCommentInput;
};

export type TsrctCommentParent = {
  id: Scalars['UUID']['input'];
  variant: TsrctCommentParentVariant;
};

export type TsrctCommentParentObjectRef = {
  __typename?: 'TsrctCommentParentObjectRef';
  id: Scalars['UUID']['output'];
  variant: TsrctCommentParentVariant;
};

export enum TsrctCommentParentVariant {
  CONTRACT_DEMAND = 'CONTRACT_DEMAND',
  DEMAND = 'DEMAND',
  NEGOTIATION_CASE = 'NEGOTIATION_CASE',
  SOURCING_CASE = 'SOURCING_CASE'
}

export enum TsrctCommentSortOrder {
  ASC = 'ASC',
  DESC = 'DESC'
}

export type TsrctCompetitiveBiddingRule = {
  __typename?: 'TsrctCompetitiveBiddingRule';
  biddingPeriodDays?: Maybe<Scalars['Int']['output']>;
  deadline?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  isCompetitiveBidding: Scalars['Boolean']['output'];
  isEditable: Scalars['Boolean']['output'];
  isMaskedBidding: Scalars['Boolean']['output'];
  variant: TsrctCompetitiveBiddingVariant;
};

export type TsrctCompetitiveBiddingRuleInput = {
  deadline?: InputMaybe<Scalars['DateTime']['input']>;
  variant: TsrctCompetitiveBiddingVariant;
};

export type TsrctCompetitiveBiddingRuleMutations = {
  __typename?: 'TsrctCompetitiveBiddingRuleMutations';
  update?: Maybe<TsrctCompetitiveBiddingRule>;
};


export type TsrctCompetitiveBiddingRuleMutationsupdateArgs = {
  data?: InputMaybe<TsrctCompetitiveBiddingRuleInput>;
};

export enum TsrctCompetitiveBiddingVariant {
  MASKED = 'MASKED',
  NONE = 'NONE',
  UNMASKED = 'UNMASKED'
}

export type TsrctContactMutations = {
  __typename?: 'TsrctContactMutations';
  update: TsrctNegotiationCaseSupplierContact;
};


export type TsrctContactMutationsupdateArgs = {
  data: TsrctNegotiationCaseSupplierContactInput;
};

export type TsrctContractDemand = {
  __typename?: 'TsrctContractDemand';
  bestOfferQuoteItems: Array<TsrctBestOfferLineItem>;
  cancellationReason?: Maybe<TsrctCaseCancellationReason>;
  cancellationReasonText?: Maybe<Scalars['String']['output']>;
  competitiveBiddingRule: TsrctContractDemandCompetitiveBiddingRule;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  demandRequest?: Maybe<TsrctContractDemandRequest>;
  id: Scalars['UUID']['output'];
  priority: Scalars['Int']['output'];
  responsibleUserId?: Maybe<Scalars['UUID']['output']>;
  sequenceNumber?: Maybe<Scalars['BigInt']['output']>;
  sourcingCases: Array<TsrctSourcingCase>;
  status: TsrctContractDemandStatus;
  tagIds: Array<Scalars['UUID']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type TsrctContractDemandAddSourcingCasesInput = {
  suppliers: Array<TsrctSourcingCaseCreateInput>;
};

export type TsrctContractDemandAwardingInput = {
  lineItemId: Scalars['UUID']['input'];
  sourcingCaseId?: InputMaybe<Scalars['UUID']['input']>;
};

export type TsrctContractDemandAwardsInput = {
  awards: Array<TsrctContractDemandAwardingInput>;
};

export type TsrctContractDemandCancelInput = {
  message?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<TsrctCaseCancellationReason>;
};

export type TsrctContractDemandCompetitiveBiddingRule = {
  __typename?: 'TsrctContractDemandCompetitiveBiddingRule';
  biddingPeriodDays?: Maybe<Scalars['Int']['output']>;
  deadline?: Maybe<Scalars['DateTime']['output']>;
  deadlineExceeded: Scalars['Boolean']['output'];
  id: Scalars['UUID']['output'];
  variant: TsrctCompetitiveBiddingVariant;
};

export type TsrctContractDemandCreateCommoditiesInput = {
  baselinePricePerPriceUnit: Scalars['TsrctDecimal']['input'];
  commodityGroupId: Scalars['UUID']['input'];
  commodityId: Scalars['UUID']['input'];
  currency: Currency;
  description?: InputMaybe<Scalars['String']['input']>;
  minimumOrderQuantity: Scalars['TsrctDecimal']['input'];
  organizationId: Scalars['UUID']['input'];
  priceUnit: Scalars['TsrctDecimal']['input'];
  qualifiedSuppliers: Array<Scalars['UUID']['input']>;
  quantity: Scalars['TsrctDecimal']['input'];
  title: Scalars['String']['input'];
  unitId: Scalars['UUID']['input'];
  validFrom: Scalars['DateTime']['input'];
  validTo: Scalars['DateTime']['input'];
};

export type TsrctContractDemandCreateFromCoveragePredictionInput = {
  commodities: Array<TsrctContractDemandCreateCommoditiesInput>;
  commodityGroupId: Scalars['UUID']['input'];
  summary: Scalars['String']['input'];
  targetTimeframe: TsrctContractDemandTimeframeInput;
};

export type TsrctContractDemandDetailsInput = {
  commodityGroup: Scalars['UUID']['input'];
  currency: Currency;
  incoTerms: Scalars['UUID']['input'];
  paymentTerms: Scalars['UUID']['input'];
  responsible: Scalars['UUID']['input'];
  summary: Scalars['String']['input'];
  tags: Array<Scalars['UUID']['input']>;
  validFrom: Scalars['DateTime']['input'];
  validTo: Scalars['DateTime']['input'];
};

export enum TsrctContractDemandFilterField {
  commodityGroupId = 'commodityGroupId',
  createdAt = 'createdAt',
  currency = 'currency',
  id = 'id',
  negotiatedCaseCount = 'negotiatedCaseCount',
  openCaseCount = 'openCaseCount',
  priority = 'priority',
  responsibleUserId = 'responsibleUserId',
  sequenceNumber = 'sequenceNumber',
  status = 'status',
  totalCaseCount = 'totalCaseCount',
  totalValue = 'totalValue',
  updatedAt = 'updatedAt',
  validFrom = 'validFrom',
  validTo = 'validTo'
}

export type TsrctContractDemandListItem = {
  __typename?: 'TsrctContractDemandListItem';
  commodityGroupId?: Maybe<Scalars['UUID']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currency?: Maybe<Currency>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  negotiatedCaseCount: Scalars['Int']['output'];
  openCaseCount: Scalars['Int']['output'];
  priority: Scalars['Int']['output'];
  qualifiedSupplierIds?: Maybe<Array<Scalars['String']['output']>>;
  responsibleUserId?: Maybe<Scalars['UUID']['output']>;
  sequenceNumber: Scalars['BigInt']['output'];
  status: Scalars['String']['output'];
  tagIds?: Maybe<Array<Scalars['String']['output']>>;
  totalCaseCount: Scalars['Int']['output'];
  totalValue: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
  validFrom?: Maybe<Scalars['DateTime']['output']>;
  validTo?: Maybe<Scalars['DateTime']['output']>;
};

export type TsrctContractDemandListItemConnection = {
  __typename?: 'TsrctContractDemandListItemConnection';
  nodes: Array<TsrctContractDemandListItem>;
  totalCount: Scalars['BigInt']['output'];
};

export type TsrctContractDemandMutations = {
  __typename?: 'TsrctContractDemandMutations';
  addSourcingCases: Array<TsrctSourcingCase>;
  awardSuppliers: TsrctContractDemand;
  cancel?: Maybe<TsrctContractDemand>;
  contractDemandRequest: TsrctContractDemandRequestMutations;
  delete?: Maybe<Scalars['Void']['output']>;
  update: TsrctContractDemand;
};


export type TsrctContractDemandMutationsaddSourcingCasesArgs = {
  data: TsrctContractDemandAddSourcingCasesInput;
};


export type TsrctContractDemandMutationsawardSuppliersArgs = {
  data: TsrctContractDemandAwardsInput;
};


export type TsrctContractDemandMutationscancelArgs = {
  data?: InputMaybe<TsrctContractDemandCancelInput>;
};


export type TsrctContractDemandMutationsupdateArgs = {
  data: TsrctContractDemandDetailsInput;
};

export type TsrctContractDemandOrder = {
  field: TsrctContractDemandOrderField;
  sort?: InputMaybe<TsrctSortDirection>;
};

export enum TsrctContractDemandOrderField {
  createdAt = 'createdAt',
  description = 'description',
  id = 'id',
  negotiatedCaseCount = 'negotiatedCaseCount',
  openCaseCount = 'openCaseCount',
  priority = 'priority',
  sequenceNumber = 'sequenceNumber',
  status = 'status',
  totalCaseCount = 'totalCaseCount',
  totalValue = 'totalValue',
  updatedAt = 'updatedAt',
  validFrom = 'validFrom',
  validTo = 'validTo'
}

export type TsrctContractDemandPriorityUpdateInput = {
  /** 0 - No priority, 1 - Low, 2 - Medium, 3 - High */
  priority: Scalars['Int']['input'];
};

export type TsrctContractDemandRequest = {
  __typename?: 'TsrctContractDemandRequest';
  commodityGroupId?: Maybe<Scalars['UUID']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currency: Currency;
  id: Scalars['UUID']['output'];
  incoTermsId?: Maybe<Scalars['UUID']['output']>;
  lineItems: Array<TsrctContractDemandRequestItem>;
  paymentTermsId?: Maybe<Scalars['UUID']['output']>;
  requestedAt: Scalars['DateTime']['output'];
  summary?: Maybe<Scalars['String']['output']>;
  totalValue?: Maybe<Scalars['TsrctDecimal']['output']>;
  validityPeriod: TsrctDateRange;
};

export type TsrctContractDemandRequestItem = {
  __typename?: 'TsrctContractDemandRequestItem';
  baselinePricePerPriceUnit?: Maybe<Scalars['TsrctDecimal']['output']>;
  baselinePricePerUnit?: Maybe<Scalars['TsrctDecimal']['output']>;
  commodityGroupId?: Maybe<Scalars['UUID']['output']>;
  commodityId?: Maybe<Scalars['UUID']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deliveryLocationId?: Maybe<Scalars['UUID']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  minimumOrderQuantity?: Maybe<Scalars['TsrctDecimal']['output']>;
  organizationId: Scalars['UUID']['output'];
  priceUnit: Scalars['TsrctDecimal']['output'];
  qualifiedSuppliers: Array<Scalars['UUID']['output']>;
  quantity: Scalars['TsrctDecimal']['output'];
  title: Scalars['String']['output'];
  totalValue?: Maybe<Scalars['TsrctDecimal']['output']>;
  unitId?: Maybe<Scalars['UUID']['output']>;
};

export type TsrctContractDemandRequestItemInput = {
  baselinePricePerUnit: Scalars['TsrctDecimal']['input'];
  commodityGroupId: Scalars['UUID']['input'];
  commodityId: Scalars['UUID']['input'];
  deliveryLocationId?: InputMaybe<Scalars['UUID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  minimumOrderQuantity: Scalars['TsrctDecimal']['input'];
  organizationId: Scalars['UUID']['input'];
  priceUnit: Scalars['TsrctDecimal']['input'];
  qualifiedSuppliers: Array<Scalars['UUID']['input']>;
  quantity: Scalars['TsrctDecimal']['input'];
  title: Scalars['String']['input'];
  unitId: Scalars['UUID']['input'];
};

export type TsrctContractDemandRequestLineItemsInput = {
  lineItems: Array<TsrctContractDemandRequestItemInput>;
};

export type TsrctContractDemandRequestMutations = {
  __typename?: 'TsrctContractDemandRequestMutations';
  updateLineItems: TsrctContractDemandRequest;
};


export type TsrctContractDemandRequestMutationsupdateLineItemsArgs = {
  data: TsrctContractDemandRequestLineItemsInput;
};

export enum TsrctContractDemandStatus {
  AWARDED = 'AWARDED',
  CANCELLED = 'CANCELLED',
  DRAFT = 'DRAFT',
  IN_PROGRESS = 'IN_PROGRESS'
}

export type TsrctContractDemandTimeframeInput = {
  validFrom: Scalars['DateTime']['input'];
  validTo: Scalars['DateTime']['input'];
};

export type TsrctDateRange = {
  __typename?: 'TsrctDateRange';
  from?: Maybe<Scalars['DateTime']['output']>;
  to?: Maybe<Scalars['DateTime']['output']>;
};

export type TsrctDeletedComment = {
  __typename?: 'TsrctDeletedComment';
  authorId: Scalars['UUID']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  message: Scalars['String']['output'];
  parent: TsrctCommentParentObjectRef;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type TsrctDemand = {
  __typename?: 'TsrctDemand';
  awardingConfiguration: TsrctDemandAwardingRuleConfiguration;
  awardingDeadline?: Maybe<Scalars['DateTime']['output']>;
  awardingSettings: TsrctDemandAwardingSettings;
  awardingStatus: Array<TsrctAwardingStatusItem>;
  cancellationReason?: Maybe<TsrctCaseCancellationReason>;
  cancellationReasonText?: Maybe<Scalars['String']['output']>;
  capabilityIds: Array<Scalars['UUID']['output']>;
  competitiveBiddingRule: TsrctCompetitiveBiddingRule;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  demandRequest: TsrctDemandRequest;
  files: Array<TsrctFile>;
  id: Scalars['UUID']['output'];
  negotiationCases: TsrctDemandNegotiationCaseConnection;
  performAutomaticAwarding: Scalars['Boolean']['output'];
  permissions: TsrctDemandPermissions;
  priority: Scalars['Int']['output'];
  processStatus?: Maybe<TsrctDemandProcessStatus>;
  processSteps: Array<TsrctDemandProcessStep>;
  processingMode: TsrctDemandProcessingMode;
  requestedBy?: Maybe<Scalars['UUID']['output']>;
  responsibleUserIds: Array<Scalars['UUID']['output']>;
  sequenceNumber: Scalars['BigInt']['output'];
  status: TsrctDemandStatus;
  updatedAt: Scalars['DateTime']['output'];
};

export type TsrctDemandAwardInput = {
  awardedSupplier?: InputMaybe<TsrctAwardedSupplierInput>;
  awards?: InputMaybe<Array<TsrctDemandAwardedLineItemInput>>;
  dismissedSupplier?: InputMaybe<TsrctDismissedSupplierInput>;
  negotiationCaseId?: InputMaybe<Scalars['UUID']['input']>;
};

export type TsrctDemandAwardedLineItemInput = {
  demandRequestItemId: Scalars['UUID']['input'];
  negotiationCaseId?: InputMaybe<Scalars['UUID']['input']>;
};

export type TsrctDemandAwardingNotificationOption = {
  __typename?: 'TsrctDemandAwardingNotificationOption';
  defaultValue: Scalars['Boolean']['output'];
  show: Scalars['Boolean']['output'];
};

export type TsrctDemandAwardingNotificationOptions = {
  __typename?: 'TsrctDemandAwardingNotificationOptions';
  dismissOtherSuppliers: TsrctDemandAwardingNotificationOption;
  informAwardedSupplier: TsrctDemandAwardingNotificationOption;
  informDismissedSupplier: TsrctDemandAwardingNotificationOption;
  informSupplier: Scalars['Boolean']['output'];
};

export type TsrctDemandAwardingNotificationSettings = {
  __typename?: 'TsrctDemandAwardingNotificationSettings';
  options: TsrctDemandAwardingNotificationOptions;
};

export type TsrctDemandAwardingRule = {
  __typename?: 'TsrctDemandAwardingRule';
  id: Scalars['UUID']['output'];
  priceDeviation?: Maybe<Scalars['TsrctDecimal']['output']>;
  variant: TsrctDemandAwardingRuleVariant;
};

export type TsrctDemandAwardingRuleConfiguration = {
  __typename?: 'TsrctDemandAwardingRuleConfiguration';
  deadline?: Maybe<Scalars['DateTime']['output']>;
  deadlineDays?: Maybe<Scalars['Int']['output']>;
  id: Scalars['UUID']['output'];
  performAutomaticAwarding: Scalars['Boolean']['output'];
  rules: Array<TsrctDemandAwardingRule>;
};

export type TsrctDemandAwardingRuleConfigurationInput = {
  deadlineDays: Scalars['Int']['input'];
  performAutomaticAwarding: Scalars['Boolean']['input'];
  rules: Array<TsrctDemandAwardingRuleInput>;
};

export type TsrctDemandAwardingRuleInput = {
  priceDeviation?: InputMaybe<Scalars['TsrctDecimal']['input']>;
  variant: TsrctDemandAwardingRuleVariant;
};

export enum TsrctDemandAwardingRuleVariant {
  BEST_PRICE = 'BEST_PRICE',
  BEST_PRICE_WITHIN_BUDGET = 'BEST_PRICE_WITHIN_BUDGET',
  MANUAL = 'MANUAL',
  PREFERRED_SUPPLIER = 'PREFERRED_SUPPLIER',
  PREFERRED_SUPPLIER_WITHIN_BUDGET = 'PREFERRED_SUPPLIER_WITHIN_BUDGET'
}

export type TsrctDemandAwardingSettings = {
  __typename?: 'TsrctDemandAwardingSettings';
  isPartialAwardingEnabled: Scalars['Boolean']['output'];
  notifications: TsrctDemandAwardingNotificationSettings;
};

export enum TsrctDemandAwardingVariant {
  AUTOMATIC = 'AUTOMATIC',
  MANUAL = 'MANUAL'
}

export type TsrctDemandCancelInput = {
  message?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<TsrctCaseCancellationReason>;
};

export type TsrctDemandDeleteInput = {
  id: Scalars['UUID']['input'];
};

export enum TsrctDemandFilterField {
  capability = 'capability',
  casesNegotiatedCount = 'casesNegotiatedCount',
  casesOpenCount = 'casesOpenCount',
  casesTotalCount = 'casesTotalCount',
  commodityGroup = 'commodityGroup',
  createdAt = 'createdAt',
  demandAwardingDeadline = 'demandAwardingDeadline',
  demandAwardingVariant = 'demandAwardingVariant',
  earlyDeliveryAt = 'earlyDeliveryAt',
  id = 'id',
  issuesOpenCount = 'issuesOpenCount',
  lateDeliveryAt = 'lateDeliveryAt',
  organization = 'organization',
  preferredSupplier = 'preferredSupplier',
  primaryCommodityGroupId = 'primaryCommodityGroupId',
  priority = 'priority',
  processStatus = 'processStatus',
  processSteps = 'processSteps',
  processingMode = 'processingMode',
  referenceId = 'referenceId',
  requestedAt = 'requestedAt',
  requestedBy = 'requestedBy',
  responsibleIds = 'responsibleIds',
  sequenceNumber = 'sequenceNumber',
  sourceSystemId = 'sourceSystemId',
  status = 'status',
  totalValue = 'totalValue',
  updatedAt = 'updatedAt'
}

export type TsrctDemandInput = {
  capabilities?: InputMaybe<Array<Scalars['UUID']['input']>>;
  commodityGroups?: InputMaybe<Array<Scalars['UUID']['input']>>;
  demandRequest: TsrctDemandRequestInput;
  negotiationCases?: InputMaybe<Array<TsrctNegotiationCaseInput>>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  requestedBy?: InputMaybe<Scalars['UUID']['input']>;
  responsibleUsers?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

export type TsrctDemandListItem = {
  __typename?: 'TsrctDemandListItem';
  awardingDeadline?: Maybe<Scalars['DateTime']['output']>;
  awardingVariant?: Maybe<TsrctDemandAwardingVariant>;
  capabilityIds?: Maybe<Array<Scalars['String']['output']>>;
  casesNegotiatedCount: Scalars['BigInt']['output'];
  casesOpenCount: Scalars['BigInt']['output'];
  casesTotalCount: Scalars['BigInt']['output'];
  commodityGroupIds?: Maybe<Array<Scalars['String']['output']>>;
  createdAt: Scalars['DateTime']['output'];
  currency?: Maybe<Currency>;
  description?: Maybe<Scalars['String']['output']>;
  earlyDeliveryAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  issuesCompletedCount: Scalars['BigInt']['output'];
  issuesOpenCount: Scalars['BigInt']['output'];
  issuesTotalCount: Scalars['BigInt']['output'];
  lateDeliveryAt?: Maybe<Scalars['DateTime']['output']>;
  links: Array<TsrctLink>;
  organizationId?: Maybe<Scalars['String']['output']>;
  preferredSupplierIds?: Maybe<Array<Scalars['String']['output']>>;
  primaryCommodityGroupId?: Maybe<Scalars['String']['output']>;
  priority: Scalars['Int']['output'];
  processStatus?: Maybe<TsrctDemandProcessStatus>;
  processSteps: Array<TsrctDemandProcessStep>;
  processingMode: TsrctDemandProcessingMode;
  purchaseRequisitionId?: Maybe<Scalars['String']['output']>;
  referenceId?: Maybe<Scalars['String']['output']>;
  requestedAt?: Maybe<Scalars['DateTime']['output']>;
  requestedBy?: Maybe<Scalars['UUID']['output']>;
  responsibleIds: Array<Scalars['UUID']['output']>;
  sequenceNumber: Scalars['BigInt']['output'];
  sourceSystemId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<TsrctDemandStatus>;
  totalValue?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type TsrctDemandListItemConnection = {
  __typename?: 'TsrctDemandListItemConnection';
  nodes: Array<TsrctDemandListItem>;
  totalCount: Scalars['BigInt']['output'];
};

export type TsrctDemandMutations = {
  __typename?: 'TsrctDemandMutations';
  award?: Maybe<Scalars['Void']['output']>;
  awardingConfiguration: TsrctAwardingConfigurationMutations;
  cancel: TsrctDemand;
  competitiveBiddingRule: TsrctCompetitiveBiddingRuleMutations;
  delete?: Maybe<Scalars['Void']['output']>;
  demandRequest: TsrctDemandRequestMutations;
  file: TsrctFileMutations;
  negotiationCase: TsrctDemandNegotiationCaseMutations;
  priority: TsrctPriorityMutations;
  releaseNegotiationCases?: Maybe<Scalars['Void']['output']>;
  reset: TsrctDemand;
  responsibleUsers: TsrctResponsibleUsersMutations;
  update: TsrctDemand;
};


export type TsrctDemandMutationsawardArgs = {
  data: TsrctDemandAwardInput;
};


export type TsrctDemandMutationscancelArgs = {
  data?: InputMaybe<TsrctDemandCancelInput>;
};


export type TsrctDemandMutationsreleaseNegotiationCasesArgs = {
  data: TsrctReleaseNegotiationCasesInput;
};


export type TsrctDemandMutationsupdateArgs = {
  data: TsrctDemandUpdateInput;
};

export type TsrctDemandNegotiationCase = TsrctNegotiationCaseAdvancedInterface & TsrctNegotiationCaseInterface & {
  __typename?: 'TsrctDemandNegotiationCase';
  cancellationReason?: Maybe<TsrctCaseCancellationReason>;
  cancellationReasonText?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /** user who created the negotiation-case (UUID) */
  createdById?: Maybe<Scalars['UUID']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  isAwardable: Scalars['Boolean']['output'];
  isMaskedBidding: Scalars['Boolean']['output'];
  isNegotiationEnabled: Scalars['Boolean']['output'];
  isReleasable: Scalars['Boolean']['output'];
  isSupplierUploadAllowed: Scalars['Boolean']['output'];
  issueSummary: TsrctIssueSummary;
  issues?: Maybe<Array<TsrctIssue>>;
  /** The latest comment on this negotiation case. */
  latestComment?: Maybe<TsrctComment>;
  lowerDiscountBoundary: Scalars['TsrctDecimal']['output'];
  options?: Maybe<TsrctNegotiationCaseOptions>;
  processStatus?: Maybe<TsrctNegotiationCaseProcessStatus>;
  processSteps: Array<TsrctNegotiationCaseProcessStep>;
  quote?: Maybe<TsrctQuoteOrNegotiatedQuote>;
  /** sequential number of the negotiation case */
  sequenceNumber: Scalars['BigInt']['output'];
  sourceReferences: Array<TsrctSourceReference>;
  status: TsrctNegotiationCaseStatus;
  strategy?: Maybe<TsrctNegotiationStrategy>;
  supplier: TsrctNegotiationCaseSupplier;
  supplierIntroductionMessage?: Maybe<TsrctSupplierIntroductionMessage>;
  updatedAt: Scalars['DateTime']['output'];
  upperDiscountBoundary: Scalars['TsrctDecimal']['output'];
  variant: TsrctNegotiationCaseVariant;
};

export type TsrctDemandNegotiationCaseConnection = {
  __typename?: 'TsrctDemandNegotiationCaseConnection';
  nodes: Array<TsrctDemandNegotiationCase>;
  totalCount: Scalars['Int']['output'];
};

export type TsrctDemandNegotiationCaseMutations = {
  __typename?: 'TsrctDemandNegotiationCaseMutations';
  create: TsrctNegotiationCase;
};


export type TsrctDemandNegotiationCaseMutationscreateArgs = {
  data: TsrctNegotiationCaseInput;
};

export type TsrctDemandOrder = {
  field: TsrctDemandOrderField;
  sort?: InputMaybe<TsrctSortDirection>;
};

export enum TsrctDemandOrderField {
  casesNegotiatedCount = 'casesNegotiatedCount',
  casesOpenCount = 'casesOpenCount',
  casesTotalCount = 'casesTotalCount',
  createdAt = 'createdAt',
  demandAwardingDeadline = 'demandAwardingDeadline',
  description = 'description',
  earlyDeliveryAt = 'earlyDeliveryAt',
  id = 'id',
  issuesOpenCount = 'issuesOpenCount',
  lateDeliveryAt = 'lateDeliveryAt',
  priority = 'priority',
  processStatus = 'processStatus',
  processSteps = 'processSteps',
  processingMode = 'processingMode',
  requestedAt = 'requestedAt',
  requestedBy = 'requestedBy',
  sequenceNumber = 'sequenceNumber',
  sourceSystemId = 'sourceSystemId',
  status = 'status',
  totalValue = 'totalValue',
  updatedAt = 'updatedAt'
}

export type TsrctDemandPermissions = {
  __typename?: 'TsrctDemandPermissions';
  assign: Scalars['Boolean']['output'];
  read: Scalars['Boolean']['output'];
  write: Scalars['Boolean']['output'];
};

export type TsrctDemandPriorityUpdateInput = {
  /** 0 - No priority, 1 - Low, 2 - Medium, 3 - High */
  priority: Scalars['Int']['input'];
};

export enum TsrctDemandProcessStatus {
  CANCELLED = 'CANCELLED',
  COMPLETED = 'COMPLETED',
  IN_PROGRESS = 'IN_PROGRESS',
  OPEN = 'OPEN'
}

export type TsrctDemandProcessStep = {
  __typename?: 'TsrctDemandProcessStep';
  status: TsrctDemandProcessStepStatus;
  variant: TsrctDemandProcessStepVariant;
};

export type TsrctDemandProcessStepEvent = {
  __typename?: 'TsrctDemandProcessStepEvent';
  id: Scalars['UUID']['output'];
};

export enum TsrctDemandProcessStepSentinel {
  NO_ACTION_REQUIRED = 'NO_ACTION_REQUIRED',
  WAITING_FOR_SUPPLIER_INTERACTION = 'WAITING_FOR_SUPPLIER_INTERACTION'
}

export enum TsrctDemandProcessStepStatus {
  ACTIVE = 'ACTIVE',
  COMPLETED = 'COMPLETED',
  DISABLED = 'DISABLED',
  OPEN = 'OPEN'
}

export enum TsrctDemandProcessStepVariant {
  AWARD_DEMAND_TO_SUPPLIER = 'AWARD_DEMAND_TO_SUPPLIER',
  BIDS_REQUIRE_MANUAL_REVIEW = 'BIDS_REQUIRE_MANUAL_REVIEW',
  FINALISE_NEGOTIATION_CASES = 'FINALISE_NEGOTIATION_CASES',
  FINALISE_REQUEST_ANALYSIS = 'FINALISE_REQUEST_ANALYSIS',
  START_AUTONOMOUS_SOURCING = 'START_AUTONOMOUS_SOURCING'
}

export enum TsrctDemandProcessingMode {
  FULLY_AUTOMATED = 'FULLY_AUTOMATED',
  GUIDED = 'GUIDED',
  POTENTIALLY_AUTOMATED = 'POTENTIALLY_AUTOMATED'
}

export type TsrctDemandRequest = {
  __typename?: 'TsrctDemandRequest';
  accountingAreaId?: Maybe<Scalars['String']['output']>;
  budget?: Maybe<Scalars['TsrctDecimal']['output']>;
  commodityGroupId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currency: Currency;
  demandId: Scalars['UUID']['output'];
  externalReference?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  lineItems: Array<TsrctDemandRequestLineItem>;
  organizationId?: Maybe<Scalars['String']['output']>;
  preferredSuppliers: Array<TsrctDemandRequestPreferredSupplier>;
  requestedAt: Scalars['DateTime']['output'];
  shipmentTerms: TsrctShipmentTerms;
  sourceReferences: Array<TsrctDemandRequestSourceReference>;
  summary?: Maybe<Scalars['String']['output']>;
  totalValue?: Maybe<Scalars['TsrctDecimal']['output']>;
};

export type TsrctDemandRequestAnalysisUpdateInput = {
  analysisId: Scalars['UUID']['input'];
};

export type TsrctDemandRequestInput = {
  budget?: InputMaybe<Scalars['TsrctDecimal']['input']>;
  commodityGroupId?: InputMaybe<Scalars['UUID']['input']>;
  currency: Currency;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  lineItems: Array<TsrctDemandRequestItemInput>;
  summary?: InputMaybe<Scalars['String']['input']>;
};

export type TsrctDemandRequestItemInput = {
  analysisId?: InputMaybe<Scalars['UUID']['input']>;
  baselinePricePerUnit?: InputMaybe<Scalars['TsrctDecimal']['input']>;
  commodityGroupId?: InputMaybe<Scalars['UUID']['input']>;
  commodityId?: InputMaybe<Scalars['UUID']['input']>;
  contractItemId?: InputMaybe<Scalars['UUID']['input']>;
  deliveryLocationId?: InputMaybe<Scalars['UUID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** The expected price per unit must be >= 0 */
  expectedPricePerUnit?: InputMaybe<Scalars['TsrctDecimal']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  internalId?: InputMaybe<Scalars['UUID']['input']>;
  organizationId?: InputMaybe<Scalars['UUID']['input']>;
  position: Scalars['String']['input'];
  preferredSupplierId?: InputMaybe<Scalars['UUID']['input']>;
  /** The quantity must be >= 0 */
  quantity: Scalars['TsrctDecimal']['input'];
  shipmentTerms: TsrctShipmentTermsInput;
  title: Scalars['String']['input'];
  unitId?: InputMaybe<Scalars['UUID']['input']>;
};

export type TsrctDemandRequestLineItem = {
  __typename?: 'TsrctDemandRequestLineItem';
  analysisId?: Maybe<Scalars['UUID']['output']>;
  baselinePricePerUnit?: Maybe<Scalars['TsrctDecimal']['output']>;
  commodityGroupId?: Maybe<Scalars['UUID']['output']>;
  commodityId?: Maybe<Scalars['UUID']['output']>;
  contractItemId?: Maybe<Scalars['UUID']['output']>;
  deliveryLocationId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  expectedPricePerUnit?: Maybe<Scalars['TsrctDecimal']['output']>;
  id: Scalars['UUID']['output'];
  internalId?: Maybe<Scalars['UUID']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
  position: Scalars['String']['output'];
  preferredSupplierId?: Maybe<Scalars['UUID']['output']>;
  quantity: Scalars['TsrctDecimal']['output'];
  recommendations?: Maybe<Array<TsrctRecommendation>>;
  shipmentTerms: TsrctShipmentTerms;
  title: Scalars['String']['output'];
  /** Derived from quantity * expectedPricePerUnit. Null when expectedPricePerUnit is null. */
  totalValue?: Maybe<Scalars['TsrctDecimal']['output']>;
  unitId?: Maybe<Scalars['UUID']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type TsrctDemandRequestLineItemMutations = {
  __typename?: 'TsrctDemandRequestLineItemMutations';
  analysisUpdate: TsrctDemandRequestLineItem;
};


export type TsrctDemandRequestLineItemMutationsanalysisUpdateArgs = {
  data: TsrctDemandRequestAnalysisUpdateInput;
};

export type TsrctDemandRequestMutations = {
  __typename?: 'TsrctDemandRequestMutations';
  lineItem: TsrctDemandRequestLineItemMutations;
  recommendations: TsrctRecommendationMutations;
  update: TsrctDemandRequest;
};


export type TsrctDemandRequestMutationslineItemArgs = {
  id: Scalars['UUID']['input'];
};


export type TsrctDemandRequestMutationsupdateArgs = {
  data: TsrctDemandRequestInput;
};

export type TsrctDemandRequestPreferredSupplier = {
  __typename?: 'TsrctDemandRequestPreferredSupplier';
  quoteReference?: Maybe<Scalars['String']['output']>;
  supplierId: Scalars['UUID']['output'];
};

export type TsrctDemandRequestSourceReference = {
  __typename?: 'TsrctDemandRequestSourceReference';
  internalId: Scalars['UUID']['output'];
  isPrimary: Scalars['Boolean']['output'];
  sourceReference: Scalars['String']['output'];
  sourceSystem: TsrctSourceSystem;
  url?: Maybe<Scalars['URL']['output']>;
};

export type TsrctDemandResponsibleUsersInput = {
  responsibleUserIds: Array<Scalars['UUID']['input']>;
};

export enum TsrctDemandStatus {
  CANCELLED = 'CANCELLED',
  COMPLETED = 'COMPLETED',
  INITIALIZED = 'INITIALIZED',
  IN_PROGRESS = 'IN_PROGRESS',
  OPEN = 'OPEN',
  PO_PENDING = 'PO_PENDING',
  UPSTREAM_DELETED = 'UPSTREAM_DELETED'
}

export type TsrctDemandUpdateInput = {
  capabilityIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  responsibleUserIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

export type TsrctDemandsMutations = {
  __typename?: 'TsrctDemandsMutations';
  republish?: Maybe<Scalars['Void']['output']>;
};

export type TsrctDismissedSupplierInput = {
  informSupplier: Scalars['Boolean']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
};

export type TsrctFile = {
  __typename?: 'TsrctFile';
  classification?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  demandId?: Maybe<Scalars['UUID']['output']>;
  id: Scalars['UUID']['output'];
  isSharedWithSupplier: Scalars['Boolean']['output'];
  negotiationCaseId?: Maybe<Scalars['UUID']['output']>;
  negotiationCaseSequence?: Maybe<Scalars['BigInt']['output']>;
  quoteId?: Maybe<Scalars['UUID']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  uploadedBy: TsrctAttachmentUploadedByObjectRef;
};

export type TsrctFileInput = {
  fileId: Scalars['UUID']['input'];
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  isSharedWithSupplier?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TsrctFileMutations = {
  __typename?: 'TsrctFileMutations';
  create: Array<TsrctFile>;
  delete: TsrctFile;
  update: Array<TsrctFile>;
};


export type TsrctFileMutationscreateArgs = {
  data: Array<TsrctFileInput>;
};


export type TsrctFileMutationsdeleteArgs = {
  data: TsrctFileInput;
};


export type TsrctFileMutationsupdateArgs = {
  files: Array<TsrctFileInput>;
};

export type TsrctFileNegotiationCaseFilterInput = {
  negotiationCaseId?: InputMaybe<Scalars['UUID']['input']>;
};

export type TsrctFlow = {
  __typename?: 'TsrctFlow';
  createdAt: Scalars['DateTime']['output'];
  currentStep: TsrctFlowStep;
  id: Scalars['UUID']['output'];
  sourcingCase?: Maybe<TsrctSupplierSourcingCase>;
  steps: Array<TsrctFlowStep>;
};

export type TsrctFlowStep = {
  __typename?: 'TsrctFlowStep';
  hidden: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  status: TsrctFlowStepStatus;
  variant: TsrctFlowStepVariant;
};

export enum TsrctFlowStepStatus {
  COMPLETED = 'COMPLETED',
  NONE = 'NONE',
  PENDING = 'PENDING',
  PROCEED = 'PROCEED'
}

export type TsrctFlowStepStatusEvent = {
  __typename?: 'TsrctFlowStepStatusEvent';
  id: Scalars['String']['output'];
  status: TsrctFlowStepStatus;
};

export enum TsrctFlowStepVariant {
  CONTRACT_EPILOGUE = 'CONTRACT_EPILOGUE',
  CONTRACT_NEGOTIATE = 'CONTRACT_NEGOTIATE',
  CONTRACT_QUOTE_BID_SHEET = 'CONTRACT_QUOTE_BID_SHEET',
  CONTRACT_RESULT_CONFIRM = 'CONTRACT_RESULT_CONFIRM',
  CONTRACT_SUPPLIER_CONTACT_CONFIRM = 'CONTRACT_SUPPLIER_CONTACT_CONFIRM',
  NEGOTIATION_EPILOGUE = 'NEGOTIATION_EPILOGUE',
  NEGOTIATION_NEGOTIATE = 'NEGOTIATION_NEGOTIATE',
  NEGOTIATION_QUOTE_BID_SHEET = 'NEGOTIATION_QUOTE_BID_SHEET',
  NEGOTIATION_QUOTE_BID_SHEET_PROPOSAL = 'NEGOTIATION_QUOTE_BID_SHEET_PROPOSAL',
  NEGOTIATION_QUOTE_CONFIRM = 'NEGOTIATION_QUOTE_CONFIRM',
  NEGOTIATION_QUOTE_EDIT = 'NEGOTIATION_QUOTE_EDIT',
  NEGOTIATION_QUOTE_UPLOAD = 'NEGOTIATION_QUOTE_UPLOAD',
  NEGOTIATION_RESULT_CONFIRM = 'NEGOTIATION_RESULT_CONFIRM',
  NEGOTIATION_SUPPLIER_CONTACT_CONFIRM = 'NEGOTIATION_SUPPLIER_CONTACT_CONFIRM',
  NEGOTIATION_SUPPLIER_INVITE = 'NEGOTIATION_SUPPLIER_INVITE'
}

export enum TsrctInitiationMode {
  PROCUREAI = 'PROCUREAI',
  SUPPLIER = 'SUPPLIER'
}

export type TsrctIntercom = {
  __typename?: 'TsrctIntercom';
  token: Scalars['String']['output'];
};

export type TsrctIssue = {
  __typename?: 'TsrctIssue';
  createdAt: Scalars['DateTime']['output'];
  details?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['UUID']['output'];
  reporter?: Maybe<TsrctIssueReporter>;
  status: TsrctIssueStatus;
  updatedAt: Scalars['DateTime']['output'];
  variant: TsrctIssueVariant;
};

export type TsrctIssueReporter = {
  __typename?: 'TsrctIssueReporter';
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['EmailAddress']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  language: TsrctLanguage;
  lastName: Scalars['String']['output'];
  mobile?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export enum TsrctIssueStatus {
  COMPLETED = 'COMPLETED',
  OPEN = 'OPEN'
}

export type TsrctIssueSummary = {
  __typename?: 'TsrctIssueSummary';
  openCount: Scalars['Int']['output'];
  resolvedCount: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
};

export enum TsrctIssueVariant {
  CONTRACT_CREATE_FAILED = 'CONTRACT_CREATE_FAILED',
  CONTRACT_UPDATE_FAILED = 'CONTRACT_UPDATE_FAILED',
  PURCHASE_ORDER_CREATE_FAILED = 'PURCHASE_ORDER_CREATE_FAILED',
  PURCHASE_ORDER_UPDATE_FAILED = 'PURCHASE_ORDER_UPDATE_FAILED',
  PURCHASE_REQUISITION_CREATE_FAILED = 'PURCHASE_REQUISITION_CREATE_FAILED',
  PURCHASE_REQUISITION_UPDATE_FAILED = 'PURCHASE_REQUISITION_UPDATE_FAILED'
}

export enum TsrctLanguage {
  AA = 'AA',
  AB = 'AB',
  AE = 'AE',
  AF = 'AF',
  AK = 'AK',
  AM = 'AM',
  AN = 'AN',
  AR = 'AR',
  AS = 'AS',
  AV = 'AV',
  AY = 'AY',
  AZ = 'AZ',
  BA = 'BA',
  BE = 'BE',
  BG = 'BG',
  BI = 'BI',
  BM = 'BM',
  BN = 'BN',
  BO = 'BO',
  BR = 'BR',
  BS = 'BS',
  CA = 'CA',
  CE = 'CE',
  CH = 'CH',
  CO = 'CO',
  CR = 'CR',
  CS = 'CS',
  CU = 'CU',
  CV = 'CV',
  CY = 'CY',
  DA = 'DA',
  DE = 'DE',
  DV = 'DV',
  DZ = 'DZ',
  EE = 'EE',
  EL = 'EL',
  EN = 'EN',
  EO = 'EO',
  ES = 'ES',
  ET = 'ET',
  EU = 'EU',
  FA = 'FA',
  FF = 'FF',
  FI = 'FI',
  FJ = 'FJ',
  FO = 'FO',
  FR = 'FR',
  FY = 'FY',
  GA = 'GA',
  GD = 'GD',
  GL = 'GL',
  GN = 'GN',
  GU = 'GU',
  GV = 'GV',
  HA = 'HA',
  HE = 'HE',
  HI = 'HI',
  HO = 'HO',
  HR = 'HR',
  HT = 'HT',
  HU = 'HU',
  HY = 'HY',
  HZ = 'HZ',
  IA = 'IA',
  ID = 'ID',
  IE = 'IE',
  IG = 'IG',
  II = 'II',
  IK = 'IK',
  IO = 'IO',
  IS = 'IS',
  IT = 'IT',
  IU = 'IU',
  JA = 'JA',
  JV = 'JV',
  KA = 'KA',
  KG = 'KG',
  KI = 'KI',
  KJ = 'KJ',
  KK = 'KK',
  KL = 'KL',
  KM = 'KM',
  KN = 'KN',
  KO = 'KO',
  KR = 'KR',
  KS = 'KS',
  KU = 'KU',
  KV = 'KV',
  KW = 'KW',
  KY = 'KY',
  LA = 'LA',
  LB = 'LB',
  LG = 'LG',
  LI = 'LI',
  LN = 'LN',
  LO = 'LO',
  LT = 'LT',
  LU = 'LU',
  LV = 'LV',
  MG = 'MG',
  MH = 'MH',
  MI = 'MI',
  MK = 'MK',
  ML = 'ML',
  MN = 'MN',
  MR = 'MR',
  MS = 'MS',
  MT = 'MT',
  MY = 'MY',
  NA = 'NA',
  NB = 'NB',
  ND = 'ND',
  NE = 'NE',
  NG = 'NG',
  NL = 'NL',
  NN = 'NN',
  NO = 'NO',
  NR = 'NR',
  NV = 'NV',
  NY = 'NY',
  OC = 'OC',
  OJ = 'OJ',
  OM = 'OM',
  OR = 'OR',
  OS = 'OS',
  PA = 'PA',
  PI = 'PI',
  PL = 'PL',
  PS = 'PS',
  PT = 'PT',
  QU = 'QU',
  RM = 'RM',
  RN = 'RN',
  RO = 'RO',
  RU = 'RU',
  RW = 'RW',
  SA = 'SA',
  SC = 'SC',
  SD = 'SD',
  SE = 'SE',
  SG = 'SG',
  SH = 'SH',
  SI = 'SI',
  SK = 'SK',
  SL = 'SL',
  SM = 'SM',
  SN = 'SN',
  SO = 'SO',
  SQ = 'SQ',
  SR = 'SR',
  SS = 'SS',
  ST = 'ST',
  SU = 'SU',
  SV = 'SV',
  SW = 'SW',
  TA = 'TA',
  TE = 'TE',
  TG = 'TG',
  TH = 'TH',
  TI = 'TI',
  TK = 'TK',
  TL = 'TL',
  TN = 'TN',
  TO = 'TO',
  TR = 'TR',
  TS = 'TS',
  TT = 'TT',
  TW = 'TW',
  TY = 'TY',
  UG = 'UG',
  UK = 'UK',
  UR = 'UR',
  UZ = 'UZ',
  VE = 'VE',
  VI = 'VI',
  VO = 'VO',
  WA = 'WA',
  WO = 'WO',
  XH = 'XH',
  YI = 'YI',
  YO = 'YO',
  ZA = 'ZA',
  ZF = 'ZF',
  ZH = 'ZH'
}

export type TsrctLink = {
  __typename?: 'TsrctLink';
  name: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type TsrctNegotiatedQuote = TsrctNegotiatedQuoteInterface & TsrctQuoteInterface & {
  __typename?: 'TsrctNegotiatedQuote';
  buyerReply?: Maybe<TsrctBuyerReply>;
  createdAt: Scalars['DateTime']['output'];
  currency: Currency;
  /** Discount in percentage */
  discount?: Maybe<Scalars['TsrctDecimal']['output']>;
  hasSupplierComment: Scalars['Boolean']['output'];
  id: Scalars['UUID']['output'];
  lineItems: Array<TsrctNegotiatedQuoteItem>;
  paymentTerms: Array<TsrctPaymentTerm>;
  shipmentTerms: TsrctShipmentTerms;
  supplierComment?: Maybe<TsrctSupplierComment>;
  supplierReference?: Maybe<Scalars['String']['output']>;
  /** Total savings (totalValue - totalPriceDiscount) */
  totalDiscountedValue?: Maybe<Scalars['TsrctDecimal']['output']>;
  totalDiscountedValueWithTaxes?: Maybe<Scalars['TsrctDecimal']['output']>;
  /** Discount in monetary value */
  totalPriceDiscount?: Maybe<Scalars['TsrctDecimal']['output']>;
  totalValue?: Maybe<Scalars['TsrctDecimal']['output']>;
};

export type TsrctNegotiatedQuoteActionInput = {
  text?: InputMaybe<Scalars['String']['input']>;
};

export type TsrctNegotiatedQuoteInterface = {
  buyerReply?: Maybe<TsrctBuyerReply>;
  /** Discount in percentage */
  discount?: Maybe<Scalars['TsrctDecimal']['output']>;
  lineItems: Array<TsrctNegotiatedQuoteItemInterface>;
  supplierComment?: Maybe<TsrctSupplierComment>;
  /** Total savings (totalValue - totalPriceDiscount) */
  totalDiscountedValue?: Maybe<Scalars['TsrctDecimal']['output']>;
  totalDiscountedValueWithTaxes?: Maybe<Scalars['TsrctDecimal']['output']>;
  /** Discount in monetary value */
  totalPriceDiscount?: Maybe<Scalars['TsrctDecimal']['output']>;
};

export type TsrctNegotiatedQuoteItem = TsrctNegotiatedQuoteItemInterface & TsrctQuoteItemInterface & {
  __typename?: 'TsrctNegotiatedQuoteItem';
  commodityId?: Maybe<Scalars['UUID']['output']>;
  deliveryLocationId?: Maybe<Scalars['UUID']['output']>;
  demandRequestItemId?: Maybe<Scalars['UUID']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<Scalars['TsrctDecimal']['output']>;
  discountedPricePerUnit?: Maybe<Scalars['TsrctDecimal']['output']>;
  id: Scalars['UUID']['output'];
  isAwardable?: Maybe<Scalars['Boolean']['output']>;
  negotiationFailedReason?: Maybe<TsrctSupplierCommentVariant>;
  negotiationFailedReasonText?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['UUID']['output']>;
  position: Scalars['String']['output'];
  pricePerUnit?: Maybe<Scalars['TsrctDecimal']['output']>;
  quantity: Scalars['TsrctDecimal']['output'];
  shipmentTerms: TsrctShipmentTerms;
  status: TsrctQuoteItemStatus;
  supplierComment?: Maybe<TsrctSupplierComment>;
  taxInformation?: Maybe<Scalars['JSON']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  totalDiscountedValue?: Maybe<Scalars['TsrctDecimal']['output']>;
  totalDiscountedValueWithTaxes?: Maybe<Scalars['TsrctDecimal']['output']>;
  totalValue?: Maybe<Scalars['TsrctDecimal']['output']>;
  unitId?: Maybe<Scalars['UUID']['output']>;
};

export type TsrctNegotiatedQuoteItemInterface = {
  discount?: Maybe<Scalars['TsrctDecimal']['output']>;
  discountedPricePerUnit?: Maybe<Scalars['TsrctDecimal']['output']>;
  supplierComment?: Maybe<TsrctSupplierComment>;
  totalDiscountedValue?: Maybe<Scalars['TsrctDecimal']['output']>;
  totalDiscountedValueWithTaxes?: Maybe<Scalars['TsrctDecimal']['output']>;
};

export type TsrctNegotiatedQuoteMutations = {
  __typename?: 'TsrctNegotiatedQuoteMutations';
  draftAccept: TsrctNegotiatedQuote;
  draftDecline: TsrctNegotiatedQuote;
};


export type TsrctNegotiatedQuoteMutationsdraftAcceptArgs = {
  data: TsrctNegotiatedQuoteActionInput;
};


export type TsrctNegotiatedQuoteMutationsdraftDeclineArgs = {
  data: TsrctNegotiatedQuoteActionInput;
};

export type TsrctNegotiationBoundarySuggestion = {
  __typename?: 'TsrctNegotiationBoundarySuggestion';
  negotiationBoundaryLower: Scalars['TsrctDecimal']['output'];
  negotiationBoundaryUpper: Scalars['TsrctDecimal']['output'];
};

export type TsrctNegotiationCase = TsrctNegotiationCaseAdvancedInterface & TsrctNegotiationCaseInterface & {
  __typename?: 'TsrctNegotiationCase';
  cancellationReason?: Maybe<TsrctCaseCancellationReason>;
  cancellationReasonText?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /** user who created the negotiation-case (UUID) */
  createdById?: Maybe<Scalars['UUID']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The demand that this negotiation case belongs to */
  demand: TsrctDemand;
  demandRequest: TsrctDemandRequest;
  files: Array<TsrctFile>;
  flowId?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  isAwardable: Scalars['Boolean']['output'];
  isMaskedBidding: Scalars['Boolean']['output'];
  isNegotiationEnabled: Scalars['Boolean']['output'];
  isReleasable: Scalars['Boolean']['output'];
  isSupplierUploadAllowed: Scalars['Boolean']['output'];
  issues?: Maybe<Array<TsrctIssue>>;
  lowerDiscountBoundary: Scalars['TsrctDecimal']['output'];
  negotiatedQuote?: Maybe<TsrctNegotiatedQuote>;
  options?: Maybe<TsrctNegotiationCaseOptions>;
  processStatus?: Maybe<TsrctNegotiationCaseProcessStatus>;
  processSteps: Array<TsrctNegotiationCaseProcessStep>;
  quote?: Maybe<TsrctQuote>;
  /** sequential number of the negotiation case */
  sequenceNumber: Scalars['BigInt']['output'];
  sourceReferences: Array<TsrctSourceReference>;
  status: TsrctNegotiationCaseStatus;
  strategy?: Maybe<TsrctNegotiationStrategy>;
  supplier: TsrctNegotiationCaseSupplier;
  supplierIntroductionMessage?: Maybe<TsrctSupplierIntroductionMessage>;
  updatedAt: Scalars['DateTime']['output'];
  upperDiscountBoundary: Scalars['TsrctDecimal']['output'];
  variant: TsrctNegotiationCaseVariant;
};

export type TsrctNegotiationCaseAdvancedInterface = {
  /** user who created the negotiation-case (UUID) */
  createdById?: Maybe<Scalars['UUID']['output']>;
  isMaskedBidding: Scalars['Boolean']['output'];
  isNegotiationEnabled: Scalars['Boolean']['output'];
  isReleasable: Scalars['Boolean']['output'];
  issues?: Maybe<Array<TsrctIssue>>;
  lowerDiscountBoundary: Scalars['TsrctDecimal']['output'];
  processSteps: Array<TsrctNegotiationCaseProcessStep>;
  strategy?: Maybe<TsrctNegotiationStrategy>;
  upperDiscountBoundary: Scalars['TsrctDecimal']['output'];
  variant: TsrctNegotiationCaseVariant;
};

export type TsrctNegotiationCaseCancelInput = {
  message?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<TsrctCaseCancellationReason>;
};

export enum TsrctNegotiationCaseFilterField {
  createdAt = 'createdAt',
  demandId = 'demandId',
  discount = 'discount',
  hasSupplierComment = 'hasSupplierComment',
  id = 'id',
  isReleasable = 'isReleasable',
  issuesCompletedCount = 'issuesCompletedCount',
  issuesOpenCount = 'issuesOpenCount',
  issuesTotalCount = 'issuesTotalCount',
  negotiationBoundaryLower = 'negotiationBoundaryLower',
  negotiationBoundaryUpper = 'negotiationBoundaryUpper',
  organizationId = 'organizationId',
  processStatus = 'processStatus',
  referenceId = 'referenceId',
  responsibleIds = 'responsibleIds',
  sequenceNumber = 'sequenceNumber',
  status = 'status',
  supplierContactEmail = 'supplierContactEmail',
  supplierContactFirstName = 'supplierContactFirstName',
  supplierContactLastName = 'supplierContactLastName',
  supplierContactPhone = 'supplierContactPhone',
  supplierExternalReference = 'supplierExternalReference',
  supplierId = 'supplierId',
  supplierName = 'supplierName',
  totalDiscountedValue = 'totalDiscountedValue',
  totalPriceDiscount = 'totalPriceDiscount',
  totalValue = 'totalValue',
  updatedAt = 'updatedAt'
}

export type TsrctNegotiationCaseForwardInput = {
  disclaimerAccepted: Scalars['Boolean']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  supplierContact: TsrctNegotiationCaseSupplierContactInput;
};

export type TsrctNegotiationCaseInput = {
  options?: InputMaybe<TsrctNegotiationCaseOptionsInput>;
  quote?: InputMaybe<TsrctQuoteInput>;
  strategy?: InputMaybe<TsrctNegotiationStrategyBoundariesInput>;
  supplier: TsrctNegotiationCaseSupplierInput;
};

export type TsrctNegotiationCaseInterface = {
  cancellationReason?: Maybe<TsrctCaseCancellationReason>;
  cancellationReasonText?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  isNegotiationEnabled: Scalars['Boolean']['output'];
  /** is the negotiation case releasable */
  isReleasable: Scalars['Boolean']['output'];
  isSupplierUploadAllowed: Scalars['Boolean']['output'];
  issues?: Maybe<Array<TsrctIssue>>;
  options?: Maybe<TsrctNegotiationCaseOptions>;
  processStatus?: Maybe<TsrctNegotiationCaseProcessStatus>;
  /** sequential number of the negotiation case */
  sequenceNumber: Scalars['BigInt']['output'];
  sourceReferences: Array<TsrctSourceReference>;
  status: TsrctNegotiationCaseStatus;
  strategy?: Maybe<TsrctNegotiationStrategy>;
  supplier: TsrctNegotiationCaseSupplier;
  supplierIntroductionMessage?: Maybe<TsrctSupplierIntroductionMessage>;
  updatedAt: Scalars['DateTime']['output'];
};

export type TsrctNegotiationCaseListConnection = {
  __typename?: 'TsrctNegotiationCaseListConnection';
  nodes: Array<TsrctNegotiationCaseListItem>;
  totalCount: Scalars['BigInt']['output'];
};

export type TsrctNegotiationCaseListItem = {
  __typename?: 'TsrctNegotiationCaseListItem';
  /** Reason the negotiation case was cancelled (enum). */
  cancellationReason?: Maybe<TsrctCaseCancellationReason>;
  /** Free-text comment provided when the negotiation case was cancelled. */
  cancellationReasonText?: Maybe<Scalars['String']['output']>;
  /** Creation date of the negotiation case. */
  createdAt: Scalars['DateTime']['output'];
  /** Currency of the negotiation case. */
  currency?: Maybe<Currency>;
  /** Internal ID of the demand. */
  demandId: Scalars['UUID']['output'];
  /** Sequence number of the demand. */
  demandSequenceNumber: Scalars['BigInt']['output'];
  /** Discount (%) agreed on in negotiation */
  discount?: Maybe<Scalars['TsrctDecimal']['output']>;
  /** Does the supplier have a comment */
  hasSupplierComment: Scalars['Boolean']['output'];
  /** Internal ID of the negotiation case. */
  id: Scalars['UUID']['output'];
  /** Set to true if the negotiation case is a masked bidding */
  isMaskedBidding: Scalars['Boolean']['output'];
  /** is the negotiation case releasable */
  isReleasable: Scalars['Boolean']['output'];
  /** Number of completed issues in the negotiation case. */
  issuesCompletedCount: Scalars['BigInt']['output'];
  /** Number of open issues in the negotiation case. */
  issuesOpenCount: Scalars['BigInt']['output'];
  /** Total number of issues in the negotiation case. */
  issuesTotalCount: Scalars['BigInt']['output'];
  /** Author ID of the latest comment. */
  latestCommentAuthorId?: Maybe<Scalars['UUID']['output']>;
  /** Creation date of the latest comment. */
  latestCommentCreatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Message of the latest comment on this negotiation case. */
  latestCommentMessage?: Maybe<Scalars['String']['output']>;
  /** Lower boundary of the negotiation */
  negotiationBoundaryLower?: Maybe<Scalars['TsrctDecimal']['output']>;
  /** Upper boundary of the negotiation */
  negotiationBoundaryUpper?: Maybe<Scalars['TsrctDecimal']['output']>;
  /** Organization ID of the demand. */
  organizationId?: Maybe<Scalars['UUID']['output']>;
  /** Process status of the negotiation case. */
  processStatus?: Maybe<TsrctNegotiationCaseProcessStatus>;
  /** Process steps with status */
  processSteps: Array<TsrctNegotiationCaseProcessStep>;
  /** External reference of the demand. */
  referenceId?: Maybe<Scalars['String']['output']>;
  /** Internal IDs of the responsible users. */
  responsibleIds: Array<Scalars['UUID']['output']>;
  /** Sequence number of the negotiation case. */
  sequenceNumber: Scalars['BigInt']['output'];
  /** Status of the negotiation case. */
  status?: Maybe<TsrctNegotiationCaseStatus>;
  /** Address (street + no) of the supplier. */
  supplierAddress?: Maybe<Scalars['String']['output']>;
  /** City of the supplier. */
  supplierCity?: Maybe<Scalars['String']['output']>;
  /** Email of the supplier contact. */
  supplierContactEmail?: Maybe<Scalars['String']['output']>;
  /** First name of the supplier contact. */
  supplierContactFirstName?: Maybe<Scalars['String']['output']>;
  /** Last name of the supplier contact. */
  supplierContactLastName?: Maybe<Scalars['String']['output']>;
  /** Phone of the supplier contact. */
  supplierContactPhone?: Maybe<Scalars['String']['output']>;
  /** Country code (ISO 3166-1 alpha-2) of the supplier. */
  supplierCountryCode?: Maybe<Scalars['String']['output']>;
  /** External reference of the supplier. */
  supplierExternalReference?: Maybe<Scalars['String']['output']>;
  /** Internal ID of the supplier. */
  supplierId?: Maybe<Scalars['UUID']['output']>;
  /** Name of the supplier. */
  supplierName?: Maybe<Scalars['String']['output']>;
  /** Postal code of the supplier. */
  supplierPostalCode?: Maybe<Scalars['String']['output']>;
  /** Total value minus discount */
  totalDiscountedValue?: Maybe<Scalars['TsrctDecimal']['output']>;
  /** Discount (in currency) agreed on in negotiation */
  totalPriceDiscount?: Maybe<Scalars['TsrctDecimal']['output']>;
  /** Total value of the negotiation case. */
  totalValue?: Maybe<Scalars['TsrctDecimal']['output']>;
  /** Last update date of the negotiation case. */
  updatedAt: Scalars['DateTime']['output'];
};

export type TsrctNegotiationCaseMutations = {
  __typename?: 'TsrctNegotiationCaseMutations';
  cancel?: Maybe<Scalars['Void']['output']>;
  delete?: Maybe<Scalars['Void']['output']>;
  negotiatedQuote: TsrctNegotiatedQuoteMutations;
  options: TsrctOptionsMutations;
  quote: TsrctQuoteMutations;
  release?: Maybe<Scalars['Void']['output']>;
  reset?: Maybe<Scalars['Void']['output']>;
  resubmit?: Maybe<Scalars['Void']['output']>;
  sendReminder?: Maybe<Scalars['Void']['output']>;
  strategy: TsrctStrategyMutations;
  supplier: TsrctNegotiationCaseSupplierMutations;
  supplierIntroductionMessage: TsrctSupplierIntroductionMessageMutation;
  updateNegotiationSettings: TsrctNegotiationCase;
};


export type TsrctNegotiationCaseMutationscancelArgs = {
  data: TsrctNegotiationCaseCancelInput;
};


export type TsrctNegotiationCaseMutationsupdateNegotiationSettingsArgs = {
  data: TsrctNegotiationCaseNegotiationSettingsInput;
};

export type TsrctNegotiationCaseNegotiationSettingsInput = {
  isEnabled: Scalars['Boolean']['input'];
  isSupplierUploadAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  negotiationOptions?: InputMaybe<TsrctNegotiationCaseOptionsWithIdInput>;
  negotiationStrategy?: InputMaybe<TsrctNegotiationCaseNegotiationStrategyInput>;
};

export type TsrctNegotiationCaseNegotiationStrategyInput = {
  boundaryAdjustments: TsrctNegotiationStrategyBoundaryAdjustmentsInput;
  boundaryRules: Array<TsrctNegotiationStrategyBoundaryRuleInput>;
};

export type TsrctNegotiationCaseOptions = {
  __typename?: 'TsrctNegotiationCaseOptions';
  id: Scalars['UUID']['output'];
  initiatedBy: TsrctInitiationMode;
  negotiationMode: TsrctNegotiationMode;
  negotiationObjective: TsrctNegotiationObjective;
  quoteMode: TsrctQuoteMode;
  supplierInteractionMode: TsrctSupplierInteractionMode;
};

export type TsrctNegotiationCaseOptionsInput = {
  initiatedBy: TsrctInitiationMode;
  isSupplierUploadAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  negotiationMode: TsrctNegotiationMode;
  negotiationObjective: TsrctNegotiationObjective;
  quoteMode: TsrctQuoteMode;
  supplierInteractionMode: TsrctSupplierInteractionMode;
};

export type TsrctNegotiationCaseOptionsWithIdInput = {
  initiatedBy: TsrctInitiationMode;
  negotiationMode: TsrctNegotiationMode;
  negotiationObjective: TsrctNegotiationObjective;
  quoteMode: TsrctQuoteMode;
  supplierInteractionMode: TsrctSupplierInteractionMode;
};

export type TsrctNegotiationCaseOrder = {
  field: TsrctNegotiationCaseOrderField;
  sort?: InputMaybe<TsrctSortDirection>;
};

export enum TsrctNegotiationCaseOrderField {
  createdAt = 'createdAt',
  demandId = 'demandId',
  demandSequenceNumber = 'demandSequenceNumber',
  discount = 'discount',
  hasSupplierComment = 'hasSupplierComment',
  id = 'id',
  isReleasable = 'isReleasable',
  issuesCompletedCount = 'issuesCompletedCount',
  issuesOpenCount = 'issuesOpenCount',
  issuesTotalCount = 'issuesTotalCount',
  latestComment = 'latestComment',
  negotiationBoundaryLower = 'negotiationBoundaryLower',
  negotiationBoundaryUpper = 'negotiationBoundaryUpper',
  processStatus = 'processStatus',
  referenceId = 'referenceId',
  sequenceNumber = 'sequenceNumber',
  status = 'status',
  supplierContactEmail = 'supplierContactEmail',
  supplierContactFirstName = 'supplierContactFirstName',
  supplierContactLastName = 'supplierContactLastName',
  supplierContactPhone = 'supplierContactPhone',
  supplierExternalReference = 'supplierExternalReference',
  supplierName = 'supplierName',
  totalDiscountedValue = 'totalDiscountedValue',
  totalPriceDiscount = 'totalPriceDiscount',
  totalValue = 'totalValue',
  updatedAt = 'updatedAt'
}

export enum TsrctNegotiationCaseProcessStatus {
  CANCELLED = 'CANCELLED',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  INVITATION_SENT = 'INVITATION_SENT',
  IN_PROGRESS = 'IN_PROGRESS',
  NEGOTIATION_SUCCESSFUL = 'NEGOTIATION_SUCCESSFUL',
  OPEN = 'OPEN'
}

export type TsrctNegotiationCaseProcessStep = {
  __typename?: 'TsrctNegotiationCaseProcessStep';
  status: TsrctNegotiationCaseProcessStepStatus;
  variant: TsrctNegotiationCaseProcessStepVariant;
};

export type TsrctNegotiationCaseProcessStepEvent = {
  __typename?: 'TsrctNegotiationCaseProcessStepEvent';
  id: Scalars['UUID']['output'];
};

export enum TsrctNegotiationCaseProcessStepStatus {
  COMPLETED = 'COMPLETED',
  OPEN = 'OPEN'
}

export enum TsrctNegotiationCaseProcessStepVariant {
  AWARDING_DEADLINE = 'AWARDING_DEADLINE',
  COMPETITIVE_BIDDING_DEADLINE = 'COMPETITIVE_BIDDING_DEADLINE',
  CONTACT = 'CONTACT',
  DEMAND_RELEASABLE = 'DEMAND_RELEASABLE',
  DEMAND_REQUEST = 'DEMAND_REQUEST',
  QUOTE = 'QUOTE',
  QUOTE_ITEMS_REQUESTED = 'QUOTE_ITEMS_REQUESTED'
}

export enum TsrctNegotiationCaseQuoteUploadStatus {
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  INITIALIZED = 'INITIALIZED',
  PROCESSED = 'PROCESSED'
}

export type TsrctNegotiationCaseReportIssueInput = {
  language: TsrctLanguage;
  message?: InputMaybe<Scalars['String']['input']>;
  negotiationCaseId: Scalars['String']['input'];
  variant: TsrctIssueVariant;
};

export type TsrctNegotiationCaseResolveIssueInput = {
  issueId: Scalars['UUID']['input'];
  negotiationCaseId: Scalars['UUID']['input'];
};

export enum TsrctNegotiationCaseStatus {
  AGREEMENT_CONFIRMED = 'AGREEMENT_CONFIRMED',
  AGREEMENT_REACHED = 'AGREEMENT_REACHED',
  AWARDED = 'AWARDED',
  CANCELLED_AFTER_INVITE_EMAIL_SENT = 'CANCELLED_AFTER_INVITE_EMAIL_SENT',
  CANCELLED_BEFORE_INVITE_EMAIL_SENT = 'CANCELLED_BEFORE_INVITE_EMAIL_SENT',
  CONTACT_DETAILS_CONFIRMED = 'CONTACT_DETAILS_CONFIRMED',
  INITIALIZED = 'INITIALIZED',
  INVITE_EMAIL_OPENED = 'INVITE_EMAIL_OPENED',
  INVITE_EMAIL_SENT = 'INVITE_EMAIL_SENT',
  LINK_OPENED = 'LINK_OPENED',
  MANUAL_NEGOTIATION = 'MANUAL_NEGOTIATION',
  NEGOTIATION_DETAILS_CONFIRMED = 'NEGOTIATION_DETAILS_CONFIRMED',
  NEGOTIATION_OPENED = 'NEGOTIATION_OPENED',
  NO_AGREEMENT_REACHED = 'NO_AGREEMENT_REACHED',
  OFFER_DISMISSED = 'OFFER_DISMISSED'
}

export type TsrctNegotiationCaseSupplier = {
  __typename?: 'TsrctNegotiationCaseSupplier';
  contact: TsrctNegotiationCaseSupplierContact;
  externalReference?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  internalId: Scalars['UUID']['output'];
  location: TsrctNegotiationCaseSupplierLocation;
  name: Scalars['String']['output'];
};

export type TsrctNegotiationCaseSupplierContact = {
  __typename?: 'TsrctNegotiationCaseSupplierContact';
  email?: Maybe<Scalars['EmailAddress']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  internalId?: Maybe<Scalars['UUID']['output']>;
  language: TsrctLanguage;
  lastName?: Maybe<Scalars['String']['output']>;
  mobile?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type TsrctNegotiationCaseSupplierContactInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  internalId?: InputMaybe<Scalars['String']['input']>;
  language: TsrctLanguage;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mobile?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type TsrctNegotiationCaseSupplierInput = {
  contact?: InputMaybe<TsrctNegotiationCaseSupplierContactInput>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  internalId: Scalars['String']['input'];
  location?: InputMaybe<TsrctNegotiationCaseSupplierLocationInput>;
  name: Scalars['String']['input'];
};

export type TsrctNegotiationCaseSupplierLocation = {
  __typename?: 'TsrctNegotiationCaseSupplierLocation';
  address?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<CountryCode>;
  id: Scalars['UUID']['output'];
  internalId?: Maybe<Scalars['UUID']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
};

export type TsrctNegotiationCaseSupplierLocationInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<CountryCode>;
  internalId: Scalars['String']['input'];
  postalCode?: InputMaybe<Scalars['String']['input']>;
};

export type TsrctNegotiationCaseSupplierMutations = {
  __typename?: 'TsrctNegotiationCaseSupplierMutations';
  contact: TsrctContactMutations;
};

export enum TsrctNegotiationCaseVariant {
  AUTOMATIC = 'AUTOMATIC',
  COMMODITY_SOURCING = 'COMMODITY_SOURCING',
  HISTORIC_PURCHASE_ORDER = 'HISTORIC_PURCHASE_ORDER',
  MANUAL = 'MANUAL',
  PREFERRED_SUPPLIER = 'PREFERRED_SUPPLIER'
}

export type TsrctNegotiationCasesMutations = {
  __typename?: 'TsrctNegotiationCasesMutations';
  republish?: Maybe<Scalars['Void']['output']>;
};

export enum TsrctNegotiationMode {
  LINE_ITEM = 'LINE_ITEM',
  QUOTE = 'QUOTE',
  SUPPLIER_SELECTION = 'SUPPLIER_SELECTION'
}

export enum TsrctNegotiationObjective {
  PRIORITISE_CLOSING = 'PRIORITISE_CLOSING',
  PRIORITISE_COMMERCIAL_RESULT = 'PRIORITISE_COMMERCIAL_RESULT'
}

export type TsrctNegotiationOptions = {
  __typename?: 'TsrctNegotiationOptions';
  id: Scalars['UUID']['output'];
  initiatedBy: TsrctSourcingCaseInitiationMode;
  negotiationObjective: TsrctSourcingCaseNegotiationObjective;
  supplierInteractionMode: TsrctSourcingCaseSupplierInteractionMode;
};

export type TsrctNegotiationStrategy = {
  __typename?: 'TsrctNegotiationStrategy';
  boundaryRules: Array<TsrctNegotiationStrategyBoundary>;
  id: Scalars['UUID']['output'];
  useHistoricNegotiationData: Scalars['Boolean']['output'];
  useHistoricTenderData: Scalars['Boolean']['output'];
};

export type TsrctNegotiationStrategyBoundariesInput = {
  boundaryAdjustments: TsrctNegotiationStrategyBoundaryAdjustmentsInput;
  boundaryRules: Array<TsrctNegotiationStrategyBoundaryRuleInput>;
};

export type TsrctNegotiationStrategyBoundary = {
  __typename?: 'TsrctNegotiationStrategyBoundary';
  base: TsrctNegotiationStrategyBoundaryBase;
  id: Scalars['UUID']['output'];
  lower: Scalars['TsrctDecimal']['output'];
  sequence: Scalars['Int']['output'];
  upper: Scalars['TsrctDecimal']['output'];
};

export type TsrctNegotiationStrategyBoundaryAdjustmentsInput = {
  historicNegotiations: Scalars['Boolean']['input'];
  historicTenderData: Scalars['Boolean']['input'];
};

export enum TsrctNegotiationStrategyBoundaryBase {
  BASELINE_PRICE = 'BASELINE_PRICE',
  BUDGET = 'BUDGET',
  COMPETITIVE_OFFER_AVG = 'COMPETITIVE_OFFER_AVG',
  COMPETITIVE_OFFER_MAX = 'COMPETITIVE_OFFER_MAX',
  COMPETITIVE_OFFER_MIN = 'COMPETITIVE_OFFER_MIN',
  EXPECTED_PRICE = 'EXPECTED_PRICE',
  QUOTED_PRICE = 'QUOTED_PRICE'
}

export type TsrctNegotiationStrategyBoundaryRuleInput = {
  base: TsrctNegotiationStrategyBoundaryBase;
  lower: Scalars['TsrctDecimal']['input'];
  upper: Scalars['TsrctDecimal']['input'];
};

export type TsrctOptionsMutations = {
  __typename?: 'TsrctOptionsMutations';
  update: TsrctNegotiationCaseOptions;
};


export type TsrctOptionsMutationsupdateArgs = {
  data: TsrctNegotiationCaseOptionsInput;
};

export type TsrctOverrideAutomaticAcceptanceTimingInput = {
  targetId: Scalars['UUID']['input'];
  timing: TsrctAutomaticAcceptanceTimingInput;
  variant: TsrctAutoAcceptTimingVariant;
};

export type TsrctPaymentTerm = {
  __typename?: 'TsrctPaymentTerm';
  daysToPayment: Scalars['Int']['output'];
  discount: Scalars['TsrctDecimal']['output'];
};

export type TsrctPaymentTermInput = {
  daysToPayment: Scalars['Int']['input'];
  discount: Scalars['TsrctDecimal']['input'];
};

export type TsrctPriorityMutations = {
  __typename?: 'TsrctPriorityMutations';
  update: TsrctDemand;
};


export type TsrctPriorityMutationsupdateArgs = {
  data: TsrctDemandPriorityUpdateInput;
};

export type TsrctQuote = TsrctQuoteInterface & {
  __typename?: 'TsrctQuote';
  createdAt: Scalars['DateTime']['output'];
  currency: Currency;
  hasSupplierComment: Scalars['Boolean']['output'];
  id: Scalars['UUID']['output'];
  lineItems: Array<TsrctQuoteItem>;
  paymentTerms: Array<TsrctPaymentTerm>;
  shipmentTerms: TsrctShipmentTerms;
  supplierReference?: Maybe<Scalars['String']['output']>;
  totalValue?: Maybe<Scalars['TsrctDecimal']['output']>;
};

export type TsrctQuoteInput = {
  currency?: InputMaybe<Currency>;
  fileId?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  lineItems: Array<TsrctQuoteItemInput>;
  paymentTerms?: InputMaybe<Array<TsrctPaymentTermInput>>;
  shipmentTerms?: InputMaybe<TsrctShipmentTermsInput>;
  supplierReference?: InputMaybe<Scalars['String']['input']>;
};

export type TsrctQuoteInterface = {
  createdAt: Scalars['DateTime']['output'];
  currency: Currency;
  hasSupplierComment: Scalars['Boolean']['output'];
  id: Scalars['UUID']['output'];
  lineItems: Array<TsrctQuoteItemInterface>;
  paymentTerms: Array<TsrctPaymentTerm>;
  shipmentTerms: TsrctShipmentTerms;
  supplierReference?: Maybe<Scalars['String']['output']>;
  totalValue?: Maybe<Scalars['TsrctDecimal']['output']>;
};

export type TsrctQuoteItem = TsrctQuoteItemInterface & {
  __typename?: 'TsrctQuoteItem';
  commodityId?: Maybe<Scalars['UUID']['output']>;
  deliveryLocationId?: Maybe<Scalars['UUID']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  organizationId?: Maybe<Scalars['UUID']['output']>;
  position: Scalars['String']['output'];
  pricePerUnit?: Maybe<Scalars['TsrctDecimal']['output']>;
  quantity: Scalars['TsrctDecimal']['output'];
  shipmentTerms: TsrctShipmentTerms;
  status: TsrctQuoteItemStatus;
  taxInformation?: Maybe<Scalars['JSON']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  totalValue?: Maybe<Scalars['TsrctDecimal']['output']>;
  unitId?: Maybe<Scalars['UUID']['output']>;
};

export type TsrctQuoteItemInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  pricePerUnit?: InputMaybe<Scalars['TsrctDecimal']['input']>;
  quantity?: InputMaybe<Scalars['TsrctDecimal']['input']>;
  shipmentTerms?: InputMaybe<TsrctShipmentTermsInput>;
  status?: InputMaybe<TsrctQuoteItemUpdatableStatus>;
  taxInformation?: InputMaybe<Scalars['JSON']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  unitId?: InputMaybe<Scalars['String']['input']>;
};

export type TsrctQuoteItemInterface = {
  commodityId?: Maybe<Scalars['UUID']['output']>;
  deliveryLocationId?: Maybe<Scalars['UUID']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  organizationId?: Maybe<Scalars['UUID']['output']>;
  position: Scalars['String']['output'];
  pricePerUnit?: Maybe<Scalars['TsrctDecimal']['output']>;
  quantity: Scalars['TsrctDecimal']['output'];
  shipmentTerms: TsrctShipmentTerms;
  status: TsrctQuoteItemStatus;
  taxInformation?: Maybe<Scalars['JSON']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  totalValue?: Maybe<Scalars['TsrctDecimal']['output']>;
  unitId?: Maybe<Scalars['UUID']['output']>;
};

export enum TsrctQuoteItemStatus {
  AGREEMENT_REACHED = 'AGREEMENT_REACHED',
  AWARDED = 'AWARDED',
  BID_DECLINED = 'BID_DECLINED',
  BID_PROVIDED = 'BID_PROVIDED',
  FINAL_OFFER_PROPOSED = 'FINAL_OFFER_PROPOSED',
  NEGOTIATION_FAILED = 'NEGOTIATION_FAILED',
  NOT_REQUESTED = 'NOT_REQUESTED',
  OFFER_DISMISSED = 'OFFER_DISMISSED',
  REQUESTED = 'REQUESTED'
}

export enum TsrctQuoteItemUpdatableStatus {
  NOT_REQUESTED = 'NOT_REQUESTED',
  REQUESTED = 'REQUESTED'
}

export type TsrctQuoteLineItemDeclineReasonInput = {
  reason?: InputMaybe<Scalars['String']['input']>;
  variant: TsrctSourcingCaseQuoteItemBidDeclineReason;
};

export enum TsrctQuoteMode {
  BID_SHEET = 'BID_SHEET',
  BID_SHEET_PROPOSAL = 'BID_SHEET_PROPOSAL',
  EDIT = 'EDIT',
  NOOP = 'NOOP',
  UPLOAD = 'UPLOAD'
}

export type TsrctQuoteMutations = {
  __typename?: 'TsrctQuoteMutations';
  create: TsrctQuote;
};


export type TsrctQuoteMutationscreateArgs = {
  data: TsrctQuoteInput;
};

export type TsrctQuoteOrNegotiatedQuote = TsrctNegotiatedQuote | TsrctQuote;

export type TsrctRecommendation = {
  __typename?: 'TsrctRecommendation';
  decisionStatus: TsrctRecommendationDecisionStatus;
  demandRequestItemId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  recommendedItem: Scalars['ID']['output'];
  variant: TsrctRecommendationVariant;
};

export enum TsrctRecommendationDecisionStatus {
  ACCEPTED = 'ACCEPTED',
  DISMISSED = 'DISMISSED',
  SUPERSEDED = 'SUPERSEDED',
  UNDECIDED = 'UNDECIDED',
  UPSTREAM = 'UPSTREAM'
}

export type TsrctRecommendationMutations = {
  __typename?: 'TsrctRecommendationMutations';
  apply: Array<TsrctRecommendation>;
};


export type TsrctRecommendationMutationsapplyArgs = {
  data: Array<TsrctRecommendationsInput>;
  demandId: Scalars['UUID']['input'];
};

export enum TsrctRecommendationVariant {
  CATALOGUE = 'CATALOGUE',
  COMMODITY_GROUP = 'COMMODITY_GROUP',
  CONTRACT = 'CONTRACT'
}

export type TsrctRecommendationsInput = {
  /** Decision status of the recommendation */
  decisionStatus: TsrctRecommendationDecisionStatus;
  /** ID of the recommendation */
  id: Scalars['UUID']['input'];
};

export type TsrctReleaseNegotiationCasesInput = {
  negotiationCaseIds: Array<Scalars['UUID']['input']>;
};

export type TsrctReminderConfig = {
  __typename?: 'TsrctReminderConfig';
  cancellationDelayWorkingDays?: Maybe<Scalars['Int']['output']>;
  executionTime: Scalars['String']['output'];
  reminderConfigId?: Maybe<Scalars['UUID']['output']>;
  reminderDelayWorkingDays?: Maybe<Scalars['Int']['output']>;
  source: TsrctReminderPolicySource;
  targetId: Scalars['UUID']['output'];
  timezone: Scalars['String']['output'];
  type: TsrctReminderType;
  variant: TsrctReminderConfigVariant;
};

export enum TsrctReminderConfigVariant {
  CONTRACT_DEMAND = 'CONTRACT_DEMAND',
  DEMAND = 'DEMAND',
  NEGOTIATION_CASE = 'NEGOTIATION_CASE',
  SOURCING_CASE = 'SOURCING_CASE'
}

export enum TsrctReminderPolicySource {
  case = 'case',
  default = 'default',
  parent = 'parent'
}

export enum TsrctReminderType {
  SUPPLIER_INACTIVE = 'SUPPLIER_INACTIVE'
}

export type TsrctResponsibleUsersMutations = {
  __typename?: 'TsrctResponsibleUsersMutations';
  update: TsrctDemand;
};


export type TsrctResponsibleUsersMutationsupdateArgs = {
  data: TsrctDemandResponsibleUsersInput;
};

export type TsrctRule = {
  __typename?: 'TsrctRule';
  currentRuleVersionId?: Maybe<Scalars['UUID']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  evaluationLog: TsrctRuleEvaluationLog;
  evaluationLogs: TsrctRuleEvaluationLogListConnection;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  responsibleUsers: Array<Scalars['UUID']['output']>;
  ruleVersion?: Maybe<TsrctRuleVersion>;
  ruleVersions: Array<TsrctRuleVersion>;
  sequenceNumber: Scalars['BigInt']['output'];
  status: TsrctRuleStatus;
  variant: TsrctRuleVariant;
};


export type TsrctRuleevaluationLogArgs = {
  id: Scalars['UUID']['input'];
};


export type TsrctRuleevaluationLogsArgs = {
  filter?: InputMaybe<Scalars['TsrctQueryBuilderQuery']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<TsrctRuleEvaluationLogOrder>>;
};


export type TsrctRuleruleVersionArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};

export type TsrctRuleBaseStats = {
  __typename?: 'TsrctRuleBaseStats';
  hits: Scalars['Int']['output'];
  /** the id of the node or edge */
  itemId: Scalars['UUID']['output'];
};

export type TsrctRuleCreateDataInput = {
  name: Scalars['String']['input'];
  responsibleUsers: Array<Scalars['UUID']['input']>;
  variant: TsrctRuleVariant;
};

export type TsrctRuleEvaluationLog = {
  __typename?: 'TsrctRuleEvaluationLog';
  /** Creation date of the negotiation case. */
  createdAt: Scalars['DateTime']['output'];
  /** Internal ID of the negotiation case. */
  id: Scalars['UUID']['output'];
  ruleVersion: TsrctRuleVersion;
};

export enum TsrctRuleEvaluationLogFilterField {
  createdAt = 'createdAt',
  evaluationInputVariant = 'evaluationInputVariant',
  id = 'id'
}

export type TsrctRuleEvaluationLogListConnection = {
  __typename?: 'TsrctRuleEvaluationLogListConnection';
  nodes: Array<TsrctRuleEvaluationLogListItem>;
  totalCount: Scalars['BigInt']['output'];
};

export type TsrctRuleEvaluationLogListItem = {
  __typename?: 'TsrctRuleEvaluationLogListItem';
  /** Creation date of the negotiation case. */
  createdAt: Scalars['DateTime']['output'];
  /** Internal ID of the negotiation case. */
  id: Scalars['UUID']['output'];
  sequenceNumber: Scalars['BigInt']['output'];
};

export type TsrctRuleEvaluationLogOrder = {
  field: TsrctRuleEvaluationLogOrderField;
  sort?: InputMaybe<TsrctSortDirection>;
};

export enum TsrctRuleEvaluationLogOrderField {
  createdAt = 'createdAt',
  id = 'id',
  sequenceNumber = 'sequenceNumber'
}

export enum TsrctRuleListCommodityCoverageRequestFilterField {
  commodityGroupIds = 'commodityGroupIds',
  createdAt = 'createdAt',
  id = 'id',
  name = 'name',
  responsibleIds = 'responsibleIds',
  sequenceNumber = 'sequenceNumber',
  status = 'status',
  updatedAt = 'updatedAt',
  variant = 'variant'
}

export type TsrctRuleListCommodityCoverageRequestItem = TsrctRuleListItemInterface & {
  __typename?: 'TsrctRuleListCommodityCoverageRequestItem';
  /** List of commodity groups associated with the rule. */
  commodityGroupIds: Array<Scalars['UUID']['output']>;
  /** When the rule was created */
  createdAt: Scalars['DateTime']['output'];
  /** Id of the rule. */
  id: Scalars['UUID']['output'];
  /** Name of the rule. */
  name: Scalars['String']['output'];
  /** List of responsible users */
  responsibleIds: Array<Scalars['UUID']['output']>;
  /** Sequence number of the rule. */
  sequenceNumber: Scalars['BigInt']['output'];
  /** Current status of the rule. */
  status: TsrctRuleStatus;
  /** When the rule was updated last */
  updatedAt: Scalars['DateTime']['output'];
  /** Variant of the rule. */
  variant: TsrctRuleVariant;
};

export type TsrctRuleListCommodityCoverageRequestItemConnection = {
  __typename?: 'TsrctRuleListCommodityCoverageRequestItemConnection';
  nodes: Array<TsrctRuleListCommodityCoverageRequestItem>;
  totalCount: Scalars['BigInt']['output'];
};

export type TsrctRuleListCommodityCoverageRequestOrder = {
  field: TsrctRuleListCommodityCoverageRequestOrderField;
  sort?: InputMaybe<TsrctSortDirection>;
};

export enum TsrctRuleListCommodityCoverageRequestOrderField {
  commodityGroupIds = 'commodityGroupIds',
  createdAt = 'createdAt',
  id = 'id',
  name = 'name',
  responsibleIds = 'responsibleIds',
  sequenceNumber = 'sequenceNumber',
  status = 'status',
  updatedAt = 'updatedAt',
  variant = 'variant'
}

export type TsrctRuleListItemInterface = {
  /** When the rule was created */
  createdAt: Scalars['DateTime']['output'];
  /** Id of the rule. */
  id: Scalars['UUID']['output'];
  /** Name of the rule. */
  name: Scalars['String']['output'];
  /** List of responsible users */
  responsibleIds: Array<Scalars['UUID']['output']>;
  /** Sequence number of the rule. */
  sequenceNumber: Scalars['BigInt']['output'];
  /** Current status of the rule. */
  status: TsrctRuleStatus;
  /** When the rule was updated last */
  updatedAt: Scalars['DateTime']['output'];
  /** Variant of the rule. */
  variant: TsrctRuleVariant;
};

export type TsrctRuleListQueries = {
  __typename?: 'TsrctRuleListQueries';
  commodityCoverageRequest: TsrctRuleListCommodityCoverageRequestItemConnection;
  sourcing: TsrctRuleListSourcingItemConnection;
};


export type TsrctRuleListQueriescommodityCoverageRequestArgs = {
  filter?: InputMaybe<Scalars['TsrctQueryBuilderQuery']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<TsrctRuleListCommodityCoverageRequestOrder>>;
};


export type TsrctRuleListQueriessourcingArgs = {
  filter?: InputMaybe<Scalars['TsrctQueryBuilderQuery']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<TsrctRuleListSourcingOrder>>;
};

export enum TsrctRuleListSourcingFilterField {
  accountingAreaIds = 'accountingAreaIds',
  commodityGroupIds = 'commodityGroupIds',
  createdAt = 'createdAt',
  id = 'id',
  name = 'name',
  organizationIds = 'organizationIds',
  responsibleIds = 'responsibleIds',
  sequenceNumber = 'sequenceNumber',
  sourceSystemIds = 'sourceSystemIds',
  status = 'status',
  updatedAt = 'updatedAt',
  variant = 'variant'
}

export type TsrctRuleListSourcingItem = TsrctRuleListItemInterface & {
  __typename?: 'TsrctRuleListSourcingItem';
  /** List of accountingAreas associated with the rule. */
  accountingAreaIds: Array<Scalars['UUID']['output']>;
  /** List of commodity groups associated with the rule. */
  commodityGroupIds: Array<Scalars['UUID']['output']>;
  /** When the rule was created */
  createdAt: Scalars['DateTime']['output'];
  /** Id of the rule. */
  id: Scalars['UUID']['output'];
  /** Name of the rule. */
  name: Scalars['String']['output'];
  /** List of organizations associated with the rule. */
  organizationIds: Array<Scalars['UUID']['output']>;
  /** List of responsible users */
  responsibleIds: Array<Scalars['UUID']['output']>;
  /** Sequence number of the rule. */
  sequenceNumber: Scalars['BigInt']['output'];
  /** List of sourceSystems associated with the rule. */
  sourceSystemIds: Array<Scalars['String']['output']>;
  /** Current status of the rule. */
  status: TsrctRuleStatus;
  /** When the rule was updated last */
  updatedAt: Scalars['DateTime']['output'];
  /** Variant of the rule. */
  variant: TsrctRuleVariant;
};

export type TsrctRuleListSourcingItemConnection = {
  __typename?: 'TsrctRuleListSourcingItemConnection';
  nodes: Array<TsrctRuleListSourcingItem>;
  totalCount: Scalars['BigInt']['output'];
};

export type TsrctRuleListSourcingOrder = {
  field: TsrctRuleListSourcingOrderField;
  sort?: InputMaybe<TsrctSortDirection>;
};

export enum TsrctRuleListSourcingOrderField {
  accountingAreaIds = 'accountingAreaIds',
  commodityGroupIds = 'commodityGroupIds',
  createdAt = 'createdAt',
  id = 'id',
  name = 'name',
  organizationIds = 'organizationIds',
  responsibleIds = 'responsibleIds',
  sequenceNumber = 'sequenceNumber',
  sourceSystemIds = 'sourceSystemIds',
  status = 'status',
  updatedAt = 'updatedAt',
  variant = 'variant'
}

export type TsrctRuleMutations = {
  __typename?: 'TsrctRuleMutations';
  create: TsrctRule;
  pause: TsrctRule;
  publish: TsrctRule;
  remove: TsrctRule;
  ruleVersion: TsrctRuleVersionMutations;
  update: TsrctRule;
};


export type TsrctRuleMutationscreateArgs = {
  data: TsrctRuleCreateDataInput;
};


export type TsrctRuleMutationspublishArgs = {
  ruleVersionId: Scalars['UUID']['input'];
};


export type TsrctRuleMutationsupdateArgs = {
  data: TsrctRuleUpdateDataInput;
};

export enum TsrctRuleStatus {
  DRAFT = 'DRAFT',
  PAUSED = 'PAUSED',
  PUBLISHED = 'PUBLISHED'
}

export type TsrctRuleUpdateDataInput = {
  name: Scalars['String']['input'];
  responsibleUsers: Array<Scalars['UUID']['input']>;
};

export enum TsrctRuleVariant {
  COMMODITY_COVERAGE_REQUEST = 'COMMODITY_COVERAGE_REQUEST',
  SOURCING = 'SOURCING'
}

export type TsrctRuleVersion = {
  __typename?: 'TsrctRuleVersion';
  graph: Scalars['JSON']['output'];
  id: Scalars['UUID']['output'];
  ruleId: Scalars['UUID']['output'];
  stats: TsrctRuleVersionStats;
  status: TsrctRuleVersionStatus;
};

export type TsrctRuleVersionMutations = {
  __typename?: 'TsrctRuleVersionMutations';
  save: TsrctRuleVersion;
};


export type TsrctRuleVersionMutationssaveArgs = {
  graph: Scalars['JSON']['input'];
};

export type TsrctRuleVersionStats = {
  __typename?: 'TsrctRuleVersionStats';
  edges: Array<TsrctRuleBaseStats>;
  id: Scalars['UUID']['output'];
  nodes: Array<TsrctRuleBaseStats>;
};

export enum TsrctRuleVersionStatus {
  DRAFT = 'DRAFT',
  TAGGED = 'TAGGED'
}

export type TsrctShipmentTerms = {
  __typename?: 'TsrctShipmentTerms';
  earlyDeliveryAt?: Maybe<Scalars['DateTime']['output']>;
  lateDeliveryAt?: Maybe<Scalars['DateTime']['output']>;
};

export type TsrctShipmentTermsInput = {
  earlyDeliveryAt?: InputMaybe<Scalars['DateTime']['input']>;
  lateDeliveryAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum TsrctSortDirection {
  asc = 'asc',
  desc = 'desc'
}

export type TsrctSourceReference = {
  __typename?: 'TsrctSourceReference';
  id: Scalars['UUID']['output'];
  sourceReference?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['URL']['output']>;
};

export type TsrctSourceSystem = {
  __typename?: 'TsrctSourceSystem';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type TsrctSourcingCase = {
  __typename?: 'TsrctSourcingCase';
  cancellationReason?: Maybe<TsrctCaseCancellationReason>;
  cancellationReasonText?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  demand?: Maybe<TsrctSourcingCaseDemandReference>;
  flow?: Maybe<TsrctSourcingCaseFlow>;
  id: Scalars['UUID']['output'];
  isAwardable: Scalars['Boolean']['output'];
  isNegotiationEnabled: Scalars['Boolean']['output'];
  isSupplierUploadAllowed: Scalars['Boolean']['output'];
  issues: Array<TsrctSourcingCaseIssue>;
  /** The latest comment on this sourcing case. */
  latestComment?: Maybe<TsrctComment>;
  negotiationOptions?: Maybe<TsrctNegotiationOptions>;
  negotiationStrategy?: Maybe<TsrctSourcingCaseNegotiationStrategy>;
  quote?: Maybe<TsrctSourcingCaseQuote>;
  sequenceNumber?: Maybe<Scalars['BigInt']['output']>;
  sourceReferences: Array<TsrctSourcingCaseReference>;
  status: TsrctSourcingCaseStatus;
  supplier?: Maybe<TsrctSourcingCaseSupplier>;
  updatedAt: Scalars['DateTime']['output'];
};

export type TsrctSourcingCaseBoundaryRule = {
  __typename?: 'TsrctSourcingCaseBoundaryRule';
  base: TsrctSourcingCaseNegotiationStrategyBoundaryBase;
  lower: Scalars['TsrctDecimal']['output'];
  upper: Scalars['TsrctDecimal']['output'];
};

export type TsrctSourcingCaseCancelInput = {
  message?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<TsrctCaseCancellationReason>;
};

export type TsrctSourcingCaseContactInput = {
  contactId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['EmailAddress']['input'];
  firstName: Scalars['String']['input'];
  language: TsrctLanguage;
  lastName: Scalars['String']['input'];
};

export type TsrctSourcingCaseCreateInput = {
  contact?: InputMaybe<TsrctSourcingCaseSupplierContactInput>;
  id: Scalars['UUID']['input'];
  name: Scalars['String']['input'];
};

export type TsrctSourcingCaseDemandReference = {
  __typename?: 'TsrctSourcingCaseDemandReference';
  id: Scalars['UUID']['output'];
  sequenceNumber: Scalars['BigInt']['output'];
};

export type TsrctSourcingCaseFlow = {
  __typename?: 'TsrctSourcingCaseFlow';
  id: Scalars['UUID']['output'];
  status: TsrctSourcingCaseFlowStatus;
  steps: Array<TsrctSourcingCaseFlowStep>;
};

export enum TsrctSourcingCaseFlowStatus {
  CANCELLED = 'CANCELLED',
  INITIALIZED = 'INITIALIZED',
  INVITE_EMAIL_SENT = 'INVITE_EMAIL_SENT'
}

export type TsrctSourcingCaseFlowStep = {
  __typename?: 'TsrctSourcingCaseFlowStep';
  hidden: Scalars['Boolean']['output'];
  id: Scalars['UUID']['output'];
  status: TsrctSourcingCaseFlowStepStatus;
  variant: TsrctSourcingCaseFlowStepVariant;
};

export enum TsrctSourcingCaseFlowStepStatus {
  COMPLETED = 'COMPLETED',
  NONE = 'NONE',
  PENDING = 'PENDING',
  PROCEED = 'PROCEED'
}

export enum TsrctSourcingCaseFlowStepVariant {
  CONTRACT_EPILOGUE = 'CONTRACT_EPILOGUE',
  CONTRACT_NEGOTIATE = 'CONTRACT_NEGOTIATE',
  CONTRACT_QUOTE_BID_SHEET = 'CONTRACT_QUOTE_BID_SHEET',
  CONTRACT_RESULT_CONFIRM = 'CONTRACT_RESULT_CONFIRM',
  CONTRACT_SUPPLIER_CONTACT_CONFIRM = 'CONTRACT_SUPPLIER_CONTACT_CONFIRM',
  NEGOTIATION_EPILOGUE = 'NEGOTIATION_EPILOGUE',
  NEGOTIATION_NEGOTIATE = 'NEGOTIATION_NEGOTIATE',
  NEGOTIATION_QUOTE_BID_SHEET = 'NEGOTIATION_QUOTE_BID_SHEET',
  NEGOTIATION_QUOTE_BID_SHEET_PROPOSAL = 'NEGOTIATION_QUOTE_BID_SHEET_PROPOSAL',
  NEGOTIATION_QUOTE_CONFIRM = 'NEGOTIATION_QUOTE_CONFIRM',
  NEGOTIATION_QUOTE_EDIT = 'NEGOTIATION_QUOTE_EDIT',
  NEGOTIATION_QUOTE_UPLOAD = 'NEGOTIATION_QUOTE_UPLOAD',
  NEGOTIATION_RESULT_CONFIRM = 'NEGOTIATION_RESULT_CONFIRM',
  NEGOTIATION_SUPPLIER_CONTACT_CONFIRM = 'NEGOTIATION_SUPPLIER_CONTACT_CONFIRM',
  NEGOTIATION_SUPPLIER_INVITE = 'NEGOTIATION_SUPPLIER_INVITE'
}

export enum TsrctSourcingCaseInitiationMode {
  PROCUREAI = 'PROCUREAI',
  SUPPLIER = 'SUPPLIER'
}

export type TsrctSourcingCaseIssue = {
  __typename?: 'TsrctSourcingCaseIssue';
  id: Scalars['UUID']['output'];
  status: TsrctIssueStatus;
  variant: TsrctIssueVariant;
};

export type TsrctSourcingCaseMutations = {
  __typename?: 'TsrctSourcingCaseMutations';
  cancel?: Maybe<TsrctSourcingCase>;
  delete?: Maybe<Scalars['Void']['output']>;
  release?: Maybe<Scalars['Void']['output']>;
  reset?: Maybe<TsrctSourcingCase>;
  resubmit?: Maybe<Scalars['Void']['output']>;
  sendReminder?: Maybe<TsrctSourcingCase>;
  updateContactDetails: TsrctSourcingCase;
  updateNegotiationSettings: TsrctSourcingCase;
  updateQuote: TsrctSourcingCase;
};


export type TsrctSourcingCaseMutationscancelArgs = {
  data?: InputMaybe<TsrctSourcingCaseCancelInput>;
};


export type TsrctSourcingCaseMutationsupdateContactDetailsArgs = {
  data: TsrctSourcingCaseContactInput;
};


export type TsrctSourcingCaseMutationsupdateNegotiationSettingsArgs = {
  data: TsrctSourcingCaseNegotiationSettingsInput;
};


export type TsrctSourcingCaseMutationsupdateQuoteArgs = {
  data: TsrctSourcingCaseQuoteInput;
};

export enum TsrctSourcingCaseNegotiationObjective {
  PRIORITISE_CLOSING = 'PRIORITISE_CLOSING',
  PRIORITISE_COMMERCIAL_RESULT = 'PRIORITISE_COMMERCIAL_RESULT'
}

export type TsrctSourcingCaseNegotiationOptionsInput = {
  initiatedBy: TsrctSourcingCaseInitiationMode;
  negotiationObjective: TsrctSourcingCaseNegotiationObjective;
  supplierInteractionMode: TsrctSourcingCaseSupplierInteractionMode;
};

export type TsrctSourcingCaseNegotiationSettingsInput = {
  isEnabled: Scalars['Boolean']['input'];
  isSupplierUploadAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  negotiationOptions?: InputMaybe<TsrctSourcingCaseNegotiationOptionsInput>;
  negotiationStrategy?: InputMaybe<TsrctSourcingCaseNegotiationStrategyInput>;
};

export type TsrctSourcingCaseNegotiationStrategy = {
  __typename?: 'TsrctSourcingCaseNegotiationStrategy';
  boundaryRules: Array<TsrctSourcingCaseBoundaryRule>;
  id: Scalars['UUID']['output'];
  useHistoricNegotiationData: Scalars['Boolean']['output'];
  useHistoricTenderData: Scalars['Boolean']['output'];
};

export type TsrctSourcingCaseNegotiationStrategyBoundaryAdjustmentsInput = {
  historicNegotiations: Scalars['Boolean']['input'];
  historicTenderData: Scalars['Boolean']['input'];
};

export enum TsrctSourcingCaseNegotiationStrategyBoundaryBase {
  BASELINE_PRICE = 'BASELINE_PRICE',
  BUDGET = 'BUDGET',
  COMPETITIVE_OFFER_AVG = 'COMPETITIVE_OFFER_AVG',
  COMPETITIVE_OFFER_MAX = 'COMPETITIVE_OFFER_MAX',
  COMPETITIVE_OFFER_MIN = 'COMPETITIVE_OFFER_MIN',
  EXPECTED_PRICE = 'EXPECTED_PRICE',
  QUOTED_PRICE = 'QUOTED_PRICE'
}

export type TsrctSourcingCaseNegotiationStrategyBoundaryRuleInput = {
  base: TsrctSourcingCaseNegotiationStrategyBoundaryBase;
  lower: Scalars['TsrctDecimal']['input'];
  sequence: Scalars['Int']['input'];
  upper: Scalars['TsrctDecimal']['input'];
};

export type TsrctSourcingCaseNegotiationStrategyInput = {
  boundaryRules: Array<TsrctSourcingCaseNegotiationStrategyBoundaryRuleInput>;
  useHistoricNegotiationData: Scalars['Boolean']['input'];
  useHistoricTenderData: Scalars['Boolean']['input'];
};

export type TsrctSourcingCaseQuote = {
  __typename?: 'TsrctSourcingCaseQuote';
  createdAt: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  discount?: Maybe<Scalars['TsrctDecimal']['output']>;
  id: Scalars['UUID']['output'];
  incoTermsId?: Maybe<Scalars['UUID']['output']>;
  lineItems: Array<TsrctSourcingCaseQuoteItem>;
  paymentTermsId?: Maybe<Scalars['UUID']['output']>;
  status: TsrctSourcingCaseQuoteStatus;
  supplierReference?: Maybe<Scalars['String']['output']>;
  totalDiscountedValue?: Maybe<Scalars['TsrctDecimal']['output']>;
  totalPriceDiscount?: Maybe<Scalars['TsrctDecimal']['output']>;
  totalValue?: Maybe<Scalars['TsrctDecimal']['output']>;
  validFrom: Scalars['DateTime']['output'];
  validTo: Scalars['DateTime']['output'];
};

export type TsrctSourcingCaseQuoteInput = {
  lineItems: Array<TsrctSourcingCaseQuoteLineItemInput>;
};

export type TsrctSourcingCaseQuoteItem = {
  __typename?: 'TsrctSourcingCaseQuoteItem';
  bidDeclinedReason?: Maybe<TsrctSourcingCaseQuoteItemBidDeclineReason>;
  bidDeclinedReasonText?: Maybe<Scalars['String']['output']>;
  commodityId?: Maybe<Scalars['UUID']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deliveryLocationId?: Maybe<Scalars['UUID']['output']>;
  demandRequestItemId: Scalars['UUID']['output'];
  description?: Maybe<Scalars['String']['output']>;
  discountedPricePerPriceUnit?: Maybe<Scalars['TsrctDecimal']['output']>;
  discountedPricePerUnit?: Maybe<Scalars['TsrctDecimal']['output']>;
  id: Scalars['UUID']['output'];
  isAwardable: Scalars['Boolean']['output'];
  minimumOrderQuantity?: Maybe<Scalars['TsrctDecimal']['output']>;
  negotiationFailedReason?: Maybe<TsrctSourcingCaseQuoteItemNegotiationFailedReason>;
  negotiationFailedReasonText?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['UUID']['output']>;
  pricePerPriceUnit?: Maybe<Scalars['TsrctDecimal']['output']>;
  pricePerUnit?: Maybe<Scalars['TsrctDecimal']['output']>;
  priceUnit: Scalars['TsrctDecimal']['output'];
  quantity: Scalars['TsrctDecimal']['output'];
  sequence: Scalars['Int']['output'];
  status: TsrctSourcingCaseQuoteItemStatus;
  title: Scalars['String']['output'];
  totalDiscountedValue?: Maybe<Scalars['TsrctDecimal']['output']>;
  totalValue?: Maybe<Scalars['TsrctDecimal']['output']>;
  unitId?: Maybe<Scalars['UUID']['output']>;
};

export enum TsrctSourcingCaseQuoteItemBidDeclineReason {
  CAPACITY_CONSTRAINTS = 'CAPACITY_CONSTRAINTS',
  DISCONTINUED = 'DISCONTINUED',
  GEOGRAPHICAL_LIMITATIONS = 'GEOGRAPHICAL_LIMITATIONS',
  MINIMUM_ORDER_NOT_MET = 'MINIMUM_ORDER_NOT_MET',
  OTHER = 'OTHER',
  OUT_OF_STOCK = 'OUT_OF_STOCK',
  REGULATORY_RESTRICTIONS = 'REGULATORY_RESTRICTIONS',
  TECHNICAL_LIMITATIONS = 'TECHNICAL_LIMITATIONS'
}

export enum TsrctSourcingCaseQuoteItemNegotiationFailedReason {
  COMMERCIAL_AGREEMENT_ALREADY_AGREED = 'COMMERCIAL_AGREEMENT_ALREADY_AGREED',
  OTHER = 'OTHER',
  PRICE_OUTDATED_AGE = 'PRICE_OUTDATED_AGE',
  PRICE_OUTDATED_TRADE_FAIR = 'PRICE_OUTDATED_TRADE_FAIR',
  TOO_MANY_OFFER_ROUNDS = 'TOO_MANY_OFFER_ROUNDS'
}

export enum TsrctSourcingCaseQuoteItemStatus {
  AGREEMENT_REACHED = 'AGREEMENT_REACHED',
  AWARDED = 'AWARDED',
  BID_DECLINED = 'BID_DECLINED',
  BID_PROVIDED = 'BID_PROVIDED',
  FINAL_OFFER_PROPOSED = 'FINAL_OFFER_PROPOSED',
  NEGOTIATION_FAILED = 'NEGOTIATION_FAILED',
  NOT_REQUESTED = 'NOT_REQUESTED',
  OFFER_DISMISSED = 'OFFER_DISMISSED',
  REQUESTED = 'REQUESTED'
}

export enum TsrctSourcingCaseQuoteItemUpdatableStatus {
  NOT_REQUESTED = 'NOT_REQUESTED',
  REQUESTED = 'REQUESTED'
}

export type TsrctSourcingCaseQuoteLineItemInput = {
  status: TsrctSourcingCaseQuoteItemUpdatableStatus;
};

export enum TsrctSourcingCaseQuoteStatus {
  BID_DECLINED = 'BID_DECLINED',
  BID_PROVIDED = 'BID_PROVIDED',
  DRAFT = 'DRAFT',
  NEGOTIATED = 'NEGOTIATED'
}

export type TsrctSourcingCaseReference = {
  __typename?: 'TsrctSourcingCaseReference';
  id: Scalars['UUID']['output'];
  sourceReference?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['URL']['output']>;
};

export enum TsrctSourcingCaseStatus {
  AWARDED = 'AWARDED',
  CANCELLED = 'CANCELLED',
  DRAFT = 'DRAFT',
  OFFER_DISMISSED = 'OFFER_DISMISSED',
  RELEASABLE = 'RELEASABLE',
  RELEASED = 'RELEASED',
  SUPPLIER_AGREEMENT_REACHED = 'SUPPLIER_AGREEMENT_REACHED'
}

export type TsrctSourcingCaseSupplier = {
  __typename?: 'TsrctSourcingCaseSupplier';
  contact: TsrctSourcingCaseSupplierContact;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  supplierId: Scalars['UUID']['output'];
};

export type TsrctSourcingCaseSupplierContact = {
  __typename?: 'TsrctSourcingCaseSupplierContact';
  email?: Maybe<Scalars['EmailAddress']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  internalId?: Maybe<Scalars['UUID']['output']>;
  language?: Maybe<TsrctLanguage>;
  lastName?: Maybe<Scalars['String']['output']>;
};

export type TsrctSourcingCaseSupplierContactInput = {
  contactId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['EmailAddress']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<TsrctLanguage>;
  lastName?: InputMaybe<Scalars['String']['input']>;
};

export enum TsrctSourcingCaseSupplierInteractionMode {
  COMMENT_ENABLED = 'COMMENT_ENABLED',
  FINAL_OFFER_ENABLED = 'FINAL_OFFER_ENABLED'
}

export enum TsrctStatus {
  ERROR = 'ERROR',
  NEUTRAL = 'NEUTRAL',
  SUCCESS = 'SUCCESS',
  WARNING = 'WARNING'
}

export type TsrctStrategyMutations = {
  __typename?: 'TsrctStrategyMutations';
  update: TsrctNegotiationStrategy;
};


export type TsrctStrategyMutationsupdateArgs = {
  data: TsrctNegotiationStrategyBoundariesInput;
};

export type TsrctSupplierAttachmentMutationInput = {
  attachments: Array<TsrctAttachmentMutationItemInput>;
};

export type TsrctSupplierCaseContactMutations = {
  __typename?: 'TsrctSupplierCaseContactMutations';
  update: TsrctNegotiationCaseSupplierContact;
};


export type TsrctSupplierCaseContactMutationsupdateArgs = {
  data: TsrctNegotiationCaseSupplierContactInput;
};

export type TsrctSupplierCaseQuoteMutations = {
  __typename?: 'TsrctSupplierCaseQuoteMutations';
  confirmBid: TsrctSupplierQuote;
  create: TsrctSupplierQuote;
};


export type TsrctSupplierCaseQuoteMutationscreateArgs = {
  data: TsrctQuoteInput;
};

export type TsrctSupplierComment = {
  __typename?: 'TsrctSupplierComment';
  text?: Maybe<Scalars['String']['output']>;
  variant: TsrctSupplierCommentVariant;
};

export enum TsrctSupplierCommentVariant {
  COMMERCIAL_AGREEMENT_ALREADY_AGREED = 'COMMERCIAL_AGREEMENT_ALREADY_AGREED',
  OTHER = 'OTHER',
  PRICE_OUTDATED_AGE = 'PRICE_OUTDATED_AGE',
  PRICE_OUTDATED_TRADE_FAIR = 'PRICE_OUTDATED_TRADE_FAIR'
}

export enum TsrctSupplierContactNamePolicy {
  NAME_WHEN_COMPLETE = 'NAME_WHEN_COMPLETE',
  REQUIRE_FULL = 'REQUIRE_FULL',
  USE_ANY_NAME = 'USE_ANY_NAME'
}

export type TsrctSupplierContactSettings = {
  __typename?: 'TsrctSupplierContactSettings';
  namePolicy: TsrctSupplierContactNamePolicy;
};

export type TsrctSupplierFlowMutations = {
  __typename?: 'TsrctSupplierFlowMutations';
  complete?: Maybe<Scalars['Void']['output']>;
  next?: Maybe<Scalars['Void']['output']>;
};


export type TsrctSupplierFlowMutationscompleteArgs = {
  variant: TsrctFlowStepVariant;
};

export enum TsrctSupplierInteractionMode {
  COMMENT_ENABLED = 'COMMENT_ENABLED',
  FINAL_OFFER_ENABLED = 'FINAL_OFFER_ENABLED'
}

export type TsrctSupplierIntroductionMessage = {
  __typename?: 'TsrctSupplierIntroductionMessage';
  language: TsrctLanguage;
  text: Scalars['String']['output'];
};

export type TsrctSupplierIntroductionMessageInput = {
  language: TsrctLanguage;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type TsrctSupplierIntroductionMessageMutation = {
  __typename?: 'TsrctSupplierIntroductionMessageMutation';
  update?: Maybe<TsrctSupplierIntroductionMessage>;
};


export type TsrctSupplierIntroductionMessageMutationupdateArgs = {
  data: TsrctSupplierIntroductionMessageInput;
};

export type TsrctSupplierMutations = {
  __typename?: 'TsrctSupplierMutations';
  flow: TsrctSupplierFlowMutations;
  negotiationCase: TsrctSupplierNegotiationCaseMutations;
  sourcingCase: TsrctSupplierSourcingCaseMutations;
};


export type TsrctSupplierMutationsflowArgs = {
  id: Scalars['UUID']['input'];
};


export type TsrctSupplierMutationsnegotiationCaseArgs = {
  id: Scalars['UUID']['input'];
};


export type TsrctSupplierMutationssourcingCaseArgs = {
  id: Scalars['UUID']['input'];
};

export type TsrctSupplierNegotiatedQuote = TsrctNegotiatedQuoteInterface & TsrctQuoteInterface & {
  __typename?: 'TsrctSupplierNegotiatedQuote';
  buyerReply?: Maybe<TsrctBuyerReply>;
  createdAt: Scalars['DateTime']['output'];
  currency: Currency;
  /** Discount in percentage */
  discount?: Maybe<Scalars['TsrctDecimal']['output']>;
  hasSupplierComment: Scalars['Boolean']['output'];
  id: Scalars['UUID']['output'];
  lineItems: Array<TsrctSupplierNegotiatedQuoteItem>;
  paymentTerms: Array<TsrctPaymentTerm>;
  shipmentTerms: TsrctShipmentTerms;
  supplierComment?: Maybe<TsrctSupplierComment>;
  supplierReference?: Maybe<Scalars['String']['output']>;
  /** Total savings (totalValue - totalPriceDiscount) */
  totalDiscountedValue?: Maybe<Scalars['TsrctDecimal']['output']>;
  totalDiscountedValueWithTaxes?: Maybe<Scalars['TsrctDecimal']['output']>;
  /** Discount in monetary value */
  totalPriceDiscount?: Maybe<Scalars['TsrctDecimal']['output']>;
  totalValue?: Maybe<Scalars['TsrctDecimal']['output']>;
};

export type TsrctSupplierNegotiatedQuoteItem = TsrctNegotiatedQuoteItemInterface & TsrctQuoteItemInterface & {
  __typename?: 'TsrctSupplierNegotiatedQuoteItem';
  commodityId?: Maybe<Scalars['UUID']['output']>;
  deliveryLocationId?: Maybe<Scalars['UUID']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<Scalars['TsrctDecimal']['output']>;
  discountedPricePerUnit?: Maybe<Scalars['TsrctDecimal']['output']>;
  id: Scalars['UUID']['output'];
  organizationId?: Maybe<Scalars['UUID']['output']>;
  position: Scalars['String']['output'];
  pricePerUnit?: Maybe<Scalars['TsrctDecimal']['output']>;
  quantity: Scalars['TsrctDecimal']['output'];
  shipmentTerms: TsrctShipmentTerms;
  status: TsrctQuoteItemStatus;
  supplierComment?: Maybe<TsrctSupplierComment>;
  taxInformation?: Maybe<Scalars['JSON']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  totalDiscountedValue?: Maybe<Scalars['TsrctDecimal']['output']>;
  totalDiscountedValueWithTaxes?: Maybe<Scalars['TsrctDecimal']['output']>;
  totalValue?: Maybe<Scalars['TsrctDecimal']['output']>;
  unitId?: Maybe<Scalars['UUID']['output']>;
};

export type TsrctSupplierNegotiationCase = TsrctNegotiationCaseInterface & {
  __typename?: 'TsrctSupplierNegotiationCase';
  cancellationReason?: Maybe<TsrctCaseCancellationReason>;
  cancellationReasonText?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  files: Array<TsrctFile>;
  id: Scalars['UUID']['output'];
  isNegotiationEnabled: Scalars['Boolean']['output'];
  /** is the negotiation case releasable */
  isReleasable: Scalars['Boolean']['output'];
  isSupplierUploadAllowed: Scalars['Boolean']['output'];
  issues?: Maybe<Array<TsrctIssue>>;
  negotiatedQuote?: Maybe<TsrctSupplierNegotiatedQuote>;
  options?: Maybe<TsrctNegotiationCaseOptions>;
  processStatus?: Maybe<TsrctNegotiationCaseProcessStatus>;
  quote?: Maybe<TsrctSupplierQuote>;
  /** sequential number of the negotiation case */
  sequenceNumber: Scalars['BigInt']['output'];
  sourceReferences: Array<TsrctSourceReference>;
  status: TsrctNegotiationCaseStatus;
  strategy?: Maybe<TsrctNegotiationStrategy>;
  supplier: TsrctNegotiationCaseSupplier;
  supplierIntroductionMessage?: Maybe<TsrctSupplierIntroductionMessage>;
  updatedAt: Scalars['DateTime']['output'];
};


export type TsrctSupplierNegotiationCasefilesArgs = {
  filter?: InputMaybe<TsrctAttachmentFilterInput>;
};

export type TsrctSupplierNegotiationCaseMutations = {
  __typename?: 'TsrctSupplierNegotiationCaseMutations';
  attachmentsUpdate: TsrctAttachmentMutationPayload;
  contact: TsrctSupplierCaseContactMutations;
  finalise?: Maybe<Scalars['Void']['output']>;
  forward?: Maybe<Scalars['Void']['output']>;
  options: TsrctSupplierOptionsMutations;
  quote: TsrctSupplierCaseQuoteMutations;
};


export type TsrctSupplierNegotiationCaseMutationsattachmentsUpdateArgs = {
  data: TsrctSupplierAttachmentMutationInput;
};


export type TsrctSupplierNegotiationCaseMutationsforwardArgs = {
  data: TsrctNegotiationCaseForwardInput;
};

export type TsrctSupplierNegotiationCaseOptions = {
  __typename?: 'TsrctSupplierNegotiationCaseOptions';
  negotiationMode: TsrctNegotiationMode;
};

export type TsrctSupplierNegotiationCaseOptionsUpdateInput = {
  negotiationMode: TsrctNegotiationMode;
};

export type TsrctSupplierOptionsMutations = {
  __typename?: 'TsrctSupplierOptionsMutations';
  switchNegotiationMode: TsrctNegotiationCaseOptions;
};


export type TsrctSupplierOptionsMutationsswitchNegotiationModeArgs = {
  data: TsrctSupplierNegotiationCaseOptionsUpdateInput;
};

export type TsrctSupplierQueries = {
  __typename?: 'TsrctSupplierQueries';
  flow: TsrctFlow;
  intercom: TsrctIntercom;
  negotiationCase: TsrctSupplierNegotiationCase;
  negotiationCaseIdFromFlow: Scalars['UUID']['output'];
};


export type TsrctSupplierQueriesflowArgs = {
  id: Scalars['UUID']['input'];
};


export type TsrctSupplierQueriesnegotiationCaseArgs = {
  id: Scalars['UUID']['input'];
};


export type TsrctSupplierQueriesnegotiationCaseIdFromFlowArgs = {
  flowId: Scalars['UUID']['input'];
};

export type TsrctSupplierQuote = TsrctQuoteInterface & {
  __typename?: 'TsrctSupplierQuote';
  createdAt: Scalars['DateTime']['output'];
  currency: Currency;
  hasSupplierComment: Scalars['Boolean']['output'];
  id: Scalars['UUID']['output'];
  lineItems: Array<TsrctSupplierQuoteItem>;
  paymentTerms: Array<TsrctPaymentTerm>;
  shipmentTerms: TsrctShipmentTerms;
  supplierReference?: Maybe<Scalars['String']['output']>;
  totalValue?: Maybe<Scalars['TsrctDecimal']['output']>;
};

export type TsrctSupplierQuoteItem = TsrctQuoteItemInterface & {
  __typename?: 'TsrctSupplierQuoteItem';
  commodityId?: Maybe<Scalars['UUID']['output']>;
  deliveryLocationId?: Maybe<Scalars['UUID']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  organizationId?: Maybe<Scalars['UUID']['output']>;
  position: Scalars['String']['output'];
  pricePerUnit?: Maybe<Scalars['TsrctDecimal']['output']>;
  quantity: Scalars['TsrctDecimal']['output'];
  shipmentTerms: TsrctShipmentTerms;
  status: TsrctQuoteItemStatus;
  taxInformation?: Maybe<Scalars['JSON']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  totalValue?: Maybe<Scalars['TsrctDecimal']['output']>;
  unitId?: Maybe<Scalars['UUID']['output']>;
};

export type TsrctSupplierSourcingCase = {
  __typename?: 'TsrctSupplierSourcingCase';
  contact?: Maybe<TsrctSupplierSourcingCaseContact>;
  files: Array<TsrctFile>;
  id: Scalars['UUID']['output'];
  isSupplierUploadAllowed: Scalars['Boolean']['output'];
  quote?: Maybe<TsrctSupplierSourcingCaseQuote>;
  sequenceNumber?: Maybe<Scalars['BigInt']['output']>;
};


export type TsrctSupplierSourcingCasefilesArgs = {
  filter?: InputMaybe<TsrctAttachmentFilterInput>;
};

export type TsrctSupplierSourcingCaseAttachmentMutationInput = {
  attachments: Array<TsrctAttachmentMutationItemInput>;
};

export type TsrctSupplierSourcingCaseContact = {
  __typename?: 'TsrctSupplierSourcingCaseContact';
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
};

export type TsrctSupplierSourcingCaseForwardInput = {
  disclaimerAccepted: Scalars['Boolean']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  supplierContact: TsrctSupplierSourcingCaseSupplierContactInput;
};

export type TsrctSupplierSourcingCaseMutations = {
  __typename?: 'TsrctSupplierSourcingCaseMutations';
  attachmentsUpdate: TsrctAttachmentMutationPayload;
  confirmAgreement: TsrctSupplierSourcingCase;
  confirmBid: TsrctSupplierSourcingCase;
  forward: TsrctSupplierSourcingCase;
  updateQuote: TsrctSupplierSourcingCase;
};


export type TsrctSupplierSourcingCaseMutationsattachmentsUpdateArgs = {
  data: TsrctSupplierSourcingCaseAttachmentMutationInput;
};


export type TsrctSupplierSourcingCaseMutationsforwardArgs = {
  data: TsrctSupplierSourcingCaseForwardInput;
};


export type TsrctSupplierSourcingCaseMutationsupdateQuoteArgs = {
  data: TsrctSupplierSourcingCaseQuoteInput;
};

export type TsrctSupplierSourcingCaseQuote = {
  __typename?: 'TsrctSupplierSourcingCaseQuote';
  createdAt: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  discount?: Maybe<Scalars['TsrctDecimal']['output']>;
  id: Scalars['UUID']['output'];
  incoTermsId?: Maybe<Scalars['UUID']['output']>;
  lineItems: Array<TsrctSupplierSourcingCaseQuoteItem>;
  paymentTermsId?: Maybe<Scalars['UUID']['output']>;
  supplierReference?: Maybe<Scalars['String']['output']>;
  totalDiscountedValue?: Maybe<Scalars['TsrctDecimal']['output']>;
  totalPriceDiscount?: Maybe<Scalars['TsrctDecimal']['output']>;
  totalValue?: Maybe<Scalars['TsrctDecimal']['output']>;
  validFrom: Scalars['DateTime']['output'];
  validTo: Scalars['DateTime']['output'];
};

export type TsrctSupplierSourcingCaseQuoteInput = {
  lineItems: Array<TsrctSupplierSourcingCaseQuoteLineItemInput>;
  supplierReference: Scalars['String']['input'];
};

export type TsrctSupplierSourcingCaseQuoteItem = {
  __typename?: 'TsrctSupplierSourcingCaseQuoteItem';
  bidDeclinedReason?: Maybe<TsrctSourcingCaseQuoteItemBidDeclineReason>;
  bidDeclinedReasonText?: Maybe<Scalars['String']['output']>;
  commodityId?: Maybe<Scalars['UUID']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deliveryLocationId?: Maybe<Scalars['UUID']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<Scalars['TsrctDecimal']['output']>;
  discountedPricePerPriceUnit?: Maybe<Scalars['TsrctDecimal']['output']>;
  discountedPricePerUnit?: Maybe<Scalars['TsrctDecimal']['output']>;
  id: Scalars['UUID']['output'];
  minimumOrderQuantity?: Maybe<Scalars['TsrctDecimal']['output']>;
  negotiationFailedReason?: Maybe<Scalars['String']['output']>;
  negotiationFailedReasonText?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['UUID']['output']>;
  pricePerPriceUnit?: Maybe<Scalars['TsrctDecimal']['output']>;
  pricePerUnit?: Maybe<Scalars['TsrctDecimal']['output']>;
  priceUnit: Scalars['TsrctDecimal']['output'];
  quantity: Scalars['TsrctDecimal']['output'];
  sequence: Scalars['Int']['output'];
  status: TsrctSourcingCaseQuoteItemStatus;
  title: Scalars['String']['output'];
  totalDiscountedValue?: Maybe<Scalars['TsrctDecimal']['output']>;
  totalValue?: Maybe<Scalars['TsrctDecimal']['output']>;
  unitId?: Maybe<Scalars['UUID']['output']>;
};

export type TsrctSupplierSourcingCaseQuoteLineItemInput = {
  declinedReason?: InputMaybe<TsrctQuoteLineItemDeclineReasonInput>;
  id: Scalars['UUID']['input'];
  pricePerUnit?: InputMaybe<Scalars['TsrctDecimal']['input']>;
};

export type TsrctSupplierSourcingCaseSupplierContactInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  internalId?: InputMaybe<Scalars['String']['input']>;
  language: TsrctLanguage;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mobile?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type TsrctUpdateReminderConfigInput = {
  cancellationDelayWorkingDays?: InputMaybe<Scalars['Int']['input']>;
  executionTime: Scalars['String']['input'];
  reminderDelayWorkingDays?: InputMaybe<Scalars['Int']['input']>;
  targetId: Scalars['UUID']['input'];
  timezone: Scalars['String']['input'];
  type: TsrctReminderType;
  variant: TsrctReminderConfigVariant;
};

export enum TsrctUploadedByVariant {
  INTERNAL_USER = 'INTERNAL_USER',
  SUPPLIER_USER = 'SUPPLIER_USER'
}

export type ValidationError = {
  __typename?: 'ValidationError';
  ctx?: Maybe<Scalars['JSON']['output']>;
  input?: Maybe<Scalars['JSON']['output']>;
  loc: Array<Maybe<query_checkFeaturePermission_oneOf_1_detail_items_loc_items>>;
  msg: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type Write = {
  __typename?: 'Write';
  String?: Maybe<Scalars['String']['output']>;
  Void?: Maybe<Scalars['Void']['output']>;
};

/** columns and relationships of "appConfig" */
export type appConfig = {
  __typename?: 'appConfig';
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  navDrawerPinned: Scalars['Boolean']['output'];
  updatedAt: Scalars['timestamptz']['output'];
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** aggregated selection of "appConfig" */
export type appConfig_aggregate = {
  __typename?: 'appConfig_aggregate';
  aggregate?: Maybe<appConfig_aggregate_fields>;
  nodes: Array<appConfig>;
};

/** aggregate fields of "appConfig" */
export type appConfig_aggregate_fields = {
  __typename?: 'appConfig_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<appConfig_max_fields>;
  min?: Maybe<appConfig_min_fields>;
};


/** aggregate fields of "appConfig" */
export type appConfig_aggregate_fieldscountArgs = {
  columns?: InputMaybe<Array<appConfig_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "appConfig". All fields are combined with a logical 'AND'. */
export type appConfig_bool_exp = {
  _and?: InputMaybe<Array<appConfig_bool_exp>>;
  _not?: InputMaybe<appConfig_bool_exp>;
  _or?: InputMaybe<Array<appConfig_bool_exp>>;
  createdAt?: InputMaybe<timestamptz_comparison_exp>;
  id?: InputMaybe<uuid_comparison_exp>;
  navDrawerPinned?: InputMaybe<Boolean_comparison_exp>;
  updatedAt?: InputMaybe<timestamptz_comparison_exp>;
  userId?: InputMaybe<uuid_comparison_exp>;
};

/** unique or primary key constraints on table "appConfig" */
export enum appConfig_constraint {
  /** unique or primary key constraint on columns "id" */
  appConfig_pkey = 'appConfig_pkey',
  /** unique or primary key constraint on columns "userId" */
  appConfig_userId_key = 'appConfig_userId_key'
}

/** input type for inserting data into table "appConfig" */
export type appConfig_insert_input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  navDrawerPinned?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type appConfig_max_fields = {
  __typename?: 'appConfig_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type appConfig_min_fields = {
  __typename?: 'appConfig_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "appConfig" */
export type appConfig_mutation_response = {
  __typename?: 'appConfig_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<appConfig>;
};

/** on_conflict condition type for table "appConfig" */
export type appConfig_on_conflict = {
  constraint: appConfig_constraint;
  update_columns?: Array<appConfig_update_column>;
  where?: InputMaybe<appConfig_bool_exp>;
};

/** Ordering options when selecting data from "appConfig". */
export type appConfig_order_by = {
  createdAt?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  navDrawerPinned?: InputMaybe<order_by>;
  updatedAt?: InputMaybe<order_by>;
  userId?: InputMaybe<order_by>;
};

/** primary key columns input for table: appConfig */
export type appConfig_pk_columns_input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "appConfig" */
export enum appConfig_select_column {
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  id = 'id',
  /** column name */
  navDrawerPinned = 'navDrawerPinned',
  /** column name */
  updatedAt = 'updatedAt',
  /** column name */
  userId = 'userId'
}

/** input type for updating data in table "appConfig" */
export type appConfig_set_input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  navDrawerPinned?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "appConfig" */
export type appConfig_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: appConfig_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type appConfig_stream_cursor_value_input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  navDrawerPinned?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "appConfig" */
export enum appConfig_update_column {
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  id = 'id',
  /** column name */
  navDrawerPinned = 'navDrawerPinned',
  /** column name */
  updatedAt = 'updatedAt',
  /** column name */
  userId = 'userId'
}

export type appConfig_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<appConfig_set_input>;
  where: appConfig_bool_exp;
};

export type astronautMutation = {
  __typename?: 'astronautMutation';
  smartLink: AstroSmartLinkMutations;
  user: AstroUserMutations;
};


export type astronautMutationuserArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};

export type astronautQuery = {
  __typename?: 'astronautQuery';
  responsibleUsers: Array<AstroResponsibleUserItem>;
  smartLink: AstroSmartLink;
  smartLinks: Array<AstroSmartLink>;
  user: AstroUserDetails;
  userAvailability: AstroUserAvailabilityListItemConnection;
  userByEmail: AstroUserDetails;
};


export type astronautQueryresponsibleUsersArgs = {
  capabilityIds?: InputMaybe<Array<Scalars['String']['input']>>;
  commodityGroupIds?: InputMaybe<Array<Scalars['String']['input']>>;
  filterBy?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type astronautQuerysmartLinkArgs = {
  slug: Scalars['String']['input'];
};


export type astronautQuerysmartLinksArgs = {
  domain: AstroSmartLinkDomain;
};


export type astronautQueryuserArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type astronautQueryuserAvailabilityArgs = {
  dateRange?: InputMaybe<AstroDateRangeInput>;
  filter?: InputMaybe<Scalars['AstroQueryBuilderQuery']['input']>;
  order?: InputMaybe<Array<AstroUserAvailabilityOrder>>;
};


export type astronautQueryuserByEmailArgs = {
  email: Scalars['EmailAddress']['input'];
};

/** columns and relationships of "baseColumnConfig" */
export type baseColumnConfig = {
  __typename?: 'baseColumnConfig';
  config?: Maybe<Scalars['jsonb']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  domain: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  updatedAt: Scalars['timestamptz']['output'];
  userId?: Maybe<Scalars['uuid']['output']>;
};


/** columns and relationships of "baseColumnConfig" */
export type baseColumnConfigconfigArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "baseColumnConfig" */
export type baseColumnConfig_aggregate = {
  __typename?: 'baseColumnConfig_aggregate';
  aggregate?: Maybe<baseColumnConfig_aggregate_fields>;
  nodes: Array<baseColumnConfig>;
};

/** aggregate fields of "baseColumnConfig" */
export type baseColumnConfig_aggregate_fields = {
  __typename?: 'baseColumnConfig_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<baseColumnConfig_max_fields>;
  min?: Maybe<baseColumnConfig_min_fields>;
};


/** aggregate fields of "baseColumnConfig" */
export type baseColumnConfig_aggregate_fieldscountArgs = {
  columns?: InputMaybe<Array<baseColumnConfig_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type baseColumnConfig_append_input = {
  config?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "baseColumnConfig". All fields are combined with a logical 'AND'. */
export type baseColumnConfig_bool_exp = {
  _and?: InputMaybe<Array<baseColumnConfig_bool_exp>>;
  _not?: InputMaybe<baseColumnConfig_bool_exp>;
  _or?: InputMaybe<Array<baseColumnConfig_bool_exp>>;
  config?: InputMaybe<jsonb_comparison_exp>;
  createdAt?: InputMaybe<timestamptz_comparison_exp>;
  domain?: InputMaybe<String_comparison_exp>;
  id?: InputMaybe<uuid_comparison_exp>;
  updatedAt?: InputMaybe<timestamptz_comparison_exp>;
  userId?: InputMaybe<uuid_comparison_exp>;
};

/** unique or primary key constraints on table "baseColumnConfig" */
export enum baseColumnConfig_constraint {
  /** unique or primary key constraint on columns "id" */
  baseColumnConfig_id_key = 'baseColumnConfig_id_key',
  /** unique or primary key constraint on columns "id" */
  baseColumnConfig_pkey = 'baseColumnConfig_pkey',
  /** unique or primary key constraint on columns "domain", "userId" */
  baseColumnConfig_userId_domain_key = 'baseColumnConfig_userId_domain_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type baseColumnConfig_delete_at_path_input = {
  config?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type baseColumnConfig_delete_elem_input = {
  config?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type baseColumnConfig_delete_key_input = {
  config?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "baseColumnConfig" */
export type baseColumnConfig_insert_input = {
  config?: InputMaybe<Scalars['jsonb']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type baseColumnConfig_max_fields = {
  __typename?: 'baseColumnConfig_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  domain?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type baseColumnConfig_min_fields = {
  __typename?: 'baseColumnConfig_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  domain?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "baseColumnConfig" */
export type baseColumnConfig_mutation_response = {
  __typename?: 'baseColumnConfig_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<baseColumnConfig>;
};

/** on_conflict condition type for table "baseColumnConfig" */
export type baseColumnConfig_on_conflict = {
  constraint: baseColumnConfig_constraint;
  update_columns?: Array<baseColumnConfig_update_column>;
  where?: InputMaybe<baseColumnConfig_bool_exp>;
};

/** Ordering options when selecting data from "baseColumnConfig". */
export type baseColumnConfig_order_by = {
  config?: InputMaybe<order_by>;
  createdAt?: InputMaybe<order_by>;
  domain?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  updatedAt?: InputMaybe<order_by>;
  userId?: InputMaybe<order_by>;
};

/** primary key columns input for table: baseColumnConfig */
export type baseColumnConfig_pk_columns_input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type baseColumnConfig_prepend_input = {
  config?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "baseColumnConfig" */
export enum baseColumnConfig_select_column {
  /** column name */
  config = 'config',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  domain = 'domain',
  /** column name */
  id = 'id',
  /** column name */
  updatedAt = 'updatedAt',
  /** column name */
  userId = 'userId'
}

/** input type for updating data in table "baseColumnConfig" */
export type baseColumnConfig_set_input = {
  config?: InputMaybe<Scalars['jsonb']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "baseColumnConfig" */
export type baseColumnConfig_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: baseColumnConfig_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type baseColumnConfig_stream_cursor_value_input = {
  config?: InputMaybe<Scalars['jsonb']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "baseColumnConfig" */
export enum baseColumnConfig_update_column {
  /** column name */
  config = 'config',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  domain = 'domain',
  /** column name */
  id = 'id',
  /** column name */
  updatedAt = 'updatedAt',
  /** column name */
  userId = 'userId'
}

export type baseColumnConfig_updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<baseColumnConfig_append_input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<baseColumnConfig_delete_at_path_input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<baseColumnConfig_delete_elem_input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<baseColumnConfig_delete_key_input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<baseColumnConfig_prepend_input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<baseColumnConfig_set_input>;
  where: baseColumnConfig_bool_exp;
};

/** columns and relationships of "capability" */
export type capability = {
  __typename?: 'capability';
  description: Scalars['jsonb']['output'];
  id: Scalars['uuid']['output'];
  name: Scalars['jsonb']['output'];
};


/** columns and relationships of "capability" */
export type capabilitydescriptionArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "capability" */
export type capabilitynameArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "capability" */
export type capability_aggregate = {
  __typename?: 'capability_aggregate';
  aggregate?: Maybe<capability_aggregate_fields>;
  nodes: Array<capability>;
};

/** aggregate fields of "capability" */
export type capability_aggregate_fields = {
  __typename?: 'capability_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<capability_max_fields>;
  min?: Maybe<capability_min_fields>;
};


/** aggregate fields of "capability" */
export type capability_aggregate_fieldscountArgs = {
  columns?: InputMaybe<Array<capability_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type capability_append_input = {
  description?: InputMaybe<Scalars['jsonb']['input']>;
  name?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "capability". All fields are combined with a logical 'AND'. */
export type capability_bool_exp = {
  _and?: InputMaybe<Array<capability_bool_exp>>;
  _not?: InputMaybe<capability_bool_exp>;
  _or?: InputMaybe<Array<capability_bool_exp>>;
  description?: InputMaybe<jsonb_comparison_exp>;
  id?: InputMaybe<uuid_comparison_exp>;
  name?: InputMaybe<jsonb_comparison_exp>;
};

/** unique or primary key constraints on table "capability" */
export enum capability_constraint {
  /** unique or primary key constraint on columns "id" */
  capability_pkey = 'capability_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type capability_delete_at_path_input = {
  description?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type capability_delete_elem_input = {
  description?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type capability_delete_key_input = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "capability" */
export type capability_insert_input = {
  description?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate max on columns */
export type capability_max_fields = {
  __typename?: 'capability_max_fields';
  id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type capability_min_fields = {
  __typename?: 'capability_min_fields';
  id?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "capability" */
export type capability_mutation_response = {
  __typename?: 'capability_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<capability>;
};

/** on_conflict condition type for table "capability" */
export type capability_on_conflict = {
  constraint: capability_constraint;
  update_columns?: Array<capability_update_column>;
  where?: InputMaybe<capability_bool_exp>;
};

/** Ordering options when selecting data from "capability". */
export type capability_order_by = {
  description?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
};

/** primary key columns input for table: capability */
export type capability_pk_columns_input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type capability_prepend_input = {
  description?: InputMaybe<Scalars['jsonb']['input']>;
  name?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "capability" */
export enum capability_select_column {
  /** column name */
  description = 'description',
  /** column name */
  id = 'id',
  /** column name */
  name = 'name'
}

/** input type for updating data in table "capability" */
export type capability_set_input = {
  description?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Streaming cursor of the table "capability" */
export type capability_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: capability_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type capability_stream_cursor_value_input = {
  description?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['jsonb']['input']>;
};

/** update columns of table "capability" */
export enum capability_update_column {
  /** column name */
  description = 'description',
  /** column name */
  id = 'id',
  /** column name */
  name = 'name'
}

export type capability_updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<capability_append_input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<capability_delete_at_path_input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<capability_delete_elem_input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<capability_delete_key_input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<capability_prepend_input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<capability_set_input>;
  /** filter the rows which have to be updated */
  where: capability_bool_exp;
};

export type cataclysmQuery = {
  __typename?: 'cataclysmQuery';
  countries: Array<CaclCountry>;
  countryReport: CaclCountryReport;
  countryReports: Array<CaclCountryReportListItem>;
  risk: CaclRisk;
  riskCategories: Array<CaclRiskCategory>;
  riskCategory: CaclRiskCategory;
  risks: Array<CaclRisk>;
  supplier: CaclSupplier;
};


export type cataclysmQuerycountryReportArgs = {
  id: Scalars['UUID']['input'];
};


export type cataclysmQueryriskArgs = {
  id: Scalars['UUID']['input'];
};


export type cataclysmQueryriskCategoryArgs = {
  id: Scalars['UUID']['input'];
};


export type cataclysmQuerysupplierArgs = {
  id: Scalars['UUID']['input'];
};

export type checkDataPermissionCreated_response = CheckResponse | HTTPValidationError;

export type checkDataPermission_response = CheckResponse | HTTPValidationError;

export type checkFeaturePermission_response = CheckResponse | HTTPValidationError;

export type cmdiMutation = {
  __typename?: 'cmdiMutation';
  /** delete data from the table: "capability" */
  delete_capability?: Maybe<capability_mutation_response>;
  /** delete single row from the table: "capability" */
  delete_capability_by_pk?: Maybe<capability>;
  /** delete data from the table: "contact" */
  delete_contact?: Maybe<contact_mutation_response>;
  /** delete data from the table: "contact_role_variant" */
  delete_contactRoleVariant?: Maybe<contactRoleVariant_mutation_response>;
  /** delete single row from the table: "contact_role_variant" */
  delete_contactRoleVariant_by_pk?: Maybe<contactRoleVariant>;
  /** delete single row from the table: "contact" */
  delete_contact_by_pk?: Maybe<contact>;
  /** delete data from the table: "language" */
  delete_language?: Maybe<language_mutation_response>;
  /** delete single row from the table: "language" */
  delete_language_by_pk?: Maybe<language>;
  /** delete data from the table: "meta.column_config" */
  delete_meta_columnConfig?: Maybe<meta_columnConfig_mutation_response>;
  /** delete single row from the table: "meta.column_config" */
  delete_meta_columnConfig_by_pk?: Maybe<meta_columnConfig>;
  /** delete data from the table: "meta.entity" */
  delete_meta_entity?: Maybe<meta_entity_mutation_response>;
  /** delete single row from the table: "meta.entity" */
  delete_meta_entity_by_pk?: Maybe<meta_entity>;
  /** insert data into the table: "capability" */
  insert_capability?: Maybe<capability_mutation_response>;
  /** insert a single row into the table: "capability" */
  insert_capability_one?: Maybe<capability>;
  /** insert data into the table: "contact" */
  insert_contact?: Maybe<contact_mutation_response>;
  /** insert data into the table: "contact_role_variant" */
  insert_contactRoleVariant?: Maybe<contactRoleVariant_mutation_response>;
  /** insert a single row into the table: "contact_role_variant" */
  insert_contactRoleVariant_one?: Maybe<contactRoleVariant>;
  /** insert a single row into the table: "contact" */
  insert_contact_one?: Maybe<contact>;
  /** insert data into the table: "language" */
  insert_language?: Maybe<language_mutation_response>;
  /** insert a single row into the table: "language" */
  insert_language_one?: Maybe<language>;
  /** insert data into the table: "meta.column_config" */
  insert_meta_columnConfig?: Maybe<meta_columnConfig_mutation_response>;
  /** insert a single row into the table: "meta.column_config" */
  insert_meta_columnConfig_one?: Maybe<meta_columnConfig>;
  /** insert data into the table: "meta.entity" */
  insert_meta_entity?: Maybe<meta_entity_mutation_response>;
  /** insert a single row into the table: "meta.entity" */
  insert_meta_entity_one?: Maybe<meta_entity>;
  /** update data of the table: "capability" */
  update_capability?: Maybe<capability_mutation_response>;
  /** update single row of the table: "capability" */
  update_capability_by_pk?: Maybe<capability>;
  /** update multiples rows of table: "capability" */
  update_capability_many?: Maybe<Array<Maybe<capability_mutation_response>>>;
  /** update data of the table: "contact" */
  update_contact?: Maybe<contact_mutation_response>;
  /** update data of the table: "contact_role_variant" */
  update_contactRoleVariant?: Maybe<contactRoleVariant_mutation_response>;
  /** update single row of the table: "contact_role_variant" */
  update_contactRoleVariant_by_pk?: Maybe<contactRoleVariant>;
  /** update multiples rows of table: "contact_role_variant" */
  update_contactRoleVariant_many?: Maybe<Array<Maybe<contactRoleVariant_mutation_response>>>;
  /** update single row of the table: "contact" */
  update_contact_by_pk?: Maybe<contact>;
  /** update multiples rows of table: "contact" */
  update_contact_many?: Maybe<Array<Maybe<contact_mutation_response>>>;
  /** update data of the table: "language" */
  update_language?: Maybe<language_mutation_response>;
  /** update single row of the table: "language" */
  update_language_by_pk?: Maybe<language>;
  /** update multiples rows of table: "language" */
  update_language_many?: Maybe<Array<Maybe<language_mutation_response>>>;
  /** update data of the table: "meta.column_config" */
  update_meta_columnConfig?: Maybe<meta_columnConfig_mutation_response>;
  /** update single row of the table: "meta.column_config" */
  update_meta_columnConfig_by_pk?: Maybe<meta_columnConfig>;
  /** update multiples rows of table: "meta.column_config" */
  update_meta_columnConfig_many?: Maybe<Array<Maybe<meta_columnConfig_mutation_response>>>;
  /** update data of the table: "meta.entity" */
  update_meta_entity?: Maybe<meta_entity_mutation_response>;
  /** update single row of the table: "meta.entity" */
  update_meta_entity_by_pk?: Maybe<meta_entity>;
  /** update multiples rows of table: "meta.entity" */
  update_meta_entity_many?: Maybe<Array<Maybe<meta_entity_mutation_response>>>;
};


export type cmdiMutationdelete_capabilityArgs = {
  where: capability_bool_exp;
};


export type cmdiMutationdelete_capability_by_pkArgs = {
  id: Scalars['uuid']['input'];
};


export type cmdiMutationdelete_contactArgs = {
  where: contact_bool_exp;
};


export type cmdiMutationdelete_contactRoleVariantArgs = {
  where: contactRoleVariant_bool_exp;
};


export type cmdiMutationdelete_contactRoleVariant_by_pkArgs = {
  role: Scalars['String']['input'];
};


export type cmdiMutationdelete_contact_by_pkArgs = {
  id: Scalars['uuid']['input'];
};


export type cmdiMutationdelete_languageArgs = {
  where: language_bool_exp;
};


export type cmdiMutationdelete_language_by_pkArgs = {
  isoCode: Scalars['String']['input'];
};


export type cmdiMutationdelete_meta_columnConfigArgs = {
  where: meta_columnConfig_bool_exp;
};


export type cmdiMutationdelete_meta_columnConfig_by_pkArgs = {
  id: Scalars['uuid']['input'];
};


export type cmdiMutationdelete_meta_entityArgs = {
  where: meta_entity_bool_exp;
};


export type cmdiMutationdelete_meta_entity_by_pkArgs = {
  id: Scalars['uuid']['input'];
};


export type cmdiMutationinsert_capabilityArgs = {
  objects: Array<capability_insert_input>;
  on_conflict?: InputMaybe<capability_on_conflict>;
};


export type cmdiMutationinsert_capability_oneArgs = {
  object: capability_insert_input;
  on_conflict?: InputMaybe<capability_on_conflict>;
};


export type cmdiMutationinsert_contactArgs = {
  objects: Array<contact_insert_input>;
  on_conflict?: InputMaybe<contact_on_conflict>;
};


export type cmdiMutationinsert_contactRoleVariantArgs = {
  objects: Array<contactRoleVariant_insert_input>;
  on_conflict?: InputMaybe<contactRoleVariant_on_conflict>;
};


export type cmdiMutationinsert_contactRoleVariant_oneArgs = {
  object: contactRoleVariant_insert_input;
  on_conflict?: InputMaybe<contactRoleVariant_on_conflict>;
};


export type cmdiMutationinsert_contact_oneArgs = {
  object: contact_insert_input;
  on_conflict?: InputMaybe<contact_on_conflict>;
};


export type cmdiMutationinsert_languageArgs = {
  objects: Array<language_insert_input>;
  on_conflict?: InputMaybe<language_on_conflict>;
};


export type cmdiMutationinsert_language_oneArgs = {
  object: language_insert_input;
  on_conflict?: InputMaybe<language_on_conflict>;
};


export type cmdiMutationinsert_meta_columnConfigArgs = {
  objects: Array<meta_columnConfig_insert_input>;
  on_conflict?: InputMaybe<meta_columnConfig_on_conflict>;
};


export type cmdiMutationinsert_meta_columnConfig_oneArgs = {
  object: meta_columnConfig_insert_input;
  on_conflict?: InputMaybe<meta_columnConfig_on_conflict>;
};


export type cmdiMutationinsert_meta_entityArgs = {
  objects: Array<meta_entity_insert_input>;
  on_conflict?: InputMaybe<meta_entity_on_conflict>;
};


export type cmdiMutationinsert_meta_entity_oneArgs = {
  object: meta_entity_insert_input;
  on_conflict?: InputMaybe<meta_entity_on_conflict>;
};


export type cmdiMutationupdate_capabilityArgs = {
  _append?: InputMaybe<capability_append_input>;
  _delete_at_path?: InputMaybe<capability_delete_at_path_input>;
  _delete_elem?: InputMaybe<capability_delete_elem_input>;
  _delete_key?: InputMaybe<capability_delete_key_input>;
  _prepend?: InputMaybe<capability_prepend_input>;
  _set?: InputMaybe<capability_set_input>;
  where: capability_bool_exp;
};


export type cmdiMutationupdate_capability_by_pkArgs = {
  _append?: InputMaybe<capability_append_input>;
  _delete_at_path?: InputMaybe<capability_delete_at_path_input>;
  _delete_elem?: InputMaybe<capability_delete_elem_input>;
  _delete_key?: InputMaybe<capability_delete_key_input>;
  _prepend?: InputMaybe<capability_prepend_input>;
  _set?: InputMaybe<capability_set_input>;
  pk_columns: capability_pk_columns_input;
};


export type cmdiMutationupdate_capability_manyArgs = {
  updates: Array<capability_updates>;
};


export type cmdiMutationupdate_contactArgs = {
  _set?: InputMaybe<contact_set_input>;
  where: contact_bool_exp;
};


export type cmdiMutationupdate_contactRoleVariantArgs = {
  _set?: InputMaybe<contactRoleVariant_set_input>;
  where: contactRoleVariant_bool_exp;
};


export type cmdiMutationupdate_contactRoleVariant_by_pkArgs = {
  _set?: InputMaybe<contactRoleVariant_set_input>;
  pk_columns: contactRoleVariant_pk_columns_input;
};


export type cmdiMutationupdate_contactRoleVariant_manyArgs = {
  updates: Array<contactRoleVariant_updates>;
};


export type cmdiMutationupdate_contact_by_pkArgs = {
  _set?: InputMaybe<contact_set_input>;
  pk_columns: contact_pk_columns_input;
};


export type cmdiMutationupdate_contact_manyArgs = {
  updates: Array<contact_updates>;
};


export type cmdiMutationupdate_languageArgs = {
  _set?: InputMaybe<language_set_input>;
  where: language_bool_exp;
};


export type cmdiMutationupdate_language_by_pkArgs = {
  _set?: InputMaybe<language_set_input>;
  pk_columns: language_pk_columns_input;
};


export type cmdiMutationupdate_language_manyArgs = {
  updates: Array<language_updates>;
};


export type cmdiMutationupdate_meta_columnConfigArgs = {
  _append?: InputMaybe<meta_columnConfig_append_input>;
  _delete_at_path?: InputMaybe<meta_columnConfig_delete_at_path_input>;
  _delete_elem?: InputMaybe<meta_columnConfig_delete_elem_input>;
  _delete_key?: InputMaybe<meta_columnConfig_delete_key_input>;
  _prepend?: InputMaybe<meta_columnConfig_prepend_input>;
  _set?: InputMaybe<meta_columnConfig_set_input>;
  where: meta_columnConfig_bool_exp;
};


export type cmdiMutationupdate_meta_columnConfig_by_pkArgs = {
  _append?: InputMaybe<meta_columnConfig_append_input>;
  _delete_at_path?: InputMaybe<meta_columnConfig_delete_at_path_input>;
  _delete_elem?: InputMaybe<meta_columnConfig_delete_elem_input>;
  _delete_key?: InputMaybe<meta_columnConfig_delete_key_input>;
  _prepend?: InputMaybe<meta_columnConfig_prepend_input>;
  _set?: InputMaybe<meta_columnConfig_set_input>;
  pk_columns: meta_columnConfig_pk_columns_input;
};


export type cmdiMutationupdate_meta_columnConfig_manyArgs = {
  updates: Array<meta_columnConfig_updates>;
};


export type cmdiMutationupdate_meta_entityArgs = {
  _append?: InputMaybe<meta_entity_append_input>;
  _delete_at_path?: InputMaybe<meta_entity_delete_at_path_input>;
  _delete_elem?: InputMaybe<meta_entity_delete_elem_input>;
  _delete_key?: InputMaybe<meta_entity_delete_key_input>;
  _prepend?: InputMaybe<meta_entity_prepend_input>;
  _set?: InputMaybe<meta_entity_set_input>;
  where: meta_entity_bool_exp;
};


export type cmdiMutationupdate_meta_entity_by_pkArgs = {
  _append?: InputMaybe<meta_entity_append_input>;
  _delete_at_path?: InputMaybe<meta_entity_delete_at_path_input>;
  _delete_elem?: InputMaybe<meta_entity_delete_elem_input>;
  _delete_key?: InputMaybe<meta_entity_delete_key_input>;
  _prepend?: InputMaybe<meta_entity_prepend_input>;
  _set?: InputMaybe<meta_entity_set_input>;
  pk_columns: meta_entity_pk_columns_input;
};


export type cmdiMutationupdate_meta_entity_manyArgs = {
  updates: Array<meta_entity_updates>;
};

export type cmdiQuery = {
  __typename?: 'cmdiQuery';
  /** fetch data from the table: "capability" */
  capability: Array<capability>;
  /** fetch aggregated fields from the table: "capability" */
  capability_aggregate: capability_aggregate;
  /** fetch data from the table: "capability" using primary key columns */
  capability_by_pk?: Maybe<capability>;
  /** fetch data from the table: "contact" */
  contact: Array<contact>;
  /** fetch data from the table: "contact_role_variant" */
  contactRoleVariant: Array<contactRoleVariant>;
  /** fetch aggregated fields from the table: "contact_role_variant" */
  contactRoleVariant_aggregate: contactRoleVariant_aggregate;
  /** fetch data from the table: "contact_role_variant" using primary key columns */
  contactRoleVariant_by_pk?: Maybe<contactRoleVariant>;
  /** fetch aggregated fields from the table: "contact" */
  contact_aggregate: contact_aggregate;
  /** fetch data from the table: "contact" using primary key columns */
  contact_by_pk?: Maybe<contact>;
  /** fetch data from the table: "language" */
  language: Array<language>;
  /** fetch aggregated fields from the table: "language" */
  language_aggregate: language_aggregate;
  /** fetch data from the table: "language" using primary key columns */
  language_by_pk?: Maybe<language>;
  /** fetch data from the table: "meta.column_config" */
  meta_columnConfig: Array<meta_columnConfig>;
  /** fetch aggregated fields from the table: "meta.column_config" */
  meta_columnConfig_aggregate: meta_columnConfig_aggregate;
  /** fetch data from the table: "meta.column_config" using primary key columns */
  meta_columnConfig_by_pk?: Maybe<meta_columnConfig>;
  /** fetch data from the table: "meta.entity" */
  meta_entity: Array<meta_entity>;
  /** fetch aggregated fields from the table: "meta.entity" */
  meta_entity_aggregate: meta_entity_aggregate;
  /** fetch data from the table: "meta.entity" using primary key columns */
  meta_entity_by_pk?: Maybe<meta_entity>;
};


export type cmdiQuerycapabilityArgs = {
  distinct_on?: InputMaybe<Array<capability_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<capability_order_by>>;
  where?: InputMaybe<capability_bool_exp>;
};


export type cmdiQuerycapability_aggregateArgs = {
  distinct_on?: InputMaybe<Array<capability_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<capability_order_by>>;
  where?: InputMaybe<capability_bool_exp>;
};


export type cmdiQuerycapability_by_pkArgs = {
  id: Scalars['uuid']['input'];
};


export type cmdiQuerycontactArgs = {
  distinct_on?: InputMaybe<Array<contact_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<contact_order_by>>;
  where?: InputMaybe<contact_bool_exp>;
};


export type cmdiQuerycontactRoleVariantArgs = {
  distinct_on?: InputMaybe<Array<contactRoleVariant_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<contactRoleVariant_order_by>>;
  where?: InputMaybe<contactRoleVariant_bool_exp>;
};


export type cmdiQuerycontactRoleVariant_aggregateArgs = {
  distinct_on?: InputMaybe<Array<contactRoleVariant_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<contactRoleVariant_order_by>>;
  where?: InputMaybe<contactRoleVariant_bool_exp>;
};


export type cmdiQuerycontactRoleVariant_by_pkArgs = {
  role: Scalars['String']['input'];
};


export type cmdiQuerycontact_aggregateArgs = {
  distinct_on?: InputMaybe<Array<contact_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<contact_order_by>>;
  where?: InputMaybe<contact_bool_exp>;
};


export type cmdiQuerycontact_by_pkArgs = {
  id: Scalars['uuid']['input'];
};


export type cmdiQuerylanguageArgs = {
  distinct_on?: InputMaybe<Array<language_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<language_order_by>>;
  where?: InputMaybe<language_bool_exp>;
};


export type cmdiQuerylanguage_aggregateArgs = {
  distinct_on?: InputMaybe<Array<language_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<language_order_by>>;
  where?: InputMaybe<language_bool_exp>;
};


export type cmdiQuerylanguage_by_pkArgs = {
  isoCode: Scalars['String']['input'];
};


export type cmdiQuerymeta_columnConfigArgs = {
  distinct_on?: InputMaybe<Array<meta_columnConfig_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<meta_columnConfig_order_by>>;
  where?: InputMaybe<meta_columnConfig_bool_exp>;
};


export type cmdiQuerymeta_columnConfig_aggregateArgs = {
  distinct_on?: InputMaybe<Array<meta_columnConfig_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<meta_columnConfig_order_by>>;
  where?: InputMaybe<meta_columnConfig_bool_exp>;
};


export type cmdiQuerymeta_columnConfig_by_pkArgs = {
  id: Scalars['uuid']['input'];
};


export type cmdiQuerymeta_entityArgs = {
  distinct_on?: InputMaybe<Array<meta_entity_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<meta_entity_order_by>>;
  where?: InputMaybe<meta_entity_bool_exp>;
};


export type cmdiQuerymeta_entity_aggregateArgs = {
  distinct_on?: InputMaybe<Array<meta_entity_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<meta_entity_order_by>>;
  where?: InputMaybe<meta_entity_bool_exp>;
};


export type cmdiQuerymeta_entity_by_pkArgs = {
  id: Scalars['uuid']['input'];
};

export type cmdiSubscription = {
  __typename?: 'cmdiSubscription';
  /** fetch data from the table: "capability" */
  capability: Array<capability>;
  /** fetch aggregated fields from the table: "capability" */
  capability_aggregate: capability_aggregate;
  /** fetch data from the table: "capability" using primary key columns */
  capability_by_pk?: Maybe<capability>;
  /** fetch data from the table in a streaming manner: "capability" */
  capability_stream: Array<capability>;
  /** fetch data from the table: "contact" */
  contact: Array<contact>;
  /** fetch data from the table: "contact_role_variant" */
  contactRoleVariant: Array<contactRoleVariant>;
  /** fetch aggregated fields from the table: "contact_role_variant" */
  contactRoleVariant_aggregate: contactRoleVariant_aggregate;
  /** fetch data from the table: "contact_role_variant" using primary key columns */
  contactRoleVariant_by_pk?: Maybe<contactRoleVariant>;
  /** fetch data from the table in a streaming manner: "contact_role_variant" */
  contactRoleVariant_stream: Array<contactRoleVariant>;
  /** fetch aggregated fields from the table: "contact" */
  contact_aggregate: contact_aggregate;
  /** fetch data from the table: "contact" using primary key columns */
  contact_by_pk?: Maybe<contact>;
  /** fetch data from the table in a streaming manner: "contact" */
  contact_stream: Array<contact>;
  /** fetch data from the table: "language" */
  language: Array<language>;
  /** fetch aggregated fields from the table: "language" */
  language_aggregate: language_aggregate;
  /** fetch data from the table: "language" using primary key columns */
  language_by_pk?: Maybe<language>;
  /** fetch data from the table in a streaming manner: "language" */
  language_stream: Array<language>;
  /** fetch data from the table: "meta.column_config" */
  meta_columnConfig: Array<meta_columnConfig>;
  /** fetch aggregated fields from the table: "meta.column_config" */
  meta_columnConfig_aggregate: meta_columnConfig_aggregate;
  /** fetch data from the table: "meta.column_config" using primary key columns */
  meta_columnConfig_by_pk?: Maybe<meta_columnConfig>;
  /** fetch data from the table in a streaming manner: "meta.column_config" */
  meta_columnConfig_stream: Array<meta_columnConfig>;
  /** fetch data from the table: "meta.entity" */
  meta_entity: Array<meta_entity>;
  /** fetch aggregated fields from the table: "meta.entity" */
  meta_entity_aggregate: meta_entity_aggregate;
  /** fetch data from the table: "meta.entity" using primary key columns */
  meta_entity_by_pk?: Maybe<meta_entity>;
  /** fetch data from the table in a streaming manner: "meta.entity" */
  meta_entity_stream: Array<meta_entity>;
};


export type cmdiSubscriptioncapabilityArgs = {
  distinct_on?: InputMaybe<Array<capability_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<capability_order_by>>;
  where?: InputMaybe<capability_bool_exp>;
};


export type cmdiSubscriptioncapability_aggregateArgs = {
  distinct_on?: InputMaybe<Array<capability_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<capability_order_by>>;
  where?: InputMaybe<capability_bool_exp>;
};


export type cmdiSubscriptioncapability_by_pkArgs = {
  id: Scalars['uuid']['input'];
};


export type cmdiSubscriptioncapability_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<capability_stream_cursor_input>>;
  where?: InputMaybe<capability_bool_exp>;
};


export type cmdiSubscriptioncontactArgs = {
  distinct_on?: InputMaybe<Array<contact_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<contact_order_by>>;
  where?: InputMaybe<contact_bool_exp>;
};


export type cmdiSubscriptioncontactRoleVariantArgs = {
  distinct_on?: InputMaybe<Array<contactRoleVariant_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<contactRoleVariant_order_by>>;
  where?: InputMaybe<contactRoleVariant_bool_exp>;
};


export type cmdiSubscriptioncontactRoleVariant_aggregateArgs = {
  distinct_on?: InputMaybe<Array<contactRoleVariant_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<contactRoleVariant_order_by>>;
  where?: InputMaybe<contactRoleVariant_bool_exp>;
};


export type cmdiSubscriptioncontactRoleVariant_by_pkArgs = {
  role: Scalars['String']['input'];
};


export type cmdiSubscriptioncontactRoleVariant_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<contactRoleVariant_stream_cursor_input>>;
  where?: InputMaybe<contactRoleVariant_bool_exp>;
};


export type cmdiSubscriptioncontact_aggregateArgs = {
  distinct_on?: InputMaybe<Array<contact_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<contact_order_by>>;
  where?: InputMaybe<contact_bool_exp>;
};


export type cmdiSubscriptioncontact_by_pkArgs = {
  id: Scalars['uuid']['input'];
};


export type cmdiSubscriptioncontact_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<contact_stream_cursor_input>>;
  where?: InputMaybe<contact_bool_exp>;
};


export type cmdiSubscriptionlanguageArgs = {
  distinct_on?: InputMaybe<Array<language_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<language_order_by>>;
  where?: InputMaybe<language_bool_exp>;
};


export type cmdiSubscriptionlanguage_aggregateArgs = {
  distinct_on?: InputMaybe<Array<language_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<language_order_by>>;
  where?: InputMaybe<language_bool_exp>;
};


export type cmdiSubscriptionlanguage_by_pkArgs = {
  isoCode: Scalars['String']['input'];
};


export type cmdiSubscriptionlanguage_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<language_stream_cursor_input>>;
  where?: InputMaybe<language_bool_exp>;
};


export type cmdiSubscriptionmeta_columnConfigArgs = {
  distinct_on?: InputMaybe<Array<meta_columnConfig_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<meta_columnConfig_order_by>>;
  where?: InputMaybe<meta_columnConfig_bool_exp>;
};


export type cmdiSubscriptionmeta_columnConfig_aggregateArgs = {
  distinct_on?: InputMaybe<Array<meta_columnConfig_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<meta_columnConfig_order_by>>;
  where?: InputMaybe<meta_columnConfig_bool_exp>;
};


export type cmdiSubscriptionmeta_columnConfig_by_pkArgs = {
  id: Scalars['uuid']['input'];
};


export type cmdiSubscriptionmeta_columnConfig_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<meta_columnConfig_stream_cursor_input>>;
  where?: InputMaybe<meta_columnConfig_bool_exp>;
};


export type cmdiSubscriptionmeta_entityArgs = {
  distinct_on?: InputMaybe<Array<meta_entity_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<meta_entity_order_by>>;
  where?: InputMaybe<meta_entity_bool_exp>;
};


export type cmdiSubscriptionmeta_entity_aggregateArgs = {
  distinct_on?: InputMaybe<Array<meta_entity_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<meta_entity_order_by>>;
  where?: InputMaybe<meta_entity_bool_exp>;
};


export type cmdiSubscriptionmeta_entity_by_pkArgs = {
  id: Scalars['uuid']['input'];
};


export type cmdiSubscriptionmeta_entity_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<meta_entity_stream_cursor_input>>;
  where?: InputMaybe<meta_entity_bool_exp>;
};

/** columns and relationships of "contact" */
export type contact = {
  __typename?: 'contact';
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  lastName: Scalars['String']['output'];
  preferredLanguage: language_enum;
  role: contactRoleVariant_enum;
  supplierId: Scalars['uuid']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

/** This is an enum table for contact roles */
export type contactRoleVariant = {
  __typename?: 'contactRoleVariant';
  role: Scalars['String']['output'];
};

/** aggregated selection of "contact_role_variant" */
export type contactRoleVariant_aggregate = {
  __typename?: 'contactRoleVariant_aggregate';
  aggregate?: Maybe<contactRoleVariant_aggregate_fields>;
  nodes: Array<contactRoleVariant>;
};

/** aggregate fields of "contact_role_variant" */
export type contactRoleVariant_aggregate_fields = {
  __typename?: 'contactRoleVariant_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<contactRoleVariant_max_fields>;
  min?: Maybe<contactRoleVariant_min_fields>;
};


/** aggregate fields of "contact_role_variant" */
export type contactRoleVariant_aggregate_fieldscountArgs = {
  columns?: InputMaybe<Array<contactRoleVariant_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "contact_role_variant". All fields are combined with a logical 'AND'. */
export type contactRoleVariant_bool_exp = {
  _and?: InputMaybe<Array<contactRoleVariant_bool_exp>>;
  _not?: InputMaybe<contactRoleVariant_bool_exp>;
  _or?: InputMaybe<Array<contactRoleVariant_bool_exp>>;
  role?: InputMaybe<String_comparison_exp>;
};

/** unique or primary key constraints on table "contact_role_variant" */
export enum contactRoleVariant_constraint {
  /** unique or primary key constraint on columns "role_" */
  contact_role_variant_pkey = 'contact_role_variant_pkey'
}

export enum contactRoleVariant_enum {
  ACCOUNTING = 'ACCOUNTING',
  CEO = 'CEO',
  PRIMARY = 'PRIMARY',
  SALES = 'SALES',
  TECHNICAL = 'TECHNICAL',
  UNKNOWN = 'UNKNOWN'
}

/** Boolean expression to compare columns of type "contactRoleVariant_enum". All fields are combined with logical 'AND'. */
export type contactRoleVariant_enum_comparison_exp = {
  _eq?: InputMaybe<contactRoleVariant_enum>;
  _in?: InputMaybe<Array<contactRoleVariant_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<contactRoleVariant_enum>;
  _nin?: InputMaybe<Array<contactRoleVariant_enum>>;
};

/** input type for inserting data into table "contact_role_variant" */
export type contactRoleVariant_insert_input = {
  role?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type contactRoleVariant_max_fields = {
  __typename?: 'contactRoleVariant_max_fields';
  role?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type contactRoleVariant_min_fields = {
  __typename?: 'contactRoleVariant_min_fields';
  role?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "contact_role_variant" */
export type contactRoleVariant_mutation_response = {
  __typename?: 'contactRoleVariant_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<contactRoleVariant>;
};

/** on_conflict condition type for table "contact_role_variant" */
export type contactRoleVariant_on_conflict = {
  constraint: contactRoleVariant_constraint;
  update_columns?: Array<contactRoleVariant_update_column>;
  where?: InputMaybe<contactRoleVariant_bool_exp>;
};

/** Ordering options when selecting data from "contact_role_variant". */
export type contactRoleVariant_order_by = {
  role?: InputMaybe<order_by>;
};

/** primary key columns input for table: contact_role_variant */
export type contactRoleVariant_pk_columns_input = {
  role: Scalars['String']['input'];
};

/** select columns of table "contact_role_variant" */
export enum contactRoleVariant_select_column {
  /** column name */
  role = 'role'
}

/** input type for updating data in table "contact_role_variant" */
export type contactRoleVariant_set_input = {
  role?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "contactRoleVariant" */
export type contactRoleVariant_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: contactRoleVariant_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type contactRoleVariant_stream_cursor_value_input = {
  role?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "contact_role_variant" */
export enum contactRoleVariant_update_column {
  /** column name */
  role = 'role'
}

export type contactRoleVariant_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<contactRoleVariant_set_input>;
  /** filter the rows which have to be updated */
  where: contactRoleVariant_bool_exp;
};

/** aggregated selection of "contact" */
export type contact_aggregate = {
  __typename?: 'contact_aggregate';
  aggregate?: Maybe<contact_aggregate_fields>;
  nodes: Array<contact>;
};

/** aggregate fields of "contact" */
export type contact_aggregate_fields = {
  __typename?: 'contact_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<contact_max_fields>;
  min?: Maybe<contact_min_fields>;
};


/** aggregate fields of "contact" */
export type contact_aggregate_fieldscountArgs = {
  columns?: InputMaybe<Array<contact_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "contact". All fields are combined with a logical 'AND'. */
export type contact_bool_exp = {
  _and?: InputMaybe<Array<contact_bool_exp>>;
  _not?: InputMaybe<contact_bool_exp>;
  _or?: InputMaybe<Array<contact_bool_exp>>;
  email?: InputMaybe<String_comparison_exp>;
  firstName?: InputMaybe<String_comparison_exp>;
  id?: InputMaybe<uuid_comparison_exp>;
  lastName?: InputMaybe<String_comparison_exp>;
  preferredLanguage?: InputMaybe<language_enum_comparison_exp>;
  role?: InputMaybe<contactRoleVariant_enum_comparison_exp>;
  supplierId?: InputMaybe<uuid_comparison_exp>;
  title?: InputMaybe<String_comparison_exp>;
};

/** unique or primary key constraints on table "contact" */
export enum contact_constraint {
  /** unique or primary key constraint on columns "id" */
  contact_pkey = 'contact_pkey',
  /** unique or primary key constraint on columns "email", "supplier_id" */
  contact_supplier_id_email_key = 'contact_supplier_id_email_key'
}

/** input type for inserting data into table "contact" */
export type contact_insert_input = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  preferredLanguage?: InputMaybe<language_enum>;
  role?: InputMaybe<contactRoleVariant_enum>;
  supplierId?: InputMaybe<Scalars['uuid']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type contact_max_fields = {
  __typename?: 'contact_max_fields';
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  supplierId?: Maybe<Scalars['uuid']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type contact_min_fields = {
  __typename?: 'contact_min_fields';
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  supplierId?: Maybe<Scalars['uuid']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "contact" */
export type contact_mutation_response = {
  __typename?: 'contact_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<contact>;
};

/** on_conflict condition type for table "contact" */
export type contact_on_conflict = {
  constraint: contact_constraint;
  update_columns?: Array<contact_update_column>;
  where?: InputMaybe<contact_bool_exp>;
};

/** Ordering options when selecting data from "contact". */
export type contact_order_by = {
  email?: InputMaybe<order_by>;
  firstName?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  lastName?: InputMaybe<order_by>;
  preferredLanguage?: InputMaybe<order_by>;
  role?: InputMaybe<order_by>;
  supplierId?: InputMaybe<order_by>;
  title?: InputMaybe<order_by>;
};

/** primary key columns input for table: contact */
export type contact_pk_columns_input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "contact" */
export enum contact_select_column {
  /** column name */
  email = 'email',
  /** column name */
  firstName = 'firstName',
  /** column name */
  id = 'id',
  /** column name */
  lastName = 'lastName',
  /** column name */
  preferredLanguage = 'preferredLanguage',
  /** column name */
  role = 'role',
  /** column name */
  supplierId = 'supplierId',
  /** column name */
  title = 'title'
}

/** input type for updating data in table "contact" */
export type contact_set_input = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  preferredLanguage?: InputMaybe<language_enum>;
  role?: InputMaybe<contactRoleVariant_enum>;
  supplierId?: InputMaybe<Scalars['uuid']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "contact" */
export type contact_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: contact_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type contact_stream_cursor_value_input = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  preferredLanguage?: InputMaybe<language_enum>;
  role?: InputMaybe<contactRoleVariant_enum>;
  supplierId?: InputMaybe<Scalars['uuid']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "contact" */
export enum contact_update_column {
  /** column name */
  email = 'email',
  /** column name */
  firstName = 'firstName',
  /** column name */
  id = 'id',
  /** column name */
  lastName = 'lastName',
  /** column name */
  preferredLanguage = 'preferredLanguage',
  /** column name */
  role = 'role',
  /** column name */
  supplierId = 'supplierId',
  /** column name */
  title = 'title'
}

export type contact_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<contact_set_input>;
  /** filter the rows which have to be updated */
  where: contact_bool_exp;
};

/** ordering argument of a cursor */
export enum cursor_ordering {
  /** ascending ordering of the cursor */
  ASC = 'ASC',
  /** descending ordering of the cursor */
  DESC = 'DESC'
}

/** columns and relationships of "dashboardConfig" */
export type dashboardConfig = {
  __typename?: 'dashboardConfig';
  config: Scalars['jsonb']['output'];
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  pageId: Scalars['String']['output'];
  updatedAt: Scalars['timestamptz']['output'];
  userId: Scalars['uuid']['output'];
};


/** columns and relationships of "dashboardConfig" */
export type dashboardConfigconfigArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "dashboardConfig" */
export type dashboardConfig_aggregate = {
  __typename?: 'dashboardConfig_aggregate';
  aggregate?: Maybe<dashboardConfig_aggregate_fields>;
  nodes: Array<dashboardConfig>;
};

/** aggregate fields of "dashboardConfig" */
export type dashboardConfig_aggregate_fields = {
  __typename?: 'dashboardConfig_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<dashboardConfig_max_fields>;
  min?: Maybe<dashboardConfig_min_fields>;
};


/** aggregate fields of "dashboardConfig" */
export type dashboardConfig_aggregate_fieldscountArgs = {
  columns?: InputMaybe<Array<dashboardConfig_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type dashboardConfig_append_input = {
  config?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "dashboardConfig". All fields are combined with a logical 'AND'. */
export type dashboardConfig_bool_exp = {
  _and?: InputMaybe<Array<dashboardConfig_bool_exp>>;
  _not?: InputMaybe<dashboardConfig_bool_exp>;
  _or?: InputMaybe<Array<dashboardConfig_bool_exp>>;
  config?: InputMaybe<jsonb_comparison_exp>;
  createdAt?: InputMaybe<timestamptz_comparison_exp>;
  id?: InputMaybe<uuid_comparison_exp>;
  pageId?: InputMaybe<String_comparison_exp>;
  updatedAt?: InputMaybe<timestamptz_comparison_exp>;
  userId?: InputMaybe<uuid_comparison_exp>;
};

/** unique or primary key constraints on table "dashboardConfig" */
export enum dashboardConfig_constraint {
  /** unique or primary key constraint on columns "id" */
  dashboardConfig_pkey = 'dashboardConfig_pkey',
  /** unique or primary key constraint on columns "pageId", "userId" */
  dashboardConfig_userId_pageId_key = 'dashboardConfig_userId_pageId_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type dashboardConfig_delete_at_path_input = {
  config?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type dashboardConfig_delete_elem_input = {
  config?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type dashboardConfig_delete_key_input = {
  config?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "dashboardConfig" */
export type dashboardConfig_insert_input = {
  config?: InputMaybe<Scalars['jsonb']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  pageId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type dashboardConfig_max_fields = {
  __typename?: 'dashboardConfig_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  pageId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type dashboardConfig_min_fields = {
  __typename?: 'dashboardConfig_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  pageId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "dashboardConfig" */
export type dashboardConfig_mutation_response = {
  __typename?: 'dashboardConfig_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<dashboardConfig>;
};

/** on_conflict condition type for table "dashboardConfig" */
export type dashboardConfig_on_conflict = {
  constraint: dashboardConfig_constraint;
  update_columns?: Array<dashboardConfig_update_column>;
  where?: InputMaybe<dashboardConfig_bool_exp>;
};

/** Ordering options when selecting data from "dashboardConfig". */
export type dashboardConfig_order_by = {
  config?: InputMaybe<order_by>;
  createdAt?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  pageId?: InputMaybe<order_by>;
  updatedAt?: InputMaybe<order_by>;
  userId?: InputMaybe<order_by>;
};

/** primary key columns input for table: dashboardConfig */
export type dashboardConfig_pk_columns_input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type dashboardConfig_prepend_input = {
  config?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "dashboardConfig" */
export enum dashboardConfig_select_column {
  /** column name */
  config = 'config',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  id = 'id',
  /** column name */
  pageId = 'pageId',
  /** column name */
  updatedAt = 'updatedAt',
  /** column name */
  userId = 'userId'
}

/** input type for updating data in table "dashboardConfig" */
export type dashboardConfig_set_input = {
  config?: InputMaybe<Scalars['jsonb']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  pageId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "dashboardConfig" */
export type dashboardConfig_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: dashboardConfig_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type dashboardConfig_stream_cursor_value_input = {
  config?: InputMaybe<Scalars['jsonb']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  pageId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "dashboardConfig" */
export enum dashboardConfig_update_column {
  /** column name */
  config = 'config',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  id = 'id',
  /** column name */
  pageId = 'pageId',
  /** column name */
  updatedAt = 'updatedAt',
  /** column name */
  userId = 'userId'
}

export type dashboardConfig_updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<dashboardConfig_append_input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<dashboardConfig_delete_at_path_input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<dashboardConfig_delete_elem_input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<dashboardConfig_delete_key_input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<dashboardConfig_prepend_input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<dashboardConfig_set_input>;
  where: dashboardConfig_bool_exp;
};

/** columns and relationships of "filters" */
export type filters = {
  __typename?: 'filters';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  domain: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  isFavorite: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  queryId: Scalars['uuid']['output'];
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** aggregated selection of "filters" */
export type filters_aggregate = {
  __typename?: 'filters_aggregate';
  aggregate?: Maybe<filters_aggregate_fields>;
  nodes: Array<filters>;
};

/** aggregate fields of "filters" */
export type filters_aggregate_fields = {
  __typename?: 'filters_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<filters_max_fields>;
  min?: Maybe<filters_min_fields>;
};


/** aggregate fields of "filters" */
export type filters_aggregate_fieldscountArgs = {
  columns?: InputMaybe<Array<filters_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "filters". All fields are combined with a logical 'AND'. */
export type filters_bool_exp = {
  _and?: InputMaybe<Array<filters_bool_exp>>;
  _not?: InputMaybe<filters_bool_exp>;
  _or?: InputMaybe<Array<filters_bool_exp>>;
  createdAt?: InputMaybe<timestamptz_comparison_exp>;
  domain?: InputMaybe<String_comparison_exp>;
  id?: InputMaybe<uuid_comparison_exp>;
  isFavorite?: InputMaybe<Boolean_comparison_exp>;
  name?: InputMaybe<String_comparison_exp>;
  queryId?: InputMaybe<uuid_comparison_exp>;
  updatedAt?: InputMaybe<timestamptz_comparison_exp>;
  userId?: InputMaybe<uuid_comparison_exp>;
};

/** unique or primary key constraints on table "filters" */
export enum filters_constraint {
  /** unique or primary key constraint on columns "id" */
  filters_pkey = 'filters_pkey',
  /** unique or primary key constraint on columns "queryId", "userId" */
  filters_userId_queryId_key = 'filters_userId_queryId_key'
}

/** input type for inserting data into table "filters" */
export type filters_insert_input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isFavorite?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  queryId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type filters_max_fields = {
  __typename?: 'filters_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  domain?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  queryId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type filters_min_fields = {
  __typename?: 'filters_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  domain?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  queryId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "filters" */
export type filters_mutation_response = {
  __typename?: 'filters_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<filters>;
};

/** on_conflict condition type for table "filters" */
export type filters_on_conflict = {
  constraint: filters_constraint;
  update_columns?: Array<filters_update_column>;
  where?: InputMaybe<filters_bool_exp>;
};

/** Ordering options when selecting data from "filters". */
export type filters_order_by = {
  createdAt?: InputMaybe<order_by>;
  domain?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  isFavorite?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  queryId?: InputMaybe<order_by>;
  updatedAt?: InputMaybe<order_by>;
  userId?: InputMaybe<order_by>;
};

/** primary key columns input for table: filters */
export type filters_pk_columns_input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "filters" */
export enum filters_select_column {
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  domain = 'domain',
  /** column name */
  id = 'id',
  /** column name */
  isFavorite = 'isFavorite',
  /** column name */
  name = 'name',
  /** column name */
  queryId = 'queryId',
  /** column name */
  updatedAt = 'updatedAt',
  /** column name */
  userId = 'userId'
}

/** input type for updating data in table "filters" */
export type filters_set_input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isFavorite?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  queryId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "filters" */
export type filters_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: filters_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type filters_stream_cursor_value_input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isFavorite?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  queryId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "filters" */
export enum filters_update_column {
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  domain = 'domain',
  /** column name */
  id = 'id',
  /** column name */
  isFavorite = 'isFavorite',
  /** column name */
  name = 'name',
  /** column name */
  queryId = 'queryId',
  /** column name */
  updatedAt = 'updatedAt',
  /** column name */
  userId = 'userId'
}

export type filters_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<filters_set_input>;
  where: filters_bool_exp;
};

export type getAccessKeys_response = AccessKeysResponse | HTTPValidationError;

export type jsonb_cast_exp = {
  String?: InputMaybe<String_comparison_exp>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type jsonb_comparison_exp = {
  _cast?: InputMaybe<jsonb_cast_exp>;
  /** is the column contained in the given json value */
  _contained_in?: InputMaybe<Scalars['jsonb']['input']>;
  /** does the column contain the given json value at the top level */
  _contains?: InputMaybe<Scalars['jsonb']['input']>;
  _eq?: InputMaybe<Scalars['jsonb']['input']>;
  _gt?: InputMaybe<Scalars['jsonb']['input']>;
  _gte?: InputMaybe<Scalars['jsonb']['input']>;
  /** does the string exist as a top-level key in the column */
  _has_key?: InputMaybe<Scalars['String']['input']>;
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: InputMaybe<Array<Scalars['String']['input']>>;
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: InputMaybe<Array<Scalars['String']['input']>>;
  _in?: InputMaybe<Array<Scalars['jsonb']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['jsonb']['input']>;
  _lte?: InputMaybe<Scalars['jsonb']['input']>;
  _neq?: InputMaybe<Scalars['jsonb']['input']>;
  _nin?: InputMaybe<Array<Scalars['jsonb']['input']>>;
};

/** This is an enum table for languages */
export type language = {
  __typename?: 'language';
  isoCode: Scalars['String']['output'];
};

/** aggregated selection of "language" */
export type language_aggregate = {
  __typename?: 'language_aggregate';
  aggregate?: Maybe<language_aggregate_fields>;
  nodes: Array<language>;
};

/** aggregate fields of "language" */
export type language_aggregate_fields = {
  __typename?: 'language_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<language_max_fields>;
  min?: Maybe<language_min_fields>;
};


/** aggregate fields of "language" */
export type language_aggregate_fieldscountArgs = {
  columns?: InputMaybe<Array<language_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "language". All fields are combined with a logical 'AND'. */
export type language_bool_exp = {
  _and?: InputMaybe<Array<language_bool_exp>>;
  _not?: InputMaybe<language_bool_exp>;
  _or?: InputMaybe<Array<language_bool_exp>>;
  isoCode?: InputMaybe<String_comparison_exp>;
};

/** unique or primary key constraints on table "language" */
export enum language_constraint {
  /** unique or primary key constraint on columns "iso_code" */
  language_pkey = 'language_pkey'
}

export enum language_enum {
  AA = 'AA',
  AB = 'AB',
  AE = 'AE',
  AF = 'AF',
  AK = 'AK',
  AM = 'AM',
  AN = 'AN',
  AR = 'AR',
  AS = 'AS',
  AV = 'AV',
  AY = 'AY',
  AZ = 'AZ',
  BA = 'BA',
  BE = 'BE',
  BG = 'BG',
  BI = 'BI',
  BM = 'BM',
  BN = 'BN',
  BO = 'BO',
  BR = 'BR',
  BS = 'BS',
  CA = 'CA',
  CE = 'CE',
  CH = 'CH',
  CO = 'CO',
  CR = 'CR',
  CS = 'CS',
  CU = 'CU',
  CV = 'CV',
  CY = 'CY',
  DA = 'DA',
  DE = 'DE',
  DV = 'DV',
  DZ = 'DZ',
  EE = 'EE',
  EL = 'EL',
  EN = 'EN',
  EO = 'EO',
  ES = 'ES',
  ET = 'ET',
  EU = 'EU',
  FA = 'FA',
  FF = 'FF',
  FI = 'FI',
  FJ = 'FJ',
  FO = 'FO',
  FR = 'FR',
  FY = 'FY',
  GA = 'GA',
  GD = 'GD',
  GL = 'GL',
  GN = 'GN',
  GU = 'GU',
  GV = 'GV',
  HA = 'HA',
  HE = 'HE',
  HI = 'HI',
  HO = 'HO',
  HR = 'HR',
  HT = 'HT',
  HU = 'HU',
  HY = 'HY',
  HZ = 'HZ',
  IA = 'IA',
  ID = 'ID',
  IE = 'IE',
  IG = 'IG',
  II = 'II',
  IK = 'IK',
  IO = 'IO',
  IS = 'IS',
  IT = 'IT',
  IU = 'IU',
  JA = 'JA',
  JV = 'JV',
  KA = 'KA',
  KG = 'KG',
  KI = 'KI',
  KJ = 'KJ',
  KK = 'KK',
  KL = 'KL',
  KM = 'KM',
  KN = 'KN',
  KO = 'KO',
  KR = 'KR',
  KS = 'KS',
  KU = 'KU',
  KV = 'KV',
  KW = 'KW',
  KY = 'KY',
  LA = 'LA',
  LB = 'LB',
  LG = 'LG',
  LI = 'LI',
  LN = 'LN',
  LO = 'LO',
  LT = 'LT',
  LU = 'LU',
  LV = 'LV',
  MG = 'MG',
  MH = 'MH',
  MI = 'MI',
  MK = 'MK',
  ML = 'ML',
  MN = 'MN',
  MR = 'MR',
  MS = 'MS',
  MT = 'MT',
  MY = 'MY',
  NA = 'NA',
  NB = 'NB',
  ND = 'ND',
  NE = 'NE',
  NG = 'NG',
  NL = 'NL',
  NN = 'NN',
  NO = 'NO',
  NR = 'NR',
  NV = 'NV',
  NY = 'NY',
  OC = 'OC',
  OJ = 'OJ',
  OM = 'OM',
  OR = 'OR',
  OS = 'OS',
  PA = 'PA',
  PI = 'PI',
  PL = 'PL',
  PS = 'PS',
  PT = 'PT',
  QU = 'QU',
  RM = 'RM',
  RN = 'RN',
  RO = 'RO',
  RU = 'RU',
  RW = 'RW',
  SA = 'SA',
  SC = 'SC',
  SD = 'SD',
  SE = 'SE',
  SG = 'SG',
  SH = 'SH',
  SI = 'SI',
  SK = 'SK',
  SL = 'SL',
  SM = 'SM',
  SN = 'SN',
  SO = 'SO',
  SQ = 'SQ',
  SR = 'SR',
  SS = 'SS',
  ST = 'ST',
  SU = 'SU',
  SV = 'SV',
  SW = 'SW',
  TA = 'TA',
  TE = 'TE',
  TG = 'TG',
  TH = 'TH',
  TI = 'TI',
  TK = 'TK',
  TL = 'TL',
  TN = 'TN',
  TO = 'TO',
  TR = 'TR',
  TS = 'TS',
  TT = 'TT',
  TW = 'TW',
  TY = 'TY',
  UG = 'UG',
  UK = 'UK',
  UR = 'UR',
  UZ = 'UZ',
  VE = 'VE',
  VI = 'VI',
  VO = 'VO',
  WA = 'WA',
  WO = 'WO',
  XH = 'XH',
  YI = 'YI',
  YO = 'YO',
  ZA = 'ZA',
  ZF = 'ZF',
  ZH = 'ZH'
}

/** Boolean expression to compare columns of type "language_enum". All fields are combined with logical 'AND'. */
export type language_enum_comparison_exp = {
  _eq?: InputMaybe<language_enum>;
  _in?: InputMaybe<Array<language_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<language_enum>;
  _nin?: InputMaybe<Array<language_enum>>;
};

/** input type for inserting data into table "language" */
export type language_insert_input = {
  isoCode?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type language_max_fields = {
  __typename?: 'language_max_fields';
  isoCode?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type language_min_fields = {
  __typename?: 'language_min_fields';
  isoCode?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "language" */
export type language_mutation_response = {
  __typename?: 'language_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<language>;
};

/** on_conflict condition type for table "language" */
export type language_on_conflict = {
  constraint: language_constraint;
  update_columns?: Array<language_update_column>;
  where?: InputMaybe<language_bool_exp>;
};

/** Ordering options when selecting data from "language". */
export type language_order_by = {
  isoCode?: InputMaybe<order_by>;
};

/** primary key columns input for table: language */
export type language_pk_columns_input = {
  isoCode: Scalars['String']['input'];
};

/** select columns of table "language" */
export enum language_select_column {
  /** column name */
  isoCode = 'isoCode'
}

/** input type for updating data in table "language" */
export type language_set_input = {
  isoCode?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "language" */
export type language_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: language_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type language_stream_cursor_value_input = {
  isoCode?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "language" */
export enum language_update_column {
  /** column name */
  isoCode = 'isoCode'
}

export type language_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<language_set_input>;
  /** filter the rows which have to be updated */
  where: language_bool_exp;
};

/** columns and relationships of "meta.column_config" */
export type meta_columnConfig = {
  __typename?: 'meta_columnConfig';
  columnName: Scalars['String']['output'];
  entityId: Scalars['uuid']['output'];
  i18n: Scalars['jsonb']['output'];
  id: Scalars['uuid']['output'];
  options: Scalars['jsonb']['output'];
  variant: Scalars['String']['output'];
};


/** columns and relationships of "meta.column_config" */
export type meta_columnConfigi18nArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "meta.column_config" */
export type meta_columnConfigoptionsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "meta.column_config" */
export type meta_columnConfig_aggregate = {
  __typename?: 'meta_columnConfig_aggregate';
  aggregate?: Maybe<meta_columnConfig_aggregate_fields>;
  nodes: Array<meta_columnConfig>;
};

/** aggregate fields of "meta.column_config" */
export type meta_columnConfig_aggregate_fields = {
  __typename?: 'meta_columnConfig_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<meta_columnConfig_max_fields>;
  min?: Maybe<meta_columnConfig_min_fields>;
};


/** aggregate fields of "meta.column_config" */
export type meta_columnConfig_aggregate_fieldscountArgs = {
  columns?: InputMaybe<Array<meta_columnConfig_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type meta_columnConfig_append_input = {
  i18n?: InputMaybe<Scalars['jsonb']['input']>;
  options?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "meta.column_config". All fields are combined with a logical 'AND'. */
export type meta_columnConfig_bool_exp = {
  _and?: InputMaybe<Array<meta_columnConfig_bool_exp>>;
  _not?: InputMaybe<meta_columnConfig_bool_exp>;
  _or?: InputMaybe<Array<meta_columnConfig_bool_exp>>;
  columnName?: InputMaybe<String_comparison_exp>;
  entityId?: InputMaybe<uuid_comparison_exp>;
  i18n?: InputMaybe<jsonb_comparison_exp>;
  id?: InputMaybe<uuid_comparison_exp>;
  options?: InputMaybe<jsonb_comparison_exp>;
  variant?: InputMaybe<String_comparison_exp>;
};

/** unique or primary key constraints on table "meta.column_config" */
export enum meta_columnConfig_constraint {
  /** unique or primary key constraint on columns "id" */
  columnConfig_pkey = 'columnConfig_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type meta_columnConfig_delete_at_path_input = {
  i18n?: InputMaybe<Array<Scalars['String']['input']>>;
  options?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type meta_columnConfig_delete_elem_input = {
  i18n?: InputMaybe<Scalars['Int']['input']>;
  options?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type meta_columnConfig_delete_key_input = {
  i18n?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "meta.column_config" */
export type meta_columnConfig_insert_input = {
  columnName?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['uuid']['input']>;
  i18n?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  options?: InputMaybe<Scalars['jsonb']['input']>;
  variant?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type meta_columnConfig_max_fields = {
  __typename?: 'meta_columnConfig_max_fields';
  columnName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  variant?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type meta_columnConfig_min_fields = {
  __typename?: 'meta_columnConfig_min_fields';
  columnName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  variant?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "meta.column_config" */
export type meta_columnConfig_mutation_response = {
  __typename?: 'meta_columnConfig_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<meta_columnConfig>;
};

/** on_conflict condition type for table "meta.column_config" */
export type meta_columnConfig_on_conflict = {
  constraint: meta_columnConfig_constraint;
  update_columns?: Array<meta_columnConfig_update_column>;
  where?: InputMaybe<meta_columnConfig_bool_exp>;
};

/** Ordering options when selecting data from "meta.column_config". */
export type meta_columnConfig_order_by = {
  columnName?: InputMaybe<order_by>;
  entityId?: InputMaybe<order_by>;
  i18n?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  options?: InputMaybe<order_by>;
  variant?: InputMaybe<order_by>;
};

/** primary key columns input for table: meta.column_config */
export type meta_columnConfig_pk_columns_input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type meta_columnConfig_prepend_input = {
  i18n?: InputMaybe<Scalars['jsonb']['input']>;
  options?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "meta.column_config" */
export enum meta_columnConfig_select_column {
  /** column name */
  columnName = 'columnName',
  /** column name */
  entityId = 'entityId',
  /** column name */
  i18n = 'i18n',
  /** column name */
  id = 'id',
  /** column name */
  options = 'options',
  /** column name */
  variant = 'variant'
}

/** input type for updating data in table "meta.column_config" */
export type meta_columnConfig_set_input = {
  columnName?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['uuid']['input']>;
  i18n?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  options?: InputMaybe<Scalars['jsonb']['input']>;
  variant?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "meta_columnConfig" */
export type meta_columnConfig_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: meta_columnConfig_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type meta_columnConfig_stream_cursor_value_input = {
  columnName?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['uuid']['input']>;
  i18n?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  options?: InputMaybe<Scalars['jsonb']['input']>;
  variant?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "meta.column_config" */
export enum meta_columnConfig_update_column {
  /** column name */
  columnName = 'columnName',
  /** column name */
  entityId = 'entityId',
  /** column name */
  i18n = 'i18n',
  /** column name */
  id = 'id',
  /** column name */
  options = 'options',
  /** column name */
  variant = 'variant'
}

export type meta_columnConfig_updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<meta_columnConfig_append_input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<meta_columnConfig_delete_at_path_input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<meta_columnConfig_delete_elem_input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<meta_columnConfig_delete_key_input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<meta_columnConfig_prepend_input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<meta_columnConfig_set_input>;
  /** filter the rows which have to be updated */
  where: meta_columnConfig_bool_exp;
};

/** Entity meta data */
export type meta_entity = {
  __typename?: 'meta_entity';
  enabled: Scalars['Boolean']['output'];
  i18n: Scalars['jsonb']['output'];
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  needsPermission?: Maybe<Scalars['String']['output']>;
};


/** Entity meta data */
export type meta_entityi18nArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "meta.entity" */
export type meta_entity_aggregate = {
  __typename?: 'meta_entity_aggregate';
  aggregate?: Maybe<meta_entity_aggregate_fields>;
  nodes: Array<meta_entity>;
};

/** aggregate fields of "meta.entity" */
export type meta_entity_aggregate_fields = {
  __typename?: 'meta_entity_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<meta_entity_max_fields>;
  min?: Maybe<meta_entity_min_fields>;
};


/** aggregate fields of "meta.entity" */
export type meta_entity_aggregate_fieldscountArgs = {
  columns?: InputMaybe<Array<meta_entity_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type meta_entity_append_input = {
  i18n?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "meta.entity". All fields are combined with a logical 'AND'. */
export type meta_entity_bool_exp = {
  _and?: InputMaybe<Array<meta_entity_bool_exp>>;
  _not?: InputMaybe<meta_entity_bool_exp>;
  _or?: InputMaybe<Array<meta_entity_bool_exp>>;
  enabled?: InputMaybe<Boolean_comparison_exp>;
  i18n?: InputMaybe<jsonb_comparison_exp>;
  id?: InputMaybe<uuid_comparison_exp>;
  name?: InputMaybe<String_comparison_exp>;
  needsPermission?: InputMaybe<String_comparison_exp>;
};

/** unique or primary key constraints on table "meta.entity" */
export enum meta_entity_constraint {
  /** unique or primary key constraint on columns "name" */
  entity_name_key = 'entity_name_key',
  /** unique or primary key constraint on columns "id" */
  entity_pkey = 'entity_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type meta_entity_delete_at_path_input = {
  i18n?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type meta_entity_delete_elem_input = {
  i18n?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type meta_entity_delete_key_input = {
  i18n?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "meta.entity" */
export type meta_entity_insert_input = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  i18n?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  needsPermission?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type meta_entity_max_fields = {
  __typename?: 'meta_entity_max_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  needsPermission?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type meta_entity_min_fields = {
  __typename?: 'meta_entity_min_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  needsPermission?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "meta.entity" */
export type meta_entity_mutation_response = {
  __typename?: 'meta_entity_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<meta_entity>;
};

/** on_conflict condition type for table "meta.entity" */
export type meta_entity_on_conflict = {
  constraint: meta_entity_constraint;
  update_columns?: Array<meta_entity_update_column>;
  where?: InputMaybe<meta_entity_bool_exp>;
};

/** Ordering options when selecting data from "meta.entity". */
export type meta_entity_order_by = {
  enabled?: InputMaybe<order_by>;
  i18n?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  needsPermission?: InputMaybe<order_by>;
};

/** primary key columns input for table: meta.entity */
export type meta_entity_pk_columns_input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type meta_entity_prepend_input = {
  i18n?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "meta.entity" */
export enum meta_entity_select_column {
  /** column name */
  enabled = 'enabled',
  /** column name */
  i18n = 'i18n',
  /** column name */
  id = 'id',
  /** column name */
  name = 'name',
  /** column name */
  needsPermission = 'needsPermission'
}

/** input type for updating data in table "meta.entity" */
export type meta_entity_set_input = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  i18n?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  needsPermission?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "meta_entity" */
export type meta_entity_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: meta_entity_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type meta_entity_stream_cursor_value_input = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  i18n?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  needsPermission?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "meta.entity" */
export enum meta_entity_update_column {
  /** column name */
  enabled = 'enabled',
  /** column name */
  i18n = 'i18n',
  /** column name */
  id = 'id',
  /** column name */
  name = 'name',
  /** column name */
  needsPermission = 'needsPermission'
}

export type meta_entity_updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<meta_entity_append_input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<meta_entity_delete_at_path_input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<meta_entity_delete_elem_input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<meta_entity_delete_key_input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<meta_entity_prepend_input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<meta_entity_set_input>;
  /** filter the rows which have to be updated */
  where: meta_entity_bool_exp;
};

/** column ordering options */
export enum order_by {
  /** in ascending order, nulls last */
  asc = 'asc',
  /** in ascending order, nulls first */
  asc_nulls_first = 'asc_nulls_first',
  /** in ascending order, nulls last */
  asc_nulls_last = 'asc_nulls_last',
  /** in descending order, nulls first */
  desc = 'desc',
  /** in descending order, nulls first */
  desc_nulls_first = 'desc_nulls_first',
  /** in descending order, nulls last */
  desc_nulls_last = 'desc_nulls_last'
}

export type pasaGraphqlMutation = {
  __typename?: 'pasaGraphqlMutation';
  deleteTeam: PasaDeleteTeamPayload;
  upsertTeam: PasaTeamPayload;
};


export type pasaGraphqlMutationdeleteTeamArgs = {
  teamId: Scalars['UUID']['input'];
};


export type pasaGraphqlMutationupsertTeamArgs = {
  input: PasaUpsertTeamInput;
};

export type pasaGraphqlQuery = {
  __typename?: 'pasaGraphqlQuery';
  health: Scalars['String']['output'];
  team?: Maybe<PasaTeamQueryResult>;
  teams: Array<PasaTeamQueryResult>;
};


export type pasaGraphqlQueryteamArgs = {
  teamId: Scalars['UUID']['input'];
};

/** Prequalification Level of the supplier */
export enum prequalificationLevelType {
  LevelOne = 'LevelOne',
  LevelTwo = 'LevelTwo',
  None = 'None'
}

/** columns and relationships of "queries" */
export type queries = {
  __typename?: 'queries';
  checksum: Scalars['String']['output'];
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  query: Scalars['jsonb']['output'];
  updatedAt?: Maybe<Scalars['timestamp']['output']>;
};


/** columns and relationships of "queries" */
export type queriesqueryArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "queries" */
export type queries_aggregate = {
  __typename?: 'queries_aggregate';
  aggregate?: Maybe<queries_aggregate_fields>;
  nodes: Array<queries>;
};

/** aggregate fields of "queries" */
export type queries_aggregate_fields = {
  __typename?: 'queries_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<queries_max_fields>;
  min?: Maybe<queries_min_fields>;
};


/** aggregate fields of "queries" */
export type queries_aggregate_fieldscountArgs = {
  columns?: InputMaybe<Array<queries_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type queries_append_input = {
  query?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "queries". All fields are combined with a logical 'AND'. */
export type queries_bool_exp = {
  _and?: InputMaybe<Array<queries_bool_exp>>;
  _not?: InputMaybe<queries_bool_exp>;
  _or?: InputMaybe<Array<queries_bool_exp>>;
  checksum?: InputMaybe<String_comparison_exp>;
  createdAt?: InputMaybe<timestamptz_comparison_exp>;
  id?: InputMaybe<uuid_comparison_exp>;
  query?: InputMaybe<jsonb_comparison_exp>;
  updatedAt?: InputMaybe<timestamp_comparison_exp>;
};

/** unique or primary key constraints on table "queries" */
export enum queries_constraint {
  /** unique or primary key constraint on columns "checksum" */
  queries_checksum_key = 'queries_checksum_key',
  /** unique or primary key constraint on columns "id" */
  queries_pkey = 'queries_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type queries_delete_at_path_input = {
  query?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type queries_delete_elem_input = {
  query?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type queries_delete_key_input = {
  query?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "queries" */
export type queries_insert_input = {
  checksum?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  query?: InputMaybe<Scalars['jsonb']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate max on columns */
export type queries_max_fields = {
  __typename?: 'queries_max_fields';
  checksum?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamp']['output']>;
};

/** aggregate min on columns */
export type queries_min_fields = {
  __typename?: 'queries_min_fields';
  checksum?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamp']['output']>;
};

/** response of any mutation on the table "queries" */
export type queries_mutation_response = {
  __typename?: 'queries_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<queries>;
};

/** on_conflict condition type for table "queries" */
export type queries_on_conflict = {
  constraint: queries_constraint;
  update_columns?: Array<queries_update_column>;
  where?: InputMaybe<queries_bool_exp>;
};

/** Ordering options when selecting data from "queries". */
export type queries_order_by = {
  checksum?: InputMaybe<order_by>;
  createdAt?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  query?: InputMaybe<order_by>;
  updatedAt?: InputMaybe<order_by>;
};

/** primary key columns input for table: queries */
export type queries_pk_columns_input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type queries_prepend_input = {
  query?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "queries" */
export enum queries_select_column {
  /** column name */
  checksum = 'checksum',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  id = 'id',
  /** column name */
  query = 'query',
  /** column name */
  updatedAt = 'updatedAt'
}

/** input type for updating data in table "queries" */
export type queries_set_input = {
  checksum?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  query?: InputMaybe<Scalars['jsonb']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
};

/** Streaming cursor of the table "queries" */
export type queries_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: queries_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type queries_stream_cursor_value_input = {
  checksum?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  query?: InputMaybe<Scalars['jsonb']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
};

/** update columns of table "queries" */
export enum queries_update_column {
  /** column name */
  checksum = 'checksum',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  id = 'id',
  /** column name */
  query = 'query',
  /** column name */
  updatedAt = 'updatedAt'
}

export type queries_updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<queries_append_input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<queries_delete_at_path_input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<queries_delete_elem_input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<queries_delete_key_input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<queries_prepend_input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<queries_set_input>;
  where: queries_bool_exp;
};

export type query_checkFeaturePermission_oneOf_1_detail_items_loc_items = {
  __typename?: 'query_checkFeaturePermission_oneOf_1_detail_items_loc_items';
  Int?: Maybe<Scalars['Int']['output']>;
  String?: Maybe<Scalars['String']['output']>;
};

export type scopeAutocomplete_response = AutocompleteResponse | ErrorDetailResponse | HTTPValidationError;

export type scopeChildren_response = ChildrenResponse | ErrorDetailResponse | HTTPValidationError;

export type scopeTranslation_response = ErrorDetailResponse | HTTPValidationError | TreeNodesResponse;

export type sevenbridgesMutation = {
  __typename?: 'sevenbridgesMutation';
  chatSession: SvbrgChatSessionMutations;
  conversationSettings: SvbrgConversationSettingsMutations;
  document: SvbrgDocumentMutations;
  quote: SvbrgQuoteAnalysisMutations;
  thread: SvbrgThreadMutations;
  upsertQuoteCompliance: SvbrgQuoteComplianceCheck;
};


export type sevenbridgesMutationupsertQuoteComplianceArgs = {
  data: SvbrgQuoteComplianceCheckUpsertInput;
};

export type sevenbridgesQuery = {
  __typename?: 'sevenbridgesQuery';
  chatSession: SvbrgChatSessionQueries;
  conversation?: Maybe<SvbrgChatSession>;
  conversationSettings?: Maybe<SvbrgConversationSettings>;
  document: SvbrgDocument;
  documentChunk: SvbrgDocumentChunk;
  documents: SvbrgDocumentListConnection;
  extendedLineItemChecks: Array<SvbrgExtendedLineItemsCheck>;
  getExtractedRequirements: SvbrgExtractedRequirements;
  quote?: Maybe<SvbrgQuote>;
  quoteCompliance?: Maybe<SvbrgQuoteComplianceCheck>;
  similarDocuments: Array<SvbrgMatchedDocumentChunk>;
  thread?: Maybe<SvbrgThread>;
  threadList: SvbrgThreadConnection;
};


export type sevenbridgesQuerychatSessionArgs = {
  id: Scalars['UUID']['input'];
};


export type sevenbridgesQueryconversationArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  variant: SvbrgConversationEntityVariant;
};


export type sevenbridgesQueryconversationSettingsArgs = {
  entityId: Scalars['UUID']['input'];
  entityVariant: SvbrgConversationEntityVariant;
};


export type sevenbridgesQuerydocumentArgs = {
  id: Scalars['UUID']['input'];
};


export type sevenbridgesQuerydocumentChunkArgs = {
  id: Scalars['UUID']['input'];
};


export type sevenbridgesQuerydocumentsArgs = {
  filter?: InputMaybe<Scalars['SvbrgQueryBuilderQuery']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<SvbrgDocumentListOrder>>;
};


export type sevenbridgesQueryextendedLineItemChecksArgs = {
  chatSessionId: Scalars['UUID']['input'];
};


export type sevenbridgesQuerygetExtractedRequirementsArgs = {
  input: SvbrgGetExtractedRequirementsInput;
};


export type sevenbridgesQueryquoteArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type sevenbridgesQueryquoteComplianceArgs = {
  chatSessionId: Scalars['UUID']['input'];
};


export type sevenbridgesQuerysimilarDocumentsArgs = {
  query: Scalars['String']['input'];
  similarityThreshold?: InputMaybe<Scalars['Float']['input']>;
  topK?: InputMaybe<Scalars['Int']['input']>;
};


export type sevenbridgesQuerythreadArgs = {
  id: Scalars['UUID']['input'];
};


export type sevenbridgesQuerythreadListArgs = {
  categories?: InputMaybe<Array<SvbrgCategoryType>>;
  filter?: InputMaybe<Scalars['SvbrgQueryBuilderQuery']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<SvbrgThreadOrder>>;
};

export type sevenbridgesSubscription = {
  __typename?: 'sevenbridgesSubscription';
  chatSession: SvbrgChatSessionQueries;
  chatSessionStatusUpdate: SvbrgChatSessionStatusUpdateEvent;
  quote?: Maybe<SvbrgQuote>;
};


export type sevenbridgesSubscriptionchatSessionArgs = {
  id: Scalars['UUID']['input'];
};


export type sevenbridgesSubscriptionquoteArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};

export type teamAutocomplete_response = AutocompleteResponse | ErrorDetailResponse | HTTPValidationError;

export type teamChildren_response = ChildrenResponse | ErrorDetailResponse | HTTPValidationError;

export type teamTranslation_response = ErrorDetailResponse | HTTPValidationError | TreeNodesResponse;

export type telescopeQuery = {
  __typename?: 'telescopeQuery';
  logEntries: TlscpLogEntryConnection;
};


export type telescopeQuerylogEntriesArgs = {
  entityId: Scalars['UUID']['input'];
  entityVariant: TlscpEntityVariant;
  includeChildren?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<TlscpSortOrder>;
};

export type tesseractMutation = {
  __typename?: 'tesseractMutation';
  attachment: TsrctAttachmentMutations;
  comment: TsrctCommentMutations;
  contractDemand: TsrctContractDemandMutations;
  contractDemandCreate: TsrctContractDemand;
  contractDemandCreateFromCoveragePredictionV2: Array<TsrctContractDemand>;
  demand: TsrctDemandMutations;
  demandCreate: TsrctDemand;
  demands: TsrctDemandsMutations;
  negotiationCase: TsrctNegotiationCaseMutations;
  negotiationCases: TsrctNegotiationCasesMutations;
  overrideAutomaticAcceptanceTiming: TsrctAutomaticAcceptanceTimingResult;
  rule: TsrctRuleMutations;
  sourcingCase: TsrctSourcingCaseMutations;
  supplier: TsrctSupplierMutations;
  updateReminderConfig: TsrctReminderConfig;
};


export type tesseractMutationcontractDemandArgs = {
  id: Scalars['UUID']['input'];
};


export type tesseractMutationcontractDemandCreateFromCoveragePredictionV2Args = {
  data: TsrctContractDemandCreateFromCoveragePredictionInput;
};


export type tesseractMutationdemandArgs = {
  id: Scalars['UUID']['input'];
};


export type tesseractMutationdemandCreateArgs = {
  data: TsrctDemandInput;
};


export type tesseractMutationnegotiationCaseArgs = {
  id: Scalars['UUID']['input'];
};


export type tesseractMutationoverrideAutomaticAcceptanceTimingArgs = {
  data: TsrctOverrideAutomaticAcceptanceTimingInput;
};


export type tesseractMutationruleArgs = {
  id: Scalars['UUID']['input'];
};


export type tesseractMutationsourcingCaseArgs = {
  id: Scalars['UUID']['input'];
};


export type tesseractMutationupdateReminderConfigArgs = {
  data: TsrctUpdateReminderConfigInput;
};

export type tesseractQuery = {
  __typename?: 'tesseractQuery';
  attachments: Array<TsrctAttachment>;
  automaticAcceptanceTiming?: Maybe<TsrctAutomaticAcceptanceTimingResult>;
  comments: Array<TsrctComment>;
  contractDemand: TsrctContractDemand;
  contractDemands: TsrctContractDemandListItemConnection;
  demand: TsrctDemand;
  demands: TsrctDemandListItemConnection;
  intercom: TsrctIntercom;
  negotiationBoundarySuggestion?: Maybe<TsrctNegotiationBoundarySuggestion>;
  negotiationCase: TsrctNegotiationCase;
  negotiationCases: TsrctNegotiationCaseListConnection;
  reminderConfig: TsrctReminderConfig;
  rule: TsrctRule;
  rules: TsrctRuleListQueries;
  sourcingCase: TsrctSourcingCase;
  supplier: TsrctSupplierQueries;
  supplierContactSettings: TsrctSupplierContactSettings;
};


export type tesseractQueryattachmentsArgs = {
  filter?: InputMaybe<TsrctAttachmentFilterInput>;
  parents: Array<TsrctAttachmentParentInput>;
};


export type tesseractQueryautomaticAcceptanceTimingArgs = {
  targetId: Scalars['UUID']['input'];
  variant: TsrctAutoAcceptTimingVariant;
};


export type tesseractQuerycommentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  parent: TsrctCommentParent;
  sort?: InputMaybe<TsrctCommentSortOrder>;
};


export type tesseractQuerycontractDemandArgs = {
  id: Scalars['UUID']['input'];
};


export type tesseractQuerycontractDemandsArgs = {
  filter?: InputMaybe<Scalars['TsrctQueryBuilderQuery']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<TsrctContractDemandOrder>>;
};


export type tesseractQuerydemandArgs = {
  id: Scalars['UUID']['input'];
};


export type tesseractQuerydemandsArgs = {
  filter?: InputMaybe<Scalars['TsrctQueryBuilderQuery']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<TsrctDemandOrder>>;
};


export type tesseractQuerynegotiationBoundarySuggestionArgs = {
  internalSupplierId: Scalars['UUID']['input'];
};


export type tesseractQuerynegotiationCaseArgs = {
  id: Scalars['UUID']['input'];
};


export type tesseractQuerynegotiationCasesArgs = {
  filter?: InputMaybe<Scalars['TsrctQueryBuilderQuery']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<TsrctNegotiationCaseOrder>>;
};


export type tesseractQueryreminderConfigArgs = {
  targetId: Scalars['UUID']['input'];
  type: TsrctReminderType;
  variant: TsrctReminderConfigVariant;
};


export type tesseractQueryruleArgs = {
  id: Scalars['UUID']['input'];
};


export type tesseractQuerysourcingCaseArgs = {
  id: Scalars['UUID']['input'];
};

export type tesseractSubscription = {
  __typename?: 'tesseractSubscription';
  demandProcessStepsUpdate: TsrctDemandProcessStepEvent;
  negotiationCaseProcessStepsUpdate: TsrctNegotiationCaseProcessStepEvent;
  supplier: TsrctSupplierQueries;
};

/** Boolean expression to compare columns of type "timestamp". All fields are combined with logical 'AND'. */
export type timestamp_comparison_exp = {
  _eq?: InputMaybe<Scalars['timestamp']['input']>;
  _gt?: InputMaybe<Scalars['timestamp']['input']>;
  _gte?: InputMaybe<Scalars['timestamp']['input']>;
  _in?: InputMaybe<Array<Scalars['timestamp']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['timestamp']['input']>;
  _lte?: InputMaybe<Scalars['timestamp']['input']>;
  _neq?: InputMaybe<Scalars['timestamp']['input']>;
  _nin?: InputMaybe<Array<Scalars['timestamp']['input']>>;
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type timestamptz_comparison_exp = {
  _eq?: InputMaybe<Scalars['timestamptz']['input']>;
  _gt?: InputMaybe<Scalars['timestamptz']['input']>;
  _gte?: InputMaybe<Scalars['timestamptz']['input']>;
  _in?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['timestamptz']['input']>;
  _lte?: InputMaybe<Scalars['timestamptz']['input']>;
  _neq?: InputMaybe<Scalars['timestamptz']['input']>;
  _nin?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
};

/** columns and relationships of "users" */
export type users = {
  __typename?: 'users';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregated selection of "users" */
export type users_aggregate = {
  __typename?: 'users_aggregate';
  aggregate?: Maybe<users_aggregate_fields>;
  nodes: Array<users>;
};

/** aggregate fields of "users" */
export type users_aggregate_fields = {
  __typename?: 'users_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<users_max_fields>;
  min?: Maybe<users_min_fields>;
};


/** aggregate fields of "users" */
export type users_aggregate_fieldscountArgs = {
  columns?: InputMaybe<Array<users_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "users". All fields are combined with a logical 'AND'. */
export type users_bool_exp = {
  _and?: InputMaybe<Array<users_bool_exp>>;
  _not?: InputMaybe<users_bool_exp>;
  _or?: InputMaybe<Array<users_bool_exp>>;
  createdAt?: InputMaybe<timestamptz_comparison_exp>;
  email?: InputMaybe<String_comparison_exp>;
  firstName?: InputMaybe<String_comparison_exp>;
  id?: InputMaybe<uuid_comparison_exp>;
  lastName?: InputMaybe<String_comparison_exp>;
  updatedAt?: InputMaybe<timestamptz_comparison_exp>;
};

/** unique or primary key constraints on table "users" */
export enum users_constraint {
  /** unique or primary key constraint on columns "id" */
  users_pkey = 'users_pkey'
}

/** input type for inserting data into table "users" */
export type users_insert_input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type users_max_fields = {
  __typename?: 'users_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type users_min_fields = {
  __typename?: 'users_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "users" */
export type users_mutation_response = {
  __typename?: 'users_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<users>;
};

/** on_conflict condition type for table "users" */
export type users_on_conflict = {
  constraint: users_constraint;
  update_columns?: Array<users_update_column>;
  where?: InputMaybe<users_bool_exp>;
};

/** Ordering options when selecting data from "users". */
export type users_order_by = {
  createdAt?: InputMaybe<order_by>;
  email?: InputMaybe<order_by>;
  firstName?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  lastName?: InputMaybe<order_by>;
  updatedAt?: InputMaybe<order_by>;
};

/** primary key columns input for table: users */
export type users_pk_columns_input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "users" */
export enum users_select_column {
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  email = 'email',
  /** column name */
  firstName = 'firstName',
  /** column name */
  id = 'id',
  /** column name */
  lastName = 'lastName',
  /** column name */
  updatedAt = 'updatedAt'
}

/** input type for updating data in table "users" */
export type users_set_input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "users" */
export type users_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: users_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type users_stream_cursor_value_input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "users" */
export enum users_update_column {
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  email = 'email',
  /** column name */
  firstName = 'firstName',
  /** column name */
  id = 'id',
  /** column name */
  lastName = 'lastName',
  /** column name */
  updatedAt = 'updatedAt'
}

export type users_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<users_set_input>;
  where: users_bool_exp;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type uuid_comparison_exp = {
  _eq?: InputMaybe<Scalars['uuid']['input']>;
  _gt?: InputMaybe<Scalars['uuid']['input']>;
  _gte?: InputMaybe<Scalars['uuid']['input']>;
  _in?: InputMaybe<Array<Scalars['uuid']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['uuid']['input']>;
  _lte?: InputMaybe<Scalars['uuid']['input']>;
  _neq?: InputMaybe<Scalars['uuid']['input']>;
  _nin?: InputMaybe<Array<Scalars['uuid']['input']>>;
};

export type ResponsibleUsersQueryVariables = Exact<{
  capabilityIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  commodityGroupIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  filterBy?: InputMaybe<Scalars['String']['input']>;
}>;


export type ResponsibleUsersQuery = { __typename?: 'Query', astronaut: { __typename?: 'astronautQuery', responsibleUsers: Array<{ __typename?: 'AstroResponsibleUserItem', id: string, primarySourceReference: string, availabilityStatus: AstroAvailabilityStatus, demandCount: number, firstName?: string | null, isRecommended: boolean, lastName?: string | null, profilePicture?: string | null }> } };

export type DocumentChunkQueryVariables = Exact<{
  chunkId: Scalars['UUID']['input'];
}>;


export type DocumentChunkQuery = { __typename?: 'Query', sevenbridges: { __typename?: 'sevenbridgesQuery', documentChunk: { __typename?: 'SvbrgDocumentChunk', id: any, title: string, content: string, fileId: any, documentUrl?: string | null } } };

export type ConversationQueryVariables = Exact<{
  entityId: Scalars['UUID']['input'];
  entityVariant: SvbrgConversationEntityVariant;
  description?: InputMaybe<Scalars['String']['input']>;
}>;


export type ConversationQuery = { __typename?: 'Query', sevenbridges: { __typename?: 'sevenbridgesQuery', conversation?: { __typename?: 'SvbrgChatSession', id: any, conversationSettings?: { __typename?: 'SvbrgConversationSettings', id: any, createdAt: any, updatedAt: any, quickActions: Array<{ __typename?: 'SvbrgQuickActions', id: any, prompt: string, isConversationStarter: boolean, translations: Array<{ __typename?: 'SvbrgQuickActionTranslation', id: string, language: SvbrgLanguage, text: string, variant: SvbrgQuickActionTranslationVariant }> }> } | null, conversationMessages?: Array<{ __typename?: 'SvbrgAgentMessage', id: any, role: string, content?: string | null, parts: Array<Record<string, any>>, metadata?: Record<string, any> | null, createdAt?: any | null }> | null } | null } };

export type ResetConversationMutationVariables = Exact<{
  data: SvbrgChatSessionInput;
}>;


export type ResetConversationMutation = { __typename?: 'Mutation', sevenbridges: { __typename?: 'sevenbridgesMutation', chatSession: { __typename?: 'SvbrgChatSessionMutations', reset: { __typename?: 'SvbrgChatSession', id: any, conversationSettings?: { __typename?: 'SvbrgConversationSettings', id: any, createdAt: any, updatedAt: any, quickActions: Array<{ __typename?: 'SvbrgQuickActions', id: any, prompt: string, isConversationStarter: boolean, translations: Array<{ __typename?: 'SvbrgQuickActionTranslation', id: string, language: SvbrgLanguage, text: string, variant: SvbrgQuickActionTranslationVariant }> }>, tools: Array<{ __typename?: 'SvbrgConversationSettingsTools', id: SvbrgConversationSettingsAvailableTools, isEnabled: boolean }> } | null, conversationMessages?: Array<{ __typename?: 'SvbrgAgentMessage', id: any, role: string, content?: string | null, parts: Array<Record<string, any>>, createdAt?: any | null }> | null } } } };

export type CustomDataNavListCmdiMetaQueryVariables = Exact<{ [key: string]: never; }>;


export type CustomDataNavListCmdiMetaQuery = { __typename?: 'Query', cmdi: { __typename?: 'cmdiQuery', meta_entity: Array<{ __typename?: 'meta_entity', id: any, name: string, i18n: any, needsPermission?: string | null }> } };

export type LoadColumnConfigQueryVariables = Exact<{
  domain: Scalars['String']['input'];
}>;


export type LoadColumnConfigQuery = { __typename?: 'Query', baseColumnConfig: Array<{ __typename?: 'baseColumnConfig', id: any, domain: string, config?: any | null, userId?: any | null }> };

export type SaveColumnConfigMutationVariables = Exact<{
  config?: InputMaybe<Scalars['jsonb']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
}>;


export type SaveColumnConfigMutation = { __typename?: 'Mutation', insert_baseColumnConfig_one?: { __typename?: 'baseColumnConfig', id: any, domain: string, config?: any | null } | null };

export type DemandCasesBatchReleaseMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  data: TsrctReleaseNegotiationCasesInput;
}>;


export type DemandCasesBatchReleaseMutation = { __typename?: 'Mutation', tesseract: { __typename?: 'tesseractMutation', demand: { __typename?: 'TsrctDemandMutations', releaseNegotiationCases?: any | null } } };

export type DemandCasesReleaseQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DemandCasesReleaseQuery = { __typename?: 'Query', tesseract: { __typename?: 'tesseractQuery', demand: { __typename?: 'TsrctDemand', id: any, negotiationCases: { __typename?: 'TsrctDemandNegotiationCaseConnection', nodes: Array<{ __typename?: 'TsrctDemandNegotiationCase', id: any, sequenceNumber: any, status: TsrctNegotiationCaseStatus, variant: TsrctNegotiationCaseVariant, createdAt: any, updatedAt: any, isReleasable: boolean, supplier: { __typename?: 'TsrctNegotiationCaseSupplier', id: any, internalId: any, name: string, location: { __typename?: 'TsrctNegotiationCaseSupplierLocation', id: any, internalId?: any | null, address?: string | null, city?: string | null, countryCode?: CountryCode | null, postalCode?: string | null }, contact: { __typename?: 'TsrctNegotiationCaseSupplierContact', id: any, internalId?: any | null, email?: any | null, firstName?: string | null, lastName?: string | null, language: TsrctLanguage, phone?: string | null, mobile?: string | null } }, processSteps: Array<{ __typename?: 'TsrctNegotiationCaseProcessStep', variant: TsrctNegotiationCaseProcessStepVariant, status: TsrctNegotiationCaseProcessStepStatus }> }> } } } };

export type DemandCasesCountQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DemandCasesCountQuery = { __typename?: 'Query', tesseract: { __typename?: 'tesseractQuery', demand: { __typename?: 'TsrctDemand', id: any, negotiationCases: { __typename?: 'TsrctDemandNegotiationCaseConnection', totalCount: number, nodes: Array<{ __typename?: 'TsrctDemandNegotiationCase', id: any, isReleasable: boolean }> } } } };

export type ExtensionConversationQueryVariables = Exact<{
  entityId: Scalars['UUID']['input'];
  entityVariant: SvbrgConversationEntityVariant;
}>;


export type ExtensionConversationQuery = { __typename?: 'Query', sevenbridges: { __typename?: 'sevenbridgesQuery', conversationSettings?: { __typename?: 'SvbrgConversationSettings', id: any } | null } };

export type TesseractDemandItemQueryVariables = Exact<{
  filter?: InputMaybe<Scalars['TsrctQueryBuilderQuery']['input']>;
}>;


export type TesseractDemandItemQuery = { __typename?: 'Query', tesseract: { __typename?: 'tesseractQuery', demands: { __typename?: 'TsrctDemandListItemConnection', nodes: Array<{ __typename?: 'TsrctDemandListItem', id: any, sequenceNumber: any }> } } };

export type DeleteFilterMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteFilterMutation = { __typename?: 'Mutation', delete_filters_by_pk?: { __typename?: 'filters', id: any } | null };

export type LoadFiltersQueryVariables = Exact<{ [key: string]: never; }>;


export type LoadFiltersQuery = { __typename?: 'Query', filters: Array<{ __typename?: 'filters', id: any, userId?: any | null, name: string, queryId: any, domain: string, isFavorite: boolean }> };

export type SaveFilterMutationVariables = Exact<{
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  queryId?: InputMaybe<Scalars['uuid']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  isFavorite?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SaveFilterMutation = { __typename?: 'Mutation', insert_filters_one?: { __typename?: 'filters', id: any, userId?: any | null, name: string, queryId: any, domain: string, isFavorite: boolean } | null };

export type UpdateFilterMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  isFavorite?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateFilterMutation = { __typename?: 'Mutation', update_filters_by_pk?: { __typename?: 'filters', id: any, isFavorite: boolean } | null };

export type NegotiationCaseCancelMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  data: TsrctNegotiationCaseCancelInput;
}>;


export type NegotiationCaseCancelMutation = { __typename?: 'Mutation', tesseract: { __typename?: 'tesseractMutation', negotiationCase: { __typename?: 'TsrctNegotiationCaseMutations', cancel?: any | null } } };

export type NegotiationCaseCancelledAlertQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type NegotiationCaseCancelledAlertQuery = { __typename?: 'Query', tesseract: { __typename?: 'tesseractQuery', negotiationCase: { __typename?: 'TsrctNegotiationCase', id: any, status: TsrctNegotiationCaseStatus, cancellationReason?: TsrctCaseCancellationReason | null, cancellationReasonText?: string | null } } };

export type LoadPermissionsQueryVariables = Exact<{ [key: string]: never; }>;


export type LoadPermissionsQuery = { __typename?: 'Query', getPermissions?: { __typename?: 'Permissions', permissions: Array<string | null> } | null };

export type DeleteSmartLinkMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DeleteSmartLinkMutation = { __typename?: 'Mutation', astronaut: { __typename?: 'astronautMutation', smartLink: { __typename?: 'AstroSmartLinkMutations', remove: { __typename?: 'AstroSmartLink', id: any } } } };

export type LoadSmartLinksQueryVariables = Exact<{
  domain: AstroSmartLinkDomain;
}>;


export type LoadSmartLinksQuery = { __typename?: 'Query', astronaut: { __typename?: 'astronautQuery', smartLinks: Array<{ __typename?: 'AstroSmartLink', id: any, updatedAt: any, title: string, domain: AstroSmartLinkDomain, url: string, description?: string | null, external: boolean, hidden: boolean, variant: AstroSmartLinkVariant, sequence: number }> } };

export type UpdateSmartLinkMutationVariables = Exact<{
  data: Array<AstroSmartLinkInput> | AstroSmartLinkInput;
}>;


export type UpdateSmartLinkMutation = { __typename?: 'Mutation', astronaut: { __typename?: 'astronautMutation', smartLink: { __typename?: 'AstroSmartLinkMutations', upsert: Array<{ __typename?: 'AstroSmartLink', id: any }> } } };

export type UpsertSmartLinkMutationVariables = Exact<{
  data: Array<AstroSmartLinkInput> | AstroSmartLinkInput;
}>;


export type UpsertSmartLinkMutation = { __typename?: 'Mutation', astronaut: { __typename?: 'astronautMutation', smartLink: { __typename?: 'AstroSmartLinkMutations', upsert: Array<{ __typename?: 'AstroSmartLink', id: any, updatedAt: any, title: string, domain: AstroSmartLinkDomain, url: string, description?: string | null, external: boolean, hidden: boolean, variant: AstroSmartLinkVariant, sequence: number }> } } };

export type SourcingCaseCancelledAlertQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type SourcingCaseCancelledAlertQuery = { __typename?: 'Query', tesseract: { __typename?: 'tesseractQuery', sourcingCase: { __typename?: 'TsrctSourcingCase', id: any, status: TsrctSourcingCaseStatus, cancellationReason?: TsrctCaseCancellationReason | null, cancellationReasonText?: string | null } } };

export type SupplierMapDetailQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SupplierMapDetailQuery = { __typename?: 'Query', supplier: { __typename?: 'SupplierDetail', id: string, name: string, relationship: SupplierRelationshipType, address: { __typename?: 'Address', countryCode?: string | null, city?: string | null, street?: string | null, postalCode?: string | null }, industry: { __typename?: 'SupplierIndustryNode', id: string, name?: string | null }, prequalificationTrades: Array<{ __typename?: 'SupplierPrequalification', name: string, status: string }>, contact: { __typename?: 'Contact', fax?: string | null, phone?: string | null, email?: string | null, website?: string | null } } };

export type TestQueryVariables = Exact<{ [key: string]: never; }>;


export type TestQuery = { __typename?: 'Query', contract?: { __typename?: 'Contract', id: string, externalId: string } | null };

export type LoadAppConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type LoadAppConfigQuery = { __typename?: 'Query', appConfig: Array<{ __typename?: 'appConfig', id: any, userId?: any | null, navDrawerPinned: boolean }> };

export type SaveAppConfigMutationVariables = Exact<{
  input: appConfig_insert_input;
}>;


export type SaveAppConfigMutation = { __typename?: 'Mutation', insert_appConfig_one?: { __typename?: 'appConfig', id: any, navDrawerPinned: boolean } | null };

export type CommentsQueryQueryVariables = Exact<{
  entityId: Scalars['UUID']['input'];
  entityVariant: TsrctCommentParentVariant;
  sort?: InputMaybe<TsrctCommentSortOrder>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CommentsQueryQuery = { __typename?: 'Query', tesseract: { __typename?: 'tesseractQuery', comments: Array<{ __typename?: 'TsrctComment', id: any, authorId: any, message: string, createdAt?: any | null, updatedAt?: any | null, parent: { __typename?: 'TsrctCommentParentObjectRef', id: any, variant: TsrctCommentParentVariant } }> } };

export type AddCommentMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  message: Scalars['String']['input'];
  parentId: Scalars['UUID']['input'];
  parentVariant: TsrctCommentParentVariant;
}>;


export type AddCommentMutation = { __typename?: 'Mutation', tesseract: { __typename?: 'tesseractMutation', comment: { __typename?: 'TsrctCommentMutations', create: { __typename?: 'TsrctComment', id: any, authorId: any, message: string, createdAt?: any | null, updatedAt?: any | null, parent: { __typename?: 'TsrctCommentParentObjectRef', id: any, variant: TsrctCommentParentVariant } } } } };

export type EditCommentMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  message: Scalars['String']['input'];
  parentId: Scalars['UUID']['input'];
  parentVariant: TsrctCommentParentVariant;
}>;


export type EditCommentMutation = { __typename?: 'Mutation', tesseract: { __typename?: 'tesseractMutation', comment: { __typename?: 'TsrctCommentMutations', edit: { __typename?: 'TsrctComment', id: any, authorId: any, message: string, createdAt?: any | null, updatedAt?: any | null, parent: { __typename?: 'TsrctCommentParentObjectRef', id: any, variant: TsrctCommentParentVariant } } } } };

export type DeleteCommentMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DeleteCommentMutation = { __typename?: 'Mutation', tesseract: { __typename?: 'tesseractMutation', comment: { __typename?: 'TsrctCommentMutations', delete: { __typename?: 'TsrctDeletedComment', id: any, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, message: string, parent: { __typename?: 'TsrctCommentParentObjectRef', id: any, variant: TsrctCommentParentVariant } } } } };

export type DemandFilesQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DemandFilesQuery = { __typename?: 'Query', tesseract: { __typename?: 'tesseractQuery', demand: { __typename?: 'TsrctDemand', id: any, files: Array<{ __typename?: 'TsrctFile', id: any, isSharedWithSupplier: boolean, quoteId?: any | null, negotiationCaseId?: any | null, negotiationCaseSequence?: any | null, createdAt: any, updatedAt: any }>, permissions: { __typename?: 'TsrctDemandPermissions', read: boolean, write: boolean, assign: boolean } } } };

export type IntakeDiscardMutationVariables = Exact<{
  data: SvbrgChatSessionInput;
}>;


export type IntakeDiscardMutation = { __typename?: 'Mutation', sevenbridges: { __typename?: 'sevenbridgesMutation', chatSession: { __typename?: 'SvbrgChatSessionMutations', discard: { __typename?: 'SvbrgChatSession', createdAt: any, id: any, status?: SvbrgIntakeStatus | null } } } };

export type IntakeCancelMutationVariables = Exact<{
  data: SvbrgChatSessionInput;
}>;


export type IntakeCancelMutation = { __typename?: 'Mutation', sevenbridges: { __typename?: 'sevenbridgesMutation', chatSession: { __typename?: 'SvbrgChatSessionMutations', cancel: { __typename?: 'SvbrgChatSession', createdAt: any, id: any, status?: SvbrgIntakeStatus | null } } } };

export type IntercomTokenQueryVariables = Exact<{ [key: string]: never; }>;


export type IntercomTokenQuery = { __typename?: 'Query', tesseract: { __typename?: 'tesseractQuery', intercom: { __typename?: 'TsrctIntercom', token: string } } };

export type LoadQueryQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type LoadQueryQuery = { __typename?: 'Query', queries_by_pk?: { __typename?: 'queries', id: any, query: any, checksum: string } | null };

export type SaveQueryMutationVariables = Exact<{
  query?: InputMaybe<Scalars['jsonb']['input']>;
  checksum?: InputMaybe<Scalars['String']['input']>;
}>;


export type SaveQueryMutation = { __typename?: 'Mutation', insert_queries_one?: { __typename?: 'queries', id: any } | null };

export type DemandProcessStepsQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DemandProcessStepsQuery = { __typename?: 'Query', tesseract: { __typename?: 'tesseractQuery', demand: { __typename?: 'TsrctDemand', id: any, processSteps: Array<{ __typename?: 'TsrctDemandProcessStep', variant: TsrctDemandProcessStepVariant, status: TsrctDemandProcessStepStatus }> } } };

export type DemandProcessStepsUpdateSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type DemandProcessStepsUpdateSubscription = { __typename?: 'Subscription', tesseract: { __typename?: 'tesseractSubscription', demandProcessStepsUpdate: { __typename?: 'TsrctDemandProcessStepEvent', id: any } } };

export type NegotiationCaseProcessStepsQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type NegotiationCaseProcessStepsQuery = { __typename?: 'Query', tesseract: { __typename?: 'tesseractQuery', negotiationCase: { __typename?: 'TsrctNegotiationCase', id: any, isReleasable: boolean, processSteps: Array<{ __typename?: 'TsrctNegotiationCaseProcessStep', variant: TsrctNegotiationCaseProcessStepVariant, status: TsrctNegotiationCaseProcessStepStatus }> } } };

export type NegotiationCaseProcessStepsUpdateSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type NegotiationCaseProcessStepsUpdateSubscription = { __typename?: 'Subscription', tesseract: { __typename?: 'tesseractSubscription', negotiationCaseProcessStepsUpdate: { __typename?: 'TsrctNegotiationCaseProcessStepEvent', id: any } } };

export type DemandNegotiationCaseProcessStepsFragment = { __typename?: 'TsrctDemandNegotiationCase', isReleasable: boolean, processSteps: Array<{ __typename?: 'TsrctNegotiationCaseProcessStep', variant: TsrctNegotiationCaseProcessStepVariant, status: TsrctNegotiationCaseProcessStepStatus }> } & { ' $fragmentName'?: 'DemandNegotiationCaseProcessStepsFragment' };

export type NegotiationCaseProcessStepsFragment = { __typename?: 'TsrctNegotiationCase', isReleasable: boolean, processSteps: Array<{ __typename?: 'TsrctNegotiationCaseProcessStep', variant: TsrctNegotiationCaseProcessStepVariant, status: TsrctNegotiationCaseProcessStepStatus }> } & { ' $fragmentName'?: 'NegotiationCaseProcessStepsFragment' };

export type DemandListItemProcessStepsFragment = { __typename?: 'TsrctDemandListItem', processSteps: Array<{ __typename?: 'TsrctDemandProcessStep', variant: TsrctDemandProcessStepVariant, status: TsrctDemandProcessStepStatus }> } & { ' $fragmentName'?: 'DemandListItemProcessStepsFragment' };

export type DemandDetailProcessStepsFragment = { __typename?: 'TsrctDemand', processSteps: Array<{ __typename?: 'TsrctDemandProcessStep', variant: TsrctDemandProcessStepVariant, status: TsrctDemandProcessStepStatus }> } & { ' $fragmentName'?: 'DemandDetailProcessStepsFragment' };

export type UserProfileQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type UserProfileQuery = { __typename?: 'Query', astronaut: { __typename?: 'astronautQuery', user: { __typename?: 'AstroUserDetails', id: any, primarySourceReference: any, profile: { __typename?: 'AstroUserProfile', id: any, firstName?: string | null, lastName?: string | null, email?: any | null, capabilityIds: Array<any>, commodityGroupIds: Array<any>, organizationId?: any | null, deliveryLocationId?: any | null, accountingAreaId?: any | null, costCenterId?: any | null, currency: Currency, workingHours?: number | null, jobTitle?: string | null, pictureId?: any | null, updatedAt: any, createdAt: any, language?: AstroLanguage | null } } } };

export type OverrideAutomaticAcceptanceTimingMutationVariables = Exact<{
  data: TsrctOverrideAutomaticAcceptanceTimingInput;
}>;


export type OverrideAutomaticAcceptanceTimingMutation = { __typename?: 'Mutation', tesseract: { __typename?: 'tesseractMutation', overrideAutomaticAcceptanceTiming: { __typename?: 'TsrctAutomaticAcceptanceTimingResult', targetId: any, variant: TsrctAutoAcceptTimingVariant, source: TsrctAutoAcceptTimingSource, plannedAt?: any | null, timing: { __typename?: 'TsrctAutomaticAcceptanceTimingConfiguration', reactionMinMinutes: number, reactionMaxMinutes: number, workingDays: Array<TsrctAutoAcceptWorkingDay>, timezone: string, workingHours: { __typename?: 'TsrctAutoAcceptWorkingHours', start: string, end: string }, holiday?: { __typename?: 'TsrctAutoAcceptHoliday', country: string, state?: string | null } | null } } } };

export type AutomaticAcceptanceTimingQueryVariables = Exact<{
  targetId: Scalars['UUID']['input'];
  variant: TsrctAutoAcceptTimingVariant;
  isNegotiationCase?: Scalars['Boolean']['input'];
  isSourcingCase?: Scalars['Boolean']['input'];
}>;


export type AutomaticAcceptanceTimingQuery = { __typename?: 'Query', tesseract: { __typename?: 'tesseractQuery', automaticAcceptanceTiming?: { __typename?: 'TsrctAutomaticAcceptanceTimingResult', targetId: any, variant: TsrctAutoAcceptTimingVariant, source: TsrctAutoAcceptTimingSource, plannedAt?: any | null, timing: { __typename?: 'TsrctAutomaticAcceptanceTimingConfiguration', reactionMinMinutes: number, reactionMaxMinutes: number, workingDays: Array<TsrctAutoAcceptWorkingDay>, timezone: string, workingHours: { __typename?: 'TsrctAutoAcceptWorkingHours', start: string, end: string }, holiday?: { __typename?: 'TsrctAutoAcceptHoliday', country: string, state?: string | null } | null } } | null, negotiationCase?: { __typename?: 'TsrctNegotiationCase', id: any, status: TsrctNegotiationCaseStatus }, sourcingCase?: { __typename?: 'TsrctSourcingCase', id: any, status: TsrctSourcingCaseStatus } } };

export type BusinessLogQueryQueryVariables = Exact<{
  entityId: Scalars['UUID']['input'];
  entityVariant: TlscpEntityVariant;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  includeChildren?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type BusinessLogQueryQuery = { __typename?: 'Query', telescope: { __typename?: 'telescopeQuery', logEntries: { __typename?: 'TlscpLogEntryConnection', totalCount: any, nodes: Array<{ __typename?: 'TlscpLogEntry', actorId?: any | null, actorVariant: string, context: Record<string, any>, createdAt: any, entityId: any, entityVariant: string, id: any, parentId?: any | null, parentVariant?: string | null, status: string, template: string }> } } };

export type DemandMaskingQueryQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DemandMaskingQueryQuery = { __typename?: 'Query', tesseract: { __typename?: 'tesseractQuery', demand: { __typename?: 'TsrctDemand', id: any, competitiveBiddingRule: { __typename?: 'TsrctCompetitiveBiddingRule', id: any, isMaskedBidding: boolean } } } };

export type NegotiationCaseMaskingQueryQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type NegotiationCaseMaskingQueryQuery = { __typename?: 'Query', tesseract: { __typename?: 'tesseractQuery', negotiationCase: { __typename?: 'TsrctNegotiationCase', id: any, isMaskedBidding: boolean } } };

export type DemandNegotiationCaseAwardMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  data: TsrctDemandAwardInput;
}>;


export type DemandNegotiationCaseAwardMutation = { __typename?: 'Mutation', tesseract: { __typename?: 'tesseractMutation', demand: { __typename?: 'TsrctDemandMutations', award?: any | null } } };

export type DemandAwardingQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DemandAwardingQuery = { __typename?: 'Query', tesseract: { __typename?: 'tesseractQuery', demand: { __typename?: 'TsrctDemand', id: any, competitiveBiddingRule: { __typename?: 'TsrctCompetitiveBiddingRule', id: any, isMaskedBidding: boolean }, demandRequest: { __typename?: 'TsrctDemandRequest', id: any, currency: Currency, totalValue?: any | null, lineItems: Array<{ __typename?: 'TsrctDemandRequestLineItem', id: any, title: string, description?: string | null, quantity: any, expectedPricePerUnit?: any | null, commodityId?: any | null, unitId?: any | null, commodityGroupId?: any | null, organizationId?: string | null, deliveryLocationId?: string | null, preferredSupplierId?: any | null, internalId?: any | null, position: string, totalValue?: any | null }> }, awardingStatus: Array<{ __typename?: 'TsrctAwardingStatusItem', entityId: any, entityVariant: TsrctAwardingStatusEntityVariant, field: TsrctAwardingStatusField, status: TsrctStatus }>, awardingSettings: { __typename?: 'TsrctDemandAwardingSettings', isPartialAwardingEnabled: boolean, notifications: { __typename?: 'TsrctDemandAwardingNotificationSettings', options: { __typename?: 'TsrctDemandAwardingNotificationOptions', informSupplier: boolean, dismissOtherSuppliers: { __typename?: 'TsrctDemandAwardingNotificationOption', show: boolean, defaultValue: boolean }, informAwardedSupplier: { __typename?: 'TsrctDemandAwardingNotificationOption', show: boolean, defaultValue: boolean }, informDismissedSupplier: { __typename?: 'TsrctDemandAwardingNotificationOption', show: boolean, defaultValue: boolean } } } }, negotiationCases: { __typename?: 'TsrctDemandNegotiationCaseConnection', totalCount: number, nodes: Array<{ __typename?: 'TsrctDemandNegotiationCase', id: any, isAwardable: boolean, sequenceNumber: any, status: TsrctNegotiationCaseStatus, processStatus?: TsrctNegotiationCaseProcessStatus | null, variant: TsrctNegotiationCaseVariant, sourceReferences: Array<{ __typename?: 'TsrctSourceReference', id: any, sourceReference?: string | null, url?: any | null }>, supplier: { __typename?: 'TsrctNegotiationCaseSupplier', id: any, name: string, internalId: any, externalReference?: string | null, contact: { __typename?: 'TsrctNegotiationCaseSupplierContact', id: any, internalId?: any | null, email?: any | null, firstName?: string | null, language: TsrctLanguage, lastName?: string | null, mobile?: string | null, phone?: string | null }, location: { __typename?: 'TsrctNegotiationCaseSupplierLocation', id: any, internalId?: any | null, address?: string | null, city?: string | null, countryCode?: CountryCode | null, postalCode?: string | null } }, quote?: { __typename?: 'TsrctNegotiatedQuote', id: any, supplierReference?: string | null, currency: Currency, totalValue?: any | null, discount?: any | null, totalPriceDiscount?: any | null, totalDiscountedValue?: any | null, lineItems: Array<{ __typename?: 'TsrctNegotiatedQuoteItem', id: any, title?: string | null, position: string, description?: string | null, quantity: any, unitId?: any | null, pricePerUnit?: any | null, totalValue?: any | null, status: TsrctQuoteItemStatus, discount?: any | null, discountedPricePerUnit?: any | null, totalDiscountedValue?: any | null, isAwardable?: boolean | null, demandRequestItemId?: any | null, negotiationFailedReason?: TsrctSupplierCommentVariant | null, negotiationFailedReasonText?: string | null }>, shipmentTerms: { __typename?: 'TsrctShipmentTerms', earlyDeliveryAt?: any | null, lateDeliveryAt?: any | null } } | { __typename?: 'TsrctQuote', id: any, supplierReference?: string | null, currency: Currency, totalValue?: any | null, lineItems: Array<{ __typename?: 'TsrctQuoteItem', id: any, title?: string | null, position: string, description?: string | null, quantity: any, unitId?: any | null, pricePerUnit?: any | null, totalValue?: any | null, status: TsrctQuoteItemStatus }>, shipmentTerms: { __typename?: 'TsrctShipmentTerms', earlyDeliveryAt?: any | null, lateDeliveryAt?: any | null } } | null }> } } } };

export type AwardingConfigurationUpdateMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  awardingConfiguration: TsrctDemandAwardingRuleConfigurationInput;
}>;


export type AwardingConfigurationUpdateMutation = { __typename?: 'Mutation', tesseract: { __typename?: 'tesseractMutation', demand: { __typename?: 'TsrctDemandMutations', awardingConfiguration: { __typename?: 'TsrctAwardingConfigurationMutations', update?: { __typename?: 'TsrctDemandAwardingRuleConfiguration', id: any, deadlineDays?: number | null, performAutomaticAwarding: boolean, rules: Array<{ __typename?: 'TsrctDemandAwardingRule', id: any, priceDeviation?: any | null, variant: TsrctDemandAwardingRuleVariant }> } | null } } } };

export type AwardingConfigurationQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type AwardingConfigurationQuery = { __typename?: 'Query', tesseract: { __typename?: 'tesseractQuery', demand: { __typename?: 'TsrctDemand', id: any, awardingConfiguration: { __typename?: 'TsrctDemandAwardingRuleConfiguration', id: any, deadline?: any | null, deadlineDays?: number | null, performAutomaticAwarding: boolean, rules: Array<{ __typename?: 'TsrctDemandAwardingRule', id: any, priceDeviation?: any | null, variant: TsrctDemandAwardingRuleVariant }> } } } };

export type DemandCasesQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DemandCasesQuery = { __typename?: 'Query', tesseract: { __typename?: 'tesseractQuery', demand: { __typename?: 'TsrctDemand', id: any, status: TsrctDemandStatus, competitiveBiddingRule: { __typename?: 'TsrctCompetitiveBiddingRule', id: any, variant: TsrctCompetitiveBiddingVariant, isEditable: boolean, isMaskedBidding: boolean }, negotiationCases: { __typename?: 'TsrctDemandNegotiationCaseConnection', totalCount: number, nodes: Array<{ __typename?: 'TsrctDemandNegotiationCase', id: any, isNegotiationEnabled: boolean, isSupplierUploadAllowed: boolean, isMaskedBidding: boolean, sequenceNumber: any, variant: TsrctNegotiationCaseVariant, createdAt: any, updatedAt: any, status: TsrctNegotiationCaseStatus, processStatus?: TsrctNegotiationCaseProcessStatus | null, isReleasable: boolean, lowerDiscountBoundary: any, upperDiscountBoundary: any, sourceReferences: Array<{ __typename?: 'TsrctSourceReference', id: any, sourceReference?: string | null, url?: any | null }>, options?: { __typename?: 'TsrctNegotiationCaseOptions', id: any, initiatedBy: TsrctInitiationMode, supplierInteractionMode: TsrctSupplierInteractionMode, negotiationMode: TsrctNegotiationMode, quoteMode: TsrctQuoteMode, negotiationObjective: TsrctNegotiationObjective } | null, supplier: { __typename?: 'TsrctNegotiationCaseSupplier', id: any, internalId: any, name: string, location: { __typename?: 'TsrctNegotiationCaseSupplierLocation', id: any, internalId?: any | null, address?: string | null, city?: string | null, countryCode?: CountryCode | null, postalCode?: string | null }, contact: { __typename?: 'TsrctNegotiationCaseSupplierContact', id: any, internalId?: any | null, email?: any | null, firstName?: string | null, lastName?: string | null, language: TsrctLanguage, phone?: string | null, mobile?: string | null } }, quote?: { __typename?: 'TsrctNegotiatedQuote', id: any, createdAt: any, totalValue?: any | null, currency: Currency, hasSupplierComment: boolean, totalDiscountedValue?: any | null, discount?: any | null, totalPriceDiscount?: any | null, shipmentTerms: { __typename?: 'TsrctShipmentTerms', earlyDeliveryAt?: any | null, lateDeliveryAt?: any | null }, lineItems: Array<{ __typename?: 'TsrctNegotiatedQuoteItem', totalValue?: any | null, description?: string | null, id: any, position: string, pricePerUnit?: any | null, quantity: any, title?: string | null, unitId?: any | null, discount?: any | null, discountedPricePerUnit?: any | null, totalDiscountedValue?: any | null, shipmentTerms: { __typename?: 'TsrctShipmentTerms', earlyDeliveryAt?: any | null, lateDeliveryAt?: any | null } }>, paymentTerms: Array<{ __typename?: 'TsrctPaymentTerm', daysToPayment: number, discount: any }> } | { __typename?: 'TsrctQuote', id: any, createdAt: any, totalValue?: any | null, currency: Currency, hasSupplierComment: boolean, shipmentTerms: { __typename?: 'TsrctShipmentTerms', earlyDeliveryAt?: any | null, lateDeliveryAt?: any | null }, lineItems: Array<{ __typename?: 'TsrctQuoteItem', totalValue?: any | null, description?: string | null, id: any, position: string, pricePerUnit?: any | null, quantity: any, title?: string | null, unitId?: any | null, shipmentTerms: { __typename?: 'TsrctShipmentTerms', earlyDeliveryAt?: any | null, lateDeliveryAt?: any | null } }>, paymentTerms: Array<{ __typename?: 'TsrctPaymentTerm', daysToPayment: number, discount: any }> } | null, processSteps: Array<{ __typename?: 'TsrctNegotiationCaseProcessStep', variant: TsrctNegotiationCaseProcessStepVariant, status: TsrctNegotiationCaseProcessStepStatus }>, issueSummary: { __typename?: 'TsrctIssueSummary', totalCount: number, openCount: number, resolvedCount: number }, latestComment?: { __typename?: 'TsrctComment', id: any, message: string, authorId: any, createdAt?: any | null, parent: { __typename?: 'TsrctCommentParentObjectRef', id: any, variant: TsrctCommentParentVariant } } | null }> } } } };

export type DemandDetailUnifiedUpdateMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  demandData: TsrctDemandUpdateInput;
  competitiveBiddingRuleData?: InputMaybe<TsrctCompetitiveBiddingRuleInput>;
}>;


export type DemandDetailUnifiedUpdateMutation = { __typename?: 'Mutation', tesseract: { __typename?: 'tesseractMutation', demand: { __typename?: 'TsrctDemandMutations', update: { __typename?: 'TsrctDemand', id: any, capabilityIds: Array<any>, responsibleUserIds: Array<any>, demandRequest: { __typename?: 'TsrctDemandRequest', id: any, sourceReferences: Array<{ __typename?: 'TsrctDemandRequestSourceReference', internalId: any, sourceReference: string, isPrimary: boolean, sourceSystem: { __typename?: 'TsrctSourceSystem', id: string, name: string } }> }, permissions: { __typename?: 'TsrctDemandPermissions', write: boolean } }, competitiveBiddingRule: { __typename?: 'TsrctCompetitiveBiddingRuleMutations', update?: { __typename?: 'TsrctCompetitiveBiddingRule', id: any, variant: TsrctCompetitiveBiddingVariant, deadline?: any | null } | null } } } };

export type DemandDetailQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DemandDetailQuery = { __typename?: 'Query', tesseract: { __typename?: 'tesseractQuery', demand: { __typename?: 'TsrctDemand', id: any, capabilityIds: Array<any>, responsibleUserIds: Array<any>, status: TsrctDemandStatus, createdAt: any, sequenceNumber: any, priority: number, processingMode: TsrctDemandProcessingMode, updatedAt: any, competitiveBiddingRule: { __typename?: 'TsrctCompetitiveBiddingRule', id: any, variant: TsrctCompetitiveBiddingVariant, deadline?: any | null, isEditable: boolean, isMaskedBidding: boolean }, demandRequest: { __typename?: 'TsrctDemandRequest', id: any, commodityGroupId?: string | null, externalReference?: string | null, sourceReferences: Array<{ __typename?: 'TsrctDemandRequestSourceReference', url?: any | null }>, lineItems: Array<{ __typename?: 'TsrctDemandRequestLineItem', id: any, preferredSupplierId?: any | null, commodityGroupId?: any | null }> }, permissions: { __typename?: 'TsrctDemandPermissions', write: boolean }, negotiationCases: { __typename?: 'TsrctDemandNegotiationCaseConnection', nodes: Array<{ __typename?: 'TsrctDemandNegotiationCase', id: any, options?: { __typename?: 'TsrctNegotiationCaseOptions', id: any, quoteMode: TsrctQuoteMode } | null }> } } } };

export type DemandFileAttachmentsQueryVariables = Exact<{
  parents: Array<TsrctAttachmentParentInput> | TsrctAttachmentParentInput;
  filter?: InputMaybe<TsrctAttachmentFilterInput>;
}>;


export type DemandFileAttachmentsQuery = { __typename?: 'Query', tesseract: { __typename?: 'tesseractQuery', attachments: Array<(
      { __typename?: 'TsrctAttachment' }
      & { ' $fragmentRefs'?: { 'FileAttachmentFragment': FileAttachmentFragment } }
    )> } };

export type DemandFileAttachmentsDemandQueryVariables = Exact<{
  demandId: Scalars['UUID']['input'];
}>;


export type DemandFileAttachmentsDemandQuery = { __typename?: 'Query', tesseract: { __typename?: 'tesseractQuery', demand: { __typename?: 'TsrctDemand', id: any, status: TsrctDemandStatus, negotiationCases: { __typename?: 'TsrctDemandNegotiationCaseConnection', nodes: Array<{ __typename?: 'TsrctDemandNegotiationCase', id: any, status: TsrctNegotiationCaseStatus }> } } } };

export type DemandRecommendationQueryQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DemandRecommendationQueryQuery = { __typename?: 'Query', tesseract: { __typename?: 'tesseractQuery', demand: { __typename?: 'TsrctDemand', id: any, status: TsrctDemandStatus, demandRequest: { __typename?: 'TsrctDemandRequest', id: any, lineItems: Array<{ __typename?: 'TsrctDemandRequestLineItem', id: any, position: string, title: string, description?: string | null, recommendations?: Array<{ __typename?: 'TsrctRecommendation', id: string, decisionStatus: TsrctRecommendationDecisionStatus, variant: TsrctRecommendationVariant, demandRequestItemId: string, recommendedItem: string }> | null }> }, permissions: { __typename?: 'TsrctDemandPermissions', write: boolean } } } };

export type DemandRecommendationApplyMutationVariables = Exact<{
  demandId: Scalars['UUID']['input'];
  data: Array<TsrctRecommendationsInput> | TsrctRecommendationsInput;
}>;


export type DemandRecommendationApplyMutation = { __typename?: 'Mutation', tesseract: { __typename?: 'tesseractMutation', demand: { __typename?: 'TsrctDemandMutations', demandRequest: { __typename?: 'TsrctDemandRequestMutations', recommendations: { __typename?: 'TsrctRecommendationMutations', apply: Array<{ __typename?: 'TsrctRecommendation', id: string, decisionStatus: TsrctRecommendationDecisionStatus, variant: TsrctRecommendationVariant, demandRequestItemId: string, recommendedItem: string }> } } } } };

export type DemandRequestUpdateMutationVariables = Exact<{
  demandId: Scalars['UUID']['input'];
  demandRequest: TsrctDemandRequestInput;
}>;


export type DemandRequestUpdateMutation = { __typename?: 'Mutation', tesseract: { __typename?: 'tesseractMutation', demand: { __typename?: 'TsrctDemandMutations', demandRequest: { __typename?: 'TsrctDemandRequestMutations', update: { __typename?: 'TsrctDemandRequest', id: any, lineItems: Array<{ __typename?: 'TsrctDemandRequestLineItem', id: any, position: string, title: string, description?: string | null, unitId?: any | null, quantity: any, updatedAt: any, preferredSupplierId?: any | null, internalId?: any | null, expectedPricePerUnit?: any | null, commodityGroupId?: any | null, contractItemId?: any | null, analysisId?: any | null, organizationId?: string | null, deliveryLocationId?: string | null, commodityId?: any | null, baselinePricePerUnit?: any | null, shipmentTerms: { __typename?: 'TsrctShipmentTerms', earlyDeliveryAt?: any | null, lateDeliveryAt?: any | null } }> } } } } };

export type TsrctDemandRequestQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type TsrctDemandRequestQuery = { __typename?: 'Query', tesseract: { __typename?: 'tesseractQuery', demand: { __typename?: 'TsrctDemand', id: any, requestedBy?: any | null, status: TsrctDemandStatus, demandRequest: { __typename?: 'TsrctDemandRequest', id: any, budget?: any | null, demandId: any, summary?: string | null, currency: Currency, createdAt: any, externalReference?: string | null, commodityGroupId?: string | null, sourceReferences: Array<{ __typename?: 'TsrctDemandRequestSourceReference', internalId: any, isPrimary: boolean, sourceReference: string, url?: any | null, sourceSystem: { __typename?: 'TsrctSourceSystem', id: string, name: string } }>, lineItems: Array<{ __typename?: 'TsrctDemandRequestLineItem', id: any, position: string, title: string, description?: string | null, deliveryLocationId?: string | null, organizationId?: string | null, unitId?: any | null, quantity: any, updatedAt: any, preferredSupplierId?: any | null, internalId?: any | null, expectedPricePerUnit?: any | null, commodityGroupId?: any | null, contractItemId?: any | null, commodityId?: any | null, baselinePricePerUnit?: any | null, analysisId?: any | null, shipmentTerms: { __typename?: 'TsrctShipmentTerms', earlyDeliveryAt?: any | null, lateDeliveryAt?: any | null } }> }, permissions: { __typename?: 'TsrctDemandPermissions', read: boolean, write: boolean, assign: boolean } } } };

export type FileAttachmentFragment = { __typename?: 'TsrctAttachment', id: any, createdAt: any, updatedAt: any, classification?: TsrctAttachmentClassification | null, parent: { __typename?: 'TsrctAttachmentParentObjectRef', id: any, variant: TsrctAttachmentParentVariant }, visibilities: Array<{ __typename?: 'TsrctAttachmentParentObjectRef', id: any, variant: TsrctAttachmentParentVariant }>, uploadedBy: { __typename?: 'TsrctAttachmentUploadedByObjectRef', variant: TsrctUploadedByVariant } } & { ' $fragmentName'?: 'FileAttachmentFragment' };

export type FileAttachmentsUpdateMutationVariables = Exact<{
  data: TsrctAttachmentMutationInput;
}>;


export type FileAttachmentsUpdateMutation = { __typename?: 'Mutation', tesseract: { __typename?: 'tesseractMutation', attachment: { __typename?: 'TsrctAttachmentMutations', update: { __typename?: 'TsrctAttachmentMutationPayload', parent: { __typename?: 'TsrctAttachmentParentObjectRef', id: any, variant: TsrctAttachmentParentVariant }, attachments: Array<(
          { __typename?: 'TsrctAttachment' }
          & { ' $fragmentRefs'?: { 'FileAttachmentFragment': FileAttachmentFragment } }
        )> } } } };

export type NegotiatedQuoteAcceptMutationVariables = Exact<{
  negotiationCaseId: Scalars['UUID']['input'];
  data: TsrctNegotiatedQuoteActionInput;
}>;


export type NegotiatedQuoteAcceptMutation = { __typename?: 'Mutation', tesseract: { __typename?: 'tesseractMutation', negotiationCase: { __typename?: 'TsrctNegotiationCaseMutations', negotiatedQuote: { __typename?: 'TsrctNegotiatedQuoteMutations', draftAccept: { __typename?: 'TsrctNegotiatedQuote', id: any } } } } };

export type NegotiatedQuoteDeclineMutationVariables = Exact<{
  negotiationCaseId: Scalars['UUID']['input'];
  data: TsrctNegotiatedQuoteActionInput;
}>;


export type NegotiatedQuoteDeclineMutation = { __typename?: 'Mutation', tesseract: { __typename?: 'tesseractMutation', negotiationCase: { __typename?: 'TsrctNegotiationCaseMutations', negotiatedQuote: { __typename?: 'TsrctNegotiatedQuoteMutations', draftDecline: { __typename?: 'TsrctNegotiatedQuote', id: any } } } } };

export type NegotiatedQuoteQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type NegotiatedQuoteQuery = { __typename?: 'Query', tesseract: { __typename?: 'tesseractQuery', negotiationCase: { __typename?: 'TsrctNegotiationCase', isMaskedBidding: boolean, id: any, status: TsrctNegotiationCaseStatus, processStatus?: TsrctNegotiationCaseProcessStatus | null, options?: { __typename?: 'TsrctNegotiationCaseOptions', id: any, supplierInteractionMode: TsrctSupplierInteractionMode } | null, negotiatedQuote?: { __typename?: 'TsrctNegotiatedQuote', id: any, createdAt: any, currency: Currency, supplierReference?: string | null, totalValue?: any | null, discount?: any | null, totalDiscountedValue?: any | null, totalPriceDiscount?: any | null, hasSupplierComment: boolean, lineItems: Array<{ __typename?: 'TsrctNegotiatedQuoteItem', id: any, title?: string | null, description?: string | null, deliveryLocationId?: any | null, organizationId?: any | null, commodityId?: any | null, unitId?: any | null, position: string, pricePerUnit?: any | null, quantity: any, totalValue?: any | null, discount?: any | null, totalDiscountedValue?: any | null, discountedPricePerUnit?: any | null, status: TsrctQuoteItemStatus, shipmentTerms: { __typename?: 'TsrctShipmentTerms', earlyDeliveryAt?: any | null, lateDeliveryAt?: any | null }, supplierComment?: { __typename?: 'TsrctSupplierComment', variant: TsrctSupplierCommentVariant, text?: string | null } | null }>, paymentTerms: Array<{ __typename?: 'TsrctPaymentTerm', daysToPayment: number, discount: any }>, shipmentTerms: { __typename?: 'TsrctShipmentTerms', earlyDeliveryAt?: any | null, lateDeliveryAt?: any | null }, buyerReply?: { __typename?: 'TsrctBuyerReply', text?: string | null, userId: string } | null, supplierComment?: { __typename?: 'TsrctSupplierComment', text?: string | null, variant: TsrctSupplierCommentVariant } | null } | null } } };

export type DemandAwardingRuleQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DemandAwardingRuleQuery = { __typename?: 'Query', tesseract: { __typename?: 'tesseractQuery', demand: { __typename?: 'TsrctDemand', id: any } } };

export type SaveDemandRequestMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  data: TsrctDemandRequestInput;
}>;


export type SaveDemandRequestMutation = { __typename?: 'Mutation', tesseract: { __typename?: 'tesseractMutation', demand: { __typename?: 'TsrctDemandMutations', demandRequest: { __typename?: 'TsrctDemandRequestMutations', update: { __typename?: 'TsrctDemandRequest', id: any } } } } };

export type DemandCaseAddMutationVariables = Exact<{
  demandId: Scalars['UUID']['input'];
  data: TsrctNegotiationCaseInput;
}>;


export type DemandCaseAddMutation = { __typename?: 'Mutation', tesseract: { __typename?: 'tesseractMutation', demand: { __typename?: 'TsrctDemandMutations', negotiationCase: { __typename?: 'TsrctDemandNegotiationCaseMutations', create: { __typename?: 'TsrctNegotiationCase', id: any } } } } };

export type DemandCaseReleaseMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  data: TsrctReleaseNegotiationCasesInput;
}>;


export type DemandCaseReleaseMutation = { __typename?: 'Mutation', tesseract: { __typename?: 'tesseractMutation', demand: { __typename?: 'TsrctDemandMutations', releaseNegotiationCases?: any | null } } };

export type CreateNegotiationCaseMutationVariables = Exact<{
  demandId: Scalars['UUID']['input'];
  data: TsrctNegotiationCaseInput;
}>;


export type CreateNegotiationCaseMutation = { __typename?: 'Mutation', tesseract: { __typename?: 'tesseractMutation', demand: { __typename?: 'TsrctDemandMutations', negotiationCase: { __typename?: 'TsrctDemandNegotiationCaseMutations', create: { __typename?: 'TsrctNegotiationCase', id: any } } } } };

export type QuoteQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type QuoteQuery = { __typename?: 'Query', sevenbridges: { __typename?: 'sevenbridgesQuery', quote?: { __typename?: 'SvbrgQuote', id: any, currency: string, quoteReference?: string | null, lineItems: Array<{ __typename?: 'SvbrgQuoteLineItem', id: any, sequence: number, position: string, title?: string | null, description?: string | null, quantity?: any | null, unitId?: any | null, pricePerUnit?: any | null, earlyDeliveryAt?: any | null, lateDeliveryAt?: any | null }> } | null } };

export type AnalyzeQuoteMutationVariables = Exact<{
  data: SvbrgQuoteAnalysisInput;
}>;


export type AnalyzeQuoteMutation = { __typename?: 'Mutation', sevenbridges: { __typename?: 'sevenbridgesMutation', quote: { __typename?: 'SvbrgQuoteAnalysisMutations', analyse: { __typename?: 'SvbrgQuoteAnalysis', id: any, fileId: any } } } };

export type QuoteAnalysisQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type QuoteAnalysisQuery = { __typename?: 'Query', sevenbridges: { __typename?: 'sevenbridgesQuery', quote?: { __typename?: 'SvbrgQuote', id: any, analysis: { __typename?: 'SvbrgQuoteAnalysis', id: any, fileId: any, completedAt?: any | null, status: SvbrgBackgroundJobStatus, quote?: { __typename?: 'SvbrgQuote', id: any, currency: string, quoteReference?: string | null, lineItems: Array<{ __typename?: 'SvbrgQuoteLineItem', id: any, sequence: number, position: string, title?: string | null, description?: string | null, quantity?: any | null, unitId?: any | null, pricePerUnit?: any | null, earlyDeliveryAt?: any | null, lateDeliveryAt?: any | null }> } | null } } | null } };

export type OnCompletedQuoteAnaylsisSubscriptionVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type OnCompletedQuoteAnaylsisSubscription = { __typename?: 'Subscription', sevenbridges: { __typename?: 'sevenbridgesSubscription', quote?: { __typename?: 'SvbrgQuote', analysis: { __typename?: 'SvbrgQuoteAnalysis', id: any, fileId: any, status: SvbrgBackgroundJobStatus, quote?: { __typename?: 'SvbrgQuote', id: any, quoteReference?: string | null, currency: string, lineItems: Array<{ __typename?: 'SvbrgQuoteLineItem', id: any, sequence: number, position: string, title?: string | null, description?: string | null, unitId?: any | null, pricePerUnit?: any | null, quantity?: any | null, earlyDeliveryAt?: any | null, lateDeliveryAt?: any | null }> } | null } } | null } };

export type TesseractNegotiationCaseResubmitMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type TesseractNegotiationCaseResubmitMutation = { __typename?: 'Mutation', tesseract: { __typename?: 'tesseractMutation', negotiationCase: { __typename?: 'TsrctNegotiationCaseMutations', resubmit?: any | null } } };

export type NegotiationCaseDetailQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type NegotiationCaseDetailQuery = { __typename?: 'Query', tesseract: { __typename?: 'tesseractQuery', negotiationCase: { __typename?: 'TsrctNegotiationCase', id: any, issues?: Array<{ __typename?: 'TsrctIssue', id: any, variant: TsrctIssueVariant, status: TsrctIssueStatus }> | null } } };

export type NegotiationCaseDetailQuoteQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type NegotiationCaseDetailQuoteQuery = { __typename?: 'Query', tesseract: { __typename?: 'tesseractQuery', negotiationCase: { __typename?: 'TsrctNegotiationCase', id: any, status: TsrctNegotiationCaseStatus, cancellationReason?: TsrctCaseCancellationReason | null, cancellationReasonText?: string | null, isMaskedBidding: boolean, options?: { __typename?: 'TsrctNegotiationCaseOptions', id: any, supplierInteractionMode: TsrctSupplierInteractionMode } | null, negotiatedQuote?: { __typename?: 'TsrctNegotiatedQuote', id: any, createdAt: any, currency: Currency, totalValue?: any | null, discount?: any | null, totalDiscountedValue?: any | null, totalPriceDiscount?: any | null, lineItems: Array<{ __typename?: 'TsrctNegotiatedQuoteItem', id: any, supplierComment?: { __typename?: 'TsrctSupplierComment', variant: TsrctSupplierCommentVariant, text?: string | null } | null }>, supplierComment?: { __typename?: 'TsrctSupplierComment', text?: string | null, variant: TsrctSupplierCommentVariant } | null } | null } } };

export type NegotiationCaseInternalFileAttachmentsQueryVariables = Exact<{
  parents: Array<TsrctAttachmentParentInput> | TsrctAttachmentParentInput;
  filter?: InputMaybe<TsrctAttachmentFilterInput>;
}>;


export type NegotiationCaseInternalFileAttachmentsQuery = { __typename?: 'Query', tesseract: { __typename?: 'tesseractQuery', attachments: Array<(
      { __typename?: 'TsrctAttachment' }
      & { ' $fragmentRefs'?: { 'FileAttachmentFragment': FileAttachmentFragment } }
    )> } };

export type NegotiationCaseInternalFileAttachmentsCaseAndDemandQueryVariables = Exact<{
  negotiationCaseId: Scalars['UUID']['input'];
}>;


export type NegotiationCaseInternalFileAttachmentsCaseAndDemandQuery = { __typename?: 'Query', tesseract: { __typename?: 'tesseractQuery', negotiationCase: { __typename?: 'TsrctNegotiationCase', id: any, status: TsrctNegotiationCaseStatus, demand: { __typename?: 'TsrctDemand', id: any } } } };

export type NegotiationCaseSupplierFileAttachmentsQueryVariables = Exact<{
  negotiationCaseId: Scalars['UUID']['input'];
  parents: Array<TsrctAttachmentParentInput> | TsrctAttachmentParentInput;
  filter?: InputMaybe<TsrctAttachmentFilterInput>;
}>;


export type NegotiationCaseSupplierFileAttachmentsQuery = { __typename?: 'Query', tesseract: { __typename?: 'tesseractQuery', attachments: Array<(
      { __typename?: 'TsrctAttachment' }
      & { ' $fragmentRefs'?: { 'FileAttachmentFragment': FileAttachmentFragment } }
    )>, negotiationCase: { __typename?: 'TsrctNegotiationCase', id: any, status: TsrctNegotiationCaseStatus } } };

export type NegotiationContactUpdateMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  contact: TsrctNegotiationCaseSupplierContactInput;
}>;


export type NegotiationContactUpdateMutation = { __typename?: 'Mutation', tesseract: { __typename?: 'tesseractMutation', negotiationCase: { __typename?: 'TsrctNegotiationCaseMutations', supplier: { __typename?: 'TsrctNegotiationCaseSupplierMutations', contact: { __typename?: 'TsrctContactMutations', update: { __typename?: 'TsrctNegotiationCaseSupplierContact', id: any, firstName?: string | null, lastName?: string | null, phone?: string | null, email?: any | null, mobile?: string | null, language: TsrctLanguage } } } } } };

export type NegotiationContactQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type NegotiationContactQuery = { __typename?: 'Query', tesseract: { __typename?: 'tesseractQuery', negotiationCase: { __typename?: 'TsrctNegotiationCase', id: any, status: TsrctNegotiationCaseStatus, processStatus?: TsrctNegotiationCaseProcessStatus | null, supplier: { __typename?: 'TsrctNegotiationCaseSupplier', id: any, internalId: any, name: string, externalReference?: string | null, location: { __typename?: 'TsrctNegotiationCaseSupplierLocation', id: any, internalId?: any | null, address?: string | null, city?: string | null, postalCode?: string | null, countryCode?: CountryCode | null }, contact: { __typename?: 'TsrctNegotiationCaseSupplierContact', id: any, internalId?: any | null, firstName?: string | null, lastName?: string | null, email?: any | null, language: TsrctLanguage, mobile?: string | null, phone?: string | null } } } } };

export type NegotiationQuoteDetailsUpdateMutationVariables = Exact<{
  negotiationCaseId: Scalars['UUID']['input'];
  data: TsrctQuoteInput;
}>;


export type NegotiationQuoteDetailsUpdateMutation = { __typename?: 'Mutation', tesseract: { __typename?: 'tesseractMutation', negotiationCase: { __typename?: 'TsrctNegotiationCaseMutations', quote: { __typename?: 'TsrctQuoteMutations', create: { __typename?: 'TsrctQuote', id: any, supplierReference?: string | null, totalValue?: any | null, paymentTerms: Array<{ __typename?: 'TsrctPaymentTerm', daysToPayment: number, discount: any }>, lineItems: Array<{ __typename?: 'TsrctQuoteItem', id: any, position: string, quantity: any, description?: string | null, pricePerUnit?: any | null, unitId?: any | null, deliveryLocationId?: any | null, organizationId?: any | null, status: TsrctQuoteItemStatus }> } } } } };

export type NegotiationQuoteDetailsQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type NegotiationQuoteDetailsQuery = { __typename?: 'Query', tesseract: { __typename?: 'tesseractQuery', negotiationCase: { __typename?: 'TsrctNegotiationCase', id: any, isMaskedBidding: boolean, status: TsrctNegotiationCaseStatus, processStatus?: TsrctNegotiationCaseProcessStatus | null, options?: { __typename?: 'TsrctNegotiationCaseOptions', id: any, quoteMode: TsrctQuoteMode } | null, quote?: { __typename?: 'TsrctQuote', id: any, supplierReference?: string | null, currency: Currency, totalValue?: any | null, paymentTerms: Array<{ __typename?: 'TsrctPaymentTerm', daysToPayment: number, discount: any }>, lineItems: Array<{ __typename?: 'TsrctQuoteItem', id: any, position: string, quantity: any, title?: string | null, description?: string | null, pricePerUnit?: any | null, unitId?: any | null, totalValue?: any | null, deliveryLocationId?: any | null, organizationId?: any | null, commodityId?: any | null, status: TsrctQuoteItemStatus, shipmentTerms: { __typename?: 'TsrctShipmentTerms', earlyDeliveryAt?: any | null, lateDeliveryAt?: any | null } }> } | null } } };

export type ReminderSettingsMutationMutationVariables = Exact<{
  data: TsrctUpdateReminderConfigInput;
}>;


export type ReminderSettingsMutationMutation = { __typename?: 'Mutation', tesseract: { __typename?: 'tesseractMutation', updateReminderConfig: { __typename?: 'TsrctReminderConfig', reminderConfigId?: any | null, targetId: any, type: TsrctReminderType, variant: TsrctReminderConfigVariant, source: TsrctReminderPolicySource, reminderDelayWorkingDays?: number | null, cancellationDelayWorkingDays?: number | null, executionTime: string, timezone: string } } };

export type ReminderSettingsQueryQueryVariables = Exact<{
  targetId: Scalars['UUID']['input'];
  type: TsrctReminderType;
  variant: TsrctReminderConfigVariant;
  isNegotiationCase?: Scalars['Boolean']['input'];
  isSourcingCase?: Scalars['Boolean']['input'];
}>;


export type ReminderSettingsQueryQuery = { __typename?: 'Query', tesseract: { __typename?: 'tesseractQuery', reminderConfig: { __typename?: 'TsrctReminderConfig', reminderConfigId?: any | null, targetId: any, type: TsrctReminderType, variant: TsrctReminderConfigVariant, source: TsrctReminderPolicySource, reminderDelayWorkingDays?: number | null, cancellationDelayWorkingDays?: number | null, executionTime: string, timezone: string }, negotiationCase?: { __typename?: 'TsrctNegotiationCase', id: any, status: TsrctNegotiationCaseStatus }, sourcingCase?: { __typename?: 'TsrctSourcingCase', id: any, status: TsrctSourcingCaseStatus } } };

export type SupplierContactNamePolicyQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type SupplierContactNamePolicyQueryQuery = { __typename?: 'Query', tesseract: { __typename?: 'tesseractQuery', supplierContactSettings: { __typename?: 'TsrctSupplierContactSettings', namePolicy: TsrctSupplierContactNamePolicy } } };

export type NegotiationCaseUpdateSupplierIntroductionMessageMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  data: TsrctSupplierIntroductionMessageInput;
}>;


export type NegotiationCaseUpdateSupplierIntroductionMessageMutation = { __typename?: 'Mutation', tesseract: { __typename?: 'tesseractMutation', negotiationCase: { __typename?: 'TsrctNegotiationCaseMutations', supplierIntroductionMessage: { __typename?: 'TsrctSupplierIntroductionMessageMutation', update?: { __typename?: 'TsrctSupplierIntroductionMessage', text: string, language: TsrctLanguage } | null } } } };

export type NegotiationSupplierIntroductionMessageQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type NegotiationSupplierIntroductionMessageQuery = { __typename?: 'Query', tesseract: { __typename?: 'tesseractQuery', negotiationCase: { __typename?: 'TsrctNegotiationCase', id: any, status: TsrctNegotiationCaseStatus, supplierIntroductionMessage?: { __typename?: 'TsrctSupplierIntroductionMessage', text: string, language: TsrctLanguage } | null } } };

export type NegotiationTaskResolveMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type NegotiationTaskResolveMutation = { __typename?: 'Mutation', resolveTask?: { __typename?: 'TaskItem', id: string, status: TaskStatus } | null };

export type NegotiationTasksQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TasksFilterInput>;
}>;


export type NegotiationTasksQuery = { __typename?: 'Query', tasks: { __typename?: 'TaskItemConnection', totalCount?: number | null, nodes: Array<{ __typename?: 'TaskItem', id: string, status: TaskStatus, variant: TaskVariant, message?: { __typename?: 'TaskMessage', variant: string, details?: Record<string, any> | null } | null, relatedResources: Array<{ __typename?: 'TaskRelatedResource', project: string, reference: string, variant: string }> }> } };

export type NegotiationTermsUpdateMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  strategy: TsrctNegotiationStrategyBoundariesInput;
  options: TsrctNegotiationCaseOptionsInput;
}>;


export type NegotiationTermsUpdateMutation = { __typename?: 'Mutation', tesseract: { __typename?: 'tesseractMutation', negotiationCase: { __typename?: 'TsrctNegotiationCaseMutations', strategy: { __typename?: 'TsrctStrategyMutations', update: { __typename?: 'TsrctNegotiationStrategy', id: any, useHistoricTenderData: boolean, useHistoricNegotiationData: boolean, boundaryRules: Array<{ __typename?: 'TsrctNegotiationStrategyBoundary', id: any, base: TsrctNegotiationStrategyBoundaryBase, lower: any, upper: any, sequence: number }> } }, options: { __typename?: 'TsrctOptionsMutations', update: { __typename?: 'TsrctNegotiationCaseOptions', id: any, initiatedBy: TsrctInitiationMode, quoteMode: TsrctQuoteMode, negotiationMode: TsrctNegotiationMode, supplierInteractionMode: TsrctSupplierInteractionMode, negotiationObjective: TsrctNegotiationObjective } } } } };

export type NegotiationTermsQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type NegotiationTermsQuery = { __typename?: 'Query', tesseract: { __typename?: 'tesseractQuery', negotiationCase: { __typename?: 'TsrctNegotiationCase', id: any, status: TsrctNegotiationCaseStatus, processStatus?: TsrctNegotiationCaseProcessStatus | null, lowerDiscountBoundary: any, upperDiscountBoundary: any, supplier: { __typename?: 'TsrctNegotiationCaseSupplier', id: any, internalId: any }, strategy?: { __typename?: 'TsrctNegotiationStrategy', id: any, useHistoricTenderData: boolean, useHistoricNegotiationData: boolean, boundaryRules: Array<{ __typename?: 'TsrctNegotiationStrategyBoundary', id: any, base: TsrctNegotiationStrategyBoundaryBase, lower: any, upper: any, sequence: number }> } | null, options?: { __typename?: 'TsrctNegotiationCaseOptions', id: any, initiatedBy: TsrctInitiationMode, quoteMode: TsrctQuoteMode, negotiationMode: TsrctNegotiationMode, supplierInteractionMode: TsrctSupplierInteractionMode, negotiationObjective: TsrctNegotiationObjective } | null, demand: { __typename?: 'TsrctDemand', id: any }, negotiatedQuote?: { __typename?: 'TsrctNegotiatedQuote', id: any, currency: Currency, discount?: any | null, totalValue?: any | null, totalDiscountedValue?: any | null, totalPriceDiscount?: any | null, createdAt: any } | null } } };

export type NewsroomWidgetQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
}>;


export type NewsroomWidgetQuery = { __typename?: 'Query', supplier: { __typename?: 'SupplierDetail', id: string, news: { __typename?: 'NewsConnection', totalCount?: number | null, nodes: Array<{ __typename?: 'News', id: string, title: string, date: any, url: any, source: { __typename?: 'ExternalLink', title: string, url: string } }> } } };

export type RuleEvaluationLogQueryVariables = Exact<{
  ruleId: Scalars['UUID']['input'];
  order?: InputMaybe<Array<TsrctRuleEvaluationLogOrder> | TsrctRuleEvaluationLogOrder>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type RuleEvaluationLogQuery = { __typename?: 'Query', tesseract: { __typename?: 'tesseractQuery', rule: { __typename?: 'TsrctRule', id: any, evaluationLogs: { __typename?: 'TsrctRuleEvaluationLogListConnection', totalCount: any, nodes: Array<{ __typename?: 'TsrctRuleEvaluationLogListItem', id: any, createdAt: any, sequenceNumber: any }> } } } };

export type DeleteSavingMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteSavingMutation = { __typename?: 'Mutation', deleteSaving: boolean };

export type SavingsListQueryVariables = Exact<{
  query?: InputMaybe<SavingQueryInput>;
}>;


export type SavingsListQuery = { __typename?: 'Query', savings: Array<{ __typename?: 'Saving', id: string, name?: string | null, description?: string | null, status: SavingStatus, savingType: SavingType, currency?: Currency | null, baselinePrice?: any | null, newPrice?: any | null, baselineQuantity?: any | null, newQuantity?: any | null, validFrom?: any | null, validTo?: any | null, multiYearSaving: boolean, createdAt: any, updatedAt: any, fkBuyer?: string | null, fkSupplier?: string | null, fkCommodityGroup?: string | null, freeTextCommodity?: string | null, fkProcurementOrganization?: string | null, fkOrganization?: string | null, fkPurchasingGroup?: string | null, fkAccountingArea?: string | null, fkUnit?: string | null, originalPriceQuantity?: any | null, newPriceQuantity?: any | null, reductionType?: SavingReductionType | null, costAllocation: Array<{ __typename?: 'SavingCostAllocation', distributionType: SavingCostAllocationDistributionType, allocationValue?: string | null, fkAccountAssignmentCategory?: string | null, fkAccountAssignment?: string | null, fkGeneralLedgerAccount?: string | null }>, sourceReferences: Array<{ __typename?: 'SourceReference', fkSourceSystem: string, isPrimary: boolean, sourceContext?: string | null, sourceReference: string, sourceReferenceItem?: string | null, synchronizedAt: any }> }> };

export type CreateSavingMutationVariables = Exact<{
  input: SavingInput;
}>;


export type CreateSavingMutation = { __typename?: 'Mutation', createSaving: { __typename?: 'Saving', id: string, name?: string | null, description?: string | null, status: SavingStatus, savingType: SavingType, currency?: Currency | null, baselinePrice?: any | null, newPrice?: any | null, baselineQuantity?: any | null, newQuantity?: any | null, validFrom?: any | null, validTo?: any | null, createdAt: any, updatedAt: any, fkBuyer?: string | null, fkSupplier?: string | null, fkCommodityGroup?: string | null, freeTextCommodity?: string | null, fkProcurementOrganization?: string | null, fkOrganization?: string | null, fkPurchasingGroup?: string | null, fkAccountingArea?: string | null, fkUnit?: string | null, originalPriceQuantity?: any | null, newPriceQuantity?: any | null, reductionType?: SavingReductionType | null, costAllocation: Array<{ __typename?: 'SavingCostAllocation', distributionType: SavingCostAllocationDistributionType, allocationValue?: string | null, fkAccountAssignmentCategory?: string | null, fkAccountAssignment?: string | null, fkGeneralLedgerAccount?: string | null }>, sourceReferences: Array<{ __typename?: 'SourceReference', fkSourceSystem: string, isPrimary: boolean, sourceContext?: string | null, sourceReference: string, sourceReferenceItem?: string | null, synchronizedAt: any }> } };

export type UpdateSavingMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: SavingInput;
}>;


export type UpdateSavingMutation = { __typename?: 'Mutation', updateSaving?: { __typename?: 'Saving', id: string, name?: string | null, description?: string | null, status: SavingStatus, savingType: SavingType, currency?: Currency | null, baselinePrice?: any | null, newPrice?: any | null, baselineQuantity?: any | null, newQuantity?: any | null, validFrom?: any | null, validTo?: any | null, createdAt: any, updatedAt: any, fkBuyer?: string | null, fkSupplier?: string | null, fkCommodityGroup?: string | null, freeTextCommodity?: string | null, fkProcurementOrganization?: string | null, fkOrganization?: string | null, fkPurchasingGroup?: string | null, fkAccountingArea?: string | null, fkUnit?: string | null, originalPriceQuantity?: any | null, newPriceQuantity?: any | null, reductionType?: SavingReductionType | null, costAllocation: Array<{ __typename?: 'SavingCostAllocation', distributionType: SavingCostAllocationDistributionType, allocationValue?: string | null, fkAccountAssignmentCategory?: string | null, fkAccountAssignment?: string | null, fkGeneralLedgerAccount?: string | null }>, sourceReferences: Array<{ __typename?: 'SourceReference', fkSourceSystem: string, isPrimary: boolean, sourceContext?: string | null, sourceReference: string, sourceReferenceItem?: string | null, synchronizedAt: any }> } | null };

export type GetSavingQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetSavingQuery = { __typename?: 'Query', saving?: { __typename?: 'Saving', id: string, name?: string | null, description?: string | null, status: SavingStatus, savingType: SavingType, currency?: Currency | null, baselinePrice?: any | null, newPrice?: any | null, baselineQuantity?: any | null, newQuantity?: any | null, validFrom?: any | null, validTo?: any | null, createdAt: any, updatedAt: any, fkBuyer?: string | null, fkSupplier?: string | null, fkCommodityGroup?: string | null, freeTextCommodity?: string | null, fkProcurementOrganization?: string | null, fkOrganization?: string | null, fkPurchasingGroup?: string | null, fkAccountingArea?: string | null, fkUnit?: string | null, originalPriceQuantity?: any | null, newPriceQuantity?: any | null, reductionType?: SavingReductionType | null, costAllocation: Array<{ __typename?: 'SavingCostAllocation', distributionType: SavingCostAllocationDistributionType, allocationValue?: string | null, fkAccountAssignmentCategory?: string | null, fkAccountAssignment?: string | null, fkGeneralLedgerAccount?: string | null }>, sourceReferences: Array<{ __typename?: 'SourceReference', fkSourceSystem: string, isPrimary: boolean, sourceContext?: string | null, sourceReference: string, sourceReferenceItem?: string | null, synchronizedAt: any }> } | null };

export type SavingHistoryQueryQueryVariables = Exact<{
  entityId: Scalars['UUID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SavingHistoryQueryQuery = { __typename?: 'Query', telescope: { __typename?: 'telescopeQuery', logEntries: { __typename?: 'TlscpLogEntryConnection', totalCount: any, nodes: Array<{ __typename?: 'TlscpLogEntry', actorId?: any | null, actorVariant: string, context: Record<string, any>, createdAt: any, entityId: any, entityVariant: string, id: any, parentId?: any | null, parentVariant?: string | null, status: string, template: string }> } } };

export type TesseractSourcingCaseResubmitMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type TesseractSourcingCaseResubmitMutation = { __typename?: 'Mutation', tesseract: { __typename?: 'tesseractMutation', sourcingCase: { __typename?: 'TsrctSourcingCaseMutations', resubmit?: any | null } } };

export type SourcingCaseIssuesQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type SourcingCaseIssuesQuery = { __typename?: 'Query', tesseract: { __typename?: 'tesseractQuery', sourcingCase: { __typename?: 'TsrctSourcingCase', id: any, issues: Array<{ __typename?: 'TsrctSourcingCaseIssue', id: any, variant: TsrctIssueVariant, status: TsrctIssueStatus }> } } };

export type UserAvailabilityListQueryVariables = Exact<{
  dateRange?: InputMaybe<AstroDateRangeInput>;
  filter?: InputMaybe<Scalars['AstroQueryBuilderQuery']['input']>;
  order?: InputMaybe<Array<AstroUserAvailabilityOrder> | AstroUserAvailabilityOrder>;
}>;


export type UserAvailabilityListQuery = { __typename?: 'Query', astronaut: { __typename?: 'astronautQuery', userAvailability: { __typename?: 'AstroUserAvailabilityListItemConnection', totalCount: any, columns: Array<{ __typename?: 'AstroUserAvailabilityListColumn', weekStart: any, weekEnd: any }>, nodes: Array<{ __typename?: 'AstroUserAvailabilityListItem', id: any, user: { __typename?: 'AstroUserAvailabilityUser', id: any, firstName?: string | null, lastName?: string | null, email?: any | null, pictureId?: any | null, workingHours?: number | null }, availabilityPerWeek: Array<{ __typename?: 'AstroUserAvailabilityPerWeek', weekStart: any, availability: number }> }> } } };

export type DeleteAbsenceMutationVariables = Exact<{
  userId?: InputMaybe<Scalars['UUID']['input']>;
  id: Scalars['UUID']['input'];
}>;


export type DeleteAbsenceMutation = { __typename?: 'Mutation', astronaut: { __typename?: 'astronautMutation', user: { __typename?: 'AstroUserMutations', absence: { __typename?: 'AstroAbsenceMutations', delete?: any | null } } } };

export type LoadAbsencesQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['UUID']['input']>;
  where?: InputMaybe<AstroAbsenceListWhereInput>;
}>;


export type LoadAbsencesQuery = { __typename?: 'Query', astronaut: { __typename?: 'astronautQuery', user: { __typename?: 'AstroUserDetails', id: any, primarySourceReference: any, absences: { __typename?: 'AstroAbsenceListItemConnection', nodes: Array<{ __typename?: 'AstroAbsenceListItem', id: any, start: any, end: any }> } } } };

export type UpsertAbsenceMutationVariables = Exact<{
  userId?: InputMaybe<Scalars['UUID']['input']>;
  data: AstroAbsenceInput;
}>;


export type UpsertAbsenceMutation = { __typename?: 'Mutation', astronaut: { __typename?: 'astronautMutation', user: { __typename?: 'AstroUserMutations', absence: { __typename?: 'AstroAbsenceMutations', upsert: { __typename?: 'AstroAbsence', id: string, start: any, end: any } } } } };

export type UpdateUserProfileMutationVariables = Exact<{
  userId?: InputMaybe<Scalars['UUID']['input']>;
  data: AstroUserProfileInput;
}>;


export type UpdateUserProfileMutation = { __typename?: 'Mutation', astronaut: { __typename?: 'astronautMutation', user: { __typename?: 'AstroUserMutations', profile: { __typename?: 'AstroUserProfileMutations', update: { __typename?: 'AstroUserProfile', id: any, firstName?: string | null, lastName?: string | null, email?: any | null, capabilityIds: Array<any>, commodityGroupIds: Array<any>, workingHours?: number | null, deliveryLocationId?: any | null, organizationId?: any | null, accountingAreaId?: any | null, costCenterId?: any | null, currency: Currency, jobTitle?: string | null, pictureId?: any | null, updatedAt: any, createdAt: any } } } } };

export type ContractDemandAwardSuppliersMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  data: TsrctContractDemandAwardsInput;
}>;


export type ContractDemandAwardSuppliersMutation = { __typename?: 'Mutation', tesseract: { __typename?: 'tesseractMutation', contractDemand: { __typename?: 'TsrctContractDemandMutations', awardSuppliers: { __typename?: 'TsrctContractDemand', id: any } } } };

export type ContractDemandAwardingQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type ContractDemandAwardingQuery = { __typename?: 'Query', tesseract: { __typename?: 'tesseractQuery', contractDemand: { __typename?: 'TsrctContractDemand', id: any, status: TsrctContractDemandStatus, sequenceNumber?: any | null, createdAt: any, updatedAt: any, deletedAt?: any | null, priority: number, responsibleUserId?: any | null, tagIds: Array<any>, bestOfferQuoteItems: Array<{ __typename?: 'TsrctBestOfferLineItem', id: any }>, sourcingCases: Array<{ __typename?: 'TsrctSourcingCase', id: any, status: TsrctSourcingCaseStatus, createdAt: any, updatedAt: any, sequenceNumber?: any | null, isAwardable: boolean, supplier?: { __typename?: 'TsrctSourcingCaseSupplier', id: any, supplierId: any, name: string, contact: { __typename?: 'TsrctSourcingCaseSupplierContact', id: any, internalId?: any | null, email?: any | null, firstName?: string | null, lastName?: string | null, language?: TsrctLanguage | null } } | null, sourceReferences: Array<{ __typename?: 'TsrctSourcingCaseReference', id: any, sourceReference?: string | null, url?: any | null }>, quote?: { __typename?: 'TsrctSourcingCaseQuote', id: any, createdAt: any, totalValue?: any | null, discount?: any | null, totalDiscountedValue?: any | null, totalPriceDiscount?: any | null, currency: string, validFrom: any, validTo: any, lineItems: Array<{ __typename?: 'TsrctSourcingCaseQuoteItem', id: any, demandRequestItemId: any, title: string, quantity: any, totalValue?: any | null, totalDiscountedValue?: any | null, pricePerUnit?: any | null, pricePerPriceUnit?: any | null, discountedPricePerUnit?: any | null, discountedPricePerPriceUnit?: any | null, status: TsrctSourcingCaseQuoteItemStatus, bidDeclinedReason?: TsrctSourcingCaseQuoteItemBidDeclineReason | null, bidDeclinedReasonText?: string | null, negotiationFailedReason?: TsrctSourcingCaseQuoteItemNegotiationFailedReason | null, negotiationFailedReasonText?: string | null, isAwardable: boolean }> } | null, issues: Array<{ __typename?: 'TsrctSourcingCaseIssue', id: any, variant: TsrctIssueVariant, status: TsrctIssueStatus }> }>, competitiveBiddingRule: { __typename?: 'TsrctContractDemandCompetitiveBiddingRule', id: any, variant: TsrctCompetitiveBiddingVariant, biddingPeriodDays?: number | null, deadline?: any | null, deadlineExceeded: boolean }, demandRequest?: { __typename?: 'TsrctContractDemandRequest', id: any, createdAt: any, requestedAt: any, summary?: string | null, totalValue?: any | null, currency: Currency, commodityGroupId?: any | null, incoTermsId?: any | null, paymentTermsId?: any | null, validityPeriod: { __typename?: 'TsrctDateRange', from?: any | null, to?: any | null }, lineItems: Array<{ __typename?: 'TsrctContractDemandRequestItem', id: any, createdAt: any, title: string, description?: string | null, quantity: any, minimumOrderQuantity?: any | null, baselinePricePerUnit?: any | null, baselinePricePerPriceUnit?: any | null, unitId?: any | null, priceUnit: any, deliveryLocationId?: any | null, organizationId: any, commodityId?: any | null, commodityGroupId?: any | null, totalValue?: any | null }> } | null } } };

export type ContractDemandCasesQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type ContractDemandCasesQuery = { __typename?: 'Query', tesseract: { __typename?: 'tesseractQuery', contractDemand: { __typename?: 'TsrctContractDemand', id: any, status: TsrctContractDemandStatus, demandRequest?: { __typename?: 'TsrctContractDemandRequest', id: any, lineItems: Array<{ __typename?: 'TsrctContractDemandRequestItem', id: any, qualifiedSuppliers: Array<any> }> } | null, sourcingCases: Array<{ __typename?: 'TsrctSourcingCase', id: any, status: TsrctSourcingCaseStatus, cancellationReason?: TsrctCaseCancellationReason | null, cancellationReasonText?: string | null, createdAt: any, updatedAt: any, sequenceNumber?: any | null, supplier?: { __typename?: 'TsrctSourcingCaseSupplier', id: any, name: string, supplierId: any, contact: { __typename?: 'TsrctSourcingCaseSupplierContact', id: any, firstName?: string | null, lastName?: string | null, email?: any | null, internalId?: any | null } } | null, quote?: { __typename?: 'TsrctSourcingCaseQuote', id: any, currency: string, totalValue?: any | null, totalDiscountedValue?: any | null, discount?: any | null } | null, issues: Array<{ __typename?: 'TsrctSourcingCaseIssue', id: any, status: TsrctIssueStatus, variant: TsrctIssueVariant }>, latestComment?: { __typename?: 'TsrctComment', id: any, message: string, authorId: any, createdAt?: any | null } | null }> } } };

export type ContractDemandAddCasesMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  data: TsrctContractDemandAddSourcingCasesInput;
}>;


export type ContractDemandAddCasesMutation = { __typename?: 'Mutation', tesseract: { __typename?: 'tesseractMutation', contractDemand: { __typename?: 'TsrctContractDemandMutations', addSourcingCases: Array<{ __typename?: 'TsrctSourcingCase', id: any, sequenceNumber?: any | null, createdAt: any, updatedAt: any, status: TsrctSourcingCaseStatus, supplier?: { __typename?: 'TsrctSourcingCaseSupplier', id: any, name: string, supplierId: any, contact: { __typename?: 'TsrctSourcingCaseSupplierContact', id: any, firstName?: string | null, lastName?: string | null, email?: any | null, internalId?: any | null } } | null, quote?: { __typename?: 'TsrctSourcingCaseQuote', id: any, currency: string, totalValue?: any | null, totalDiscountedValue?: any | null, discount?: any | null } | null, issues: Array<{ __typename?: 'TsrctSourcingCaseIssue', id: any, status: TsrctIssueStatus, variant: TsrctIssueVariant }> }> } } };

export type ReleaseSourcingCaseMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type ReleaseSourcingCaseMutation = { __typename?: 'Mutation', tesseract: { __typename?: 'tesseractMutation', sourcingCase: { __typename?: 'TsrctSourcingCaseMutations', release?: any | null } } };

export type ContractDemandDetailUnifiedUpdateMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  demandData: TsrctDemandUpdateInput;
  competitiveBiddingRuleData?: InputMaybe<TsrctCompetitiveBiddingRuleInput>;
}>;


export type ContractDemandDetailUnifiedUpdateMutation = { __typename?: 'Mutation', tesseract: { __typename?: 'tesseractMutation', demand: { __typename?: 'TsrctDemandMutations', update: { __typename?: 'TsrctDemand', id: any, capabilityIds: Array<any>, responsibleUserIds: Array<any>, demandRequest: { __typename?: 'TsrctDemandRequest', id: any, sourceReferences: Array<{ __typename?: 'TsrctDemandRequestSourceReference', internalId: any, sourceReference: string, isPrimary: boolean, sourceSystem: { __typename?: 'TsrctSourceSystem', id: string, name: string } }> }, permissions: { __typename?: 'TsrctDemandPermissions', write: boolean } }, competitiveBiddingRule: { __typename?: 'TsrctCompetitiveBiddingRuleMutations', update?: { __typename?: 'TsrctCompetitiveBiddingRule', id: any, variant: TsrctCompetitiveBiddingVariant, deadline?: any | null } | null } } } };

export type ContractDemandUpdateMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  contractDemandData: TsrctContractDemandDetailsInput;
}>;


export type ContractDemandUpdateMutation = { __typename?: 'Mutation', tesseract: { __typename?: 'tesseractMutation', contractDemand: { __typename?: 'TsrctContractDemandMutations', update: { __typename?: 'TsrctContractDemand', id: any, priority: number, sequenceNumber?: any | null, createdAt: any, updatedAt: any, responsibleUserId?: any | null, tagIds: Array<any>, competitiveBiddingRule: { __typename?: 'TsrctContractDemandCompetitiveBiddingRule', id: any, variant: TsrctCompetitiveBiddingVariant, biddingPeriodDays?: number | null, deadline?: any | null, deadlineExceeded: boolean }, demandRequest?: { __typename?: 'TsrctContractDemandRequest', id: any, commodityGroupId?: any | null, createdAt: any, currency: Currency, incoTermsId?: any | null, requestedAt: any, totalValue?: any | null, summary?: string | null, paymentTermsId?: any | null, validityPeriod: { __typename?: 'TsrctDateRange', from?: any | null, to?: any | null }, lineItems: Array<{ __typename?: 'TsrctContractDemandRequestItem', id: any, baselinePricePerUnit?: any | null, commodityGroupId?: any | null, commodityId?: any | null, createdAt: any, deliveryLocationId?: any | null, description?: string | null, minimumOrderQuantity?: any | null, quantity: any, title: string, unitId?: any | null }> } | null } } } };

export type ContractDemandDetailQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type ContractDemandDetailQuery = { __typename?: 'Query', tesseract: { __typename?: 'tesseractQuery', contractDemand: { __typename?: 'TsrctContractDemand', id: any, status: TsrctContractDemandStatus, priority: number, sequenceNumber?: any | null, createdAt: any, updatedAt: any, responsibleUserId?: any | null, tagIds: Array<any>, competitiveBiddingRule: { __typename?: 'TsrctContractDemandCompetitiveBiddingRule', id: any, variant: TsrctCompetitiveBiddingVariant, biddingPeriodDays?: number | null, deadline?: any | null, deadlineExceeded: boolean }, demandRequest?: { __typename?: 'TsrctContractDemandRequest', id: any, commodityGroupId?: any | null, createdAt: any, currency: Currency, incoTermsId?: any | null, paymentTermsId?: any | null, summary?: string | null, requestedAt: any, totalValue?: any | null, validityPeriod: { __typename?: 'TsrctDateRange', from?: any | null, to?: any | null }, lineItems: Array<{ __typename?: 'TsrctContractDemandRequestItem', id: any, baselinePricePerUnit?: any | null, commodityGroupId?: any | null, commodityId?: any | null, createdAt: any, deliveryLocationId?: any | null, description?: string | null, minimumOrderQuantity?: any | null, quantity: any, title: string, unitId?: any | null }> } | null } } };

export type ContractDemandFileAttachmentsQueryVariables = Exact<{
  parents: Array<TsrctAttachmentParentInput> | TsrctAttachmentParentInput;
  filter?: InputMaybe<TsrctAttachmentFilterInput>;
}>;


export type ContractDemandFileAttachmentsQuery = { __typename?: 'Query', tesseract: { __typename?: 'tesseractQuery', attachments: Array<(
      { __typename?: 'TsrctAttachment' }
      & { ' $fragmentRefs'?: { 'FileAttachmentFragment': FileAttachmentFragment } }
    )> } };

export type ContractDemandFileAttachmentsDemandQueryVariables = Exact<{
  demandId: Scalars['UUID']['input'];
}>;


export type ContractDemandFileAttachmentsDemandQuery = { __typename?: 'Query', tesseract: { __typename?: 'tesseractQuery', contractDemand: { __typename?: 'TsrctContractDemand', id: any, status: TsrctContractDemandStatus, sourcingCases: Array<{ __typename?: 'TsrctSourcingCase', id: any, status: TsrctSourcingCaseStatus }> } } };

export type ContractDemandRequestUpdateMutationVariables = Exact<{
  demandId: Scalars['UUID']['input'];
  data: TsrctContractDemandRequestLineItemsInput;
}>;


export type ContractDemandRequestUpdateMutation = { __typename?: 'Mutation', tesseract: { __typename?: 'tesseractMutation', contractDemand: { __typename?: 'TsrctContractDemandMutations', contractDemandRequest: { __typename?: 'TsrctContractDemandRequestMutations', updateLineItems: { __typename?: 'TsrctContractDemandRequest', id: any, currency: Currency, lineItems: Array<{ __typename?: 'TsrctContractDemandRequestItem', id: any, createdAt: any, title: string, description?: string | null, deliveryLocationId?: any | null, organizationId: any, unitId?: any | null, quantity: any, commodityGroupId?: any | null, commodityId?: any | null, baselinePricePerUnit?: any | null, baselinePricePerPriceUnit?: any | null, minimumOrderQuantity?: any | null, priceUnit: any, qualifiedSuppliers: Array<any>, totalValue?: any | null }> } } } } };

export type TsrctContractDemandRequestQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type TsrctContractDemandRequestQuery = { __typename?: 'Query', tesseract: { __typename?: 'tesseractQuery', contractDemand: { __typename?: 'TsrctContractDemand', id: any, status: TsrctContractDemandStatus, demandRequest?: { __typename?: 'TsrctContractDemandRequest', id: any, currency: Currency, lineItems: Array<{ __typename?: 'TsrctContractDemandRequestItem', id: any, createdAt: any, title: string, description?: string | null, deliveryLocationId?: any | null, organizationId: any, unitId?: any | null, quantity: any, commodityGroupId?: any | null, commodityId?: any | null, baselinePricePerUnit?: any | null, baselinePricePerPriceUnit?: any | null, minimumOrderQuantity?: any | null, priceUnit: any, qualifiedSuppliers: Array<any>, totalValue?: any | null }> } | null } } };

export type ContractDemandCreateFromCoveragePredictionWithRuleBuilderMutationVariables = Exact<{
  data: TsrctContractDemandCreateFromCoveragePredictionInput;
}>;


export type ContractDemandCreateFromCoveragePredictionWithRuleBuilderMutation = { __typename?: 'Mutation', tesseract: { __typename?: 'tesseractMutation', contractDemandCreateFromCoveragePrediction: Array<{ __typename?: 'TsrctContractDemand', id: any, sequenceNumber?: any | null, priority: number, tagIds: Array<any>, responsibleUserId?: any | null, createdAt: any, updatedAt: any, competitiveBiddingRule: { __typename?: 'TsrctContractDemandCompetitiveBiddingRule', id: any, variant: TsrctCompetitiveBiddingVariant }, demandRequest?: { __typename?: 'TsrctContractDemandRequest', id: any, createdAt: any, requestedAt: any, totalValue?: any | null, currency: Currency, summary?: string | null } | null }> } };

export type CommodityUndercoveragesQueryVariables = Exact<{
  timeframeFrom: Scalars['DateTime']['input'];
  timeframeTo: Scalars['DateTime']['input'];
  commodityGroupIds: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
  organizationIds: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
  commodityIds?: InputMaybe<Array<Scalars['UUID']['input']> | Scalars['UUID']['input']>;
  maxResults?: InputMaybe<Scalars['Int']['input']>;
  languageCode: Language;
}>;


export type CommodityUndercoveragesQuery = { __typename?: 'Query', commodityUndercoverages: { __typename?: 'CommodityUndercoverageConnection', id: string, totalCount?: number | null, pageSize?: number | null, undercoverages: Array<{ __typename?: 'CommodityUndercoverage', commodityId: string, commodityGroupId?: string | null, organizationId: string, undercoveredQuantity: any, unitId: string, priceUnit: any, validFrom: any, validTo: any, currency: Currency, minimumOrderQuantity: any, qualifiedSupplierIds: Array<string>, title?: string | null, description?: string | null }> } };

export type SourcingCaseInternalFileAttachmentsQueryVariables = Exact<{
  parents: Array<TsrctAttachmentParentInput> | TsrctAttachmentParentInput;
  filter?: InputMaybe<TsrctAttachmentFilterInput>;
}>;


export type SourcingCaseInternalFileAttachmentsQuery = { __typename?: 'Query', tesseract: { __typename?: 'tesseractQuery', attachments: Array<(
      { __typename?: 'TsrctAttachment' }
      & { ' $fragmentRefs'?: { 'FileAttachmentFragment': FileAttachmentFragment } }
    )> } };

export type SourcingCaseInternalFileAttachmentsCaseAndDemandQueryVariables = Exact<{
  sourcingCaseId: Scalars['UUID']['input'];
}>;


export type SourcingCaseInternalFileAttachmentsCaseAndDemandQuery = { __typename?: 'Query', tesseract: { __typename?: 'tesseractQuery', sourcingCase: { __typename?: 'TsrctSourcingCase', id: any, status: TsrctSourcingCaseStatus, demand?: { __typename?: 'TsrctSourcingCaseDemandReference', id: any } | null } } };

export type SourcingCaseContactUpdateMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  data: TsrctSourcingCaseContactInput;
}>;


export type SourcingCaseContactUpdateMutation = { __typename?: 'Mutation', tesseract: { __typename?: 'tesseractMutation', sourcingCase: { __typename?: 'TsrctSourcingCaseMutations', updateContactDetails: { __typename?: 'TsrctSourcingCase', id: any, supplier?: { __typename?: 'TsrctSourcingCaseSupplier', id: any, name: string, supplierId: any, contact: { __typename?: 'TsrctSourcingCaseSupplierContact', id: any, internalId?: any | null, firstName?: string | null, lastName?: string | null, email?: any | null, language?: TsrctLanguage | null } } | null } } } };

export type SourcingCaseContactQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type SourcingCaseContactQuery = { __typename?: 'Query', tesseract: { __typename?: 'tesseractQuery', sourcingCase: { __typename?: 'TsrctSourcingCase', id: any, status: TsrctSourcingCaseStatus, supplier?: { __typename?: 'TsrctSourcingCaseSupplier', id: any, name: string, supplierId: any, contact: { __typename?: 'TsrctSourcingCaseSupplierContact', id: any, internalId?: any | null, firstName?: string | null, lastName?: string | null, email?: any | null, language?: TsrctLanguage | null } } | null } } };

export type SourcingCaseFlowQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type SourcingCaseFlowQuery = { __typename?: 'Query', tesseract: { __typename?: 'tesseractQuery', sourcingCase: { __typename?: 'TsrctSourcingCase', id: any, flow?: { __typename?: 'TsrctSourcingCaseFlow', id: any, status: TsrctSourcingCaseFlowStatus, steps: Array<{ __typename?: 'TsrctSourcingCaseFlowStep', id: any, variant: TsrctSourcingCaseFlowStepVariant, status: TsrctSourcingCaseFlowStepStatus, hidden: boolean }> } | null } } };

export type SourcingCaseNegotiationSettingsMutationMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  data: TsrctSourcingCaseNegotiationSettingsInput;
}>;


export type SourcingCaseNegotiationSettingsMutationMutation = { __typename?: 'Mutation', tesseract: { __typename?: 'tesseractMutation', sourcingCase: { __typename?: 'TsrctSourcingCaseMutations', updateNegotiationSettings: { __typename?: 'TsrctSourcingCase', id: any, isNegotiationEnabled: boolean, negotiationOptions?: { __typename?: 'TsrctNegotiationOptions', id: any, initiatedBy: TsrctSourcingCaseInitiationMode, negotiationObjective: TsrctSourcingCaseNegotiationObjective, supplierInteractionMode: TsrctSourcingCaseSupplierInteractionMode } | null, negotiationStrategy?: { __typename?: 'TsrctSourcingCaseNegotiationStrategy', id: any, useHistoricNegotiationData: boolean, useHistoricTenderData: boolean, boundaryRules: Array<{ __typename?: 'TsrctSourcingCaseBoundaryRule', base: TsrctSourcingCaseNegotiationStrategyBoundaryBase, lower: any, upper: any }> } | null } } } };

export type SourcingCaseNegotiationSettingsQueryQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type SourcingCaseNegotiationSettingsQueryQuery = { __typename?: 'Query', tesseract: { __typename?: 'tesseractQuery', sourcingCase: { __typename?: 'TsrctSourcingCase', id: any, status: TsrctSourcingCaseStatus, isNegotiationEnabled: boolean, isSupplierUploadAllowed: boolean, negotiationOptions?: { __typename?: 'TsrctNegotiationOptions', id: any, initiatedBy: TsrctSourcingCaseInitiationMode, negotiationObjective: TsrctSourcingCaseNegotiationObjective, supplierInteractionMode: TsrctSourcingCaseSupplierInteractionMode } | null, negotiationStrategy?: { __typename?: 'TsrctSourcingCaseNegotiationStrategy', id: any, useHistoricNegotiationData: boolean, useHistoricTenderData: boolean, boundaryRules: Array<{ __typename?: 'TsrctSourcingCaseBoundaryRule', base: TsrctSourcingCaseNegotiationStrategyBoundaryBase, lower: any, upper: any }> } | null } } };

export type UpdateSourcingCaseQuoteMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  data: TsrctSourcingCaseQuoteInput;
}>;


export type UpdateSourcingCaseQuoteMutation = { __typename?: 'Mutation', tesseract: { __typename?: 'tesseractMutation', sourcingCase: { __typename?: 'TsrctSourcingCaseMutations', updateQuote: { __typename?: 'TsrctSourcingCase', id: any, sequenceNumber?: any | null, createdAt: any, updatedAt: any, supplier?: { __typename?: 'TsrctSourcingCaseSupplier', id: any, name: string, supplierId: any, contact: { __typename?: 'TsrctSourcingCaseSupplierContact', id: any, firstName?: string | null, lastName?: string | null, email?: any | null, internalId?: any | null } } | null, quote?: { __typename?: 'TsrctSourcingCaseQuote', id: any, createdAt: any, currency: string, supplierReference?: string | null, validFrom: any, validTo: any, paymentTermsId?: any | null, incoTermsId?: any | null, lineItems: Array<{ __typename?: 'TsrctSourcingCaseQuoteItem', id: any, sequence: number, createdAt: any, title: string, description?: string | null, unitId?: any | null, commodityId?: any | null, deliveryLocationId?: any | null, status: TsrctSourcingCaseQuoteItemStatus, organizationId?: any | null, priceUnit: any, quantity: any }> } | null } } } };

export type SourcingCaseQuoteQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type SourcingCaseQuoteQuery = { __typename?: 'Query', tesseract: { __typename?: 'tesseractQuery', sourcingCase: { __typename?: 'TsrctSourcingCase', id: any, status: TsrctSourcingCaseStatus, sequenceNumber?: any | null, createdAt: any, updatedAt: any, isNegotiationEnabled: boolean, isSupplierUploadAllowed: boolean, isAwardable: boolean, issues: Array<{ __typename?: 'TsrctSourcingCaseIssue', id: any, status: TsrctIssueStatus, variant: TsrctIssueVariant }>, supplier?: { __typename?: 'TsrctSourcingCaseSupplier', id: any, name: string, supplierId: any, contact: { __typename?: 'TsrctSourcingCaseSupplierContact', id: any, firstName?: string | null, lastName?: string | null, email?: any | null, internalId?: any | null } } | null, quote?: { __typename?: 'TsrctSourcingCaseQuote', id: any, status: TsrctSourcingCaseQuoteStatus, createdAt: any, currency: string, supplierReference?: string | null, validFrom: any, validTo: any, paymentTermsId?: any | null, incoTermsId?: any | null, lineItems: Array<{ __typename?: 'TsrctSourcingCaseQuoteItem', id: any, sequence: number, createdAt: any, title: string, description?: string | null, unitId?: any | null, commodityId?: any | null, deliveryLocationId?: any | null, status: TsrctSourcingCaseQuoteItemStatus, organizationId?: any | null, priceUnit: any, pricePerPriceUnit?: any | null, pricePerUnit?: any | null, minimumOrderQuantity?: any | null, quantity: any, discountedPricePerUnit?: any | null, discountedPricePerPriceUnit?: any | null, totalDiscountedValue?: any | null, totalValue?: any | null, demandRequestItemId: any, bidDeclinedReason?: TsrctSourcingCaseQuoteItemBidDeclineReason | null, bidDeclinedReasonText?: string | null, isAwardable: boolean }> } | null } } };

export type SourcingCaseSupplierFileAttachmentsQueryVariables = Exact<{
  sourcingCaseId: Scalars['UUID']['input'];
  parents: Array<TsrctAttachmentParentInput> | TsrctAttachmentParentInput;
  filter?: InputMaybe<TsrctAttachmentFilterInput>;
}>;


export type SourcingCaseSupplierFileAttachmentsQuery = { __typename?: 'Query', tesseract: { __typename?: 'tesseractQuery', attachments: Array<(
      { __typename?: 'TsrctAttachment' }
      & { ' $fragmentRefs'?: { 'FileAttachmentFragment': FileAttachmentFragment } }
    )>, sourcingCase: { __typename?: 'TsrctSourcingCase', id: any, status: TsrctSourcingCaseStatus } } };

export type TesseractDemandDocumentCreateMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  data: Array<TsrctFileInput> | TsrctFileInput;
}>;


export type TesseractDemandDocumentCreateMutation = { __typename?: 'Mutation', tesseract: { __typename?: 'tesseractMutation', demand: { __typename?: 'TsrctDemandMutations', file: { __typename?: 'TsrctFileMutations', create: Array<{ __typename?: 'TsrctFile', id: any, isSharedWithSupplier: boolean, quoteId?: any | null, negotiationCaseId?: any | null, negotiationCaseSequence?: any | null }> } } } };

export type FilesByDemandQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type FilesByDemandQuery = { __typename?: 'Query', tesseract: { __typename?: 'tesseractQuery', demand: { __typename?: 'TsrctDemand', id: any, status: TsrctDemandStatus, files: Array<{ __typename?: 'TsrctFile', id: any, isSharedWithSupplier: boolean, quoteId?: any | null, negotiationCaseId?: any | null, negotiationCaseSequence?: any | null, createdAt: any, updatedAt: any }>, permissions: { __typename?: 'TsrctDemandPermissions', read: boolean, write: boolean, assign: boolean }, negotiationCases: { __typename?: 'TsrctDemandNegotiationCaseConnection', nodes: Array<{ __typename?: 'TsrctDemandNegotiationCase', id: any, status: TsrctNegotiationCaseStatus }> } } } };

export type TesseractDemandDocumentsUpdateMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  files: Array<TsrctFileInput> | TsrctFileInput;
}>;


export type TesseractDemandDocumentsUpdateMutation = { __typename?: 'Mutation', tesseract: { __typename?: 'tesseractMutation', demand: { __typename?: 'TsrctDemandMutations', file: { __typename?: 'TsrctFileMutations', update: Array<{ __typename?: 'TsrctFile', id: any, isSharedWithSupplier: boolean, deletedAt?: any | null }> } } } };

export type NegotiationSettingsMutationMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  data: TsrctNegotiationCaseNegotiationSettingsInput;
}>;


export type NegotiationSettingsMutationMutation = { __typename?: 'Mutation', tesseract: { __typename?: 'tesseractMutation', negotiationCase: { __typename?: 'TsrctNegotiationCaseMutations', updateNegotiationSettings: { __typename?: 'TsrctNegotiationCase', id: any, isNegotiationEnabled: boolean, isSupplierUploadAllowed: boolean, lowerDiscountBoundary: any, upperDiscountBoundary: any, strategy?: { __typename?: 'TsrctNegotiationStrategy', id: any, useHistoricTenderData: boolean, useHistoricNegotiationData: boolean, boundaryRules: Array<{ __typename?: 'TsrctNegotiationStrategyBoundary', id: any, base: TsrctNegotiationStrategyBoundaryBase, lower: any, upper: any, sequence: number }> } | null, options?: { __typename?: 'TsrctNegotiationCaseOptions', id: any, initiatedBy: TsrctInitiationMode, quoteMode: TsrctQuoteMode, negotiationMode: TsrctNegotiationMode, supplierInteractionMode: TsrctSupplierInteractionMode, negotiationObjective: TsrctNegotiationObjective } | null } } } };

export type QuoteSourcingCaseNegotiationSettingsQueryQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type QuoteSourcingCaseNegotiationSettingsQueryQuery = { __typename?: 'Query', tesseract: { __typename?: 'tesseractQuery', negotiationCase: { __typename?: 'TsrctNegotiationCase', id: any, isNegotiationEnabled: boolean, isSupplierUploadAllowed: boolean, status: TsrctNegotiationCaseStatus, processStatus?: TsrctNegotiationCaseProcessStatus | null, lowerDiscountBoundary: any, upperDiscountBoundary: any, supplier: { __typename?: 'TsrctNegotiationCaseSupplier', id: any, internalId: any }, strategy?: { __typename?: 'TsrctNegotiationStrategy', id: any, useHistoricTenderData: boolean, useHistoricNegotiationData: boolean, boundaryRules: Array<{ __typename?: 'TsrctNegotiationStrategyBoundary', id: any, base: TsrctNegotiationStrategyBoundaryBase, lower: any, upper: any, sequence: number }> } | null, options?: { __typename?: 'TsrctNegotiationCaseOptions', id: any, initiatedBy: TsrctInitiationMode, quoteMode: TsrctQuoteMode, negotiationMode: TsrctNegotiationMode, supplierInteractionMode: TsrctSupplierInteractionMode, negotiationObjective: TsrctNegotiationObjective } | null, demand: { __typename?: 'TsrctDemand', id: any }, negotiatedQuote?: { __typename?: 'TsrctNegotiatedQuote', id: any, currency: Currency, discount?: any | null, totalValue?: any | null, totalDiscountedValue?: any | null, totalPriceDiscount?: any | null, createdAt: any } | null } } };

export type BaseCommodityGroupListQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<Scalars['JSON']['input']>;
  order?: InputMaybe<Array<CommodityGroupSortOrder> | CommodityGroupSortOrder>;
}>;


export type BaseCommodityGroupListQuery = { __typename?: 'Query', commodityGroups: { __typename?: 'CommodityGroupConnection', totalCount?: number | null, nodes: Array<{ __typename?: 'CommodityGroup', id: string, name: string, description?: string | null, orderVolumeCurrentYear: number, orderCountCurrentYear: number, orderVolumeLast12Months: number, orderCountLast12Months: number, orderVolumeLastYear: number, orderCountLastYear: number, orderVolumeShareCurrentYear?: number | null, orderVolumeShareLast12Months?: number | null, orderVolumeShareLastYear?: number | null, orderVolumeCumulativeCurrentYear?: number | null, orderVolumeCumulativeLast12Months?: number | null, orderVolumeCumulativeLastYear?: number | null }> } };

export type BaseCommodityListQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<Scalars['JSON']['input']>;
  order?: InputMaybe<Array<CommoditySortOrder> | CommoditySortOrder>;
  skipExport?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type BaseCommodityListQuery = { __typename?: 'Query', commodities: { __typename?: 'CommodityConnection', totalCount?: number | null, nodes: Array<{ __typename?: 'Commodity', id: string, name: string, description?: string | null, externalId?: string | null, supplierCount: number, contractCount: number, deliveryOnTimePercentage: number, correctOrderPercentage: number, deviatingPricePercentage: number, deviatingQuantityPercentage: number, deviatingPriceQuantityPercentage: number, leadTime: number, orderVolume: number, orderVolumeYear: number, orderCount: number, orderCountYear: number, primaryCommodityGroup?: string | null, commodityGroupCount: number, supplierList?: Array<{ __typename?: 'SupplierNode', id: string, name?: string | null }>, contractList?: Array<{ __typename?: 'ContractNode', id: string, name?: string | null }>, links?: Array<{ __typename?: 'ExternalLink', title: string, url: string }>, commodityGroupList?: Array<{ __typename?: 'CommodityGroupNode', id: string, name: string }> }> } };

export type BaseContractListQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<Scalars['JSON']['input']>;
  order?: InputMaybe<Array<ContractSortOrder> | ContractSortOrder>;
  skipExport?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type BaseContractListQuery = { __typename?: 'Query', contracts: { __typename?: 'ContractConnection', totalCount?: number | null, nodes: Array<{ __typename?: 'Contract', id: string, externalId: string, supplierId: string, supplierName: string, supplierExternalId: string, supplierEmployeeCount: number, contractReceivedProposalsCount?: number | null, contractAverageValueContribution: number, contractActive?: boolean | null, contractCreationDate: any, contractValidFrom?: any | null, contractValidTo?: any | null, contractProductCount: number, contractProductCategoryCount: number, contractServiceCount: number, representativeCount: number, orderVolume?: number | null, orderVolumeYear?: number | null, orderCount?: number | null, orderCountYear?: number | null, orderLastDate?: any | null, supplierIndustry: { __typename?: 'SupplierIndustryNode', id: string, name?: string | null }, supplierLegalType: { __typename?: 'SupplierLegalTypeNode', id: string, name?: string | null }, supplierAddress: { __typename?: 'Address', city?: string | null, street?: string | null, postalCode?: string | null, countryCode?: string | null }, contractProductList?: Array<{ __typename?: 'ProductNode', id: string, name?: string | null }>, contractProductCategoryList?: Array<{ __typename?: 'ProductCategoryNode', id: string, name?: string | null }>, contractServiceList?: Array<{ __typename?: 'ServiceNode', id: string, name?: string | null }>, representativeList?: Array<{ __typename?: 'SupplierRepresentative', id: string, name: string }>, links?: Array<{ __typename?: 'ExternalLink', title: string, url: string }> }> } };

export type BaseOrderListQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<Scalars['JSON']['input']>;
  order?: InputMaybe<Array<OrderSortOrder> | OrderSortOrder>;
  skipExport?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type BaseOrderListQuery = { __typename?: 'Query', orders: { __typename?: 'OrderConnection', totalCount?: number | null, nodes: Array<{ __typename?: 'Order', id: string, externalId: string, supplierName?: string | null, supplierId?: string | null, supplierExternalId?: string | null, supplierEmployeeCount?: number | null, contractReceivedProposalsCount?: number | null, contractAverageValueContribution?: number | null, orderCreationDate: any, contractValidFrom?: any | null, contractValidTo?: any | null, orderProductCount?: number | null, orderProductCategoryCount?: number | null, orderServiceCount?: number | null, representativeCount?: number | null, orderVolume: number, primaryCommodityGroup?: string | null, commodityGroupCount: number, supplierIndustry?: { __typename?: 'SupplierIndustryNode', id: string, name?: string | null } | null, supplierLegalType?: { __typename?: 'SupplierLegalTypeNode', id: string, name?: string | null } | null, supplierAddress?: { __typename?: 'Address', city?: string | null, street?: string | null, postalCode?: string | null, countryCode?: string | null } | null, orderProductList?: Array<{ __typename?: 'ProductNode', id: string, name?: string | null }>, orderProductCategoryList?: Array<{ __typename?: 'ProductCategoryNode', id: string, name?: string | null }>, orderServiceList?: Array<{ __typename?: 'ServiceNode', id: string, name?: string | null }>, representativeList?: Array<{ __typename?: 'SupplierRepresentative', id: string, name: string }> | null, links?: Array<{ __typename?: 'ExternalLink', title: string, url: string }>, commodityGroupList?: Array<{ __typename?: 'CommodityGroupNode', id: string, name: string }> }> } };

export type BasePurchaseRequisitionListQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<Scalars['JSON']['input']>;
  order?: InputMaybe<Array<PurchaseRequisitionSortOrder> | PurchaseRequisitionSortOrder>;
  skipExport?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type BasePurchaseRequisitionListQuery = { __typename?: 'Query', purchaseRequisitions: { __typename?: 'PurchaseRequisitionConnection', totalCount?: number | null, nodes: Array<{ __typename?: 'PurchaseRequisition', description?: string | null, externalId: string, id: string, fixedSuppliersCount: number, isBlocked: boolean, lineItemsCount: number, preferredSuppliersCount: number, totalValue: number, type: string, primaryCommodityGroup?: string | null, commodityGroupCount: number, commodityGroupList?: Array<{ __typename?: 'CommodityGroupNode', id: string, name: string }>, links?: Array<{ __typename?: 'ExternalLink', title: string, url: string }> }> } };

export type BaseSupplierListQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<Scalars['JSON']['input']>;
  order?: InputMaybe<Array<SupplierSortOrder> | SupplierSortOrder>;
  skipExport?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type BaseSupplierListQuery = { __typename?: 'Query', suppliers: { __typename?: 'SupplierConnection', totalCount?: number | null, nodes: Array<{ __typename?: 'Supplier', id: string, name: string, externalId: string, orderCount: number, orderCountYear: number, orderVolume: number, orderVolumeYear: number, revenue: number, ebit: number, peRatio: number, employeeCount: number, quotationSuccessRate: number, orderLastDate?: any | null, prequalificationLevel: prequalificationLevelType, relationship: SupplierRelationshipType, activeContractCount: number, representativeCount: number, orderedProductCount: number, orderedServiceCount: number, orderedProductInCategoryCount: number, orderedServiceInCategoryCount: number, tagCount: number, commodityGroupCount: number, orderVolumeCumulative?: number | null, orderVolumeCumulativeYear?: number | null, orderVolumeShare?: number | null, orderVolumeShareYear?: number | null, prequalificationTrades: Array<{ __typename?: 'SupplierPrequalification', name: string, status: string }>, locationGroupList: Array<{ __typename?: 'LocationGroupNode', id: string, name?: string | null }>, contact: { __typename?: 'Contact', fax?: string | null, phone?: string | null, email?: string | null, website?: string | null }, industry: { __typename?: 'SupplierIndustryNode', id: string, name?: string | null }, legalType: { __typename?: 'SupplierLegalTypeNode', id: string, name?: string | null }, address: { __typename?: 'Address', city?: string | null, street?: string | null, postalCode?: string | null, countryCode?: string | null }, location?: { __typename?: 'LatLng', lat?: number | null, lng?: number | null } | null, activeContractList?: Array<{ __typename?: 'ContractNode', id: string, name?: string | null }>, representativeList?: Array<{ __typename?: 'SupplierRepresentative', id: string, name: string }>, orderedProductList?: Array<{ __typename?: 'ProductNode', id: string, name?: string | null }>, orderedServiceList?: Array<{ __typename?: 'ServiceNode', id: string, name?: string | null }>, orderedProductInCategoryList?: Array<{ __typename?: 'ProductCategoryNode', id: string, name?: string | null }>, orderedServiceInCategoryList?: Array<{ __typename?: 'ServiceCategoryNode', id: string, name?: string | null }>, links?: Array<{ __typename?: 'ExternalLink', title: string, url: string }>, tagList?: Array<{ __typename?: 'TagNode', id: string, name: string }>, commodityGroupList?: Array<{ __typename?: 'CommodityGroupNode', id: string, name: string }> }> } };

export type LocationGroupQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filterBy?: InputMaybe<Scalars['String']['input']>;
}>;


export type LocationGroupQuery = { __typename?: 'Query', locationGroups?: { __typename?: 'LocationGroupsFeatureCollection', type: string, features?: Array<{ __typename?: 'LocationGroupsFeatureObject', type: string, geometry?: { __typename?: 'PointGeometry', type: string, coordinates: any } | null, properties?: { __typename?: 'LocationGroupProps', name: string, description?: string | null } | null } | null> | null } | null };

export type SupplierGeoQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type SupplierGeoQuery = { __typename?: 'Query', suppliersGeo?: { __typename?: 'FeatureCollection', type: string, features?: Array<{ __typename?: 'PointObject', type: string, geometry?: { __typename?: 'PointGeometry', type: string, coordinates: any } | null, properties?: { __typename?: 'SupplierPointProps', id: string, name: string, relationship: string } | null } | null> | null } | null };

export type CmdiMetaColumnConfigQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type CmdiMetaColumnConfigQuery = { __typename?: 'Query', cmdi: { __typename?: 'cmdiQuery', meta_columnConfig: Array<{ __typename?: 'meta_columnConfig', id: any, columnName: string, options: any, variant: string, i18n: any }> } };

export type CmdiMetaQueryVariables = Exact<{ [key: string]: never; }>;


export type CmdiMetaQuery = { __typename?: 'Query', cmdi: { __typename?: 'cmdiQuery', meta_entity: Array<{ __typename?: 'meta_entity', id: any, name: string, i18n: any, needsPermission?: string | null }> } };

export type DemandSequenceNumberQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DemandSequenceNumberQuery = { __typename?: 'Query', tesseract: { __typename?: 'tesseractQuery', demand: { __typename?: 'TsrctDemand', id: any, sequenceNumber: any } } };

export type IntakeChatThreadDetailsQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type IntakeChatThreadDetailsQuery = { __typename?: 'Query', sevenbridges: { __typename?: 'sevenbridgesQuery', thread?: { __typename?: 'SvbrgThread', id: any, metadata?: Record<string, any> | null, messages: Array<{ __typename?: 'SvbrgAgentMessage', id: any, role: string, content?: string | null, parts: Array<Record<string, any>>, metadata?: Record<string, any> | null, createdAt?: any | null }> } | null } };

export type CreateChatSessionMutationVariables = Exact<{
  data: SvbrgChatSessionCreateInput;
}>;


export type CreateChatSessionMutation = { __typename?: 'Mutation', sevenbridges: { __typename?: 'sevenbridgesMutation', chatSession: { __typename?: 'SvbrgChatSessionMutations', create: { __typename?: 'SvbrgChatSession', id: any } } } };

export type CreateChatThreadMutationVariables = Exact<{
  data: SvbrgThreadCreateInput;
}>;


export type CreateChatThreadMutation = { __typename?: 'Mutation', sevenbridges: { __typename?: 'sevenbridgesMutation', thread: { __typename?: 'SvbrgThreadMutations', create: { __typename?: 'SvbrgThread', id: any } } } };

export type OnChatSessionCurrentStepSubscriptionVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type OnChatSessionCurrentStepSubscription = { __typename?: 'Subscription', sevenbridges: { __typename?: 'sevenbridgesSubscription', chatSession: { __typename?: 'SvbrgChatSessionQueries', id: any, status?: SvbrgIntakeStatus | null, createdBy?: any | null, demandId?: any | null, demandResponsibleUsers?: Array<any> | null, demandSequenceNumber?: any | null, currentStep: { __typename?: 'SvbrgChatMessage', id: any, status: SvbrgChatMessageStatus, variant: SvbrgChatMessageVariant, createdAt: any, sequence: number, role: SvbrgChatMessageRole, chatSessionId: any } } } };

export type IntakeDetailQueryQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type IntakeDetailQueryQuery = { __typename?: 'Query', sevenbridges: { __typename?: 'sevenbridgesQuery', chatSession: { __typename?: 'SvbrgChatSessionQueries', id: any, status?: SvbrgIntakeStatus | null, createdBy?: any | null, demandId?: any | null, demandResponsibleUsers?: Array<any> | null, demandSequenceNumber?: any | null, chatMessages: Array<{ __typename?: 'SvbrgChatMessage', id: any, sequence: number, status: SvbrgChatMessageStatus, variant: SvbrgChatMessageVariant, message?: string | null, role: SvbrgChatMessageRole }> } } };

export type IntakeDiscardMutationMutationVariables = Exact<{
  data: SvbrgChatSessionInput;
}>;


export type IntakeDiscardMutationMutation = { __typename?: 'Mutation', sevenbridges: { __typename?: 'sevenbridgesMutation', chatSession: { __typename?: 'SvbrgChatSessionMutations', discard: { __typename?: 'SvbrgChatSession', createdAt: any, id: any, status?: SvbrgIntakeStatus | null } } } };

export type SupplierContactDetailsUpdateMutationVariables = Exact<{
  input: contact_insert_input;
}>;


export type SupplierContactDetailsUpdateMutation = { __typename?: 'Mutation', cmdi: { __typename?: 'cmdiMutation', insert_contact_one?: { __typename?: 'contact', id: any, supplierId: any, title?: string | null, firstName: string, lastName: string, email: string, role: contactRoleVariant_enum, preferredLanguage: language_enum } | null } };

export type SupplierContactDetailsQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type SupplierContactDetailsQuery = { __typename?: 'Query', cmdi: { __typename?: 'cmdiQuery', contact: Array<{ __typename?: 'contact', id: any, supplierId: any, title?: string | null, firstName: string, lastName: string, email: string, role: contactRoleVariant_enum, preferredLanguage: language_enum }> } };

export type IntakeAttachmentsUpdateMutationVariables = Exact<{
  data: SvbrgAttachmentUpdateInput;
}>;


export type IntakeAttachmentsUpdateMutation = { __typename?: 'Mutation', sevenbridges: { __typename?: 'sevenbridgesMutation', chatSession: { __typename?: 'SvbrgChatSessionMutations', attachment: { __typename?: 'SvbrgAttachmentMutations', update: Array<{ __typename?: 'SvbrgAttachment', id: any, name: string, createdAt: any, isVisible: boolean }> } } } };

export type IntakeAttachmentsNextMutationVariables = Exact<{
  data: SvbrgAttachmentNextInput;
}>;


export type IntakeAttachmentsNextMutation = { __typename?: 'Mutation', sevenbridges: { __typename?: 'sevenbridgesMutation', chatSession: { __typename?: 'SvbrgChatSessionMutations', attachment: { __typename?: 'SvbrgAttachmentMutations', next: { __typename?: 'SvbrgIntakeRequest', id: any } } } } };

export type IntakeAttachmentsQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type IntakeAttachmentsQuery = { __typename?: 'Query', sevenbridges: { __typename?: 'sevenbridgesQuery', chatSession: { __typename?: 'SvbrgChatSessionQueries', id: any, status?: SvbrgIntakeStatus | null, attachments: Array<{ __typename?: 'SvbrgAttachment', id: any, name: string, createdAt: any, isVisible: boolean }> } } };

export type IntakeBudgetMutationMutationVariables = Exact<{
  data: SvbrgRequestBudgetInput;
}>;


export type IntakeBudgetMutationMutation = { __typename?: 'Mutation', sevenbridges: { __typename?: 'sevenbridgesMutation', chatSession: { __typename?: 'SvbrgChatSessionMutations', budget: { __typename?: 'SvbrgBudgetMutations', next: { __typename?: 'SvbrgIntakeRequest', accountingAreaId?: any | null, budget?: any | null, commodityGroupId?: any | null, costCenterId?: any | null, currency?: Currency | null, deliveryLocationId?: any | null, id: any, organizationId?: any | null, lineItems: Array<{ __typename?: 'SvbrgIntakeRequestLineItem', commodityGroupId?: any | null, unitId?: any | null, description?: string | null, earlyDeliveryAt?: any | null, expectedPricePerUnit?: any | null, id: any, lateDeliveryAt?: any | null, position: string, quantity?: any | null, sequence: number, title?: string | null }> } } } } };

export type IntakeBudgetQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type IntakeBudgetQuery = { __typename?: 'Query', sevenbridges: { __typename?: 'sevenbridgesQuery', chatSession: { __typename?: 'SvbrgChatSessionQueries', id: any, status?: SvbrgIntakeStatus | null, request?: { __typename?: 'SvbrgIntakeRequest', id: any, budget?: any | null, currency?: Currency | null } | null, quote?: { __typename?: 'SvbrgQuote', id: any, quotedValue: any } | null } } };

export type IntakeChatRequestDescriptionStepMutationMutationVariables = Exact<{
  data: SvbrgRequestDescriptionInput;
}>;


export type IntakeChatRequestDescriptionStepMutationMutation = { __typename?: 'Mutation', sevenbridges: { __typename?: 'sevenbridgesMutation', chatSession: { __typename?: 'SvbrgChatSessionMutations', requestDescription: { __typename?: 'SvbrgRequestDescriptionMutations', createInChat: { __typename?: 'SvbrgRequestDescription', id: any, language: SvbrgLanguage, text: string } } } } };

export type IntakeChatRequestDescriptionQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type IntakeChatRequestDescriptionQuery = { __typename?: 'Query', sevenbridges: { __typename?: 'sevenbridgesQuery', chatSession: { __typename?: 'SvbrgChatSessionQueries', id: any, status?: SvbrgIntakeStatus | null, requestDescription?: { __typename?: 'SvbrgRequestDescription', id: any, text: string, language: SvbrgLanguage } | null } } };

export type IntakeChatRequestMessageStepMutationMutationVariables = Exact<{
  data: SvbrgChatRequestMessageInput;
}>;


export type IntakeChatRequestMessageStepMutationMutation = { __typename?: 'Mutation', sevenbridges: { __typename?: 'sevenbridgesMutation', chatSession: { __typename?: 'SvbrgChatSessionMutations', chatRequestMessage: { __typename?: 'SvbrgChatRequestMessageMutations', generate: { __typename?: 'SvbrgChatRequestMessage', id: any } } } } };

export type IntakeExtendedLineItemsMutationVariables = Exact<{
  data: SvbrgExtendedLineItemsCheckInput;
}>;


export type IntakeExtendedLineItemsMutation = { __typename?: 'Mutation', sevenbridges: { __typename?: 'sevenbridgesMutation', chatSession: { __typename?: 'SvbrgChatSessionMutations', extendedLineItemsCheck: { __typename?: 'SvbrgExtendedLineItemCheckMutations', checkLineItems: { __typename?: 'SvbrgExtendedLineItemsCheckResult', chatSessionId: string, checks: Array<{ __typename?: 'SvbrgExtendedLineItemsCheck', id: any, chatSessionId: any, position: string, title?: string | null, description?: string | null, pricePerUnit?: any | null, quantity?: any | null, earlyDeliveryAt?: any | null, lateDeliveryAt?: any | null, checkResults?: { __typename?: 'SvbrgCheckResults', catalogueItems: Array<{ __typename?: 'SvbrgCatalogueItem', currency: string, deliveryTime: number, description?: string | null, id: string, inStock?: boolean | null, manufacturer?: string | null, name: string, previewImage?: string | null, price: number, punchoutUrl?: string | null, shippingCosts: number }>, contractItems: Array<{ __typename?: 'SvbrgContractItem', createdAtTimestamp: number, id: string, plannedQuantityFloat?: number | null, pricePerUnitFloat: number, title: string, contract: { __typename?: 'SvbrgContract', id: string, currency?: string | null, plannedValueFloat?: number | null, supplierId?: string | null } }> } | null }> } } } } };

export type IntakeExtendedLineItemsNextMutationVariables = Exact<{
  data: SvbrgExtendedLineItemsCheckNextInput;
}>;


export type IntakeExtendedLineItemsNextMutation = { __typename?: 'Mutation', sevenbridges: { __typename?: 'sevenbridgesMutation', chatSession: { __typename?: 'SvbrgChatSessionMutations', extendedLineItemsCheck: { __typename?: 'SvbrgExtendedLineItemCheckMutations', next: { __typename?: 'SvbrgIntakeRequest', id: any } } } } };

export type IntakeExtendedLineItemsCheckQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type IntakeExtendedLineItemsCheckQuery = { __typename?: 'Query', sevenbridges: { __typename?: 'sevenbridgesQuery', chatSession: { __typename?: 'SvbrgChatSessionQueries', id: any, extendedLineItemChecks: Array<{ __typename?: 'SvbrgExtendedLineItemsCheck', id: any, chatSessionId: any, position: string, title?: string | null, description?: string | null, pricePerUnit?: any | null, quantity?: any | null, earlyDeliveryAt?: any | null, lateDeliveryAt?: any | null, commodityGroupId?: any | null, unitId?: any | null, checkResults?: { __typename?: 'SvbrgCheckResults', catalogueItems: Array<{ __typename?: 'SvbrgCatalogueItem', currency: string, deliveryTime: number, description?: string | null, id: string, inStock?: boolean | null, manufacturer?: string | null, name: string, previewImage?: string | null, price: number, punchoutUrl?: string | null, shippingCosts: number }>, contractItems: Array<{ __typename?: 'SvbrgContractItem', createdAtTimestamp: number, id: string, plannedQuantityFloat?: number | null, pricePerUnitFloat: number, title: string, contract: { __typename?: 'SvbrgContract', id: string, currency?: string | null, plannedValueFloat?: number | null, supplierId?: string | null } }> } | null }> } } };

export type IntakeStatementsOfWorkUpsertMutationMutationVariables = Exact<{
  data: SvbrgStatementOfWorkUpsertInput;
}>;


export type IntakeStatementsOfWorkUpsertMutationMutation = { __typename?: 'Mutation', sevenbridges: { __typename?: 'sevenbridgesMutation', chatSession: { __typename?: 'SvbrgChatSessionMutations', statementOfWork: { __typename?: 'SvbrgStatementOfWorkMutations', upsert: { __typename?: 'SvbrgStatementOfWork', id: string, text: string, language: string } } } } };

export type IntakeStatementsOfWorkNextMutationMutationVariables = Exact<{
  data: SvbrgStatementOfWorkNextInput;
}>;


export type IntakeStatementsOfWorkNextMutationMutation = { __typename?: 'Mutation', sevenbridges: { __typename?: 'sevenbridgesMutation', chatSession: { __typename?: 'SvbrgChatSessionMutations', statementOfWork: { __typename?: 'SvbrgStatementOfWorkMutations', next?: any | null } } } };

export type IntakeStatementsOfWorkQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type IntakeStatementsOfWorkQuery = { __typename?: 'Query', sevenbridges: { __typename?: 'sevenbridgesQuery', chatSession: { __typename?: 'SvbrgChatSessionQueries', id: any, statementsOfWork: Array<{ __typename?: 'SvbrgStatementOfWork', id: string, language: string, text: string }>, requestDescription?: { __typename?: 'SvbrgRequestDescription', id: any, language: SvbrgLanguage } | null } } };

export type SelectIntentMutationVariables = Exact<{
  data: SvbrgChatSessionSelectIntentInput;
}>;


export type SelectIntentMutation = { __typename?: 'Mutation', sevenbridges: { __typename?: 'sevenbridgesMutation', chatSession: { __typename?: 'SvbrgChatSessionMutations', selectIntent: { __typename?: 'SvbrgChatSession', id: any } } } };

export type IntakeNuclearComplianceFormSubmitMutationVariables = Exact<{
  chatSessionId: Scalars['UUID']['input'];
  data: Scalars['JSON']['input'];
}>;


export type IntakeNuclearComplianceFormSubmitMutation = { __typename?: 'Mutation', sevenbridges: { __typename?: 'sevenbridgesMutation', chatSession: { __typename?: 'SvbrgChatSessionMutations', request: { __typename?: 'SvbrgRequestDetailsMutations', submitComplianceFormData: { __typename?: 'SvbrgIntakeRequest', id: any, complianceFormData?: Record<string, any> | null } } } } };

export type IntakeNuclearComplianceFormQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type IntakeNuclearComplianceFormQuery = { __typename?: 'Query', sevenbridges: { __typename?: 'sevenbridgesQuery', chatSession: { __typename?: 'SvbrgChatSessionQueries', id: any, status?: SvbrgIntakeStatus | null, request?: { __typename?: 'SvbrgIntakeRequest', id: any, complianceFormData?: Record<string, any> | null } | null } } };

export type IntakeQuoteComplianceMutationMutationVariables = Exact<{
  data: SvbrgQuoteComplianceNextInput;
}>;


export type IntakeQuoteComplianceMutationMutation = { __typename?: 'Mutation', sevenbridges: { __typename?: 'sevenbridgesMutation', chatSession: { __typename?: 'SvbrgChatSessionMutations', quoteCompliance: { __typename?: 'SvbrgQuoteComplianceCheckMutations', next: { __typename?: 'SvbrgQuoteComplianceCheck', id: any, chatSessionId: any, quoteId: any, score: SvbrgRiskScore, userComment?: string | null, userReason?: SvbrgRiskResolutionReason | null, complianceData?: { __typename?: 'SvbrgCheckAgainstPoliciesOutput', summary: string, parts: Array<{ __typename?: 'SvbrgPolicyCompliancePart', details: string, section?: string | null, status: SvbrgComplianceStatus, sourceFileName?: string | null }> } | null } } } } };

export type IntakeQuoteComplianceQueryQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type IntakeQuoteComplianceQueryQuery = { __typename?: 'Query', sevenbridges: { __typename?: 'sevenbridgesQuery', chatSession: { __typename?: 'SvbrgChatSessionQueries', id: any, status?: SvbrgIntakeStatus | null, quote?: { __typename?: 'SvbrgQuote', id: any } | null, analysis?: { __typename?: 'SvbrgQuoteAnalysis', id: any, fileId: any } | null, quoteCompliance?: { __typename?: 'SvbrgQuoteComplianceCheck', id: any, chatSessionId: any, quoteId: any, score: SvbrgRiskScore, userComment?: string | null, userReason?: SvbrgRiskResolutionReason | null, complianceData?: { __typename?: 'SvbrgCheckAgainstPoliciesOutput', summary: string, parts: Array<{ __typename?: 'SvbrgPolicyCompliancePart', details: string, section?: string | null, status: SvbrgComplianceStatus, sourceFileName?: string | null }> } | null } | null } } };

export type IntakeQuoteStepCreateMutationMutationVariables = Exact<{
  data: SvbrgQuoteDraftInput;
}>;


export type IntakeQuoteStepCreateMutationMutation = { __typename?: 'Mutation', sevenbridges: { __typename?: 'sevenbridgesMutation', chatSession: { __typename?: 'SvbrgChatSessionMutations', quote: { __typename?: 'SvbrgQuoteAnalysisMutations', next: { __typename?: 'SvbrgQuote', id: any, currency: string, quoteReference?: string | null, quotedValue: any, lineItems: Array<{ __typename?: 'SvbrgQuoteLineItem', description?: string | null, earlyDeliveryAt?: any | null, id: any, lateDeliveryAt?: any | null, pricePerUnit?: any | null, quantity?: any | null, sequence: number, title?: string | null, unitId?: any | null, commodityGroupId?: any | null }> } } } } };

export type IntakeQuoteQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type IntakeQuoteQuery = { __typename?: 'Query', sevenbridges: { __typename?: 'sevenbridgesQuery', chatSession: { __typename?: 'SvbrgChatSessionQueries', id: any, status?: SvbrgIntakeStatus | null, request?: { __typename?: 'SvbrgIntakeRequest', commodityGroupId?: any | null } | null, quote?: { __typename?: 'SvbrgQuote', id: any, currency: string, quoteReference?: string | null, lineItems: Array<{ __typename?: 'SvbrgQuoteLineItem', id: any, title?: string | null, description?: string | null, quantity?: any | null, pricePerUnit?: any | null, unitId?: any | null, position: string, sequence: number, earlyDeliveryAt?: any | null, lateDeliveryAt?: any | null, commodityGroupId?: any | null }> } | null } } };

export type IntakeConfirmSupplierSelectionMutationVariables = Exact<{
  data: SvbrgIntakeRequestSupplierAddInput;
}>;


export type IntakeConfirmSupplierSelectionMutation = { __typename?: 'Mutation', sevenbridges: { __typename?: 'sevenbridgesMutation', chatSession: { __typename?: 'SvbrgChatSessionMutations', supplierSelection: { __typename?: 'SvbrgSupplierSelectionMutations', confirmQuotedSupplier: Array<{ __typename?: 'SvbrgIntakeRequestSupplier', id: any, internalId: any, isQuoted: boolean, contact: { __typename?: 'SvbrgIntakeRequestSupplierContact', firstName?: string | null, lastName?: string | null, email?: string | null, internalId?: any | null, language?: SvbrgLanguage | null }, location: { __typename?: 'SvbrgIntakeRequestSupplierLocation', address?: string | null, city?: string | null, countryCode?: CountryCode | null, internalId?: any | null, postalCode?: string | null } }> } } } };

export type IntakeQuoteSupplierConfirmationQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type IntakeQuoteSupplierConfirmationQuery = { __typename?: 'Query', sevenbridges: { __typename?: 'sevenbridgesQuery', chatSession: { __typename?: 'SvbrgChatSessionQueries', id: any, status?: SvbrgIntakeStatus | null, variant: SvbrgChatSessionVariant, suppliers?: Array<{ __typename?: 'SvbrgIntakeRequestSupplier', id: any, internalId: any, isQuoted: boolean, contact: { __typename?: 'SvbrgIntakeRequestSupplierContact', internalId?: any | null, email?: string | null, firstName?: string | null, language?: SvbrgLanguage | null, lastName?: string | null, mobile?: string | null, phone?: string | null, title?: string | null }, location: { __typename?: 'SvbrgIntakeRequestSupplierLocation', internalId?: any | null, address?: string | null, city?: string | null, postalCode?: string | null, countryCode?: CountryCode | null } }> | null } } };

export type IntakeQuoteUploadStepMutationMutationVariables = Exact<{
  data: SvbrgQuoteAnalysisInput;
}>;


export type IntakeQuoteUploadStepMutationMutation = { __typename?: 'Mutation', sevenbridges: { __typename?: 'sevenbridgesMutation', chatSession: { __typename?: 'SvbrgChatSessionMutations', quote: { __typename?: 'SvbrgQuoteAnalysisMutations', analyse: { __typename?: 'SvbrgQuoteAnalysis', id: any, fileId: any } } } } };

export type IntakeQuoteUploadSkipMutationVariables = Exact<{
  data: SvbrgChatSessionInput;
}>;


export type IntakeQuoteUploadSkipMutation = { __typename?: 'Mutation', sevenbridges: { __typename?: 'sevenbridgesMutation', chatSession: { __typename?: 'SvbrgChatSessionMutations', quote: { __typename?: 'SvbrgQuoteAnalysisMutations', skip?: any | null } } } };

export type IntakeQuoteAnaylsisQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type IntakeQuoteAnaylsisQuery = { __typename?: 'Query', sevenbridges: { __typename?: 'sevenbridgesQuery', chatSession: { __typename?: 'SvbrgChatSessionQueries', id: any, status?: SvbrgIntakeStatus | null, analysis?: { __typename?: 'SvbrgQuoteAnalysis', id: any, fileId: any, status: SvbrgBackgroundJobStatus } | null } } };

export type OnCompletedIntakeQuoteAnaylsisSubscriptionVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type OnCompletedIntakeQuoteAnaylsisSubscription = { __typename?: 'Subscription', sevenbridges: { __typename?: 'sevenbridgesSubscription', chatSession: { __typename?: 'SvbrgChatSessionQueries', id: any, status?: SvbrgIntakeStatus | null, analysis?: { __typename?: 'SvbrgQuoteAnalysis', id: any, fileId: any, status: SvbrgBackgroundJobStatus } | null } } };

export type IntakeRequestComplexNextMutationVariables = Exact<{
  data: SvbrgIntakeRequestComplexInput;
}>;


export type IntakeRequestComplexNextMutation = { __typename?: 'Mutation', sevenbridges: { __typename?: 'sevenbridgesMutation', chatSession: { __typename?: 'SvbrgChatSessionMutations', request: { __typename?: 'SvbrgRequestDetailsMutations', requestNextComplex: { __typename?: 'SvbrgIntakeRequest', id: any, accountingAreaId?: any | null, commodityGroupId?: any | null, currency?: Currency | null, budget?: any | null, organizationId?: any | null, deliveryLocationId?: any | null, lineItems: Array<{ __typename?: 'SvbrgIntakeRequestLineItem', id: any, sequence: number, position: string, title?: string | null, description?: string | null, quantity?: any | null, expectedPricePerUnit?: any | null, unitId?: any | null, earlyDeliveryAt?: any | null, lateDeliveryAt?: any | null }> } } } } };

export type IntakeRequestComplexQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type IntakeRequestComplexQuery = { __typename?: 'Query', sevenbridges: { __typename?: 'sevenbridgesQuery', chatSession: { __typename?: 'SvbrgChatSessionQueries', id: any, status?: SvbrgIntakeStatus | null, requestDescription?: { __typename?: 'SvbrgRequestDescription', id: any, text: string } | null, request?: { __typename?: 'SvbrgIntakeRequest', accountingAreaId?: any | null, organizationId?: any | null, commodityGroupId?: any | null, currency?: Currency | null, budget?: any | null, id: any, costCenterId?: any | null, deliveryLocationId?: any | null, lineItems: Array<{ __typename?: 'SvbrgIntakeRequestLineItem', id: any, sequence: number, position: string, title?: string | null, description?: string | null, commodityGroupId?: any | null, quantity?: any | null, earlyDeliveryAt?: any | null, lateDeliveryAt?: any | null, expectedPricePerUnit?: any | null, unitId?: any | null }> } | null } } };

export type IntakeRequestDescriptionStepMutationMutationVariables = Exact<{
  data: SvbrgRequestDescriptionInput;
}>;


export type IntakeRequestDescriptionStepMutationMutation = { __typename?: 'Mutation', sevenbridges: { __typename?: 'sevenbridgesMutation', chatSession: { __typename?: 'SvbrgChatSessionMutations', requestDescription: { __typename?: 'SvbrgRequestDescriptionMutations', next: { __typename?: 'SvbrgRequestDescription', id: any, language: SvbrgLanguage, text: string } } } } };

export type IntakeRequestDescriptionStepGenerateMutationMutationVariables = Exact<{
  data: SvbrgRequestDescriptionInput;
}>;


export type IntakeRequestDescriptionStepGenerateMutationMutation = { __typename?: 'Mutation', sevenbridges: { __typename?: 'sevenbridgesMutation', chatSession: { __typename?: 'SvbrgChatSessionMutations', requestDescription: { __typename?: 'SvbrgRequestDescriptionMutations', generate: { __typename?: 'SvbrgRequestDescription', id: any, text: string, language: SvbrgLanguage } } } } };

export type IntakeRequestDescriptionQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type IntakeRequestDescriptionQuery = { __typename?: 'Query', sevenbridges: { __typename?: 'sevenbridgesQuery', chatSession: { __typename?: 'SvbrgChatSessionQueries', id: any, status?: SvbrgIntakeStatus | null, requestDescription?: { __typename?: 'SvbrgRequestDescription', id: any, text: string, language: SvbrgLanguage } | null, requirementsExtraction?: { __typename?: 'SvbrgRequirementsExtraction', id: any, extractedData?: Record<string, any> | null, enhancedData?: Record<string, any> | null, processingStatus: string } | null } } };

export type IntakeRequestDetailsStepMutationMutationVariables = Exact<{
  data: SvbrgIntakeRequestInput;
}>;


export type IntakeRequestDetailsStepMutationMutation = { __typename?: 'Mutation', sevenbridges: { __typename?: 'sevenbridgesMutation', chatSession: { __typename?: 'SvbrgChatSessionMutations', request: { __typename?: 'SvbrgRequestDetailsMutations', requestNext: { __typename?: 'SvbrgIntakeRequest', id: any, accountingAreaId?: any | null, commodityGroupId?: any | null, costCenterId?: any | null, currency?: Currency | null, deliveryLocationId?: any | null, organizationId?: any | null } } } } };

export type IntakeRequestDetailsQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type IntakeRequestDetailsQuery = { __typename?: 'Query', sevenbridges: { __typename?: 'sevenbridgesQuery', chatSession: { __typename?: 'SvbrgChatSessionQueries', id: any, status?: SvbrgIntakeStatus | null, request?: { __typename?: 'SvbrgIntakeRequest', id: any, accountingAreaId?: any | null, commodityGroupId?: any | null, costCenterId?: any | null, currency?: Currency | null, deliveryLocationId?: any | null, organizationId?: any | null } | null, requirementsExtraction?: { __typename?: 'SvbrgRequirementsExtraction', id: any, extractedData?: Record<string, any> | null, enhancedData?: Record<string, any> | null, processingStatus: string } | null } } };

export type IntakeRequestLineItemNextMutationVariables = Exact<{
  data: SvbrgIntakeRequestLineItemNextInput;
}>;


export type IntakeRequestLineItemNextMutation = { __typename?: 'Mutation', sevenbridges: { __typename?: 'sevenbridgesMutation', chatSession: { __typename?: 'SvbrgChatSessionMutations', request: { __typename?: 'SvbrgRequestDetailsMutations', requestNextLineItems: { __typename?: 'SvbrgIntakeRequest', id: any, accountingAreaId?: any | null, commodityGroupId?: any | null, costCenterId?: any | null, currency?: Currency | null, deliveryLocationId?: any | null, organizationId?: any | null, lineItems: Array<{ __typename?: 'SvbrgIntakeRequestLineItem', commodityGroupId?: any | null, unitId?: any | null, description?: string | null, earlyDeliveryAt?: any | null, expectedPricePerUnit?: any | null, id: any, lateDeliveryAt?: any | null, position: string, quantity?: any | null, sequence: number, title?: string | null }> } } } } };

export type IntakeRequestLineItemsQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type IntakeRequestLineItemsQuery = { __typename?: 'Query', sevenbridges: { __typename?: 'sevenbridgesQuery', chatSession: { __typename?: 'SvbrgChatSessionQueries', id: any, status?: SvbrgIntakeStatus | null, request?: { __typename?: 'SvbrgIntakeRequest', id: any, currency?: Currency | null, commodityGroupId?: any | null, lineItems: Array<{ __typename?: 'SvbrgIntakeRequestLineItem', id: any, sequence: number, position: string, title?: string | null, description?: string | null, quantity?: any | null, expectedPricePerUnit?: any | null, unitId?: any | null, earlyDeliveryAt?: any | null, lateDeliveryAt?: any | null, commodityGroupId?: any | null }> } | null, requirementsExtraction?: { __typename?: 'SvbrgRequirementsExtraction', id: any, extractedData?: Record<string, any> | null, enhancedData?: Record<string, any> | null, processingStatus: string } | null } } };

export type IntakeRequestReleaseMutationVariables = Exact<{
  data: SvbrgIntakeRequestReleaseInput;
}>;


export type IntakeRequestReleaseMutation = { __typename?: 'Mutation', sevenbridges: { __typename?: 'sevenbridgesMutation', chatSession: { __typename?: 'SvbrgChatSessionMutations', request: { __typename?: 'SvbrgRequestDetailsMutations', release?: any | null } } } };

export type IntakeResubmitMutationVariables = Exact<{
  data: SvbrgIntakeRequestReleaseInput;
}>;


export type IntakeResubmitMutation = { __typename?: 'Mutation', sevenbridges: { __typename?: 'sevenbridgesMutation', chatSession: { __typename?: 'SvbrgChatSessionMutations', request: { __typename?: 'SvbrgRequestDetailsMutations', resubmit?: any | null } } } };

export type IntakeDemandQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type IntakeDemandQuery = { __typename?: 'Query', sevenbridges: { __typename?: 'sevenbridgesQuery', chatSession: { __typename?: 'SvbrgChatSessionQueries', id: any, status?: SvbrgIntakeStatus | null, demandId?: any | null, demandSequenceNumber?: any | null } } };

export type IntakeSupplierSelectionNextMutationVariables = Exact<{
  data: SvbrgIntakeRequestSupplierNext;
}>;


export type IntakeSupplierSelectionNextMutation = { __typename?: 'Mutation', sevenbridges: { __typename?: 'sevenbridgesMutation', chatSession: { __typename?: 'SvbrgChatSessionMutations', supplierSelection: { __typename?: 'SvbrgSupplierSelectionMutations', next: Array<{ __typename?: 'SvbrgIntakeRequestSupplier', id: any, internalId: any, isQuoted: boolean, source?: SvbrgIntakeSupplierSource | null, reason?: string | null, contact: { __typename?: 'SvbrgIntakeRequestSupplierContact', firstName?: string | null, lastName?: string | null, email?: string | null, internalId?: any | null, language?: SvbrgLanguage | null, mobile?: string | null, phone?: string | null }, location: { __typename?: 'SvbrgIntakeRequestSupplierLocation', address?: string | null, city?: string | null, countryCode?: CountryCode | null, internalId?: any | null, postalCode?: string | null } }> } } } };

export type IntakeSupplierContactQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type IntakeSupplierContactQuery = { __typename?: 'Query', sevenbridges: { __typename?: 'sevenbridgesQuery', chatSession: { __typename?: 'SvbrgChatSessionQueries', id: any, status?: SvbrgIntakeStatus | null, variant: SvbrgChatSessionVariant, suppliers?: Array<{ __typename?: 'SvbrgIntakeRequestSupplier', id: any, internalId: any, isQuoted: boolean, source?: SvbrgIntakeSupplierSource | null, reason?: string | null, contact: { __typename?: 'SvbrgIntakeRequestSupplierContact', firstName?: string | null, lastName?: string | null, email?: string | null, internalId?: any | null, language?: SvbrgLanguage | null }, location: { __typename?: 'SvbrgIntakeRequestSupplierLocation', address?: string | null, city?: string | null, countryCode?: CountryCode | null, internalId?: any | null, postalCode?: string | null } }> | null, requirementsExtraction?: { __typename?: 'SvbrgRequirementsExtraction', id: any, extractedData?: Record<string, any> | null, enhancedData?: Record<string, any> | null, processingStatus: string } | null } } };

export type IntakeRequirementsUploadMutationMutationVariables = Exact<{
  data: SvbrgRequirementsExtractionUpsertInput;
}>;


export type IntakeRequirementsUploadMutationMutation = { __typename?: 'Mutation', sevenbridges: { __typename?: 'sevenbridgesMutation', chatSession: { __typename?: 'SvbrgChatSessionMutations', requirementsExtraction: { __typename?: 'SvbrgRequirementsExtractionMutations', uploadDcoument: { __typename?: 'SvbrgRequirementsExtraction', id: any, chatSessionId: any, fileIds?: Array<string> | null, processingStatus: string, extractedData?: Record<string, any> | null, enhancedData?: Record<string, any> | null, errorMessage?: string | null } } } } };

export type IntakeRequirementsSkipMutationMutationVariables = Exact<{
  data: SvbrgRequirementsExtractionSkipInput;
}>;


export type IntakeRequirementsSkipMutationMutation = { __typename?: 'Mutation', sevenbridges: { __typename?: 'sevenbridgesMutation', chatSession: { __typename?: 'SvbrgChatSessionMutations', requirementsExtraction: { __typename?: 'SvbrgRequirementsExtractionMutations', skip: { __typename?: 'SvbrgRequirementsExtraction', id: any, chatSessionId: any, processingStatus: string } } } } };

export type IntakeRequirementsNextMutationMutationVariables = Exact<{
  data: SvbrgRequirementsExtractionNextInput;
}>;


export type IntakeRequirementsNextMutationMutation = { __typename?: 'Mutation', sevenbridges: { __typename?: 'sevenbridgesMutation', chatSession: { __typename?: 'SvbrgChatSessionMutations', requirementsExtraction: { __typename?: 'SvbrgRequirementsExtractionMutations', next?: { __typename?: 'SvbrgRequirementsExtraction', id: any, chatSessionId: any, processingStatus: string } | null } } } };

export type IntakeRequirementsQueryQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type IntakeRequirementsQueryQuery = { __typename?: 'Query', sevenbridges: { __typename?: 'sevenbridgesQuery', chatSession: { __typename?: 'SvbrgChatSessionQueries', id: any, status?: SvbrgIntakeStatus | null, requirementsExtraction?: { __typename?: 'SvbrgRequirementsExtraction', id: any, chatSessionId: any, fileIds?: Array<string> | null, processingStatus: string, extractedData?: Record<string, any> | null, enhancedData?: Record<string, any> | null, errorMessage?: string | null, createdAt: any, updatedAt: any } | null } } };

export type IntakeTacticalSourcingSkipMutationVariables = Exact<{
  data: SvbrgTacticalSourcingInput;
}>;


export type IntakeTacticalSourcingSkipMutation = { __typename?: 'Mutation', sevenbridges: { __typename?: 'sevenbridgesMutation', chatSession: { __typename?: 'SvbrgChatSessionMutations', tacticalSourcing: { __typename?: 'SvbrgTacticalSourcingMutations', skip?: any | null } } } };

export type IntakeTacticalSourcingStartMutationVariables = Exact<{
  data: SvbrgTacticalSourcingInput;
}>;


export type IntakeTacticalSourcingStartMutation = { __typename?: 'Mutation', sevenbridges: { __typename?: 'sevenbridgesMutation', chatSession: { __typename?: 'SvbrgChatSessionMutations', tacticalSourcing: { __typename?: 'SvbrgTacticalSourcingMutations', start?: any | null } } } };

export type IntakeTacticalSourcingSelectionQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type IntakeTacticalSourcingSelectionQuery = { __typename?: 'Query', sevenbridges: { __typename?: 'sevenbridgesQuery', chatSession: { __typename?: 'SvbrgChatSessionQueries', id: any, status?: SvbrgIntakeStatus | null, tacticalSourcing?: { __typename?: 'SvbrgTacticalSourcing', isSkipped: boolean } | null } } };

export type GetExtractedRequirementsQueryVariables = Exact<{
  input: SvbrgGetExtractedRequirementsInput;
}>;


export type GetExtractedRequirementsQuery = { __typename?: 'Query', sevenbridges: { __typename?: 'sevenbridgesQuery', getExtractedRequirements: { __typename?: 'SvbrgExtractedRequirements', stepType: SvbrgFormStepType, hasData: boolean, data?: Record<string, any> | null } } };

export type ThreadListIntakeQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<Scalars['SvbrgQueryBuilderQuery']['input']>;
  order?: InputMaybe<Array<SvbrgThreadOrder> | SvbrgThreadOrder>;
  categories?: InputMaybe<Array<SvbrgCategoryType> | SvbrgCategoryType>;
}>;


export type ThreadListIntakeQuery = { __typename?: 'Query', sevenbridges: { __typename?: 'sevenbridgesQuery', threadList: { __typename?: 'SvbrgThreadConnection', totalCount: any, nodes: Array<{ __typename?: 'SvbrgThreadItem', id: any, sequenceNumber: any, createdAt: any, createdBy?: any | null, status?: SvbrgIntakeStatus | null, demandId?: any | null, demandSequenceNumber?: any | null, demandResponsibleUsers?: Array<any> | null, summary: string }> } } };

export type NegotiationCaseManualCreateMutationVariables = Exact<{
  data: TsrctDemandInput;
}>;


export type NegotiationCaseManualCreateMutation = { __typename?: 'Mutation', tesseract: { __typename?: 'tesseractMutation', demandCreate: { __typename?: 'TsrctDemand', id: any, negotiationCases: { __typename?: 'TsrctDemandNegotiationCaseConnection', nodes: Array<{ __typename?: 'TsrctDemandNegotiationCase', id: any }> } } } };

export type NegotiationCaseDeleteMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type NegotiationCaseDeleteMutation = { __typename?: 'Mutation', tesseract: { __typename?: 'tesseractMutation', negotiationCase: { __typename?: 'TsrctNegotiationCaseMutations', delete?: any | null } } };

export type NegotiationCaseReleaseMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type NegotiationCaseReleaseMutation = { __typename?: 'Mutation', tesseract: { __typename?: 'tesseractMutation', negotiationCase: { __typename?: 'TsrctNegotiationCaseMutations', release?: any | null } } };

export type NegotiationCaseRemindMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type NegotiationCaseRemindMutation = { __typename?: 'Mutation', tesseract: { __typename?: 'tesseractMutation', negotiationCase: { __typename?: 'TsrctNegotiationCaseMutations', sendReminder?: any | null } } };

export type NegotiationCaseResetMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type NegotiationCaseResetMutation = { __typename?: 'Mutation', tesseract: { __typename?: 'tesseractMutation', negotiationCase: { __typename?: 'TsrctNegotiationCaseMutations', reset?: any | null } } };

export type NegotiationDetailQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type NegotiationDetailQuery = { __typename?: 'Query', tesseract: { __typename?: 'tesseractQuery', negotiationCase: { __typename?: 'TsrctNegotiationCase', id: any, sequenceNumber: any, status: TsrctNegotiationCaseStatus, processStatus?: TsrctNegotiationCaseProcessStatus | null, isReleasable: boolean, processSteps: Array<{ __typename?: 'TsrctNegotiationCaseProcessStep', variant: TsrctNegotiationCaseProcessStepVariant, status: TsrctNegotiationCaseProcessStepStatus }>, demand: { __typename?: 'TsrctDemand', id: any, sequenceNumber: any }, supplier: { __typename?: 'TsrctNegotiationCaseSupplier', id: any, internalId: any, name: string, contact: { __typename?: 'TsrctNegotiationCaseSupplierContact', id: any, internalId?: any | null, firstName?: string | null, lastName?: string | null, email?: any | null, language: TsrctLanguage }, location: { __typename?: 'TsrctNegotiationCaseSupplierLocation', id: any, internalId?: any | null, city?: string | null, countryCode?: CountryCode | null, postalCode?: string | null, address?: string | null } }, quote?: { __typename?: 'TsrctQuote', id: any } | null, negotiatedQuote?: { __typename?: 'TsrctNegotiatedQuote', id: any } | null } } };

export type NegotiationCaseListQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<Scalars['TsrctQueryBuilderQuery']['input']>;
  order?: InputMaybe<Array<TsrctNegotiationCaseOrder> | TsrctNegotiationCaseOrder>;
}>;


export type NegotiationCaseListQuery = { __typename?: 'Query', tesseract: { __typename?: 'tesseractQuery', negotiationCases: { __typename?: 'TsrctNegotiationCaseListConnection', totalCount: any, nodes: Array<{ __typename?: 'TsrctNegotiationCaseListItem', id: any, isMaskedBidding: boolean, sequenceNumber: any, createdAt: any, updatedAt: any, issuesCompletedCount: any, issuesOpenCount: any, issuesTotalCount: any, totalValue?: any | null, totalDiscountedValue?: any | null, totalPriceDiscount?: any | null, discount?: any | null, currency?: Currency | null, organizationId?: any | null, demandId: any, demandSequenceNumber: any, referenceId?: string | null, responsibleIds: Array<any>, status?: TsrctNegotiationCaseStatus | null, processStatus?: TsrctNegotiationCaseProcessStatus | null, cancellationReason?: TsrctCaseCancellationReason | null, cancellationReasonText?: string | null, supplierAddress?: string | null, supplierCity?: string | null, supplierContactEmail?: string | null, supplierContactFirstName?: string | null, supplierContactLastName?: string | null, supplierContactPhone?: string | null, supplierCountryCode?: string | null, supplierId?: any | null, supplierExternalReference?: string | null, supplierName?: string | null, supplierPostalCode?: string | null, negotiationBoundaryUpper?: any | null, negotiationBoundaryLower?: any | null, hasSupplierComment: boolean, latestCommentAuthorId?: any | null, latestCommentCreatedAt?: any | null, latestCommentMessage?: string | null }> } } };

export type NegotiationListUpdateResponsibleMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  data: TsrctDemandResponsibleUsersInput;
}>;


export type NegotiationListUpdateResponsibleMutation = { __typename?: 'Mutation', tesseract: { __typename?: 'tesseractMutation', demand: { __typename?: 'TsrctDemandMutations', responsibleUsers: { __typename?: 'TsrctResponsibleUsersMutations', update: { __typename?: 'TsrctDemand', id: any, responsibleUserIds: Array<any> } } } } };

export type TsrctNegotiationDemandDetailQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type TsrctNegotiationDemandDetailQuery = { __typename?: 'Query', tesseract: { __typename?: 'tesseractQuery', demand: { __typename?: 'TsrctDemand', id: any, priority: number, sequenceNumber: any, status: TsrctDemandStatus, processStatus?: TsrctDemandProcessStatus | null, permissions: { __typename?: 'TsrctDemandPermissions', write: boolean }, processSteps: Array<{ __typename?: 'TsrctDemandProcessStep', variant: TsrctDemandProcessStepVariant, status: TsrctDemandProcessStepStatus }>, competitiveBiddingRule: { __typename?: 'TsrctCompetitiveBiddingRule', id: any, isEditable: boolean } } } };

export type SvbrgDemandConversationSettingsQueryVariables = Exact<{
  entityId: Scalars['UUID']['input'];
  entityVariant: SvbrgConversationEntityVariant;
}>;


export type SvbrgDemandConversationSettingsQuery = { __typename?: 'Query', sevenbridges: { __typename?: 'sevenbridgesQuery', conversationSettings?: { __typename?: 'SvbrgConversationSettings', id: any } | null } };

export type DemandConversationSettingsCreateMutationVariables = Exact<{
  data: SvbrgConversationSettingsCreateMutation;
}>;


export type DemandConversationSettingsCreateMutation = { __typename?: 'Mutation', sevenbridges: { __typename?: 'sevenbridgesMutation', conversationSettings: { __typename?: 'SvbrgConversationSettingsMutations', create: { __typename?: 'SvbrgConversationSettings', id: any, entityId: any, entityVariant: SvbrgConversationEntityVariant, createdAt: any, updatedAt: any, tools: Array<{ __typename?: 'SvbrgConversationSettingsTools', id: SvbrgConversationSettingsAvailableTools, isEnabled: boolean }>, quickActions: Array<{ __typename?: 'SvbrgQuickActions', id: any, prompt: string, isConversationStarter: boolean, translations: Array<{ __typename?: 'SvbrgQuickActionTranslation', id: string, language: SvbrgLanguage, text: string, variant: SvbrgQuickActionTranslationVariant }> }> } } } };

export type DemandConversationSettingsQueryQueryVariables = Exact<{
  entityId: Scalars['UUID']['input'];
  entityVariant: SvbrgConversationEntityVariant;
}>;


export type DemandConversationSettingsQueryQuery = { __typename?: 'Query', sevenbridges: { __typename?: 'sevenbridgesQuery', conversationSettings?: { __typename?: 'SvbrgConversationSettings', id: any, entityId: any, entityVariant: SvbrgConversationEntityVariant, createdAt: any, updatedAt: any, tools: Array<{ __typename?: 'SvbrgConversationSettingsTools', id: SvbrgConversationSettingsAvailableTools, isEnabled: boolean }>, quickActions: Array<{ __typename?: 'SvbrgQuickActions', id: any, prompt: string, isConversationStarter: boolean, translations: Array<{ __typename?: 'SvbrgQuickActionTranslation', id: string, language: SvbrgLanguage, text: string, variant: SvbrgQuickActionTranslationVariant }> }> } | null } };

export type DemandConversationSettingsUpdateMutationVariables = Exact<{
  data: SvbrgConversationSettingsUpdateMutation;
}>;


export type DemandConversationSettingsUpdateMutation = { __typename?: 'Mutation', sevenbridges: { __typename?: 'sevenbridgesMutation', conversationSettings: { __typename?: 'SvbrgConversationSettingsMutations', update: { __typename?: 'SvbrgConversationSettings', id: any, entityId: any, entityVariant: SvbrgConversationEntityVariant, createdAt: any, updatedAt: any, tools: Array<{ __typename?: 'SvbrgConversationSettingsTools', id: SvbrgConversationSettingsAvailableTools, isEnabled: boolean }>, quickActions: Array<{ __typename?: 'SvbrgQuickActions', id: any, prompt: string, isConversationStarter: boolean, translations: Array<{ __typename?: 'SvbrgQuickActionTranslation', id: string, language: SvbrgLanguage, text: string, variant: SvbrgQuickActionTranslationVariant }> }> } } } };

export type DemandCancelMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  data?: InputMaybe<TsrctDemandCancelInput>;
}>;


export type DemandCancelMutation = { __typename?: 'Mutation', tesseract: { __typename?: 'tesseractMutation', demand: { __typename?: 'TsrctDemandMutations', cancel: { __typename?: 'TsrctDemand', id: any, status: TsrctDemandStatus, cancellationReason?: TsrctCaseCancellationReason | null, cancellationReasonText?: string | null } } } };

export type DemandDeleteMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DemandDeleteMutation = { __typename?: 'Mutation', tesseract: { __typename?: 'tesseractMutation', demand: { __typename?: 'TsrctDemandMutations', delete?: any | null } } };

export type DemandResetMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DemandResetMutation = { __typename?: 'Mutation', tesseract: { __typename?: 'tesseractMutation', demand: { __typename?: 'TsrctDemandMutations', reset: { __typename?: 'TsrctDemand', id: any, status: TsrctDemandStatus, awardingConfiguration: { __typename?: 'TsrctDemandAwardingRuleConfiguration', id: any, deadline?: any | null } } } } };

export type TesseractNegotiationDemandDetailUpdatePriorityMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  data: TsrctDemandPriorityUpdateInput;
}>;


export type TesseractNegotiationDemandDetailUpdatePriorityMutation = { __typename?: 'Mutation', tesseract: { __typename?: 'tesseractMutation', demand: { __typename?: 'TsrctDemandMutations', priority: { __typename?: 'TsrctPriorityMutations', update: { __typename?: 'TsrctDemand', id: any, priority: number } } } } };

export type TesseractNegotiationDemandListQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<Scalars['TsrctQueryBuilderQuery']['input']>;
  order?: InputMaybe<Array<TsrctDemandOrder> | TsrctDemandOrder>;
}>;


export type TesseractNegotiationDemandListQuery = { __typename?: 'Query', tesseract: { __typename?: 'tesseractQuery', demands: { __typename?: 'TsrctDemandListItemConnection', totalCount: any, nodes: Array<{ __typename?: 'TsrctDemandListItem', capabilityIds?: Array<string> | null, casesNegotiatedCount: any, casesOpenCount: any, casesTotalCount: any, commodityGroupIds?: Array<string> | null, createdAt: any, currency?: Currency | null, description?: string | null, earlyDeliveryAt?: any | null, id: any, issuesOpenCount: any, lateDeliveryAt?: any | null, organizationId?: string | null, preferredSupplierIds?: Array<string> | null, priority: number, processingMode: TsrctDemandProcessingMode, purchaseRequisitionId?: string | null, referenceId?: string | null, requestedAt?: any | null, requestedBy?: any | null, responsibleIds: Array<any>, sequenceNumber: any, status?: TsrctDemandStatus | null, processStatus?: TsrctDemandProcessStatus | null, totalValue?: number | null, updatedAt: any, sourceSystemId?: string | null, links: Array<{ __typename?: 'TsrctLink', name: string, url: string }>, processSteps: Array<{ __typename?: 'TsrctDemandProcessStep', status: TsrctDemandProcessStepStatus, variant: TsrctDemandProcessStepVariant }> }> } } };

export type TesseractNegotiationDemandListUpdatePriorityMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  data: TsrctDemandPriorityUpdateInput;
}>;


export type TesseractNegotiationDemandListUpdatePriorityMutation = { __typename?: 'Mutation', tesseract: { __typename?: 'tesseractMutation', demand: { __typename?: 'TsrctDemandMutations', priority: { __typename?: 'TsrctPriorityMutations', update: { __typename?: 'TsrctDemand', id: any, priority: number } } } } };

export type TesseractNegotiationDemandUpdateResponsibleMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  data: TsrctDemandResponsibleUsersInput;
}>;


export type TesseractNegotiationDemandUpdateResponsibleMutation = { __typename?: 'Mutation', tesseract: { __typename?: 'tesseractMutation', demand: { __typename?: 'TsrctDemandMutations', responsibleUsers: { __typename?: 'TsrctResponsibleUsersMutations', update: { __typename?: 'TsrctDemand', id: any, responsibleUserIds: Array<any> } } } } };

export type SevenbridgesDocumentListQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<Scalars['SvbrgQueryBuilderQuery']['input']>;
  order?: InputMaybe<Array<SvbrgDocumentListOrder> | SvbrgDocumentListOrder>;
}>;


export type SevenbridgesDocumentListQuery = { __typename?: 'Query', sevenbridges: { __typename?: 'sevenbridgesQuery', documents: { __typename?: 'SvbrgDocumentListConnection', totalCount: any, nodes: Array<{ __typename?: 'SvbrgDocumentListItem', id: any, fileId: any, fileName?: string | null, title: string, description?: string | null, updatedAt: any, language: SvbrgLanguage, mimeType: string, variant: SvbrgDocumentVariant, url?: string | null }> } } };

export type ProcurementKnowledgeDocumentFragment = { __typename?: 'SvbrgDocument', id: any, fileId: any, fileName?: string | null, title: string, description?: string | null, updatedAt: any, language: SvbrgLanguage, mimeType: string, variant: SvbrgDocumentVariant, url?: string | null } & { ' $fragmentName'?: 'ProcurementKnowledgeDocumentFragment' };

export type AddProcurementKnowledgeDocumentMutationVariables = Exact<{
  input: SvbrgDocumentUpload;
}>;


export type AddProcurementKnowledgeDocumentMutation = { __typename?: 'Mutation', sevenbridges: { __typename?: 'sevenbridgesMutation', document: { __typename?: 'SvbrgDocumentMutations', upload: (
        { __typename?: 'SvbrgDocument' }
        & { ' $fragmentRefs'?: { 'ProcurementKnowledgeDocumentFragment': ProcurementKnowledgeDocumentFragment } }
      ) } } };

export type UpdateProcurementKnowledgeDocumentMetadataMutationVariables = Exact<{
  input: SvbrgDocumentUpdateMetadata;
}>;


export type UpdateProcurementKnowledgeDocumentMetadataMutation = { __typename?: 'Mutation', sevenbridges: { __typename?: 'sevenbridgesMutation', document: { __typename?: 'SvbrgDocumentMutations', updateMetadata: (
        { __typename?: 'SvbrgDocument' }
        & { ' $fragmentRefs'?: { 'ProcurementKnowledgeDocumentFragment': ProcurementKnowledgeDocumentFragment } }
      ) } } };

export type DeleteProcurementKnowledgeDocumentMutationVariables = Exact<{
  docId: Scalars['UUID']['input'];
}>;


export type DeleteProcurementKnowledgeDocumentMutation = { __typename?: 'Mutation', sevenbridges: { __typename?: 'sevenbridgesMutation', document: { __typename?: 'SvbrgDocumentMutations', delete: Array<(
        { __typename?: 'SvbrgDocument' }
        & { ' $fragmentRefs'?: { 'ProcurementKnowledgeDocumentFragment': ProcurementKnowledgeDocumentFragment } }
      )> } } };

export type ProcurementKnowledgeDocumentDetailsQueryVariables = Exact<{
  docId: Scalars['UUID']['input'];
}>;


export type ProcurementKnowledgeDocumentDetailsQuery = { __typename?: 'Query', sevenbridges: { __typename?: 'sevenbridgesQuery', document: { __typename?: 'SvbrgDocument', id: any, fileId: any, title: string, description?: string | null, variant: SvbrgDocumentVariant, language: SvbrgLanguage, url?: string | null, content: string } } };

export type GetRuleHeaderQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetRuleHeaderQuery = { __typename?: 'Query', tesseract: { __typename?: 'tesseractQuery', rule: { __typename?: 'TsrctRule', id: any, name: string, status: TsrctRuleStatus } } };

export type GetRuleVersionStatusesQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetRuleVersionStatusesQuery = { __typename?: 'Query', tesseract: { __typename?: 'tesseractQuery', rule: { __typename?: 'TsrctRule', id: any, status: TsrctRuleStatus, ruleVersion?: { __typename?: 'TsrctRuleVersion', id: any, status: TsrctRuleVersionStatus } | null } } };

export type RuleVersionPublishMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  versionId: Scalars['UUID']['input'];
}>;


export type RuleVersionPublishMutation = { __typename?: 'Mutation', tesseract: { __typename?: 'tesseractMutation', rule: { __typename?: 'TsrctRuleMutations', publish: { __typename?: 'TsrctRule', id: any, status: TsrctRuleStatus } } } };

export type RuleVersionPauseMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type RuleVersionPauseMutation = { __typename?: 'Mutation', tesseract: { __typename?: 'tesseractMutation', rule: { __typename?: 'TsrctRuleMutations', pause: { __typename?: 'TsrctRule', id: any, status: TsrctRuleStatus } } } };

export type RuleVersionSaveMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  graph: Scalars['JSON']['input'];
}>;


export type RuleVersionSaveMutation = { __typename?: 'Mutation', tesseract: { __typename?: 'tesseractMutation', rule: { __typename?: 'TsrctRuleMutations', ruleVersion: { __typename?: 'TsrctRuleVersionMutations', save: { __typename?: 'TsrctRuleVersion', id: any, ruleId: any, graph: Record<string, any> } } } } };

export type RuleSettingsCreateMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  data: TsrctRuleCreateDataInput;
}>;


export type RuleSettingsCreateMutation = { __typename?: 'Mutation', tesseract: { __typename?: 'tesseractMutation', rule: { __typename?: 'TsrctRuleMutations', create: { __typename?: 'TsrctRule', id: any, name: string, responsibleUsers: Array<any> } } } };

export type RuleSettingsUpdateMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  data: TsrctRuleUpdateDataInput;
}>;


export type RuleSettingsUpdateMutation = { __typename?: 'Mutation', tesseract: { __typename?: 'tesseractMutation', rule: { __typename?: 'TsrctRuleMutations', update: { __typename?: 'TsrctRule', id: any, name: string, responsibleUsers: Array<any> } } } };

export type RuleSettingsDeleteMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type RuleSettingsDeleteMutation = { __typename?: 'Mutation', tesseract: { __typename?: 'tesseractMutation', rule: { __typename?: 'TsrctRuleMutations', remove: { __typename?: 'TsrctRule', id: any } } } };

export type GetRuleRuleBuilderBackendDataQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetRuleRuleBuilderBackendDataQuery = { __typename?: 'Query', tesseract: { __typename?: 'tesseractQuery', rule: { __typename?: 'TsrctRule', id: any, variant: TsrctRuleVariant, ruleVersion?: { __typename?: 'TsrctRuleVersion', id: any, status: TsrctRuleVersionStatus, graph: Record<string, any>, stats: { __typename?: 'TsrctRuleVersionStats', id: any, edges: Array<{ __typename?: 'TsrctRuleBaseStats', itemId: any, hits: number }>, nodes: Array<{ __typename?: 'TsrctRuleBaseStats', itemId: any, hits: number }> } } | null } } };

export type GetRuleDataQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetRuleDataQuery = { __typename?: 'Query', tesseract: { __typename?: 'tesseractQuery', rule: { __typename?: 'TsrctRule', id: any, name: string, responsibleUsers: Array<any>, variant: TsrctRuleVariant } } };

export type RuleEvaluationLogDetailQueryVariables = Exact<{
  ruleId: Scalars['UUID']['input'];
  evaluationLogId: Scalars['UUID']['input'];
}>;


export type RuleEvaluationLogDetailQuery = { __typename?: 'Query', tesseract: { __typename?: 'tesseractQuery', rule: { __typename?: 'TsrctRule', id: any, evaluationLog: { __typename?: 'TsrctRuleEvaluationLog', id: any, createdAt: any, ruleVersion: { __typename?: 'TsrctRuleVersion', id: any, status: TsrctRuleVersionStatus, graph: Record<string, any>, stats: { __typename?: 'TsrctRuleVersionStats', id: any, nodes: Array<{ __typename?: 'TsrctRuleBaseStats', itemId: any, hits: number }>, edges: Array<{ __typename?: 'TsrctRuleBaseStats', itemId: any, hits: number }> } } } } } };

export type RuleListQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<Scalars['TsrctQueryBuilderQuery']['input']>;
  order?: InputMaybe<Array<TsrctRuleListSourcingOrder> | TsrctRuleListSourcingOrder>;
}>;


export type RuleListQuery = { __typename?: 'Query', tesseract: { __typename?: 'tesseractQuery', rules: { __typename?: 'TsrctRuleListQueries', sourcing: { __typename?: 'TsrctRuleListSourcingItemConnection', totalCount: any, nodes: Array<{ __typename?: 'TsrctRuleListSourcingItem', id: any, name: string, variant: TsrctRuleVariant, sequenceNumber: any, status: TsrctRuleStatus, createdAt: any, updatedAt: any, accountingAreaIds: Array<any>, commodityGroupIds: Array<any>, organizationIds: Array<any>, sourceSystemIds: Array<string>, responsibleIds: Array<any> }> } } } };

export type SmartLinkDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type SmartLinkDetailsQuery = { __typename?: 'Query', astronaut: { __typename: 'astronautQuery' } };

export type TeamManagementTeamQueryVariables = Exact<{
  teamId: Scalars['UUID']['input'];
}>;


export type TeamManagementTeamQuery = { __typename?: 'Query', Pasa: { __typename?: 'pasaGraphqlQuery', team?: { __typename?: 'PasaTeamQueryResult', id: string, name: string, users: Array<{ __typename?: 'PasaTeamUserAssignment', id: string }>, teams: Array<{ __typename?: 'PasaTeamChildAssignment', id: string }>, scopes: Array<{ __typename?: 'PasaTeamScopeAssignment', id: string }> } | null } };

export type TeamManagementUpsertTeamMutationVariables = Exact<{
  input: PasaUpsertTeamInput;
}>;


export type TeamManagementUpsertTeamMutation = { __typename?: 'Mutation', Pasa: { __typename?: 'pasaGraphqlMutation', upsertTeam: { __typename?: 'PasaTeamPayload', id: string, name: string, scopeIds: Array<string>, userMemberIds: Array<string>, teamMemberIds: Array<string> } } };

export type TeamManagementDeleteTeamMutationVariables = Exact<{
  teamId: Scalars['UUID']['input'];
}>;


export type TeamManagementDeleteTeamMutation = { __typename?: 'Mutation', Pasa: { __typename?: 'pasaGraphqlMutation', deleteTeam: { __typename?: 'PasaDeleteTeamPayload', id: string } } };

export type TsrctContractDemandDetailQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type TsrctContractDemandDetailQuery = { __typename?: 'Query', tesseract: { __typename?: 'tesseractQuery', contractDemand: { __typename?: 'TsrctContractDemand', id: any, priority: number, status: TsrctContractDemandStatus, sequenceNumber?: any | null, createdAt: any, updatedAt: any, responsibleUserId?: any | null, tagIds: Array<any>, competitiveBiddingRule: { __typename?: 'TsrctContractDemandCompetitiveBiddingRule', id: any, variant: TsrctCompetitiveBiddingVariant, biddingPeriodDays?: number | null, deadline?: any | null, deadlineExceeded: boolean }, demandRequest?: { __typename?: 'TsrctContractDemandRequest', id: any, commodityGroupId?: any | null, createdAt: any, currency: Currency, incoTermsId?: any | null, requestedAt: any, totalValue?: any | null, validityPeriod: { __typename?: 'TsrctDateRange', from?: any | null, to?: any | null }, lineItems: Array<{ __typename?: 'TsrctContractDemandRequestItem', id: any, baselinePricePerUnit?: any | null, commodityGroupId?: any | null, commodityId?: any | null, createdAt: any, deliveryLocationId?: any | null, description?: string | null, minimumOrderQuantity?: any | null, quantity: any, title: string, unitId?: any | null }> } | null } } };

export type TsrctDeleteContractDemandMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type TsrctDeleteContractDemandMutation = { __typename?: 'Mutation', tesseract: { __typename?: 'tesseractMutation', contractDemand: { __typename?: 'TsrctContractDemandMutations', delete?: any | null } } };

export type TsrctCancelContractDemandMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  data?: InputMaybe<TsrctContractDemandCancelInput>;
}>;


export type TsrctCancelContractDemandMutation = { __typename?: 'Mutation', tesseract: { __typename?: 'tesseractMutation', contractDemand: { __typename?: 'TsrctContractDemandMutations', cancel?: { __typename?: 'TsrctContractDemand', id: any, status: TsrctContractDemandStatus, cancellationReason?: TsrctCaseCancellationReason | null, cancellationReasonText?: string | null, sourcingCases: Array<{ __typename?: 'TsrctSourcingCase', id: any, status: TsrctSourcingCaseStatus, cancellationReason?: TsrctCaseCancellationReason | null, cancellationReasonText?: string | null, createdAt: any, updatedAt: any, sequenceNumber?: any | null, supplier?: { __typename?: 'TsrctSourcingCaseSupplier', id: any, name: string, supplierId: any, contact: { __typename?: 'TsrctSourcingCaseSupplierContact', id: any, firstName?: string | null, lastName?: string | null, email?: any | null, internalId?: any | null } } | null, quote?: { __typename?: 'TsrctSourcingCaseQuote', id: any, currency: string, totalValue?: any | null, totalDiscountedValue?: any | null, discount?: any | null } | null, issues: Array<{ __typename?: 'TsrctSourcingCaseIssue', id: any, status: TsrctIssueStatus, variant: TsrctIssueVariant }> }> } | null } } };

export type TesseractContractDemandCreateMutationVariables = Exact<{ [key: string]: never; }>;


export type TesseractContractDemandCreateMutation = { __typename?: 'Mutation', tesseract: { __typename?: 'tesseractMutation', contractDemandCreate: { __typename?: 'TsrctContractDemand', id: any, createdAt: any, updatedAt: any, priority: number, responsibleUserId?: any | null, sequenceNumber?: any | null, tagIds: Array<any>, demandRequest?: { __typename?: 'TsrctContractDemandRequest', commodityGroupId?: any | null, createdAt: any, currency: Currency, id: any, incoTermsId?: any | null, requestedAt: any, totalValue?: any | null, validityPeriod: { __typename?: 'TsrctDateRange', from?: any | null, to?: any | null }, lineItems: Array<{ __typename?: 'TsrctContractDemandRequestItem', baselinePricePerUnit?: any | null, commodityGroupId?: any | null, commodityId?: any | null, createdAt: any, deliveryLocationId?: any | null, description?: string | null, id: any, minimumOrderQuantity?: any | null, quantity: any, title: string, unitId?: any | null }> } | null, competitiveBiddingRule: { __typename?: 'TsrctContractDemandCompetitiveBiddingRule', id: any, biddingPeriodDays?: number | null, deadline?: any | null, deadlineExceeded: boolean, variant: TsrctCompetitiveBiddingVariant } } } };

export type TesseractContractDemandListQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<Scalars['TsrctQueryBuilderQuery']['input']>;
  order?: InputMaybe<Array<TsrctContractDemandOrder> | TsrctContractDemandOrder>;
}>;


export type TesseractContractDemandListQuery = { __typename?: 'Query', tesseract: { __typename?: 'tesseractQuery', contractDemands: { __typename?: 'TsrctContractDemandListItemConnection', totalCount: any, nodes: Array<{ __typename?: 'TsrctContractDemandListItem', commodityGroupId?: any | null, createdAt: any, description?: string | null, id: any, status: string, priority: number, responsibleUserId?: any | null, sequenceNumber: any, tagIds?: Array<string> | null, validFrom?: any | null, validTo?: any | null, totalValue: number, currency?: Currency | null, openCaseCount: number, negotiatedCaseCount: number, totalCaseCount: number }> } } };

export type TsrctSourcingCaseDetailQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type TsrctSourcingCaseDetailQuery = { __typename?: 'Query', tesseract: { __typename?: 'tesseractQuery', sourcingCase: { __typename?: 'TsrctSourcingCase', id: any, status: TsrctSourcingCaseStatus, sequenceNumber?: any | null, createdAt: any, updatedAt: any, isNegotiationEnabled: boolean, isSupplierUploadAllowed: boolean, issues: Array<{ __typename?: 'TsrctSourcingCaseIssue', id: any, status: TsrctIssueStatus, variant: TsrctIssueVariant }>, demand?: { __typename?: 'TsrctSourcingCaseDemandReference', id: any, sequenceNumber: any } | null, supplier?: { __typename?: 'TsrctSourcingCaseSupplier', id: any, name: string, supplierId: any, contact: { __typename?: 'TsrctSourcingCaseSupplierContact', id: any, firstName?: string | null, lastName?: string | null, email?: any | null, internalId?: any | null } } | null, quote?: { __typename?: 'TsrctSourcingCaseQuote', id: any, status: TsrctSourcingCaseQuoteStatus, createdAt: any, currency: string, supplierReference?: string | null, validFrom: any, validTo: any, paymentTermsId?: any | null, incoTermsId?: any | null, lineItems: Array<{ __typename?: 'TsrctSourcingCaseQuoteItem', id: any, sequence: number, createdAt: any, title: string, description?: string | null, unitId?: any | null, commodityId?: any | null, deliveryLocationId?: any | null, status: TsrctSourcingCaseQuoteItemStatus, organizationId?: any | null, priceUnit: any, pricePerPriceUnit?: any | null, pricePerUnit?: any | null, minimumOrderQuantity?: any | null, quantity: any, discountedPricePerUnit?: any | null, totalDiscountedValue?: any | null, totalValue?: any | null, demandRequestItemId: any, bidDeclinedReason?: TsrctSourcingCaseQuoteItemBidDeclineReason | null, bidDeclinedReasonText?: string | null }> } | null } } };

export type TsrctReleaseSourcingCaseMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type TsrctReleaseSourcingCaseMutation = { __typename?: 'Mutation', tesseract: { __typename?: 'tesseractMutation', sourcingCase: { __typename?: 'TsrctSourcingCaseMutations', release?: any | null } } };

export type TsrctDeleteSourcingCaseMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type TsrctDeleteSourcingCaseMutation = { __typename?: 'Mutation', tesseract: { __typename?: 'tesseractMutation', sourcingCase: { __typename?: 'TsrctSourcingCaseMutations', delete?: any | null } } };

export type TsrctCancelSourcingCaseMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  data?: InputMaybe<TsrctSourcingCaseCancelInput>;
}>;


export type TsrctCancelSourcingCaseMutation = { __typename?: 'Mutation', tesseract: { __typename?: 'tesseractMutation', sourcingCase: { __typename?: 'TsrctSourcingCaseMutations', cancel?: { __typename?: 'TsrctSourcingCase', id: any, status: TsrctSourcingCaseStatus, cancellationReason?: TsrctCaseCancellationReason | null, cancellationReasonText?: string | null, updatedAt: any, demand?: { __typename?: 'TsrctSourcingCaseDemandReference', id: any } | null } | null } } };

export type TsrctRemindSourcingCaseMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type TsrctRemindSourcingCaseMutation = { __typename?: 'Mutation', tesseract: { __typename?: 'tesseractMutation', sourcingCase: { __typename?: 'TsrctSourcingCaseMutations', sendReminder?: { __typename?: 'TsrctSourcingCase', id: any } | null } } };

export type TsrctResetSourcingCaseMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type TsrctResetSourcingCaseMutation = { __typename?: 'Mutation', tesseract: { __typename?: 'tesseractMutation', sourcingCase: { __typename?: 'TsrctSourcingCaseMutations', reset?: { __typename?: 'TsrctSourcingCase', id: any, status: TsrctSourcingCaseStatus, sequenceNumber?: any | null, createdAt: any, updatedAt: any, isNegotiationEnabled: boolean, issues: Array<{ __typename?: 'TsrctSourcingCaseIssue', id: any, status: TsrctIssueStatus, variant: TsrctIssueVariant }>, demand?: { __typename?: 'TsrctSourcingCaseDemandReference', id: any, sequenceNumber: any } | null, supplier?: { __typename?: 'TsrctSourcingCaseSupplier', id: any, name: string, supplierId: any, contact: { __typename?: 'TsrctSourcingCaseSupplierContact', id: any, firstName?: string | null, lastName?: string | null, email?: any | null, internalId?: any | null } } | null, quote?: { __typename?: 'TsrctSourcingCaseQuote', id: any, status: TsrctSourcingCaseQuoteStatus, createdAt: any, currency: string, supplierReference?: string | null, validFrom: any, validTo: any, paymentTermsId?: any | null, incoTermsId?: any | null, lineItems: Array<{ __typename?: 'TsrctSourcingCaseQuoteItem', id: any, sequence: number, createdAt: any, title: string, description?: string | null, unitId?: any | null, commodityId?: any | null, deliveryLocationId?: any | null, status: TsrctSourcingCaseQuoteItemStatus, organizationId?: any | null, priceUnit: any, pricePerPriceUnit?: any | null, pricePerUnit?: any | null, minimumOrderQuantity?: any | null, quantity: any, discountedPricePerUnit?: any | null, totalDiscountedValue?: any | null, totalValue?: any | null, demandRequestItemId: any, bidDeclinedReason?: TsrctSourcingCaseQuoteItemBidDeclineReason | null, bidDeclinedReasonText?: string | null }> } | null } | null } } };

export type ThreadListByCategoriesQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<Scalars['SvbrgQueryBuilderQuery']['input']>;
  order?: InputMaybe<Array<SvbrgThreadOrder> | SvbrgThreadOrder>;
  categories?: InputMaybe<Array<SvbrgCategoryType> | SvbrgCategoryType>;
}>;


export type ThreadListByCategoriesQuery = { __typename?: 'Query', sevenbridges: { __typename?: 'sevenbridgesQuery', threadList: { __typename?: 'SvbrgThreadConnection', totalCount: any, nodes: Array<{ __typename?: 'SvbrgThreadItem', id: any, sequenceNumber: any, createdAt: any, createdBy?: any | null, status?: SvbrgIntakeStatus | null, demandId?: any | null, demandSequenceNumber?: any | null, demandResponsibleUsers?: Array<any> | null, summary: string, variant: SvbrgChatSessionVariant, conversationSettingsEntityId?: any | null, conversationSettingsEntityVariant?: SvbrgConversationEntityVariant | null }> } } };

export type CountryReportDetailQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type CountryReportDetailQuery = { __typename?: 'Query', cataclysm: { __typename?: 'cataclysmQuery', countryReport: { __typename?: 'CaclCountryReport', id: any, name: string, description?: string | null } } };

export type RiskDetailQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type RiskDetailQuery = { __typename?: 'Query', cataclysm: { __typename?: 'cataclysmQuery', risk: { __typename?: 'CaclRisk', id: any, name: string, description?: string | null } } };

export type RiskCountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type RiskCountriesQuery = { __typename?: 'Query', cataclysm: { __typename?: 'cataclysmQuery', countries: Array<{ __typename?: 'CaclCountry', id: CountryCode, area: Record<string, any>, riskScores: Record<string, any> }> } };

export type CountryReportListWidgetQueryVariables = Exact<{ [key: string]: never; }>;


export type CountryReportListWidgetQuery = { __typename?: 'Query', cataclysm: { __typename?: 'cataclysmQuery', countryReports: Array<{ __typename?: 'CaclCountryReportListItem', id: any, name: string, description?: string | null, publishedAt?: any | null }> } };

export type CountryReportTableQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type CountryReportTableQuery = { __typename?: 'Query', cataclysm: { __typename?: 'cataclysmQuery', countryReport: { __typename?: 'CaclCountryReport', id: any, dimensions: Array<{ __typename?: 'CaclCountryReportDimension', id: any, name: string }>, values: Array<{ __typename?: 'CaclCountryReportDimensionValue', dimensionId: any, value: any, countryCode: CountryCode }> } } };

export type SupplierListWidgetQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type SupplierListWidgetQuery = { __typename?: 'Query', cataclysm: { __typename?: 'cataclysmQuery', risk: { __typename?: 'CaclRisk', id: any, suppliers?: Array<{ __typename?: 'CaclSupplierBase', id: any, status: string, score: CaclRiskScore }> | null } } };

export type SupplierRiskCategoryScoreWidgetQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type SupplierRiskCategoryScoreWidgetQuery = { __typename?: 'Query', cataclysm: { __typename?: 'cataclysmQuery', supplier: { __typename?: 'CaclSupplier', id: any, score: CaclRiskScore, categories: Array<{ __typename?: 'CaclCategoryScore', id: any, name: string, score: CaclRiskScore }> } } };

export type SupplierRiskScoreWidgetQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type SupplierRiskScoreWidgetQuery = { __typename?: 'Query', cataclysm: { __typename?: 'cataclysmQuery', supplier: { __typename?: 'CaclSupplier', id: any, score: CaclRiskScore, categories: Array<{ __typename?: 'CaclCategoryScore', id: any, score: CaclRiskScore }> } } };

export type SupplierRisksWidgetQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type SupplierRisksWidgetQuery = { __typename?: 'Query', cataclysm: { __typename?: 'cataclysmQuery', supplier: { __typename?: 'CaclSupplier', id: any, risks: Array<{ __typename?: 'CaclSupplierRisk', id: any, name: string, description?: string | null, score: CaclRiskScore, riskCategoryId: any }> } } };

export const DemandNegotiationCaseProcessStepsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DemandNegotiationCaseProcessSteps"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TsrctDemandNegotiationCase"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isReleasable"}},{"kind":"Field","name":{"kind":"Name","value":"processSteps"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"variant"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<DemandNegotiationCaseProcessStepsFragment, unknown>;
export const NegotiationCaseProcessStepsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"NegotiationCaseProcessSteps"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TsrctNegotiationCase"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isReleasable"}},{"kind":"Field","name":{"kind":"Name","value":"processSteps"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"variant"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<NegotiationCaseProcessStepsFragment, unknown>;
export const DemandListItemProcessStepsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DemandListItemProcessSteps"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TsrctDemandListItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"processSteps"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"variant"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<DemandListItemProcessStepsFragment, unknown>;
export const DemandDetailProcessStepsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DemandDetailProcessSteps"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TsrctDemand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"processSteps"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"variant"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<DemandDetailProcessStepsFragment, unknown>;
export const FileAttachmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FileAttachment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TsrctAttachment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"variant"}}]}},{"kind":"Field","name":{"kind":"Name","value":"visibilities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"variant"}}]}},{"kind":"Field","name":{"kind":"Name","value":"classification"}},{"kind":"Field","name":{"kind":"Name","value":"uploadedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"variant"}}]}}]}}]} as unknown as DocumentNode<FileAttachmentFragment, unknown>;
export const ProcurementKnowledgeDocumentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProcurementKnowledgeDocument"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SvbrgDocument"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fileId"}},{"kind":"Field","name":{"kind":"Name","value":"fileName"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"mimeType"}},{"kind":"Field","name":{"kind":"Name","value":"variant"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]} as unknown as DocumentNode<ProcurementKnowledgeDocumentFragment, unknown>;
export const ResponsibleUsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ResponsibleUsers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"capabilityIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"commodityGroupIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filterBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"astronaut"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"responsibleUsers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"capabilityIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"capabilityIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"commodityGroupIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"commodityGroupIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"filterBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filterBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primarySourceReference"}},{"kind":"Field","name":{"kind":"Name","value":"availabilityStatus"}},{"kind":"Field","name":{"kind":"Name","value":"demandCount"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"isRecommended"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"profilePicture"}}]}}]}}]}}]} as unknown as DocumentNode<ResponsibleUsersQuery, ResponsibleUsersQueryVariables>;
export const DocumentChunkDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DocumentChunk"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chunkId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sevenbridges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentChunk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chunkId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"fileId"}},{"kind":"Field","name":{"kind":"Name","value":"documentUrl"}}]}}]}}]}}]} as unknown as DocumentNode<DocumentChunkQuery, DocumentChunkQueryVariables>;
export const ConversationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Conversation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"entityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"entityVariant"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SvbrgConversationEntityVariant"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sevenbridges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"conversation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"entityId"}}},{"kind":"Argument","name":{"kind":"Name","value":"variant"},"value":{"kind":"Variable","name":{"kind":"Name","value":"entityVariant"}}},{"kind":"Argument","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"conversationSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"quickActions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"prompt"}},{"kind":"Field","name":{"kind":"Name","value":"isConversationStarter"}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"variant"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"conversationMessages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"parts"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ConversationQuery, ConversationQueryVariables>;
export const ResetConversationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ResetConversation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SvbrgChatSessionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sevenbridges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chatSession"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reset"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"conversationSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"quickActions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"prompt"}},{"kind":"Field","name":{"kind":"Name","value":"isConversationStarter"}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"variant"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tools"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isEnabled"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"conversationMessages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"parts"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ResetConversationMutation, ResetConversationMutationVariables>;
export const CustomDataNavListCmdiMetaDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CustomDataNavListCmdiMeta"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cmdi"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"meta_entity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"i18n"}},{"kind":"Field","name":{"kind":"Name","value":"needsPermission"}}]}}]}}]}}]} as unknown as DocumentNode<CustomDataNavListCmdiMetaQuery, CustomDataNavListCmdiMetaQueryVariables>;
export const LoadColumnConfigDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LoadColumnConfig"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"domain"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseColumnConfig"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"domain"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"domain"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"domain"}},{"kind":"Field","name":{"kind":"Name","value":"config"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}}]}}]} as unknown as DocumentNode<LoadColumnConfigQuery, LoadColumnConfigQueryVariables>;
export const SaveColumnConfigDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SaveColumnConfig"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"config"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"jsonb"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"domain"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_baseColumnConfig_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"config"},"value":{"kind":"Variable","name":{"kind":"Name","value":"config"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"domain"},"value":{"kind":"Variable","name":{"kind":"Name","value":"domain"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"baseColumnConfig_userId_domain_key"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"config"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"domain"}},{"kind":"Field","name":{"kind":"Name","value":"config"}}]}}]}}]} as unknown as DocumentNode<SaveColumnConfigMutation, SaveColumnConfigMutationVariables>;
export const DemandCasesBatchReleaseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DemandCasesBatchRelease"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TsrctReleaseNegotiationCasesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"demand"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"releaseNegotiationCases"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}]}]}}]}}]}}]} as unknown as DocumentNode<DemandCasesBatchReleaseMutation, DemandCasesBatchReleaseMutationVariables>;
export const DemandCasesReleaseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DemandCasesRelease"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"demand"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"negotiationCases"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sequenceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"variant"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"supplier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"internalId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"internalId"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"internalId"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"isReleasable"}},{"kind":"Field","name":{"kind":"Name","value":"processSteps"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"variant"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<DemandCasesReleaseQuery, DemandCasesReleaseQueryVariables>;
export const DemandCasesCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DemandCasesCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"demand"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"negotiationCases"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isReleasable"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<DemandCasesCountQuery, DemandCasesCountQueryVariables>;
export const ExtensionConversationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ExtensionConversation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"entityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"entityVariant"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SvbrgConversationEntityVariant"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sevenbridges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"conversationSettings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"entityId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"entityId"}}},{"kind":"Argument","name":{"kind":"Name","value":"entityVariant"},"value":{"kind":"Variable","name":{"kind":"Name","value":"entityVariant"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<ExtensionConversationQuery, ExtensionConversationQueryVariables>;
export const TesseractDemandItemDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TesseractDemandItem"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TsrctQueryBuilderQuery"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"demands"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sequenceNumber"}}]}}]}}]}}]}}]} as unknown as DocumentNode<TesseractDemandItemQuery, TesseractDemandItemQueryVariables>;
export const DeleteFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_filters_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteFilterMutation, DeleteFilterMutationVariables>;
export const LoadFiltersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LoadFilters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"filters"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"updatedAt"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"queryId"}},{"kind":"Field","name":{"kind":"Name","value":"domain"}},{"kind":"Field","name":{"kind":"Name","value":"isFavorite"}}]}}]}}]} as unknown as DocumentNode<LoadFiltersQuery, LoadFiltersQueryVariables>;
export const SaveFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SaveFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"queryId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"domain"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isFavorite"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_filters_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"queryId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"queryId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"domain"},"value":{"kind":"Variable","name":{"kind":"Name","value":"domain"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"isFavorite"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isFavorite"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"filters_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"name"},{"kind":"EnumValue","value":"queryId"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"queryId"}},{"kind":"Field","name":{"kind":"Name","value":"domain"}},{"kind":"Field","name":{"kind":"Name","value":"isFavorite"}}]}}]}}]} as unknown as DocumentNode<SaveFilterMutation, SaveFilterMutationVariables>;
export const UpdateFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isFavorite"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_filters_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isFavorite"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isFavorite"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isFavorite"}}]}}]}}]} as unknown as DocumentNode<UpdateFilterMutation, UpdateFilterMutationVariables>;
export const NegotiationCaseCancelDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"NegotiationCaseCancel"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TsrctNegotiationCaseCancelInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"negotiationCase"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cancel"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}]}]}}]}}]}}]} as unknown as DocumentNode<NegotiationCaseCancelMutation, NegotiationCaseCancelMutationVariables>;
export const NegotiationCaseCancelledAlertDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"NegotiationCaseCancelledAlert"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"negotiationCase"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"cancellationReason"}},{"kind":"Field","name":{"kind":"Name","value":"cancellationReasonText"}}]}}]}}]}}]} as unknown as DocumentNode<NegotiationCaseCancelledAlertQuery, NegotiationCaseCancelledAlertQueryVariables>;
export const LoadPermissionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LoadPermissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getPermissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"permissions"}}]}}]}}]} as unknown as DocumentNode<LoadPermissionsQuery, LoadPermissionsQueryVariables>;
export const DeleteSmartLinkDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteSmartLink"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"astronaut"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"smartLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"remove"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<DeleteSmartLinkMutation, DeleteSmartLinkMutationVariables>;
export const LoadSmartLinksDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LoadSmartLinks"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"domain"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AstroSmartLinkDomain"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"astronaut"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"smartLinks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"domain"},"value":{"kind":"Variable","name":{"kind":"Name","value":"domain"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"domain"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"external"}},{"kind":"Field","name":{"kind":"Name","value":"hidden"}},{"kind":"Field","name":{"kind":"Name","value":"variant"}},{"kind":"Field","name":{"kind":"Name","value":"sequence"}}]}}]}}]}}]} as unknown as DocumentNode<LoadSmartLinksQuery, LoadSmartLinksQueryVariables>;
export const UpdateSmartLinkDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateSmartLink"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AstroSmartLinkInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"astronaut"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"smartLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upsert"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateSmartLinkMutation, UpdateSmartLinkMutationVariables>;
export const UpsertSmartLinkDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertSmartLink"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AstroSmartLinkInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"astronaut"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"smartLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upsert"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"domain"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"external"}},{"kind":"Field","name":{"kind":"Name","value":"hidden"}},{"kind":"Field","name":{"kind":"Name","value":"variant"}},{"kind":"Field","name":{"kind":"Name","value":"sequence"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpsertSmartLinkMutation, UpsertSmartLinkMutationVariables>;
export const SourcingCaseCancelledAlertDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SourcingCaseCancelledAlert"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sourcingCase"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"cancellationReason"}},{"kind":"Field","name":{"kind":"Name","value":"cancellationReasonText"}}]}}]}}]}}]} as unknown as DocumentNode<SourcingCaseCancelledAlertQuery, SourcingCaseCancelledAlertQueryVariables>;
export const SupplierMapDetailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SupplierMapDetail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"supplier"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"relationship"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"industry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"prequalificationTrades"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fax"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"website"}}]}}]}}]}}]} as unknown as DocumentNode<SupplierMapDetailQuery, SupplierMapDetailQueryVariables>;
export const TestDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Test"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contract"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"StringValue","value":"1234","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}}]}}]}}]} as unknown as DocumentNode<TestQuery, TestQueryVariables>;
export const LoadAppConfigDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LoadAppConfig"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appConfig"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"navDrawerPinned"}}]}}]}}]} as unknown as DocumentNode<LoadAppConfigQuery, LoadAppConfigQueryVariables>;
export const SaveAppConfigDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SaveAppConfig"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"appConfig_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_appConfig_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"appConfig_userId_key"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"navDrawerPinned"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"navDrawerPinned"}}]}}]}}]} as unknown as DocumentNode<SaveAppConfigMutation, SaveAppConfigMutationVariables>;
export const CommentsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CommentsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"entityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"entityVariant"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TsrctCommentParentVariant"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TsrctCommentSortOrder"}},"defaultValue":{"kind":"EnumValue","value":"DESC"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"100"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"comments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"parent"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"entityId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"variant"},"value":{"kind":"Variable","name":{"kind":"Name","value":"entityVariant"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"authorId"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"variant"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CommentsQueryQuery, CommentsQueryQueryVariables>;
export const AddCommentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddComment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"message"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"parentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"parentVariant"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TsrctCommentParentVariant"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"comment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"create"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"message"},"value":{"kind":"Variable","name":{"kind":"Name","value":"message"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"parent"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parentId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"variant"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parentVariant"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"authorId"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"variant"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<AddCommentMutation, AddCommentMutationVariables>;
export const EditCommentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"EditComment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"message"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"parentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"parentVariant"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TsrctCommentParentVariant"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"comment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"message"},"value":{"kind":"Variable","name":{"kind":"Name","value":"message"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"parent"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parentId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"variant"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parentVariant"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"authorId"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"variant"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<EditCommentMutation, EditCommentMutationVariables>;
export const DeleteCommentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteComment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"comment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"variant"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<DeleteCommentMutation, DeleteCommentMutationVariables>;
export const DemandFilesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DemandFiles"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"demand"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isSharedWithSupplier"}},{"kind":"Field","name":{"kind":"Name","value":"quoteId"}},{"kind":"Field","name":{"kind":"Name","value":"negotiationCaseId"}},{"kind":"Field","name":{"kind":"Name","value":"negotiationCaseSequence"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"permissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"read"}},{"kind":"Field","name":{"kind":"Name","value":"write"}},{"kind":"Field","name":{"kind":"Name","value":"assign"}}]}}]}}]}}]}}]} as unknown as DocumentNode<DemandFilesQuery, DemandFilesQueryVariables>;
export const IntakeDiscardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"IntakeDiscard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SvbrgChatSessionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sevenbridges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chatSession"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"discard"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]}}]} as unknown as DocumentNode<IntakeDiscardMutation, IntakeDiscardMutationVariables>;
export const IntakeCancelDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"IntakeCancel"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SvbrgChatSessionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sevenbridges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chatSession"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cancel"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]}}]} as unknown as DocumentNode<IntakeCancelMutation, IntakeCancelMutationVariables>;
export const IntercomTokenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"IntercomToken"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"intercom"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token"}}]}}]}}]}}]} as unknown as DocumentNode<IntercomTokenQuery, IntercomTokenQueryVariables>;
export const LoadQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LoadQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"queries_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"query"}},{"kind":"Field","name":{"kind":"Name","value":"checksum"}}]}}]}}]} as unknown as DocumentNode<LoadQueryQuery, LoadQueryQueryVariables>;
export const SaveQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SaveQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"jsonb"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"checksum"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_queries_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"checksum"},"value":{"kind":"Variable","name":{"kind":"Name","value":"checksum"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"queries_checksum_key"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"checksum"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<SaveQueryMutation, SaveQueryMutationVariables>;
export const DemandProcessStepsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DemandProcessSteps"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"demand"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"processSteps"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"variant"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]}}]} as unknown as DocumentNode<DemandProcessStepsQuery, DemandProcessStepsQueryVariables>;
export const DemandProcessStepsUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"DemandProcessStepsUpdate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"demandProcessStepsUpdate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<DemandProcessStepsUpdateSubscription, DemandProcessStepsUpdateSubscriptionVariables>;
export const NegotiationCaseProcessStepsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"NegotiationCaseProcessSteps"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"negotiationCase"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isReleasable"}},{"kind":"Field","name":{"kind":"Name","value":"processSteps"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"variant"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]}}]} as unknown as DocumentNode<NegotiationCaseProcessStepsQuery, NegotiationCaseProcessStepsQueryVariables>;
export const NegotiationCaseProcessStepsUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"NegotiationCaseProcessStepsUpdate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"negotiationCaseProcessStepsUpdate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<NegotiationCaseProcessStepsUpdateSubscription, NegotiationCaseProcessStepsUpdateSubscriptionVariables>;
export const UserProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserProfile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"astronaut"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primarySourceReference"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"capabilityIds"}},{"kind":"Field","name":{"kind":"Name","value":"commodityGroupIds"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"deliveryLocationId"}},{"kind":"Field","name":{"kind":"Name","value":"accountingAreaId"}},{"kind":"Field","name":{"kind":"Name","value":"costCenterId"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"workingHours"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"pictureId"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"language"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UserProfileQuery, UserProfileQueryVariables>;
export const OverrideAutomaticAcceptanceTimingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"OverrideAutomaticAcceptanceTiming"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TsrctOverrideAutomaticAcceptanceTimingInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"overrideAutomaticAcceptanceTiming"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"targetId"}},{"kind":"Field","name":{"kind":"Name","value":"variant"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"plannedAt"}},{"kind":"Field","name":{"kind":"Name","value":"timing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reactionMinMinutes"}},{"kind":"Field","name":{"kind":"Name","value":"reactionMaxMinutes"}},{"kind":"Field","name":{"kind":"Name","value":"workingDays"}},{"kind":"Field","name":{"kind":"Name","value":"workingHours"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}}]}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"holiday"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"state"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<OverrideAutomaticAcceptanceTimingMutation, OverrideAutomaticAcceptanceTimingMutationVariables>;
export const AutomaticAcceptanceTimingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AutomaticAcceptanceTiming"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"targetId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"variant"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TsrctAutoAcceptTimingVariant"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isNegotiationCase"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},"defaultValue":{"kind":"BooleanValue","value":false}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isSourcingCase"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},"defaultValue":{"kind":"BooleanValue","value":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"automaticAcceptanceTiming"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"targetId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"targetId"}}},{"kind":"Argument","name":{"kind":"Name","value":"variant"},"value":{"kind":"Variable","name":{"kind":"Name","value":"variant"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"targetId"}},{"kind":"Field","name":{"kind":"Name","value":"variant"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"plannedAt"}},{"kind":"Field","name":{"kind":"Name","value":"timing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reactionMinMinutes"}},{"kind":"Field","name":{"kind":"Name","value":"reactionMaxMinutes"}},{"kind":"Field","name":{"kind":"Name","value":"workingDays"}},{"kind":"Field","name":{"kind":"Name","value":"workingHours"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}}]}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"holiday"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"state"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"negotiationCase"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"targetId"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isNegotiationCase"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sourcingCase"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"targetId"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isSourcingCase"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]} as unknown as DocumentNode<AutomaticAcceptanceTimingQuery, AutomaticAcceptanceTimingQueryVariables>;
export const BusinessLogQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BusinessLogQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"entityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"entityVariant"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TlscpEntityVariant"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeChildren"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"telescope"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"logEntries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"entityId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"entityId"}}},{"kind":"Argument","name":{"kind":"Name","value":"entityVariant"},"value":{"kind":"Variable","name":{"kind":"Name","value":"entityVariant"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"includeChildren"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeChildren"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actorId"}},{"kind":"Field","name":{"kind":"Name","value":"actorVariant"}},{"kind":"Field","name":{"kind":"Name","value":"context"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"entityId"}},{"kind":"Field","name":{"kind":"Name","value":"entityVariant"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"parentVariant"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"template"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}}]} as unknown as DocumentNode<BusinessLogQueryQuery, BusinessLogQueryQueryVariables>;
export const DemandMaskingQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DemandMaskingQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"demand"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"competitiveBiddingRule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isMaskedBidding"}}]}}]}}]}}]}}]} as unknown as DocumentNode<DemandMaskingQueryQuery, DemandMaskingQueryQueryVariables>;
export const NegotiationCaseMaskingQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"NegotiationCaseMaskingQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"negotiationCase"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isMaskedBidding"}}]}}]}}]}}]} as unknown as DocumentNode<NegotiationCaseMaskingQueryQuery, NegotiationCaseMaskingQueryQueryVariables>;
export const DemandNegotiationCaseAwardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DemandNegotiationCaseAward"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TsrctDemandAwardInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"demand"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"award"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}]}]}}]}}]}}]} as unknown as DocumentNode<DemandNegotiationCaseAwardMutation, DemandNegotiationCaseAwardMutationVariables>;
export const DemandAwardingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DemandAwarding"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"demand"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"competitiveBiddingRule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isMaskedBidding"}}]}},{"kind":"Field","name":{"kind":"Name","value":"demandRequest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"totalValue"}},{"kind":"Field","name":{"kind":"Name","value":"lineItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"expectedPricePerUnit"}},{"kind":"Field","name":{"kind":"Name","value":"commodityId"}},{"kind":"Field","name":{"kind":"Name","value":"unitId"}},{"kind":"Field","name":{"kind":"Name","value":"commodityGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"deliveryLocationId"}},{"kind":"Field","name":{"kind":"Name","value":"preferredSupplierId"}},{"kind":"Field","name":{"kind":"Name","value":"internalId"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"totalValue"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"awardingStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entityId"}},{"kind":"Field","name":{"kind":"Name","value":"entityVariant"}},{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"awardingSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isPartialAwardingEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"notifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"informSupplier"}},{"kind":"Field","name":{"kind":"Name","value":"dismissOtherSuppliers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"show"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}}]}},{"kind":"Field","name":{"kind":"Name","value":"informAwardedSupplier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"show"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}}]}},{"kind":"Field","name":{"kind":"Name","value":"informDismissedSupplier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"show"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"negotiationCases"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isAwardable"}},{"kind":"Field","name":{"kind":"Name","value":"sequenceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"processStatus"}},{"kind":"Field","name":{"kind":"Name","value":"sourceReferences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sourceReference"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"supplier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"internalId"}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"internalId"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"internalId"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"variant"}},{"kind":"Field","name":{"kind":"Name","value":"quote"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TsrctQuoteInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"supplierReference"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"totalValue"}},{"kind":"Field","name":{"kind":"Name","value":"lineItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"unitId"}},{"kind":"Field","name":{"kind":"Name","value":"pricePerUnit"}},{"kind":"Field","name":{"kind":"Name","value":"totalValue"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shipmentTerms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"earlyDeliveryAt"}},{"kind":"Field","name":{"kind":"Name","value":"lateDeliveryAt"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TsrctNegotiatedQuote"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"discount"}},{"kind":"Field","name":{"kind":"Name","value":"totalPriceDiscount"}},{"kind":"Field","name":{"kind":"Name","value":"totalDiscountedValue"}},{"kind":"Field","name":{"kind":"Name","value":"lineItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"discount"}},{"kind":"Field","name":{"kind":"Name","value":"discountedPricePerUnit"}},{"kind":"Field","name":{"kind":"Name","value":"totalDiscountedValue"}},{"kind":"Field","name":{"kind":"Name","value":"isAwardable"}},{"kind":"Field","name":{"kind":"Name","value":"demandRequestItemId"}},{"kind":"Field","name":{"kind":"Name","value":"negotiationFailedReason"}},{"kind":"Field","name":{"kind":"Name","value":"negotiationFailedReasonText"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}}]}}]} as unknown as DocumentNode<DemandAwardingQuery, DemandAwardingQueryVariables>;
export const AwardingConfigurationUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AwardingConfigurationUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"awardingConfiguration"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TsrctDemandAwardingRuleConfigurationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"demand"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"awardingConfiguration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"awardingConfiguration"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"deadlineDays"}},{"kind":"Field","name":{"kind":"Name","value":"performAutomaticAwarding"}},{"kind":"Field","name":{"kind":"Name","value":"rules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"priceDeviation"}},{"kind":"Field","name":{"kind":"Name","value":"variant"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<AwardingConfigurationUpdateMutation, AwardingConfigurationUpdateMutationVariables>;
export const AwardingConfigurationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AwardingConfiguration"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"demand"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"awardingConfiguration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"deadline"}},{"kind":"Field","name":{"kind":"Name","value":"deadlineDays"}},{"kind":"Field","name":{"kind":"Name","value":"performAutomaticAwarding"}},{"kind":"Field","name":{"kind":"Name","value":"rules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"priceDeviation"}},{"kind":"Field","name":{"kind":"Name","value":"variant"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<AwardingConfigurationQuery, AwardingConfigurationQueryVariables>;
export const DemandCasesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DemandCases"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"demand"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"competitiveBiddingRule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"variant"}},{"kind":"Field","name":{"kind":"Name","value":"isEditable"}},{"kind":"Field","name":{"kind":"Name","value":"isMaskedBidding"}}]}},{"kind":"Field","name":{"kind":"Name","value":"negotiationCases"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isNegotiationEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"isSupplierUploadAllowed"}},{"kind":"Field","name":{"kind":"Name","value":"isMaskedBidding"}},{"kind":"Field","name":{"kind":"Name","value":"sequenceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"variant"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"sourceReferences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sourceReference"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"initiatedBy"}},{"kind":"Field","name":{"kind":"Name","value":"supplierInteractionMode"}},{"kind":"Field","name":{"kind":"Name","value":"negotiationMode"}},{"kind":"Field","name":{"kind":"Name","value":"quoteMode"}},{"kind":"Field","name":{"kind":"Name","value":"negotiationObjective"}}]}},{"kind":"Field","name":{"kind":"Name","value":"supplier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"internalId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"internalId"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"internalId"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"quote"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TsrctQuoteInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"totalValue"}},{"kind":"Field","name":{"kind":"Name","value":"shipmentTerms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"earlyDeliveryAt"}},{"kind":"Field","name":{"kind":"Name","value":"lateDeliveryAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"lineItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalValue"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"pricePerUnit"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"shipmentTerms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"earlyDeliveryAt"}},{"kind":"Field","name":{"kind":"Name","value":"lateDeliveryAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"unitId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentTerms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"daysToPayment"}},{"kind":"Field","name":{"kind":"Name","value":"discount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hasSupplierComment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TsrctNegotiatedQuoteInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalDiscountedValue"}},{"kind":"Field","name":{"kind":"Name","value":"discount"}},{"kind":"Field","name":{"kind":"Name","value":"totalPriceDiscount"}},{"kind":"Field","name":{"kind":"Name","value":"lineItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"discount"}},{"kind":"Field","name":{"kind":"Name","value":"discountedPricePerUnit"}},{"kind":"Field","name":{"kind":"Name","value":"totalDiscountedValue"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"processStatus"}},{"kind":"Field","name":{"kind":"Name","value":"isReleasable"}},{"kind":"Field","name":{"kind":"Name","value":"processSteps"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"variant"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lowerDiscountBoundary"}},{"kind":"Field","name":{"kind":"Name","value":"upperDiscountBoundary"}},{"kind":"Field","name":{"kind":"Name","value":"issueSummary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"openCount"}},{"kind":"Field","name":{"kind":"Name","value":"resolvedCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"latestComment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"authorId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"variant"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}}]}}]} as unknown as DocumentNode<DemandCasesQuery, DemandCasesQueryVariables>;
export const DemandDetailUnifiedUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DemandDetailUnifiedUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"demandData"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TsrctDemandUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"competitiveBiddingRuleData"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TsrctCompetitiveBiddingRuleInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"demand"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"demandData"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"capabilityIds"}},{"kind":"Field","name":{"kind":"Name","value":"responsibleUserIds"}},{"kind":"Field","name":{"kind":"Name","value":"demandRequest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sourceReferences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"internalId"}},{"kind":"Field","name":{"kind":"Name","value":"sourceReference"}},{"kind":"Field","name":{"kind":"Name","value":"sourceSystem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isPrimary"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"permissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"write"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"competitiveBiddingRule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"competitiveBiddingRuleData"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"variant"}},{"kind":"Field","name":{"kind":"Name","value":"deadline"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<DemandDetailUnifiedUpdateMutation, DemandDetailUnifiedUpdateMutationVariables>;
export const DemandDetailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DemandDetail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"demand"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"competitiveBiddingRule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"variant"}},{"kind":"Field","name":{"kind":"Name","value":"deadline"}},{"kind":"Field","name":{"kind":"Name","value":"isEditable"}},{"kind":"Field","name":{"kind":"Name","value":"isMaskedBidding"}}]}},{"kind":"Field","name":{"kind":"Name","value":"capabilityIds"}},{"kind":"Field","name":{"kind":"Name","value":"responsibleUserIds"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"demandRequest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"commodityGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"sourceReferences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lineItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"preferredSupplierId"}},{"kind":"Field","name":{"kind":"Name","value":"commodityGroupId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"permissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"write"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"sequenceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"processingMode"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"negotiationCases"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"quoteMode"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<DemandDetailQuery, DemandDetailQueryVariables>;
export const DemandFileAttachmentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DemandFileAttachments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"parents"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TsrctAttachmentParentInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TsrctAttachmentFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attachments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"parents"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parents"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FileAttachment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FileAttachment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TsrctAttachment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"variant"}}]}},{"kind":"Field","name":{"kind":"Name","value":"visibilities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"variant"}}]}},{"kind":"Field","name":{"kind":"Name","value":"classification"}},{"kind":"Field","name":{"kind":"Name","value":"uploadedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"variant"}}]}}]}}]} as unknown as DocumentNode<DemandFileAttachmentsQuery, DemandFileAttachmentsQueryVariables>;
export const DemandFileAttachmentsDemandDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DemandFileAttachmentsDemand"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"demandId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"demand"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"demandId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"negotiationCases"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<DemandFileAttachmentsDemandQuery, DemandFileAttachmentsDemandQueryVariables>;
export const DemandRecommendationQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DemandRecommendationQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"demand"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"demandRequest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lineItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"recommendations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"decisionStatus"}},{"kind":"Field","name":{"kind":"Name","value":"variant"}},{"kind":"Field","name":{"kind":"Name","value":"demandRequestItemId"}},{"kind":"Field","name":{"kind":"Name","value":"recommendedItem"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"permissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"write"}}]}}]}}]}}]}}]} as unknown as DocumentNode<DemandRecommendationQueryQuery, DemandRecommendationQueryQueryVariables>;
export const DemandRecommendationApplyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DemandRecommendationApply"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"demandId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TsrctRecommendationsInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"demand"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"demandId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"demandRequest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recommendations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"apply"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"demandId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"demandId"}}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"decisionStatus"}},{"kind":"Field","name":{"kind":"Name","value":"variant"}},{"kind":"Field","name":{"kind":"Name","value":"demandRequestItemId"}},{"kind":"Field","name":{"kind":"Name","value":"recommendedItem"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<DemandRecommendationApplyMutation, DemandRecommendationApplyMutationVariables>;
export const DemandRequestUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DemandRequestUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"demandId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"demandRequest"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TsrctDemandRequestInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"demand"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"demandId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"demandRequest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"demandRequest"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lineItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"unitId"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"shipmentTerms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"earlyDeliveryAt"}},{"kind":"Field","name":{"kind":"Name","value":"lateDeliveryAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"preferredSupplierId"}},{"kind":"Field","name":{"kind":"Name","value":"internalId"}},{"kind":"Field","name":{"kind":"Name","value":"expectedPricePerUnit"}},{"kind":"Field","name":{"kind":"Name","value":"commodityGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"contractItemId"}},{"kind":"Field","name":{"kind":"Name","value":"analysisId"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"deliveryLocationId"}},{"kind":"Field","name":{"kind":"Name","value":"commodityId"}},{"kind":"Field","name":{"kind":"Name","value":"baselinePricePerUnit"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<DemandRequestUpdateMutation, DemandRequestUpdateMutationVariables>;
export const TsrctDemandRequestDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TsrctDemandRequest"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"demand"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"requestedBy"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"demandRequest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"budget"}},{"kind":"Field","name":{"kind":"Name","value":"demandId"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"commodityGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"sourceReferences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"internalId"}},{"kind":"Field","name":{"kind":"Name","value":"isPrimary"}},{"kind":"Field","name":{"kind":"Name","value":"sourceReference"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"sourceSystem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lineItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"deliveryLocationId"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"unitId"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"shipmentTerms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"earlyDeliveryAt"}},{"kind":"Field","name":{"kind":"Name","value":"lateDeliveryAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"preferredSupplierId"}},{"kind":"Field","name":{"kind":"Name","value":"internalId"}},{"kind":"Field","name":{"kind":"Name","value":"expectedPricePerUnit"}},{"kind":"Field","name":{"kind":"Name","value":"commodityGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"contractItemId"}},{"kind":"Field","name":{"kind":"Name","value":"commodityId"}},{"kind":"Field","name":{"kind":"Name","value":"baselinePricePerUnit"}},{"kind":"Field","name":{"kind":"Name","value":"analysisId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"permissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"read"}},{"kind":"Field","name":{"kind":"Name","value":"write"}},{"kind":"Field","name":{"kind":"Name","value":"assign"}}]}}]}}]}}]}}]} as unknown as DocumentNode<TsrctDemandRequestQuery, TsrctDemandRequestQueryVariables>;
export const FileAttachmentsUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"FileAttachmentsUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TsrctAttachmentMutationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attachment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"variant"}}]}},{"kind":"Field","name":{"kind":"Name","value":"attachments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FileAttachment"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FileAttachment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TsrctAttachment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"variant"}}]}},{"kind":"Field","name":{"kind":"Name","value":"visibilities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"variant"}}]}},{"kind":"Field","name":{"kind":"Name","value":"classification"}},{"kind":"Field","name":{"kind":"Name","value":"uploadedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"variant"}}]}}]}}]} as unknown as DocumentNode<FileAttachmentsUpdateMutation, FileAttachmentsUpdateMutationVariables>;
export const NegotiatedQuoteAcceptDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"NegotiatedQuoteAccept"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"negotiationCaseId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TsrctNegotiatedQuoteActionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"negotiationCase"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"negotiationCaseId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"negotiatedQuote"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"draftAccept"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<NegotiatedQuoteAcceptMutation, NegotiatedQuoteAcceptMutationVariables>;
export const NegotiatedQuoteDeclineDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"NegotiatedQuoteDecline"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"negotiationCaseId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TsrctNegotiatedQuoteActionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"negotiationCase"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"negotiationCaseId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"negotiatedQuote"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"draftDecline"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<NegotiatedQuoteDeclineMutation, NegotiatedQuoteDeclineMutationVariables>;
export const NegotiatedQuoteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"NegotiatedQuote"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"negotiationCase"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isMaskedBidding"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"processStatus"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"supplierInteractionMode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"negotiatedQuote"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"supplierReference"}},{"kind":"Field","name":{"kind":"Name","value":"totalValue"}},{"kind":"Field","name":{"kind":"Name","value":"lineItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"deliveryLocationId"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"commodityId"}},{"kind":"Field","name":{"kind":"Name","value":"unitId"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"pricePerUnit"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"totalValue"}},{"kind":"Field","name":{"kind":"Name","value":"shipmentTerms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"earlyDeliveryAt"}},{"kind":"Field","name":{"kind":"Name","value":"lateDeliveryAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"discount"}},{"kind":"Field","name":{"kind":"Name","value":"totalDiscountedValue"}},{"kind":"Field","name":{"kind":"Name","value":"discountedPricePerUnit"}},{"kind":"Field","name":{"kind":"Name","value":"supplierComment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"variant"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentTerms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"daysToPayment"}},{"kind":"Field","name":{"kind":"Name","value":"discount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shipmentTerms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"earlyDeliveryAt"}},{"kind":"Field","name":{"kind":"Name","value":"lateDeliveryAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"discount"}},{"kind":"Field","name":{"kind":"Name","value":"totalDiscountedValue"}},{"kind":"Field","name":{"kind":"Name","value":"totalPriceDiscount"}},{"kind":"Field","name":{"kind":"Name","value":"buyerReply"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"supplierComment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"variant"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hasSupplierComment"}}]}}]}}]}}]}}]} as unknown as DocumentNode<NegotiatedQuoteQuery, NegotiatedQuoteQueryVariables>;
export const DemandAwardingRuleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DemandAwardingRule"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"demand"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<DemandAwardingRuleQuery, DemandAwardingRuleQueryVariables>;
export const SaveDemandRequestDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SaveDemandRequest"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TsrctDemandRequestInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"demand"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"demandRequest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<SaveDemandRequestMutation, SaveDemandRequestMutationVariables>;
export const DemandCaseAddDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DemandCaseAdd"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"demandId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TsrctNegotiationCaseInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"demand"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"demandId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"negotiationCase"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"create"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<DemandCaseAddMutation, DemandCaseAddMutationVariables>;
export const DemandCaseReleaseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DemandCaseRelease"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TsrctReleaseNegotiationCasesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"demand"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"releaseNegotiationCases"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}]}]}}]}}]}}]} as unknown as DocumentNode<DemandCaseReleaseMutation, DemandCaseReleaseMutationVariables>;
export const CreateNegotiationCaseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateNegotiationCase"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"demandId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TsrctNegotiationCaseInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"demand"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"demandId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"negotiationCase"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"create"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<CreateNegotiationCaseMutation, CreateNegotiationCaseMutationVariables>;
export const QuoteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Quote"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sevenbridges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quote"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"quoteReference"}},{"kind":"Field","name":{"kind":"Name","value":"lineItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sequence"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"unitId"}},{"kind":"Field","name":{"kind":"Name","value":"pricePerUnit"}},{"kind":"Field","name":{"kind":"Name","value":"earlyDeliveryAt"}},{"kind":"Field","name":{"kind":"Name","value":"lateDeliveryAt"}}]}}]}}]}}]}}]} as unknown as DocumentNode<QuoteQuery, QuoteQueryVariables>;
export const AnalyzeQuoteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AnalyzeQuote"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SvbrgQuoteAnalysisInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sevenbridges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quote"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"analyse"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fileId"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AnalyzeQuoteMutation, AnalyzeQuoteMutationVariables>;
export const QuoteAnalysisDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"QuoteAnalysis"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sevenbridges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quote"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"analysis"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fileId"}},{"kind":"Field","name":{"kind":"Name","value":"completedAt"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"quote"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"quoteReference"}},{"kind":"Field","name":{"kind":"Name","value":"lineItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sequence"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"unitId"}},{"kind":"Field","name":{"kind":"Name","value":"pricePerUnit"}},{"kind":"Field","name":{"kind":"Name","value":"earlyDeliveryAt"}},{"kind":"Field","name":{"kind":"Name","value":"lateDeliveryAt"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<QuoteAnalysisQuery, QuoteAnalysisQueryVariables>;
export const OnCompletedQuoteAnaylsisDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"OnCompletedQuoteAnaylsis"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sevenbridges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quote"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"analysis"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fileId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"quote"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"quoteReference"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"lineItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sequence"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"unitId"}},{"kind":"Field","name":{"kind":"Name","value":"pricePerUnit"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"earlyDeliveryAt"}},{"kind":"Field","name":{"kind":"Name","value":"lateDeliveryAt"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<OnCompletedQuoteAnaylsisSubscription, OnCompletedQuoteAnaylsisSubscriptionVariables>;
export const TesseractNegotiationCaseResubmitDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TesseractNegotiationCaseResubmit"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"negotiationCase"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resubmit"}}]}}]}}]}}]} as unknown as DocumentNode<TesseractNegotiationCaseResubmitMutation, TesseractNegotiationCaseResubmitMutationVariables>;
export const NegotiationCaseDetailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"NegotiationCaseDetail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"negotiationCase"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"issues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"variant"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]}}]} as unknown as DocumentNode<NegotiationCaseDetailQuery, NegotiationCaseDetailQueryVariables>;
export const NegotiationCaseDetailQuoteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"NegotiationCaseDetailQuote"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"negotiationCase"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"cancellationReason"}},{"kind":"Field","name":{"kind":"Name","value":"cancellationReasonText"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"supplierInteractionMode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isMaskedBidding"}},{"kind":"Field","name":{"kind":"Name","value":"negotiatedQuote"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"totalValue"}},{"kind":"Field","name":{"kind":"Name","value":"discount"}},{"kind":"Field","name":{"kind":"Name","value":"lineItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"supplierComment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"variant"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalDiscountedValue"}},{"kind":"Field","name":{"kind":"Name","value":"totalPriceDiscount"}},{"kind":"Field","name":{"kind":"Name","value":"supplierComment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"variant"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<NegotiationCaseDetailQuoteQuery, NegotiationCaseDetailQuoteQueryVariables>;
export const NegotiationCaseInternalFileAttachmentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"NegotiationCaseInternalFileAttachments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"parents"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TsrctAttachmentParentInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TsrctAttachmentFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attachments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"parents"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parents"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FileAttachment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FileAttachment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TsrctAttachment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"variant"}}]}},{"kind":"Field","name":{"kind":"Name","value":"visibilities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"variant"}}]}},{"kind":"Field","name":{"kind":"Name","value":"classification"}},{"kind":"Field","name":{"kind":"Name","value":"uploadedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"variant"}}]}}]}}]} as unknown as DocumentNode<NegotiationCaseInternalFileAttachmentsQuery, NegotiationCaseInternalFileAttachmentsQueryVariables>;
export const NegotiationCaseInternalFileAttachmentsCaseAndDemandDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"NegotiationCaseInternalFileAttachmentsCaseAndDemand"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"negotiationCaseId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"negotiationCase"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"negotiationCaseId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"demand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<NegotiationCaseInternalFileAttachmentsCaseAndDemandQuery, NegotiationCaseInternalFileAttachmentsCaseAndDemandQueryVariables>;
export const NegotiationCaseSupplierFileAttachmentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"NegotiationCaseSupplierFileAttachments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"negotiationCaseId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"parents"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TsrctAttachmentParentInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TsrctAttachmentFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attachments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"parents"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parents"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FileAttachment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"negotiationCase"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"negotiationCaseId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FileAttachment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TsrctAttachment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"variant"}}]}},{"kind":"Field","name":{"kind":"Name","value":"visibilities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"variant"}}]}},{"kind":"Field","name":{"kind":"Name","value":"classification"}},{"kind":"Field","name":{"kind":"Name","value":"uploadedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"variant"}}]}}]}}]} as unknown as DocumentNode<NegotiationCaseSupplierFileAttachmentsQuery, NegotiationCaseSupplierFileAttachmentsQueryVariables>;
export const NegotiationContactUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"NegotiationContactUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contact"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TsrctNegotiationCaseSupplierContactInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"negotiationCase"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"supplier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contact"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"language"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<NegotiationContactUpdateMutation, NegotiationContactUpdateMutationVariables>;
export const NegotiationContactDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"NegotiationContact"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"negotiationCase"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"processStatus"}},{"kind":"Field","name":{"kind":"Name","value":"supplier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"internalId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"internalId"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"internalId"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<NegotiationContactQuery, NegotiationContactQueryVariables>;
export const NegotiationQuoteDetailsUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"NegotiationQuoteDetailsUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"negotiationCaseId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TsrctQuoteInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"negotiationCase"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"negotiationCaseId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quote"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"create"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"supplierReference"}},{"kind":"Field","name":{"kind":"Name","value":"totalValue"}},{"kind":"Field","name":{"kind":"Name","value":"paymentTerms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"daysToPayment"}},{"kind":"Field","name":{"kind":"Name","value":"discount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lineItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"pricePerUnit"}},{"kind":"Field","name":{"kind":"Name","value":"unitId"}},{"kind":"Field","name":{"kind":"Name","value":"deliveryLocationId"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<NegotiationQuoteDetailsUpdateMutation, NegotiationQuoteDetailsUpdateMutationVariables>;
export const NegotiationQuoteDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"NegotiationQuoteDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"negotiationCase"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isMaskedBidding"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"processStatus"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"quoteMode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"quote"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"supplierReference"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"totalValue"}},{"kind":"Field","name":{"kind":"Name","value":"paymentTerms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"daysToPayment"}},{"kind":"Field","name":{"kind":"Name","value":"discount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lineItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"pricePerUnit"}},{"kind":"Field","name":{"kind":"Name","value":"unitId"}},{"kind":"Field","name":{"kind":"Name","value":"totalValue"}},{"kind":"Field","name":{"kind":"Name","value":"shipmentTerms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"earlyDeliveryAt"}},{"kind":"Field","name":{"kind":"Name","value":"lateDeliveryAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deliveryLocationId"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"commodityId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<NegotiationQuoteDetailsQuery, NegotiationQuoteDetailsQueryVariables>;
export const ReminderSettingsMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ReminderSettingsMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TsrctUpdateReminderConfigInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateReminderConfig"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reminderConfigId"}},{"kind":"Field","name":{"kind":"Name","value":"targetId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"variant"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"reminderDelayWorkingDays"}},{"kind":"Field","name":{"kind":"Name","value":"cancellationDelayWorkingDays"}},{"kind":"Field","name":{"kind":"Name","value":"executionTime"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}}]}}]}}]}}]} as unknown as DocumentNode<ReminderSettingsMutationMutation, ReminderSettingsMutationMutationVariables>;
export const ReminderSettingsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ReminderSettingsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"targetId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TsrctReminderType"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"variant"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TsrctReminderConfigVariant"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isNegotiationCase"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},"defaultValue":{"kind":"BooleanValue","value":false}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isSourcingCase"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},"defaultValue":{"kind":"BooleanValue","value":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reminderConfig"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"targetId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"targetId"}}},{"kind":"Argument","name":{"kind":"Name","value":"type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}},{"kind":"Argument","name":{"kind":"Name","value":"variant"},"value":{"kind":"Variable","name":{"kind":"Name","value":"variant"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reminderConfigId"}},{"kind":"Field","name":{"kind":"Name","value":"targetId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"variant"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"reminderDelayWorkingDays"}},{"kind":"Field","name":{"kind":"Name","value":"cancellationDelayWorkingDays"}},{"kind":"Field","name":{"kind":"Name","value":"executionTime"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}}]}},{"kind":"Field","name":{"kind":"Name","value":"negotiationCase"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"targetId"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isNegotiationCase"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sourcingCase"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"targetId"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isSourcingCase"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]} as unknown as DocumentNode<ReminderSettingsQueryQuery, ReminderSettingsQueryQueryVariables>;
export const SupplierContactNamePolicyQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SupplierContactNamePolicyQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"supplierContactSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"namePolicy"}}]}}]}}]}}]} as unknown as DocumentNode<SupplierContactNamePolicyQueryQuery, SupplierContactNamePolicyQueryQueryVariables>;
export const NegotiationCaseUpdateSupplierIntroductionMessageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"NegotiationCaseUpdateSupplierIntroductionMessage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TsrctSupplierIntroductionMessageInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"negotiationCase"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"supplierIntroductionMessage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"language"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<NegotiationCaseUpdateSupplierIntroductionMessageMutation, NegotiationCaseUpdateSupplierIntroductionMessageMutationVariables>;
export const NegotiationSupplierIntroductionMessageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"NegotiationSupplierIntroductionMessage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"negotiationCase"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"supplierIntroductionMessage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"language"}}]}}]}}]}}]}}]} as unknown as DocumentNode<NegotiationSupplierIntroductionMessageQuery, NegotiationSupplierIntroductionMessageQueryVariables>;
export const NegotiationTaskResolveDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"NegotiationTaskResolve"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resolveTask"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<NegotiationTaskResolveMutation, NegotiationTaskResolveMutationVariables>;
export const NegotiationTasksDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"NegotiationTasks"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TasksFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tasks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"message"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"variant"}},{"kind":"Field","name":{"kind":"Name","value":"details"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"variant"}},{"kind":"Field","name":{"kind":"Name","value":"relatedResources"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project"}},{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"variant"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<NegotiationTasksQuery, NegotiationTasksQueryVariables>;
export const NegotiationTermsUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"NegotiationTermsUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"strategy"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TsrctNegotiationStrategyBoundariesInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"options"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TsrctNegotiationCaseOptionsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"negotiationCase"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"strategy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"strategy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"useHistoricTenderData"}},{"kind":"Field","name":{"kind":"Name","value":"useHistoricNegotiationData"}},{"kind":"Field","name":{"kind":"Name","value":"boundaryRules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"base"}},{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}},{"kind":"Field","name":{"kind":"Name","value":"sequence"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"options"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"initiatedBy"}},{"kind":"Field","name":{"kind":"Name","value":"quoteMode"}},{"kind":"Field","name":{"kind":"Name","value":"negotiationMode"}},{"kind":"Field","name":{"kind":"Name","value":"supplierInteractionMode"}},{"kind":"Field","name":{"kind":"Name","value":"negotiationObjective"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<NegotiationTermsUpdateMutation, NegotiationTermsUpdateMutationVariables>;
export const NegotiationTermsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"NegotiationTerms"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"negotiationCase"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"processStatus"}},{"kind":"Field","name":{"kind":"Name","value":"supplier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"internalId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lowerDiscountBoundary"}},{"kind":"Field","name":{"kind":"Name","value":"upperDiscountBoundary"}},{"kind":"Field","name":{"kind":"Name","value":"strategy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"useHistoricTenderData"}},{"kind":"Field","name":{"kind":"Name","value":"useHistoricNegotiationData"}},{"kind":"Field","name":{"kind":"Name","value":"boundaryRules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"base"}},{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}},{"kind":"Field","name":{"kind":"Name","value":"sequence"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"initiatedBy"}},{"kind":"Field","name":{"kind":"Name","value":"quoteMode"}},{"kind":"Field","name":{"kind":"Name","value":"negotiationMode"}},{"kind":"Field","name":{"kind":"Name","value":"supplierInteractionMode"}},{"kind":"Field","name":{"kind":"Name","value":"negotiationObjective"}}]}},{"kind":"Field","name":{"kind":"Name","value":"demand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"negotiatedQuote"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"discount"}},{"kind":"Field","name":{"kind":"Name","value":"totalValue"}},{"kind":"Field","name":{"kind":"Name","value":"totalDiscountedValue"}},{"kind":"Field","name":{"kind":"Name","value":"totalPriceDiscount"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}}]}}]} as unknown as DocumentNode<NegotiationTermsQuery, NegotiationTermsQueryVariables>;
export const NewsroomWidgetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"NewsroomWidget"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locale"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"supplier"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"news"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locale"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"source"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}}]} as unknown as DocumentNode<NewsroomWidgetQuery, NewsroomWidgetQueryVariables>;
export const RuleEvaluationLogDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RuleEvaluationLog"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ruleId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TsrctRuleEvaluationLogOrder"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rule"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ruleId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"evaluationLogs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"sequenceNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}}]}}]} as unknown as DocumentNode<RuleEvaluationLogQuery, RuleEvaluationLogQueryVariables>;
export const DeleteSavingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteSaving"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteSaving"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<DeleteSavingMutation, DeleteSavingMutationVariables>;
export const SavingsListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SavingsList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SavingQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"savings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"savingType"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"baselinePrice"}},{"kind":"Field","name":{"kind":"Name","value":"newPrice"}},{"kind":"Field","name":{"kind":"Name","value":"baselineQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"newQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"validFrom"}},{"kind":"Field","name":{"kind":"Name","value":"validTo"}},{"kind":"Field","name":{"kind":"Name","value":"multiYearSaving"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"fkBuyer"}},{"kind":"Field","name":{"kind":"Name","value":"fkSupplier"}},{"kind":"Field","name":{"kind":"Name","value":"fkCommodityGroup"}},{"kind":"Field","name":{"kind":"Name","value":"freeTextCommodity"}},{"kind":"Field","name":{"kind":"Name","value":"fkProcurementOrganization"}},{"kind":"Field","name":{"kind":"Name","value":"fkOrganization"}},{"kind":"Field","name":{"kind":"Name","value":"fkPurchasingGroup"}},{"kind":"Field","name":{"kind":"Name","value":"fkAccountingArea"}},{"kind":"Field","name":{"kind":"Name","value":"fkUnit"}},{"kind":"Field","name":{"kind":"Name","value":"originalPriceQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"newPriceQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"reductionType"}},{"kind":"Field","name":{"kind":"Name","value":"costAllocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"distributionType"}},{"kind":"Field","name":{"kind":"Name","value":"allocationValue"}},{"kind":"Field","name":{"kind":"Name","value":"fkAccountAssignmentCategory"}},{"kind":"Field","name":{"kind":"Name","value":"fkAccountAssignment"}},{"kind":"Field","name":{"kind":"Name","value":"fkGeneralLedgerAccount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sourceReferences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fkSourceSystem"}},{"kind":"Field","name":{"kind":"Name","value":"isPrimary"}},{"kind":"Field","name":{"kind":"Name","value":"sourceContext"}},{"kind":"Field","name":{"kind":"Name","value":"sourceReference"}},{"kind":"Field","name":{"kind":"Name","value":"sourceReferenceItem"}},{"kind":"Field","name":{"kind":"Name","value":"synchronizedAt"}}]}}]}}]}}]} as unknown as DocumentNode<SavingsListQuery, SavingsListQueryVariables>;
export const CreateSavingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateSaving"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SavingInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createSaving"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"savingType"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"baselinePrice"}},{"kind":"Field","name":{"kind":"Name","value":"newPrice"}},{"kind":"Field","name":{"kind":"Name","value":"baselineQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"newQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"validFrom"}},{"kind":"Field","name":{"kind":"Name","value":"validTo"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"fkBuyer"}},{"kind":"Field","name":{"kind":"Name","value":"fkSupplier"}},{"kind":"Field","name":{"kind":"Name","value":"fkCommodityGroup"}},{"kind":"Field","name":{"kind":"Name","value":"freeTextCommodity"}},{"kind":"Field","name":{"kind":"Name","value":"fkProcurementOrganization"}},{"kind":"Field","name":{"kind":"Name","value":"fkOrganization"}},{"kind":"Field","name":{"kind":"Name","value":"fkPurchasingGroup"}},{"kind":"Field","name":{"kind":"Name","value":"fkAccountingArea"}},{"kind":"Field","name":{"kind":"Name","value":"fkUnit"}},{"kind":"Field","name":{"kind":"Name","value":"originalPriceQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"newPriceQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"reductionType"}},{"kind":"Field","name":{"kind":"Name","value":"costAllocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"distributionType"}},{"kind":"Field","name":{"kind":"Name","value":"allocationValue"}},{"kind":"Field","name":{"kind":"Name","value":"fkAccountAssignmentCategory"}},{"kind":"Field","name":{"kind":"Name","value":"fkAccountAssignment"}},{"kind":"Field","name":{"kind":"Name","value":"fkGeneralLedgerAccount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sourceReferences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fkSourceSystem"}},{"kind":"Field","name":{"kind":"Name","value":"isPrimary"}},{"kind":"Field","name":{"kind":"Name","value":"sourceContext"}},{"kind":"Field","name":{"kind":"Name","value":"sourceReference"}},{"kind":"Field","name":{"kind":"Name","value":"sourceReferenceItem"}},{"kind":"Field","name":{"kind":"Name","value":"synchronizedAt"}}]}}]}}]}}]} as unknown as DocumentNode<CreateSavingMutation, CreateSavingMutationVariables>;
export const UpdateSavingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateSaving"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SavingInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateSaving"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"savingType"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"baselinePrice"}},{"kind":"Field","name":{"kind":"Name","value":"newPrice"}},{"kind":"Field","name":{"kind":"Name","value":"baselineQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"newQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"validFrom"}},{"kind":"Field","name":{"kind":"Name","value":"validTo"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"fkBuyer"}},{"kind":"Field","name":{"kind":"Name","value":"fkSupplier"}},{"kind":"Field","name":{"kind":"Name","value":"fkCommodityGroup"}},{"kind":"Field","name":{"kind":"Name","value":"freeTextCommodity"}},{"kind":"Field","name":{"kind":"Name","value":"fkProcurementOrganization"}},{"kind":"Field","name":{"kind":"Name","value":"fkOrganization"}},{"kind":"Field","name":{"kind":"Name","value":"fkPurchasingGroup"}},{"kind":"Field","name":{"kind":"Name","value":"fkAccountingArea"}},{"kind":"Field","name":{"kind":"Name","value":"fkUnit"}},{"kind":"Field","name":{"kind":"Name","value":"originalPriceQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"newPriceQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"reductionType"}},{"kind":"Field","name":{"kind":"Name","value":"costAllocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"distributionType"}},{"kind":"Field","name":{"kind":"Name","value":"allocationValue"}},{"kind":"Field","name":{"kind":"Name","value":"fkAccountAssignmentCategory"}},{"kind":"Field","name":{"kind":"Name","value":"fkAccountAssignment"}},{"kind":"Field","name":{"kind":"Name","value":"fkGeneralLedgerAccount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sourceReferences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fkSourceSystem"}},{"kind":"Field","name":{"kind":"Name","value":"isPrimary"}},{"kind":"Field","name":{"kind":"Name","value":"sourceContext"}},{"kind":"Field","name":{"kind":"Name","value":"sourceReference"}},{"kind":"Field","name":{"kind":"Name","value":"sourceReferenceItem"}},{"kind":"Field","name":{"kind":"Name","value":"synchronizedAt"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateSavingMutation, UpdateSavingMutationVariables>;
export const GetSavingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSaving"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"saving"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"savingType"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"baselinePrice"}},{"kind":"Field","name":{"kind":"Name","value":"newPrice"}},{"kind":"Field","name":{"kind":"Name","value":"baselineQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"newQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"validFrom"}},{"kind":"Field","name":{"kind":"Name","value":"validTo"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"fkBuyer"}},{"kind":"Field","name":{"kind":"Name","value":"fkSupplier"}},{"kind":"Field","name":{"kind":"Name","value":"fkCommodityGroup"}},{"kind":"Field","name":{"kind":"Name","value":"freeTextCommodity"}},{"kind":"Field","name":{"kind":"Name","value":"fkProcurementOrganization"}},{"kind":"Field","name":{"kind":"Name","value":"fkOrganization"}},{"kind":"Field","name":{"kind":"Name","value":"fkPurchasingGroup"}},{"kind":"Field","name":{"kind":"Name","value":"fkAccountingArea"}},{"kind":"Field","name":{"kind":"Name","value":"fkUnit"}},{"kind":"Field","name":{"kind":"Name","value":"originalPriceQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"newPriceQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"reductionType"}},{"kind":"Field","name":{"kind":"Name","value":"costAllocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"distributionType"}},{"kind":"Field","name":{"kind":"Name","value":"allocationValue"}},{"kind":"Field","name":{"kind":"Name","value":"fkAccountAssignmentCategory"}},{"kind":"Field","name":{"kind":"Name","value":"fkAccountAssignment"}},{"kind":"Field","name":{"kind":"Name","value":"fkGeneralLedgerAccount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sourceReferences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fkSourceSystem"}},{"kind":"Field","name":{"kind":"Name","value":"isPrimary"}},{"kind":"Field","name":{"kind":"Name","value":"sourceContext"}},{"kind":"Field","name":{"kind":"Name","value":"sourceReference"}},{"kind":"Field","name":{"kind":"Name","value":"sourceReferenceItem"}},{"kind":"Field","name":{"kind":"Name","value":"synchronizedAt"}}]}}]}}]}}]} as unknown as DocumentNode<GetSavingQuery, GetSavingQueryVariables>;
export const SavingHistoryQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SavingHistoryQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"entityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"telescope"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"logEntries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"entityId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"entityId"}}},{"kind":"Argument","name":{"kind":"Name","value":"entityVariant"},"value":{"kind":"EnumValue","value":"SAVING"}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"includeChildren"},"value":{"kind":"BooleanValue","value":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actorId"}},{"kind":"Field","name":{"kind":"Name","value":"actorVariant"}},{"kind":"Field","name":{"kind":"Name","value":"context"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"entityId"}},{"kind":"Field","name":{"kind":"Name","value":"entityVariant"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"parentVariant"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"template"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}}]} as unknown as DocumentNode<SavingHistoryQueryQuery, SavingHistoryQueryQueryVariables>;
export const TesseractSourcingCaseResubmitDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TesseractSourcingCaseResubmit"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sourcingCase"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resubmit"}}]}}]}}]}}]} as unknown as DocumentNode<TesseractSourcingCaseResubmitMutation, TesseractSourcingCaseResubmitMutationVariables>;
export const SourcingCaseIssuesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SourcingCaseIssues"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sourcingCase"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"issues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"variant"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]}}]} as unknown as DocumentNode<SourcingCaseIssuesQuery, SourcingCaseIssuesQueryVariables>;
export const UserAvailabilityListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserAvailabilityList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dateRange"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AstroDateRangeInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AstroQueryBuilderQuery"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AstroUserAvailabilityOrder"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"astronaut"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userAvailability"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"dateRange"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateRange"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"columns"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"weekStart"}},{"kind":"Field","name":{"kind":"Name","value":"weekEnd"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"pictureId"}},{"kind":"Field","name":{"kind":"Name","value":"workingHours"}}]}},{"kind":"Field","name":{"kind":"Name","value":"availabilityPerWeek"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"weekStart"}},{"kind":"Field","name":{"kind":"Name","value":"availability"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<UserAvailabilityListQuery, UserAvailabilityListQueryVariables>;
export const DeleteAbsenceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteAbsence"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"astronaut"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"absence"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}]}}]}}]}}]}}]} as unknown as DocumentNode<DeleteAbsenceMutation, DeleteAbsenceMutationVariables>;
export const LoadAbsencesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LoadAbsences"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AstroAbsenceListWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"astronaut"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primarySourceReference"}},{"kind":"Field","name":{"kind":"Name","value":"absences"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<LoadAbsencesQuery, LoadAbsencesQueryVariables>;
export const UpsertAbsenceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertAbsence"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AstroAbsenceInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"astronaut"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"absence"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upsert"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpsertAbsenceMutation, UpsertAbsenceMutationVariables>;
export const UpdateUserProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateUserProfile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AstroUserProfileInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"astronaut"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"capabilityIds"}},{"kind":"Field","name":{"kind":"Name","value":"commodityGroupIds"}},{"kind":"Field","name":{"kind":"Name","value":"workingHours"}},{"kind":"Field","name":{"kind":"Name","value":"deliveryLocationId"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"accountingAreaId"}},{"kind":"Field","name":{"kind":"Name","value":"costCenterId"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"pictureId"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateUserProfileMutation, UpdateUserProfileMutationVariables>;
export const ContractDemandAwardSuppliersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ContractDemandAwardSuppliers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TsrctContractDemandAwardsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contractDemand"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"awardSuppliers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ContractDemandAwardSuppliersMutation, ContractDemandAwardSuppliersMutationVariables>;
export const ContractDemandAwardingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ContractDemandAwarding"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contractDemand"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"sequenceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"responsibleUserId"}},{"kind":"Field","name":{"kind":"Name","value":"tagIds"}},{"kind":"Field","name":{"kind":"Name","value":"bestOfferQuoteItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sourcingCases"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"sequenceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"isAwardable"}},{"kind":"Field","name":{"kind":"Name","value":"supplier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"supplierId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"internalId"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"language"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"sourceReferences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sourceReference"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"quote"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"totalValue"}},{"kind":"Field","name":{"kind":"Name","value":"discount"}},{"kind":"Field","name":{"kind":"Name","value":"totalDiscountedValue"}},{"kind":"Field","name":{"kind":"Name","value":"totalPriceDiscount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"validFrom"}},{"kind":"Field","name":{"kind":"Name","value":"validTo"}},{"kind":"Field","name":{"kind":"Name","value":"lineItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"demandRequestItemId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"totalValue"}},{"kind":"Field","name":{"kind":"Name","value":"totalDiscountedValue"}},{"kind":"Field","name":{"kind":"Name","value":"pricePerUnit"}},{"kind":"Field","name":{"kind":"Name","value":"pricePerPriceUnit"}},{"kind":"Field","name":{"kind":"Name","value":"discountedPricePerUnit"}},{"kind":"Field","name":{"kind":"Name","value":"discountedPricePerPriceUnit"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"bidDeclinedReason"}},{"kind":"Field","name":{"kind":"Name","value":"bidDeclinedReasonText"}},{"kind":"Field","name":{"kind":"Name","value":"negotiationFailedReason"}},{"kind":"Field","name":{"kind":"Name","value":"negotiationFailedReasonText"}},{"kind":"Field","name":{"kind":"Name","value":"isAwardable"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"issues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"variant"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"competitiveBiddingRule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"variant"}},{"kind":"Field","name":{"kind":"Name","value":"biddingPeriodDays"}},{"kind":"Field","name":{"kind":"Name","value":"deadline"}},{"kind":"Field","name":{"kind":"Name","value":"deadlineExceeded"}}]}},{"kind":"Field","name":{"kind":"Name","value":"demandRequest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"requestedAt"}},{"kind":"Field","name":{"kind":"Name","value":"validityPeriod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}}]}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"totalValue"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"commodityGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"incoTermsId"}},{"kind":"Field","name":{"kind":"Name","value":"paymentTermsId"}},{"kind":"Field","name":{"kind":"Name","value":"lineItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"minimumOrderQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"baselinePricePerUnit"}},{"kind":"Field","name":{"kind":"Name","value":"baselinePricePerPriceUnit"}},{"kind":"Field","name":{"kind":"Name","value":"unitId"}},{"kind":"Field","name":{"kind":"Name","value":"priceUnit"}},{"kind":"Field","name":{"kind":"Name","value":"deliveryLocationId"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"commodityId"}},{"kind":"Field","name":{"kind":"Name","value":"commodityGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"totalValue"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ContractDemandAwardingQuery, ContractDemandAwardingQueryVariables>;
export const ContractDemandCasesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ContractDemandCases"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contractDemand"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"demandRequest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lineItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"qualifiedSuppliers"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"sourcingCases"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"cancellationReason"}},{"kind":"Field","name":{"kind":"Name","value":"cancellationReasonText"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"sequenceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"supplier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"supplierId"}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"internalId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"quote"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"totalValue"}},{"kind":"Field","name":{"kind":"Name","value":"totalDiscountedValue"}},{"kind":"Field","name":{"kind":"Name","value":"discount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"issues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"variant"}}]}},{"kind":"Field","name":{"kind":"Name","value":"latestComment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"authorId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ContractDemandCasesQuery, ContractDemandCasesQueryVariables>;
export const ContractDemandAddCasesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ContractDemandAddCases"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TsrctContractDemandAddSourcingCasesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contractDemand"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addSourcingCases"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sequenceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"supplier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"supplierId"}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"internalId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"quote"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"totalValue"}},{"kind":"Field","name":{"kind":"Name","value":"totalDiscountedValue"}},{"kind":"Field","name":{"kind":"Name","value":"discount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"issues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"variant"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ContractDemandAddCasesMutation, ContractDemandAddCasesMutationVariables>;
export const ReleaseSourcingCaseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ReleaseSourcingCase"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sourcingCase"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"release"}}]}}]}}]}}]} as unknown as DocumentNode<ReleaseSourcingCaseMutation, ReleaseSourcingCaseMutationVariables>;
export const ContractDemandDetailUnifiedUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ContractDemandDetailUnifiedUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"demandData"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TsrctDemandUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"competitiveBiddingRuleData"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TsrctCompetitiveBiddingRuleInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"demand"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"demandData"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"capabilityIds"}},{"kind":"Field","name":{"kind":"Name","value":"responsibleUserIds"}},{"kind":"Field","name":{"kind":"Name","value":"demandRequest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sourceReferences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"internalId"}},{"kind":"Field","name":{"kind":"Name","value":"sourceReference"}},{"kind":"Field","name":{"kind":"Name","value":"sourceSystem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isPrimary"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"permissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"write"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"competitiveBiddingRule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"competitiveBiddingRuleData"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"variant"}},{"kind":"Field","name":{"kind":"Name","value":"deadline"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ContractDemandDetailUnifiedUpdateMutation, ContractDemandDetailUnifiedUpdateMutationVariables>;
export const ContractDemandUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ContractDemandUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractDemandData"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TsrctContractDemandDetailsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contractDemand"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractDemandData"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"sequenceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"competitiveBiddingRule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"variant"}},{"kind":"Field","name":{"kind":"Name","value":"biddingPeriodDays"}},{"kind":"Field","name":{"kind":"Name","value":"deadline"}},{"kind":"Field","name":{"kind":"Name","value":"deadlineExceeded"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"responsibleUserId"}},{"kind":"Field","name":{"kind":"Name","value":"tagIds"}},{"kind":"Field","name":{"kind":"Name","value":"demandRequest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"commodityGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"incoTermsId"}},{"kind":"Field","name":{"kind":"Name","value":"requestedAt"}},{"kind":"Field","name":{"kind":"Name","value":"totalValue"}},{"kind":"Field","name":{"kind":"Name","value":"validityPeriod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}}]}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"paymentTermsId"}},{"kind":"Field","name":{"kind":"Name","value":"lineItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"baselinePricePerUnit"}},{"kind":"Field","name":{"kind":"Name","value":"commodityGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"commodityId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"deliveryLocationId"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"minimumOrderQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"unitId"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ContractDemandUpdateMutation, ContractDemandUpdateMutationVariables>;
export const ContractDemandDetailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ContractDemandDetail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contractDemand"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"sequenceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"competitiveBiddingRule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"variant"}},{"kind":"Field","name":{"kind":"Name","value":"biddingPeriodDays"}},{"kind":"Field","name":{"kind":"Name","value":"deadline"}},{"kind":"Field","name":{"kind":"Name","value":"deadlineExceeded"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"responsibleUserId"}},{"kind":"Field","name":{"kind":"Name","value":"tagIds"}},{"kind":"Field","name":{"kind":"Name","value":"demandRequest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"commodityGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"incoTermsId"}},{"kind":"Field","name":{"kind":"Name","value":"paymentTermsId"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"requestedAt"}},{"kind":"Field","name":{"kind":"Name","value":"totalValue"}},{"kind":"Field","name":{"kind":"Name","value":"validityPeriod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lineItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"baselinePricePerUnit"}},{"kind":"Field","name":{"kind":"Name","value":"commodityGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"commodityId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"deliveryLocationId"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"minimumOrderQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"unitId"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ContractDemandDetailQuery, ContractDemandDetailQueryVariables>;
export const ContractDemandFileAttachmentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ContractDemandFileAttachments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"parents"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TsrctAttachmentParentInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TsrctAttachmentFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attachments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"parents"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parents"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FileAttachment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FileAttachment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TsrctAttachment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"variant"}}]}},{"kind":"Field","name":{"kind":"Name","value":"visibilities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"variant"}}]}},{"kind":"Field","name":{"kind":"Name","value":"classification"}},{"kind":"Field","name":{"kind":"Name","value":"uploadedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"variant"}}]}}]}}]} as unknown as DocumentNode<ContractDemandFileAttachmentsQuery, ContractDemandFileAttachmentsQueryVariables>;
export const ContractDemandFileAttachmentsDemandDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ContractDemandFileAttachmentsDemand"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"demandId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contractDemand"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"demandId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"sourcingCases"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ContractDemandFileAttachmentsDemandQuery, ContractDemandFileAttachmentsDemandQueryVariables>;
export const ContractDemandRequestUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ContractDemandRequestUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"demandId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TsrctContractDemandRequestLineItemsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contractDemand"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"demandId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contractDemandRequest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateLineItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"lineItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"deliveryLocationId"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"unitId"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"commodityGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"commodityId"}},{"kind":"Field","name":{"kind":"Name","value":"baselinePricePerUnit"}},{"kind":"Field","name":{"kind":"Name","value":"baselinePricePerPriceUnit"}},{"kind":"Field","name":{"kind":"Name","value":"minimumOrderQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"priceUnit"}},{"kind":"Field","name":{"kind":"Name","value":"qualifiedSuppliers"}},{"kind":"Field","name":{"kind":"Name","value":"totalValue"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ContractDemandRequestUpdateMutation, ContractDemandRequestUpdateMutationVariables>;
export const TsrctContractDemandRequestDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TsrctContractDemandRequest"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contractDemand"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"demandRequest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"lineItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"deliveryLocationId"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"unitId"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"commodityGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"commodityId"}},{"kind":"Field","name":{"kind":"Name","value":"baselinePricePerUnit"}},{"kind":"Field","name":{"kind":"Name","value":"baselinePricePerPriceUnit"}},{"kind":"Field","name":{"kind":"Name","value":"minimumOrderQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"priceUnit"}},{"kind":"Field","name":{"kind":"Name","value":"qualifiedSuppliers"}},{"kind":"Field","name":{"kind":"Name","value":"totalValue"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<TsrctContractDemandRequestQuery, TsrctContractDemandRequestQueryVariables>;
export const ContractDemandCreateFromCoveragePredictionWithRuleBuilderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ContractDemandCreateFromCoveragePredictionWithRuleBuilder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TsrctContractDemandCreateFromCoveragePredictionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"contractDemandCreateFromCoveragePrediction"},"name":{"kind":"Name","value":"contractDemandCreateFromCoveragePredictionV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sequenceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"tagIds"}},{"kind":"Field","name":{"kind":"Name","value":"responsibleUserId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"competitiveBiddingRule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"variant"}}]}},{"kind":"Field","name":{"kind":"Name","value":"demandRequest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"requestedAt"}},{"kind":"Field","name":{"kind":"Name","value":"totalValue"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ContractDemandCreateFromCoveragePredictionWithRuleBuilderMutation, ContractDemandCreateFromCoveragePredictionWithRuleBuilderMutationVariables>;
export const CommodityUndercoveragesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CommodityUndercoverages"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"timeframeFrom"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"timeframeTo"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"commodityGroupIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"commodityIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"maxResults"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Language"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"commodityUndercoverages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"timeframeFrom"},"value":{"kind":"Variable","name":{"kind":"Name","value":"timeframeFrom"}}},{"kind":"Argument","name":{"kind":"Name","value":"timeframeTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"timeframeTo"}}},{"kind":"Argument","name":{"kind":"Name","value":"commodityGroupIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"commodityGroupIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"organizationIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"commodityIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"commodityIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"maxResults"},"value":{"kind":"Variable","name":{"kind":"Name","value":"maxResults"}}},{"kind":"Argument","name":{"kind":"Name","value":"languageCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"undercoverages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"commodityId"}},{"kind":"Field","name":{"kind":"Name","value":"commodityGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"undercoveredQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"unitId"}},{"kind":"Field","name":{"kind":"Name","value":"priceUnit"}},{"kind":"Field","name":{"kind":"Name","value":"validFrom"}},{"kind":"Field","name":{"kind":"Name","value":"validTo"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"minimumOrderQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"qualifiedSupplierIds"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageSize"}}]}}]}}]} as unknown as DocumentNode<CommodityUndercoveragesQuery, CommodityUndercoveragesQueryVariables>;
export const SourcingCaseInternalFileAttachmentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SourcingCaseInternalFileAttachments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"parents"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TsrctAttachmentParentInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TsrctAttachmentFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attachments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"parents"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parents"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FileAttachment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FileAttachment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TsrctAttachment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"variant"}}]}},{"kind":"Field","name":{"kind":"Name","value":"visibilities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"variant"}}]}},{"kind":"Field","name":{"kind":"Name","value":"classification"}},{"kind":"Field","name":{"kind":"Name","value":"uploadedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"variant"}}]}}]}}]} as unknown as DocumentNode<SourcingCaseInternalFileAttachmentsQuery, SourcingCaseInternalFileAttachmentsQueryVariables>;
export const SourcingCaseInternalFileAttachmentsCaseAndDemandDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SourcingCaseInternalFileAttachmentsCaseAndDemand"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sourcingCaseId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sourcingCase"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sourcingCaseId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"demand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<SourcingCaseInternalFileAttachmentsCaseAndDemandQuery, SourcingCaseInternalFileAttachmentsCaseAndDemandQueryVariables>;
export const SourcingCaseContactUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SourcingCaseContactUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TsrctSourcingCaseContactInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sourcingCase"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateContactDetails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"supplier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"supplierId"}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"internalId"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"language"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<SourcingCaseContactUpdateMutation, SourcingCaseContactUpdateMutationVariables>;
export const SourcingCaseContactDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SourcingCaseContact"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sourcingCase"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"supplier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"supplierId"}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"internalId"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"language"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<SourcingCaseContactQuery, SourcingCaseContactQueryVariables>;
export const SourcingCaseFlowDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SourcingCaseFlow"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sourcingCase"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"flow"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"steps"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"variant"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"hidden"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<SourcingCaseFlowQuery, SourcingCaseFlowQueryVariables>;
export const SourcingCaseNegotiationSettingsMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SourcingCaseNegotiationSettingsMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TsrctSourcingCaseNegotiationSettingsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sourcingCase"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateNegotiationSettings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isNegotiationEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"negotiationOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"initiatedBy"}},{"kind":"Field","name":{"kind":"Name","value":"negotiationObjective"}},{"kind":"Field","name":{"kind":"Name","value":"supplierInteractionMode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"negotiationStrategy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"boundaryRules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"base"}},{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}}]}},{"kind":"Field","name":{"kind":"Name","value":"useHistoricNegotiationData"}},{"kind":"Field","name":{"kind":"Name","value":"useHistoricTenderData"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<SourcingCaseNegotiationSettingsMutationMutation, SourcingCaseNegotiationSettingsMutationMutationVariables>;
export const SourcingCaseNegotiationSettingsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SourcingCaseNegotiationSettingsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sourcingCase"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"isNegotiationEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"isSupplierUploadAllowed"}},{"kind":"Field","name":{"kind":"Name","value":"negotiationOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"initiatedBy"}},{"kind":"Field","name":{"kind":"Name","value":"negotiationObjective"}},{"kind":"Field","name":{"kind":"Name","value":"supplierInteractionMode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"negotiationStrategy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"boundaryRules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"base"}},{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}}]}},{"kind":"Field","name":{"kind":"Name","value":"useHistoricNegotiationData"}},{"kind":"Field","name":{"kind":"Name","value":"useHistoricTenderData"}}]}}]}}]}}]}}]} as unknown as DocumentNode<SourcingCaseNegotiationSettingsQueryQuery, SourcingCaseNegotiationSettingsQueryQueryVariables>;
export const UpdateSourcingCaseQuoteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateSourcingCaseQuote"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TsrctSourcingCaseQuoteInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sourcingCase"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateQuote"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sequenceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"supplier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"supplierId"}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"internalId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"quote"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"supplierReference"}},{"kind":"Field","name":{"kind":"Name","value":"validFrom"}},{"kind":"Field","name":{"kind":"Name","value":"validTo"}},{"kind":"Field","name":{"kind":"Name","value":"paymentTermsId"}},{"kind":"Field","name":{"kind":"Name","value":"incoTermsId"}},{"kind":"Field","name":{"kind":"Name","value":"lineItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sequence"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"unitId"}},{"kind":"Field","name":{"kind":"Name","value":"commodityId"}},{"kind":"Field","name":{"kind":"Name","value":"deliveryLocationId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"priceUnit"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateSourcingCaseQuoteMutation, UpdateSourcingCaseQuoteMutationVariables>;
export const SourcingCaseQuoteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SourcingCaseQuote"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sourcingCase"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"sequenceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isNegotiationEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"isSupplierUploadAllowed"}},{"kind":"Field","name":{"kind":"Name","value":"isAwardable"}},{"kind":"Field","name":{"kind":"Name","value":"issues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"variant"}}]}},{"kind":"Field","name":{"kind":"Name","value":"supplier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"supplierId"}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"internalId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"quote"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"supplierReference"}},{"kind":"Field","name":{"kind":"Name","value":"validFrom"}},{"kind":"Field","name":{"kind":"Name","value":"validTo"}},{"kind":"Field","name":{"kind":"Name","value":"paymentTermsId"}},{"kind":"Field","name":{"kind":"Name","value":"incoTermsId"}},{"kind":"Field","name":{"kind":"Name","value":"lineItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sequence"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"unitId"}},{"kind":"Field","name":{"kind":"Name","value":"commodityId"}},{"kind":"Field","name":{"kind":"Name","value":"deliveryLocationId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"priceUnit"}},{"kind":"Field","name":{"kind":"Name","value":"pricePerPriceUnit"}},{"kind":"Field","name":{"kind":"Name","value":"pricePerUnit"}},{"kind":"Field","name":{"kind":"Name","value":"minimumOrderQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"discountedPricePerUnit"}},{"kind":"Field","name":{"kind":"Name","value":"discountedPricePerPriceUnit"}},{"kind":"Field","name":{"kind":"Name","value":"totalDiscountedValue"}},{"kind":"Field","name":{"kind":"Name","value":"totalValue"}},{"kind":"Field","name":{"kind":"Name","value":"demandRequestItemId"}},{"kind":"Field","name":{"kind":"Name","value":"bidDeclinedReason"}},{"kind":"Field","name":{"kind":"Name","value":"bidDeclinedReasonText"}},{"kind":"Field","name":{"kind":"Name","value":"isAwardable"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<SourcingCaseQuoteQuery, SourcingCaseQuoteQueryVariables>;
export const SourcingCaseSupplierFileAttachmentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SourcingCaseSupplierFileAttachments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sourcingCaseId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"parents"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TsrctAttachmentParentInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TsrctAttachmentFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attachments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"parents"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parents"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FileAttachment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sourcingCase"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sourcingCaseId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FileAttachment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TsrctAttachment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"variant"}}]}},{"kind":"Field","name":{"kind":"Name","value":"visibilities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"variant"}}]}},{"kind":"Field","name":{"kind":"Name","value":"classification"}},{"kind":"Field","name":{"kind":"Name","value":"uploadedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"variant"}}]}}]}}]} as unknown as DocumentNode<SourcingCaseSupplierFileAttachmentsQuery, SourcingCaseSupplierFileAttachmentsQueryVariables>;
export const TesseractDemandDocumentCreateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TesseractDemandDocumentCreate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TsrctFileInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"demand"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"create"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isSharedWithSupplier"}},{"kind":"Field","name":{"kind":"Name","value":"quoteId"}},{"kind":"Field","name":{"kind":"Name","value":"negotiationCaseId"}},{"kind":"Field","name":{"kind":"Name","value":"negotiationCaseSequence"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<TesseractDemandDocumentCreateMutation, TesseractDemandDocumentCreateMutationVariables>;
export const FilesByDemandDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FilesByDemand"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"demand"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isSharedWithSupplier"}},{"kind":"Field","name":{"kind":"Name","value":"quoteId"}},{"kind":"Field","name":{"kind":"Name","value":"negotiationCaseId"}},{"kind":"Field","name":{"kind":"Name","value":"negotiationCaseSequence"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"permissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"read"}},{"kind":"Field","name":{"kind":"Name","value":"write"}},{"kind":"Field","name":{"kind":"Name","value":"assign"}}]}},{"kind":"Field","name":{"kind":"Name","value":"negotiationCases"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<FilesByDemandQuery, FilesByDemandQueryVariables>;
export const TesseractDemandDocumentsUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TesseractDemandDocumentsUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"files"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TsrctFileInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"demand"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"files"},"value":{"kind":"Variable","name":{"kind":"Name","value":"files"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isSharedWithSupplier"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<TesseractDemandDocumentsUpdateMutation, TesseractDemandDocumentsUpdateMutationVariables>;
export const NegotiationSettingsMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"NegotiationSettingsMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TsrctNegotiationCaseNegotiationSettingsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"negotiationCase"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateNegotiationSettings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isNegotiationEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"isSupplierUploadAllowed"}},{"kind":"Field","name":{"kind":"Name","value":"lowerDiscountBoundary"}},{"kind":"Field","name":{"kind":"Name","value":"upperDiscountBoundary"}},{"kind":"Field","name":{"kind":"Name","value":"strategy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"useHistoricTenderData"}},{"kind":"Field","name":{"kind":"Name","value":"useHistoricNegotiationData"}},{"kind":"Field","name":{"kind":"Name","value":"boundaryRules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"base"}},{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}},{"kind":"Field","name":{"kind":"Name","value":"sequence"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"initiatedBy"}},{"kind":"Field","name":{"kind":"Name","value":"quoteMode"}},{"kind":"Field","name":{"kind":"Name","value":"negotiationMode"}},{"kind":"Field","name":{"kind":"Name","value":"supplierInteractionMode"}},{"kind":"Field","name":{"kind":"Name","value":"negotiationObjective"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<NegotiationSettingsMutationMutation, NegotiationSettingsMutationMutationVariables>;
export const QuoteSourcingCaseNegotiationSettingsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"QuoteSourcingCaseNegotiationSettingsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"negotiationCase"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isNegotiationEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"isSupplierUploadAllowed"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"processStatus"}},{"kind":"Field","name":{"kind":"Name","value":"supplier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"internalId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lowerDiscountBoundary"}},{"kind":"Field","name":{"kind":"Name","value":"upperDiscountBoundary"}},{"kind":"Field","name":{"kind":"Name","value":"strategy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"useHistoricTenderData"}},{"kind":"Field","name":{"kind":"Name","value":"useHistoricNegotiationData"}},{"kind":"Field","name":{"kind":"Name","value":"boundaryRules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"base"}},{"kind":"Field","name":{"kind":"Name","value":"lower"}},{"kind":"Field","name":{"kind":"Name","value":"upper"}},{"kind":"Field","name":{"kind":"Name","value":"sequence"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"initiatedBy"}},{"kind":"Field","name":{"kind":"Name","value":"quoteMode"}},{"kind":"Field","name":{"kind":"Name","value":"negotiationMode"}},{"kind":"Field","name":{"kind":"Name","value":"supplierInteractionMode"}},{"kind":"Field","name":{"kind":"Name","value":"negotiationObjective"}}]}},{"kind":"Field","name":{"kind":"Name","value":"demand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"negotiatedQuote"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"discount"}},{"kind":"Field","name":{"kind":"Name","value":"totalValue"}},{"kind":"Field","name":{"kind":"Name","value":"totalDiscountedValue"}},{"kind":"Field","name":{"kind":"Name","value":"totalPriceDiscount"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}}]}}]} as unknown as DocumentNode<QuoteSourcingCaseNegotiationSettingsQueryQuery, QuoteSourcingCaseNegotiationSettingsQueryQueryVariables>;
export const BaseCommodityGroupListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BaseCommodityGroupList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CommodityGroupSortOrder"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"commodityGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"orderVolumeCurrentYear"}},{"kind":"Field","name":{"kind":"Name","value":"orderCountCurrentYear"}},{"kind":"Field","name":{"kind":"Name","value":"orderVolumeLast12Months"}},{"kind":"Field","name":{"kind":"Name","value":"orderCountLast12Months"}},{"kind":"Field","name":{"kind":"Name","value":"orderVolumeLastYear"}},{"kind":"Field","name":{"kind":"Name","value":"orderCountLastYear"}},{"kind":"Field","name":{"kind":"Name","value":"orderVolumeShareCurrentYear"}},{"kind":"Field","name":{"kind":"Name","value":"orderVolumeShareLast12Months"}},{"kind":"Field","name":{"kind":"Name","value":"orderVolumeShareLastYear"}},{"kind":"Field","name":{"kind":"Name","value":"orderVolumeCumulativeCurrentYear"}},{"kind":"Field","name":{"kind":"Name","value":"orderVolumeCumulativeLast12Months"}},{"kind":"Field","name":{"kind":"Name","value":"orderVolumeCumulativeLastYear"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<BaseCommodityGroupListQuery, BaseCommodityGroupListQueryVariables>;
export const BaseCommodityListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BaseCommodityList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CommoditySortOrder"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skipExport"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"defaultValue":{"kind":"BooleanValue","value":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"commodities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"supplierCount"}},{"kind":"Field","name":{"kind":"Name","value":"supplierList"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skipExport"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contractCount"}},{"kind":"Field","name":{"kind":"Name","value":"contractList"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skipExport"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deliveryOnTimePercentage"}},{"kind":"Field","name":{"kind":"Name","value":"correctOrderPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"deviatingPricePercentage"}},{"kind":"Field","name":{"kind":"Name","value":"deviatingQuantityPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"deviatingPriceQuantityPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"leadTime"}},{"kind":"Field","name":{"kind":"Name","value":"orderVolume"}},{"kind":"Field","name":{"kind":"Name","value":"orderVolumeYear"}},{"kind":"Field","name":{"kind":"Name","value":"orderCount"}},{"kind":"Field","name":{"kind":"Name","value":"orderCountYear"}},{"kind":"Field","name":{"kind":"Name","value":"links"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skipExport"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"primaryCommodityGroup"}},{"kind":"Field","name":{"kind":"Name","value":"commodityGroupCount"}},{"kind":"Field","name":{"kind":"Name","value":"commodityGroupList"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skipExport"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<BaseCommodityListQuery, BaseCommodityListQueryVariables>;
export const BaseContractListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BaseContractList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ContractSortOrder"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skipExport"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"defaultValue":{"kind":"BooleanValue","value":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contracts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"supplierId"}},{"kind":"Field","name":{"kind":"Name","value":"supplierName"}},{"kind":"Field","name":{"kind":"Name","value":"supplierExternalId"}},{"kind":"Field","name":{"kind":"Name","value":"supplierIndustry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"supplierEmployeeCount"}},{"kind":"Field","name":{"kind":"Name","value":"supplierLegalType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"supplierAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contractReceivedProposalsCount"}},{"kind":"Field","name":{"kind":"Name","value":"contractAverageValueContribution"}},{"kind":"Field","name":{"kind":"Name","value":"contractActive"}},{"kind":"Field","name":{"kind":"Name","value":"contractCreationDate"}},{"kind":"Field","name":{"kind":"Name","value":"contractValidFrom"}},{"kind":"Field","name":{"kind":"Name","value":"contractValidTo"}},{"kind":"Field","name":{"kind":"Name","value":"contractProductCount"}},{"kind":"Field","name":{"kind":"Name","value":"contractProductList"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skipExport"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contractProductCategoryCount"}},{"kind":"Field","name":{"kind":"Name","value":"contractProductCategoryList"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skipExport"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contractServiceCount"}},{"kind":"Field","name":{"kind":"Name","value":"contractServiceList"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skipExport"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"representativeCount"}},{"kind":"Field","name":{"kind":"Name","value":"representativeList"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skipExport"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"orderVolume"}},{"kind":"Field","name":{"kind":"Name","value":"orderVolumeYear"}},{"kind":"Field","name":{"kind":"Name","value":"orderCount"}},{"kind":"Field","name":{"kind":"Name","value":"orderCountYear"}},{"kind":"Field","name":{"kind":"Name","value":"orderLastDate"}},{"kind":"Field","name":{"kind":"Name","value":"links"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skipExport"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<BaseContractListQuery, BaseContractListQueryVariables>;
export const BaseOrderListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BaseOrderList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderSortOrder"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skipExport"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"defaultValue":{"kind":"BooleanValue","value":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"supplierName"}},{"kind":"Field","name":{"kind":"Name","value":"supplierId"}},{"kind":"Field","name":{"kind":"Name","value":"supplierExternalId"}},{"kind":"Field","name":{"kind":"Name","value":"supplierIndustry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"supplierEmployeeCount"}},{"kind":"Field","name":{"kind":"Name","value":"supplierLegalType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"supplierAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contractReceivedProposalsCount"}},{"kind":"Field","name":{"kind":"Name","value":"contractAverageValueContribution"}},{"kind":"Field","name":{"kind":"Name","value":"orderCreationDate"}},{"kind":"Field","name":{"kind":"Name","value":"contractValidFrom"}},{"kind":"Field","name":{"kind":"Name","value":"contractValidTo"}},{"kind":"Field","name":{"kind":"Name","value":"orderProductCount"}},{"kind":"Field","name":{"kind":"Name","value":"orderProductList"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skipExport"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"orderProductCategoryCount"}},{"kind":"Field","name":{"kind":"Name","value":"orderProductCategoryList"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skipExport"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"orderServiceCount"}},{"kind":"Field","name":{"kind":"Name","value":"orderServiceList"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skipExport"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"representativeCount"}},{"kind":"Field","name":{"kind":"Name","value":"representativeList"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skipExport"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"orderVolume"}},{"kind":"Field","name":{"kind":"Name","value":"links"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skipExport"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"primaryCommodityGroup"}},{"kind":"Field","name":{"kind":"Name","value":"commodityGroupCount"}},{"kind":"Field","name":{"kind":"Name","value":"commodityGroupList"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skipExport"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<BaseOrderListQuery, BaseOrderListQueryVariables>;
export const BasePurchaseRequisitionListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BasePurchaseRequisitionList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PurchaseRequisitionSortOrder"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skipExport"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"defaultValue":{"kind":"BooleanValue","value":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"purchaseRequisitions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fixedSuppliersCount"}},{"kind":"Field","name":{"kind":"Name","value":"isBlocked"}},{"kind":"Field","name":{"kind":"Name","value":"lineItemsCount"}},{"kind":"Field","name":{"kind":"Name","value":"preferredSuppliersCount"}},{"kind":"Field","name":{"kind":"Name","value":"totalValue"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"primaryCommodityGroup"}},{"kind":"Field","name":{"kind":"Name","value":"commodityGroupCount"}},{"kind":"Field","name":{"kind":"Name","value":"commodityGroupList"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skipExport"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"links"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skipExport"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<BasePurchaseRequisitionListQuery, BasePurchaseRequisitionListQueryVariables>;
export const BaseSupplierListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BaseSupplierList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SupplierSortOrder"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skipExport"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"defaultValue":{"kind":"BooleanValue","value":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"suppliers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"orderCount"}},{"kind":"Field","name":{"kind":"Name","value":"orderCountYear"}},{"kind":"Field","name":{"kind":"Name","value":"orderVolume"}},{"kind":"Field","name":{"kind":"Name","value":"orderVolumeYear"}},{"kind":"Field","name":{"kind":"Name","value":"revenue"}},{"kind":"Field","name":{"kind":"Name","value":"ebit"}},{"kind":"Field","name":{"kind":"Name","value":"peRatio"}},{"kind":"Field","name":{"kind":"Name","value":"employeeCount"}},{"kind":"Field","name":{"kind":"Name","value":"quotationSuccessRate"}},{"kind":"Field","name":{"kind":"Name","value":"orderLastDate"}},{"kind":"Field","name":{"kind":"Name","value":"prequalificationLevel"}},{"kind":"Field","name":{"kind":"Name","value":"prequalificationTrades"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"locationGroupList"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"relationship"}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fax"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"website"}}]}},{"kind":"Field","name":{"kind":"Name","value":"industry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"legalType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}},{"kind":"Field","name":{"kind":"Name","value":"activeContractCount"}},{"kind":"Field","name":{"kind":"Name","value":"activeContractList"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skipExport"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"representativeCount"}},{"kind":"Field","name":{"kind":"Name","value":"representativeList"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skipExport"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"orderedProductCount"}},{"kind":"Field","name":{"kind":"Name","value":"orderedProductList"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skipExport"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"orderedServiceCount"}},{"kind":"Field","name":{"kind":"Name","value":"orderedServiceList"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skipExport"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"orderedProductInCategoryCount"}},{"kind":"Field","name":{"kind":"Name","value":"orderedProductInCategoryList"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skipExport"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"orderedServiceInCategoryCount"}},{"kind":"Field","name":{"kind":"Name","value":"orderedServiceInCategoryList"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skipExport"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"links"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skipExport"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tagCount"}},{"kind":"Field","name":{"kind":"Name","value":"tagList"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skipExport"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"commodityGroupCount"}},{"kind":"Field","name":{"kind":"Name","value":"commodityGroupList"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skipExport"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"orderVolumeCumulative"}},{"kind":"Field","name":{"kind":"Name","value":"orderVolumeCumulativeYear"}},{"kind":"Field","name":{"kind":"Name","value":"orderVolumeShare"}},{"kind":"Field","name":{"kind":"Name","value":"orderVolumeShareYear"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<BaseSupplierListQuery, BaseSupplierListQueryVariables>;
export const LocationGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LocationGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filterBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locationGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"filterBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filterBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"features"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"geometry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"coordinates"}}]}},{"kind":"Field","name":{"kind":"Name","value":"properties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}}]}}]} as unknown as DocumentNode<LocationGroupQuery, LocationGroupQueryVariables>;
export const SupplierGeoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SupplierGeo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"suppliersGeo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"features"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"geometry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"coordinates"}}]}},{"kind":"Field","name":{"kind":"Name","value":"properties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"relationship"}}]}}]}}]}}]}}]} as unknown as DocumentNode<SupplierGeoQuery, SupplierGeoQueryVariables>;
export const CmdiMetaColumnConfigDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CmdiMetaColumnConfig"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cmdi"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"meta_columnConfig"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"entityId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"columnName"}},{"kind":"Field","name":{"kind":"Name","value":"options"}},{"kind":"Field","name":{"kind":"Name","value":"variant"}},{"kind":"Field","name":{"kind":"Name","value":"i18n"}}]}}]}}]}}]} as unknown as DocumentNode<CmdiMetaColumnConfigQuery, CmdiMetaColumnConfigQueryVariables>;
export const CmdiMetaDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CmdiMeta"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cmdi"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"meta_entity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"i18n"}},{"kind":"Field","name":{"kind":"Name","value":"needsPermission"}}]}}]}}]}}]} as unknown as DocumentNode<CmdiMetaQuery, CmdiMetaQueryVariables>;
export const DemandSequenceNumberDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DemandSequenceNumber"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"demand"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sequenceNumber"}}]}}]}}]}}]} as unknown as DocumentNode<DemandSequenceNumberQuery, DemandSequenceNumberQueryVariables>;
export const IntakeChatThreadDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"IntakeChatThreadDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sevenbridges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"thread"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"messages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"parts"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}}]}}]} as unknown as DocumentNode<IntakeChatThreadDetailsQuery, IntakeChatThreadDetailsQueryVariables>;
export const CreateChatSessionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateChatSession"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SvbrgChatSessionCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sevenbridges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chatSession"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"create"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CreateChatSessionMutation, CreateChatSessionMutationVariables>;
export const CreateChatThreadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateChatThread"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SvbrgThreadCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sevenbridges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"thread"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"create"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CreateChatThreadMutation, CreateChatThreadMutationVariables>;
export const OnChatSessionCurrentStepDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"OnChatSessionCurrentStep"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sevenbridges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chatSession"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"demandId"}},{"kind":"Field","name":{"kind":"Name","value":"demandResponsibleUsers"}},{"kind":"Field","name":{"kind":"Name","value":"demandSequenceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"currentStep"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"variant"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"sequence"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"chatSessionId"}}]}}]}}]}}]}}]} as unknown as DocumentNode<OnChatSessionCurrentStepSubscription, OnChatSessionCurrentStepSubscriptionVariables>;
export const IntakeDetailQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"IntakeDetailQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sevenbridges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chatSession"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"demandId"}},{"kind":"Field","name":{"kind":"Name","value":"demandResponsibleUsers"}},{"kind":"Field","name":{"kind":"Name","value":"demandSequenceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"chatMessages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sequence"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"variant"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"role"}}]}}]}}]}}]}}]} as unknown as DocumentNode<IntakeDetailQueryQuery, IntakeDetailQueryQueryVariables>;
export const IntakeDiscardMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"IntakeDiscardMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SvbrgChatSessionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sevenbridges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chatSession"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"discard"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]}}]} as unknown as DocumentNode<IntakeDiscardMutationMutation, IntakeDiscardMutationMutationVariables>;
export const SupplierContactDetailsUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SupplierContactDetailsUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"contact_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cmdi"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_contact_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"contact_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"id"},{"kind":"EnumValue","value":"title"},{"kind":"EnumValue","value":"firstName"},{"kind":"EnumValue","value":"lastName"},{"kind":"EnumValue","value":"email"},{"kind":"EnumValue","value":"role"},{"kind":"EnumValue","value":"preferredLanguage"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"supplierId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"preferredLanguage"}}]}}]}}]}}]} as unknown as DocumentNode<SupplierContactDetailsUpdateMutation, SupplierContactDetailsUpdateMutationVariables>;
export const SupplierContactDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SupplierContactDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cmdi"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contact"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"supplierId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"preferredLanguage"}}]}}]}}]}}]} as unknown as DocumentNode<SupplierContactDetailsQuery, SupplierContactDetailsQueryVariables>;
export const IntakeAttachmentsUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"IntakeAttachmentsUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SvbrgAttachmentUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sevenbridges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chatSession"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attachment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"isVisible"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<IntakeAttachmentsUpdateMutation, IntakeAttachmentsUpdateMutationVariables>;
export const IntakeAttachmentsNextDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"IntakeAttachmentsNext"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SvbrgAttachmentNextInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sevenbridges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chatSession"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attachment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"next"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<IntakeAttachmentsNextMutation, IntakeAttachmentsNextMutationVariables>;
export const IntakeAttachmentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"IntakeAttachments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sevenbridges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chatSession"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"attachments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"isVisible"}}]}}]}}]}}]}}]} as unknown as DocumentNode<IntakeAttachmentsQuery, IntakeAttachmentsQueryVariables>;
export const IntakeBudgetMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"IntakeBudgetMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SvbrgRequestBudgetInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sevenbridges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chatSession"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"budget"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"next"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountingAreaId"}},{"kind":"Field","name":{"kind":"Name","value":"budget"}},{"kind":"Field","name":{"kind":"Name","value":"commodityGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"costCenterId"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"deliveryLocationId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lineItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"commodityGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"unitId"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"earlyDeliveryAt"}},{"kind":"Field","name":{"kind":"Name","value":"expectedPricePerUnit"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lateDeliveryAt"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"sequence"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<IntakeBudgetMutationMutation, IntakeBudgetMutationMutationVariables>;
export const IntakeBudgetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"IntakeBudget"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sevenbridges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chatSession"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"request"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"budget"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"quote"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"quotedValue"}}]}}]}}]}}]}}]} as unknown as DocumentNode<IntakeBudgetQuery, IntakeBudgetQueryVariables>;
export const IntakeChatRequestDescriptionStepMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"IntakeChatRequestDescriptionStepMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SvbrgRequestDescriptionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sevenbridges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chatSession"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requestDescription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createInChat"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<IntakeChatRequestDescriptionStepMutationMutation, IntakeChatRequestDescriptionStepMutationMutationVariables>;
export const IntakeChatRequestDescriptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"IntakeChatRequestDescription"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sevenbridges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chatSession"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"requestDescription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"language"}}]}}]}}]}}]}}]} as unknown as DocumentNode<IntakeChatRequestDescriptionQuery, IntakeChatRequestDescriptionQueryVariables>;
export const IntakeChatRequestMessageStepMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"IntakeChatRequestMessageStepMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SvbrgChatRequestMessageInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sevenbridges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chatSession"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chatRequestMessage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"generate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<IntakeChatRequestMessageStepMutationMutation, IntakeChatRequestMessageStepMutationMutationVariables>;
export const IntakeExtendedLineItemsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"IntakeExtendedLineItems"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SvbrgExtendedLineItemsCheckInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sevenbridges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chatSession"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"extendedLineItemsCheck"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkLineItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chatSessionId"}},{"kind":"Field","name":{"kind":"Name","value":"checks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"chatSessionId"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"pricePerUnit"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"earlyDeliveryAt"}},{"kind":"Field","name":{"kind":"Name","value":"lateDeliveryAt"}},{"kind":"Field","name":{"kind":"Name","value":"checkResults"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogueItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"deliveryTime"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"inStock"}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"previewImage"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"punchoutUrl"}},{"kind":"Field","name":{"kind":"Name","value":"shippingCosts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contractItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"plannedValueFloat"}},{"kind":"Field","name":{"kind":"Name","value":"supplierId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"plannedQuantityFloat"}},{"kind":"Field","name":{"kind":"Name","value":"pricePerUnitFloat"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<IntakeExtendedLineItemsMutation, IntakeExtendedLineItemsMutationVariables>;
export const IntakeExtendedLineItemsNextDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"IntakeExtendedLineItemsNext"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SvbrgExtendedLineItemsCheckNextInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sevenbridges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chatSession"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"extendedLineItemsCheck"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"next"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<IntakeExtendedLineItemsNextMutation, IntakeExtendedLineItemsNextMutationVariables>;
export const IntakeExtendedLineItemsCheckDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"IntakeExtendedLineItemsCheck"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sevenbridges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chatSession"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"extendedLineItemChecks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"chatSessionId"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"pricePerUnit"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"earlyDeliveryAt"}},{"kind":"Field","name":{"kind":"Name","value":"lateDeliveryAt"}},{"kind":"Field","name":{"kind":"Name","value":"checkResults"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogueItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"deliveryTime"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"inStock"}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"previewImage"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"punchoutUrl"}},{"kind":"Field","name":{"kind":"Name","value":"shippingCosts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contractItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"plannedValueFloat"}},{"kind":"Field","name":{"kind":"Name","value":"supplierId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"plannedQuantityFloat"}},{"kind":"Field","name":{"kind":"Name","value":"pricePerUnitFloat"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"commodityGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"unitId"}}]}}]}}]}}]}}]} as unknown as DocumentNode<IntakeExtendedLineItemsCheckQuery, IntakeExtendedLineItemsCheckQueryVariables>;
export const IntakeStatementsOfWorkUpsertMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"IntakeStatementsOfWorkUpsertMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SvbrgStatementOfWorkUpsertInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sevenbridges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chatSession"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"statementOfWork"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upsert"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"language"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<IntakeStatementsOfWorkUpsertMutationMutation, IntakeStatementsOfWorkUpsertMutationMutationVariables>;
export const IntakeStatementsOfWorkNextMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"IntakeStatementsOfWorkNextMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SvbrgStatementOfWorkNextInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sevenbridges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chatSession"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"statementOfWork"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"next"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}]}]}}]}}]}}]}}]} as unknown as DocumentNode<IntakeStatementsOfWorkNextMutationMutation, IntakeStatementsOfWorkNextMutationMutationVariables>;
export const IntakeStatementsOfWorkDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"IntakeStatementsOfWork"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sevenbridges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chatSession"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"statementsOfWork"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}},{"kind":"Field","name":{"kind":"Name","value":"requestDescription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"language"}}]}}]}}]}}]}}]} as unknown as DocumentNode<IntakeStatementsOfWorkQuery, IntakeStatementsOfWorkQueryVariables>;
export const SelectIntentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SelectIntent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SvbrgChatSessionSelectIntentInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sevenbridges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chatSession"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"selectIntent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<SelectIntentMutation, SelectIntentMutationVariables>;
export const IntakeNuclearComplianceFormSubmitDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"IntakeNuclearComplianceFormSubmit"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chatSessionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sevenbridges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chatSession"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"request"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"submitComplianceFormData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"chatSessionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chatSessionId"}}},{"kind":"Argument","name":{"kind":"Name","value":"complianceFormData"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"complianceFormData"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<IntakeNuclearComplianceFormSubmitMutation, IntakeNuclearComplianceFormSubmitMutationVariables>;
export const IntakeNuclearComplianceFormDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"IntakeNuclearComplianceForm"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sevenbridges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chatSession"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"request"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"complianceFormData"}}]}}]}}]}}]}}]} as unknown as DocumentNode<IntakeNuclearComplianceFormQuery, IntakeNuclearComplianceFormQueryVariables>;
export const IntakeQuoteComplianceMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"IntakeQuoteComplianceMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SvbrgQuoteComplianceNextInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sevenbridges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chatSession"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quoteCompliance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"next"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"chatSessionId"}},{"kind":"Field","name":{"kind":"Name","value":"quoteId"}},{"kind":"Field","name":{"kind":"Name","value":"score"}},{"kind":"Field","name":{"kind":"Name","value":"userComment"}},{"kind":"Field","name":{"kind":"Name","value":"userReason"}},{"kind":"Field","name":{"kind":"Name","value":"complianceData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"parts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"details"}},{"kind":"Field","name":{"kind":"Name","value":"section"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"sourceFileName"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<IntakeQuoteComplianceMutationMutation, IntakeQuoteComplianceMutationMutationVariables>;
export const IntakeQuoteComplianceQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"IntakeQuoteComplianceQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sevenbridges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chatSession"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"quote"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"analysis"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fileId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"quoteCompliance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"chatSessionId"}},{"kind":"Field","name":{"kind":"Name","value":"quoteId"}},{"kind":"Field","name":{"kind":"Name","value":"score"}},{"kind":"Field","name":{"kind":"Name","value":"userComment"}},{"kind":"Field","name":{"kind":"Name","value":"userReason"}},{"kind":"Field","name":{"kind":"Name","value":"complianceData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"parts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"details"}},{"kind":"Field","name":{"kind":"Name","value":"section"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"sourceFileName"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<IntakeQuoteComplianceQueryQuery, IntakeQuoteComplianceQueryQueryVariables>;
export const IntakeQuoteStepCreateMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"IntakeQuoteStepCreateMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SvbrgQuoteDraftInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sevenbridges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chatSession"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quote"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"next"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"quoteReference"}},{"kind":"Field","name":{"kind":"Name","value":"quotedValue"}},{"kind":"Field","name":{"kind":"Name","value":"lineItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"earlyDeliveryAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lateDeliveryAt"}},{"kind":"Field","name":{"kind":"Name","value":"pricePerUnit"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"sequence"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"unitId"}},{"kind":"Field","name":{"kind":"Name","value":"commodityGroupId"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<IntakeQuoteStepCreateMutationMutation, IntakeQuoteStepCreateMutationMutationVariables>;
export const IntakeQuoteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"IntakeQuote"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sevenbridges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chatSession"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"request"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"commodityGroupId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"quote"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"quoteReference"}},{"kind":"Field","name":{"kind":"Name","value":"lineItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"pricePerUnit"}},{"kind":"Field","name":{"kind":"Name","value":"unitId"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"sequence"}},{"kind":"Field","name":{"kind":"Name","value":"earlyDeliveryAt"}},{"kind":"Field","name":{"kind":"Name","value":"lateDeliveryAt"}},{"kind":"Field","name":{"kind":"Name","value":"commodityGroupId"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<IntakeQuoteQuery, IntakeQuoteQueryVariables>;
export const IntakeConfirmSupplierSelectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"IntakeConfirmSupplierSelection"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SvbrgIntakeRequestSupplierAddInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sevenbridges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chatSession"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"supplierSelection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"confirmQuotedSupplier"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"internalId"}},{"kind":"Field","name":{"kind":"Name","value":"isQuoted"}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"internalId"}},{"kind":"Field","name":{"kind":"Name","value":"language"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"internalId"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<IntakeConfirmSupplierSelectionMutation, IntakeConfirmSupplierSelectionMutationVariables>;
export const IntakeQuoteSupplierConfirmationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"IntakeQuoteSupplierConfirmation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sevenbridges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chatSession"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"variant"}},{"kind":"Field","name":{"kind":"Name","value":"suppliers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"internalId"}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"internalId"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"internalId"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isQuoted"}}]}}]}}]}}]}}]} as unknown as DocumentNode<IntakeQuoteSupplierConfirmationQuery, IntakeQuoteSupplierConfirmationQueryVariables>;
export const IntakeQuoteUploadStepMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"IntakeQuoteUploadStepMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SvbrgQuoteAnalysisInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sevenbridges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chatSession"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quote"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"analyse"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fileId"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<IntakeQuoteUploadStepMutationMutation, IntakeQuoteUploadStepMutationMutationVariables>;
export const IntakeQuoteUploadSkipDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"IntakeQuoteUploadSkip"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SvbrgChatSessionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sevenbridges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chatSession"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quote"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}]}]}}]}}]}}]}}]} as unknown as DocumentNode<IntakeQuoteUploadSkipMutation, IntakeQuoteUploadSkipMutationVariables>;
export const IntakeQuoteAnaylsisDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"IntakeQuoteAnaylsis"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sevenbridges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chatSession"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"analysis"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fileId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]}}]} as unknown as DocumentNode<IntakeQuoteAnaylsisQuery, IntakeQuoteAnaylsisQueryVariables>;
export const OnCompletedIntakeQuoteAnaylsisDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"OnCompletedIntakeQuoteAnaylsis"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sevenbridges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chatSession"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"analysis"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fileId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]}}]} as unknown as DocumentNode<OnCompletedIntakeQuoteAnaylsisSubscription, OnCompletedIntakeQuoteAnaylsisSubscriptionVariables>;
export const IntakeRequestComplexNextDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"IntakeRequestComplexNext"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SvbrgIntakeRequestComplexInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sevenbridges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chatSession"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"request"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requestNextComplex"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"accountingAreaId"}},{"kind":"Field","name":{"kind":"Name","value":"commodityGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"budget"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"deliveryLocationId"}},{"kind":"Field","name":{"kind":"Name","value":"lineItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sequence"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"expectedPricePerUnit"}},{"kind":"Field","name":{"kind":"Name","value":"unitId"}},{"kind":"Field","name":{"kind":"Name","value":"earlyDeliveryAt"}},{"kind":"Field","name":{"kind":"Name","value":"lateDeliveryAt"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<IntakeRequestComplexNextMutation, IntakeRequestComplexNextMutationVariables>;
export const IntakeRequestComplexDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"IntakeRequestComplex"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sevenbridges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chatSession"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"requestDescription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}},{"kind":"Field","name":{"kind":"Name","value":"request"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountingAreaId"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"commodityGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"budget"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"costCenterId"}},{"kind":"Field","name":{"kind":"Name","value":"deliveryLocationId"}},{"kind":"Field","name":{"kind":"Name","value":"lineItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sequence"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"commodityGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"earlyDeliveryAt"}},{"kind":"Field","name":{"kind":"Name","value":"lateDeliveryAt"}},{"kind":"Field","name":{"kind":"Name","value":"expectedPricePerUnit"}},{"kind":"Field","name":{"kind":"Name","value":"unitId"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<IntakeRequestComplexQuery, IntakeRequestComplexQueryVariables>;
export const IntakeRequestDescriptionStepMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"IntakeRequestDescriptionStepMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SvbrgRequestDescriptionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sevenbridges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chatSession"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requestDescription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"next"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<IntakeRequestDescriptionStepMutationMutation, IntakeRequestDescriptionStepMutationMutationVariables>;
export const IntakeRequestDescriptionStepGenerateMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"IntakeRequestDescriptionStepGenerateMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SvbrgRequestDescriptionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sevenbridges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chatSession"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requestDescription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"generate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"language"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<IntakeRequestDescriptionStepGenerateMutationMutation, IntakeRequestDescriptionStepGenerateMutationMutationVariables>;
export const IntakeRequestDescriptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"IntakeRequestDescription"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sevenbridges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chatSession"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"requestDescription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"language"}}]}},{"kind":"Field","name":{"kind":"Name","value":"requirementsExtraction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"extractedData"}},{"kind":"Field","name":{"kind":"Name","value":"enhancedData"}},{"kind":"Field","name":{"kind":"Name","value":"processingStatus"}}]}}]}}]}}]}}]} as unknown as DocumentNode<IntakeRequestDescriptionQuery, IntakeRequestDescriptionQueryVariables>;
export const IntakeRequestDetailsStepMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"IntakeRequestDetailsStepMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SvbrgIntakeRequestInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sevenbridges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chatSession"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"request"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requestNext"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"accountingAreaId"}},{"kind":"Field","name":{"kind":"Name","value":"commodityGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"costCenterId"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"deliveryLocationId"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<IntakeRequestDetailsStepMutationMutation, IntakeRequestDetailsStepMutationMutationVariables>;
export const IntakeRequestDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"IntakeRequestDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sevenbridges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chatSession"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"request"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"accountingAreaId"}},{"kind":"Field","name":{"kind":"Name","value":"commodityGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"costCenterId"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"deliveryLocationId"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"requirementsExtraction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"extractedData"}},{"kind":"Field","name":{"kind":"Name","value":"enhancedData"}},{"kind":"Field","name":{"kind":"Name","value":"processingStatus"}}]}}]}}]}}]}}]} as unknown as DocumentNode<IntakeRequestDetailsQuery, IntakeRequestDetailsQueryVariables>;
export const IntakeRequestLineItemNextDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"IntakeRequestLineItemNext"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SvbrgIntakeRequestLineItemNextInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sevenbridges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chatSession"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"request"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requestNextLineItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"accountingAreaId"}},{"kind":"Field","name":{"kind":"Name","value":"commodityGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"costCenterId"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"deliveryLocationId"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"lineItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"commodityGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"unitId"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"earlyDeliveryAt"}},{"kind":"Field","name":{"kind":"Name","value":"expectedPricePerUnit"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lateDeliveryAt"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"sequence"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<IntakeRequestLineItemNextMutation, IntakeRequestLineItemNextMutationVariables>;
export const IntakeRequestLineItemsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"IntakeRequestLineItems"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sevenbridges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chatSession"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"request"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"commodityGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"lineItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sequence"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"expectedPricePerUnit"}},{"kind":"Field","name":{"kind":"Name","value":"unitId"}},{"kind":"Field","name":{"kind":"Name","value":"earlyDeliveryAt"}},{"kind":"Field","name":{"kind":"Name","value":"lateDeliveryAt"}},{"kind":"Field","name":{"kind":"Name","value":"commodityGroupId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"requirementsExtraction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"extractedData"}},{"kind":"Field","name":{"kind":"Name","value":"enhancedData"}},{"kind":"Field","name":{"kind":"Name","value":"processingStatus"}}]}}]}}]}}]}}]} as unknown as DocumentNode<IntakeRequestLineItemsQuery, IntakeRequestLineItemsQueryVariables>;
export const IntakeRequestReleaseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"IntakeRequestRelease"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SvbrgIntakeRequestReleaseInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sevenbridges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chatSession"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"request"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"release"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}]}]}}]}}]}}]}}]} as unknown as DocumentNode<IntakeRequestReleaseMutation, IntakeRequestReleaseMutationVariables>;
export const IntakeResubmitDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"IntakeResubmit"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SvbrgIntakeRequestReleaseInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sevenbridges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chatSession"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"request"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resubmit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}]}]}}]}}]}}]}}]} as unknown as DocumentNode<IntakeResubmitMutation, IntakeResubmitMutationVariables>;
export const IntakeDemandDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"IntakeDemand"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sevenbridges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chatSession"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"demandId"}},{"kind":"Field","name":{"kind":"Name","value":"demandSequenceNumber"}}]}}]}}]}}]} as unknown as DocumentNode<IntakeDemandQuery, IntakeDemandQueryVariables>;
export const IntakeSupplierSelectionNextDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"IntakeSupplierSelectionNext"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SvbrgIntakeRequestSupplierNext"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sevenbridges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chatSession"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"supplierSelection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"next"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"internalId"}},{"kind":"Field","name":{"kind":"Name","value":"isQuoted"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"internalId"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"internalId"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<IntakeSupplierSelectionNextMutation, IntakeSupplierSelectionNextMutationVariables>;
export const IntakeSupplierContactDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"IntakeSupplierContact"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sevenbridges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chatSession"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"variant"}},{"kind":"Field","name":{"kind":"Name","value":"suppliers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"internalId"}},{"kind":"Field","name":{"kind":"Name","value":"isQuoted"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"internalId"}},{"kind":"Field","name":{"kind":"Name","value":"language"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"internalId"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"requirementsExtraction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"extractedData"}},{"kind":"Field","name":{"kind":"Name","value":"enhancedData"}},{"kind":"Field","name":{"kind":"Name","value":"processingStatus"}}]}}]}}]}}]}}]} as unknown as DocumentNode<IntakeSupplierContactQuery, IntakeSupplierContactQueryVariables>;
export const IntakeRequirementsUploadMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"IntakeRequirementsUploadMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SvbrgRequirementsExtractionUpsertInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sevenbridges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chatSession"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requirementsExtraction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uploadDcoument"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"chatSessionId"}},{"kind":"Field","name":{"kind":"Name","value":"fileIds"}},{"kind":"Field","name":{"kind":"Name","value":"processingStatus"}},{"kind":"Field","name":{"kind":"Name","value":"extractedData"}},{"kind":"Field","name":{"kind":"Name","value":"enhancedData"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<IntakeRequirementsUploadMutationMutation, IntakeRequirementsUploadMutationMutationVariables>;
export const IntakeRequirementsSkipMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"IntakeRequirementsSkipMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SvbrgRequirementsExtractionSkipInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sevenbridges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chatSession"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requirementsExtraction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"chatSessionId"}},{"kind":"Field","name":{"kind":"Name","value":"processingStatus"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<IntakeRequirementsSkipMutationMutation, IntakeRequirementsSkipMutationMutationVariables>;
export const IntakeRequirementsNextMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"IntakeRequirementsNextMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SvbrgRequirementsExtractionNextInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sevenbridges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chatSession"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requirementsExtraction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"next"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"chatSessionId"}},{"kind":"Field","name":{"kind":"Name","value":"processingStatus"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<IntakeRequirementsNextMutationMutation, IntakeRequirementsNextMutationMutationVariables>;
export const IntakeRequirementsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"IntakeRequirementsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sevenbridges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chatSession"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"requirementsExtraction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"chatSessionId"}},{"kind":"Field","name":{"kind":"Name","value":"fileIds"}},{"kind":"Field","name":{"kind":"Name","value":"processingStatus"}},{"kind":"Field","name":{"kind":"Name","value":"extractedData"}},{"kind":"Field","name":{"kind":"Name","value":"enhancedData"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]}}]}}]} as unknown as DocumentNode<IntakeRequirementsQueryQuery, IntakeRequirementsQueryQueryVariables>;
export const IntakeTacticalSourcingSkipDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"IntakeTacticalSourcingSkip"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SvbrgTacticalSourcingInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sevenbridges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chatSession"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tacticalSourcing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}]}]}}]}}]}}]}}]} as unknown as DocumentNode<IntakeTacticalSourcingSkipMutation, IntakeTacticalSourcingSkipMutationVariables>;
export const IntakeTacticalSourcingStartDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"IntakeTacticalSourcingStart"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SvbrgTacticalSourcingInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sevenbridges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chatSession"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tacticalSourcing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"start"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}]}]}}]}}]}}]}}]} as unknown as DocumentNode<IntakeTacticalSourcingStartMutation, IntakeTacticalSourcingStartMutationVariables>;
export const IntakeTacticalSourcingSelectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"IntakeTacticalSourcingSelection"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sevenbridges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chatSession"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"tacticalSourcing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isSkipped"}}]}}]}}]}}]}}]} as unknown as DocumentNode<IntakeTacticalSourcingSelectionQuery, IntakeTacticalSourcingSelectionQueryVariables>;
export const GetExtractedRequirementsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetExtractedRequirements"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SvbrgGetExtractedRequirementsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sevenbridges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getExtractedRequirements"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stepType"}},{"kind":"Field","name":{"kind":"Name","value":"hasData"}},{"kind":"Field","name":{"kind":"Name","value":"data"}}]}}]}}]}}]} as unknown as DocumentNode<GetExtractedRequirementsQuery, GetExtractedRequirementsQueryVariables>;
export const ThreadListIntakeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ThreadListIntake"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SvbrgQueryBuilderQuery"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SvbrgThreadOrder"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"categories"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SvbrgCategoryType"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sevenbridges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"threadList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"categories"},"value":{"kind":"Variable","name":{"kind":"Name","value":"categories"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"connection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"threadList","block":false}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sequenceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"demandId"}},{"kind":"Field","name":{"kind":"Name","value":"demandSequenceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"demandResponsibleUsers"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}}]} as unknown as DocumentNode<ThreadListIntakeQuery, ThreadListIntakeQueryVariables>;
export const NegotiationCaseManualCreateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"NegotiationCaseManualCreate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TsrctDemandInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"demandCreate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"negotiationCases"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<NegotiationCaseManualCreateMutation, NegotiationCaseManualCreateMutationVariables>;
export const NegotiationCaseDeleteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"NegotiationCaseDelete"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"negotiationCase"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete"}}]}}]}}]}}]} as unknown as DocumentNode<NegotiationCaseDeleteMutation, NegotiationCaseDeleteMutationVariables>;
export const NegotiationCaseReleaseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"NegotiationCaseRelease"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"negotiationCase"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"release"}}]}}]}}]}}]} as unknown as DocumentNode<NegotiationCaseReleaseMutation, NegotiationCaseReleaseMutationVariables>;
export const NegotiationCaseRemindDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"NegotiationCaseRemind"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"negotiationCase"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendReminder"}}]}}]}}]}}]} as unknown as DocumentNode<NegotiationCaseRemindMutation, NegotiationCaseRemindMutationVariables>;
export const NegotiationCaseResetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"NegotiationCaseReset"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"negotiationCase"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reset"}}]}}]}}]}}]} as unknown as DocumentNode<NegotiationCaseResetMutation, NegotiationCaseResetMutationVariables>;
export const NegotiationDetailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"NegotiationDetail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"negotiationCase"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sequenceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"processStatus"}},{"kind":"Field","name":{"kind":"Name","value":"processSteps"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"variant"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isReleasable"}},{"kind":"Field","name":{"kind":"Name","value":"demand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sequenceNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"supplier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"internalId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"internalId"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"language"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"internalId"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"address"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"quote"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"negotiatedQuote"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<NegotiationDetailQuery, NegotiationDetailQueryVariables>;
export const NegotiationCaseListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"NegotiationCaseList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TsrctQueryBuilderQuery"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TsrctNegotiationCaseOrder"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"negotiationCases"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isMaskedBidding"}},{"kind":"Field","name":{"kind":"Name","value":"sequenceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"issuesCompletedCount"}},{"kind":"Field","name":{"kind":"Name","value":"issuesOpenCount"}},{"kind":"Field","name":{"kind":"Name","value":"issuesTotalCount"}},{"kind":"Field","name":{"kind":"Name","value":"totalValue"}},{"kind":"Field","name":{"kind":"Name","value":"totalDiscountedValue"}},{"kind":"Field","name":{"kind":"Name","value":"totalPriceDiscount"}},{"kind":"Field","name":{"kind":"Name","value":"discount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"demandId"}},{"kind":"Field","name":{"kind":"Name","value":"demandSequenceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"referenceId"}},{"kind":"Field","name":{"kind":"Name","value":"responsibleIds"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"processStatus"}},{"kind":"Field","name":{"kind":"Name","value":"cancellationReason"}},{"kind":"Field","name":{"kind":"Name","value":"cancellationReasonText"}},{"kind":"Field","name":{"kind":"Name","value":"supplierAddress"}},{"kind":"Field","name":{"kind":"Name","value":"supplierCity"}},{"kind":"Field","name":{"kind":"Name","value":"supplierContactEmail"}},{"kind":"Field","name":{"kind":"Name","value":"supplierContactFirstName"}},{"kind":"Field","name":{"kind":"Name","value":"supplierContactLastName"}},{"kind":"Field","name":{"kind":"Name","value":"supplierContactPhone"}},{"kind":"Field","name":{"kind":"Name","value":"supplierCountryCode"}},{"kind":"Field","name":{"kind":"Name","value":"supplierId"}},{"kind":"Field","name":{"kind":"Name","value":"supplierExternalReference"}},{"kind":"Field","name":{"kind":"Name","value":"supplierName"}},{"kind":"Field","name":{"kind":"Name","value":"supplierPostalCode"}},{"kind":"Field","name":{"kind":"Name","value":"negotiationBoundaryUpper"}},{"kind":"Field","name":{"kind":"Name","value":"negotiationBoundaryLower"}},{"kind":"Field","name":{"kind":"Name","value":"hasSupplierComment"}},{"kind":"Field","name":{"kind":"Name","value":"latestCommentAuthorId"}},{"kind":"Field","name":{"kind":"Name","value":"latestCommentCreatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"latestCommentMessage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}}]} as unknown as DocumentNode<NegotiationCaseListQuery, NegotiationCaseListQueryVariables>;
export const NegotiationListUpdateResponsibleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"NegotiationListUpdateResponsible"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TsrctDemandResponsibleUsersInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"demand"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"responsibleUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"responsibleUserIds"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<NegotiationListUpdateResponsibleMutation, NegotiationListUpdateResponsibleMutationVariables>;
export const TsrctNegotiationDemandDetailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TsrctNegotiationDemandDetail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"demand"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"sequenceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"processStatus"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"write"}}]}},{"kind":"Field","name":{"kind":"Name","value":"processSteps"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"variant"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"competitiveBiddingRule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isEditable"}}]}}]}}]}}]}}]} as unknown as DocumentNode<TsrctNegotiationDemandDetailQuery, TsrctNegotiationDemandDetailQueryVariables>;
export const SvbrgDemandConversationSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SvbrgDemandConversationSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"entityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"entityVariant"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SvbrgConversationEntityVariant"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sevenbridges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"conversationSettings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"entityId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"entityId"}}},{"kind":"Argument","name":{"kind":"Name","value":"entityVariant"},"value":{"kind":"Variable","name":{"kind":"Name","value":"entityVariant"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<SvbrgDemandConversationSettingsQuery, SvbrgDemandConversationSettingsQueryVariables>;
export const DemandConversationSettingsCreateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DemandConversationSettingsCreate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SvbrgConversationSettingsCreateMutation"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sevenbridges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"conversationSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"create"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"entityId"}},{"kind":"Field","name":{"kind":"Name","value":"entityVariant"}},{"kind":"Field","name":{"kind":"Name","value":"tools"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isEnabled"}}]}},{"kind":"Field","name":{"kind":"Name","value":"quickActions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"prompt"}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"variant"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isConversationStarter"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]}}]}}]} as unknown as DocumentNode<DemandConversationSettingsCreateMutation, DemandConversationSettingsCreateMutationVariables>;
export const DemandConversationSettingsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DemandConversationSettingsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"entityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"entityVariant"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SvbrgConversationEntityVariant"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sevenbridges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"conversationSettings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"entityId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"entityId"}}},{"kind":"Argument","name":{"kind":"Name","value":"entityVariant"},"value":{"kind":"Variable","name":{"kind":"Name","value":"entityVariant"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"entityId"}},{"kind":"Field","name":{"kind":"Name","value":"entityVariant"}},{"kind":"Field","name":{"kind":"Name","value":"tools"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isEnabled"}}]}},{"kind":"Field","name":{"kind":"Name","value":"quickActions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"prompt"}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"variant"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isConversationStarter"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]}}]} as unknown as DocumentNode<DemandConversationSettingsQueryQuery, DemandConversationSettingsQueryQueryVariables>;
export const DemandConversationSettingsUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DemandConversationSettingsUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SvbrgConversationSettingsUpdateMutation"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sevenbridges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"conversationSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"entityId"}},{"kind":"Field","name":{"kind":"Name","value":"entityVariant"}},{"kind":"Field","name":{"kind":"Name","value":"tools"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isEnabled"}}]}},{"kind":"Field","name":{"kind":"Name","value":"quickActions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"prompt"}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"variant"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isConversationStarter"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]}}]}}]} as unknown as DocumentNode<DemandConversationSettingsUpdateMutation, DemandConversationSettingsUpdateMutationVariables>;
export const DemandCancelDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DemandCancel"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TsrctDemandCancelInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"demand"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cancel"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"cancellationReason"}},{"kind":"Field","name":{"kind":"Name","value":"cancellationReasonText"}}]}}]}}]}}]}}]} as unknown as DocumentNode<DemandCancelMutation, DemandCancelMutationVariables>;
export const DemandDeleteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DemandDelete"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"demand"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete"}}]}}]}}]}}]} as unknown as DocumentNode<DemandDeleteMutation, DemandDeleteMutationVariables>;
export const DemandResetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DemandReset"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"demand"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"awardingConfiguration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"deadline"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<DemandResetMutation, DemandResetMutationVariables>;
export const TesseractNegotiationDemandDetailUpdatePriorityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TesseractNegotiationDemandDetailUpdatePriority"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TsrctDemandPriorityUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"demand"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"priority"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<TesseractNegotiationDemandDetailUpdatePriorityMutation, TesseractNegotiationDemandDetailUpdatePriorityMutationVariables>;
export const TesseractNegotiationDemandListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TesseractNegotiationDemandList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TsrctQueryBuilderQuery"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TsrctDemandOrder"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"demands"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"capabilityIds"}},{"kind":"Field","name":{"kind":"Name","value":"casesNegotiatedCount"}},{"kind":"Field","name":{"kind":"Name","value":"casesOpenCount"}},{"kind":"Field","name":{"kind":"Name","value":"casesTotalCount"}},{"kind":"Field","name":{"kind":"Name","value":"commodityGroupIds"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"earlyDeliveryAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"issuesOpenCount"}},{"kind":"Field","name":{"kind":"Name","value":"lateDeliveryAt"}},{"kind":"Field","name":{"kind":"Name","value":"links"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"preferredSupplierIds"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"processingMode"}},{"kind":"Field","name":{"kind":"Name","value":"purchaseRequisitionId"}},{"kind":"Field","name":{"kind":"Name","value":"referenceId"}},{"kind":"Field","name":{"kind":"Name","value":"requestedAt"}},{"kind":"Field","name":{"kind":"Name","value":"requestedBy"}},{"kind":"Field","name":{"kind":"Name","value":"responsibleIds"}},{"kind":"Field","name":{"kind":"Name","value":"sequenceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"processStatus"}},{"kind":"Field","name":{"kind":"Name","value":"processSteps"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"variant"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalValue"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"sourceSystemId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}}]} as unknown as DocumentNode<TesseractNegotiationDemandListQuery, TesseractNegotiationDemandListQueryVariables>;
export const TesseractNegotiationDemandListUpdatePriorityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TesseractNegotiationDemandListUpdatePriority"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TsrctDemandPriorityUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"demand"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"priority"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<TesseractNegotiationDemandListUpdatePriorityMutation, TesseractNegotiationDemandListUpdatePriorityMutationVariables>;
export const TesseractNegotiationDemandUpdateResponsibleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TesseractNegotiationDemandUpdateResponsible"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TsrctDemandResponsibleUsersInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"demand"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"responsibleUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"responsibleUserIds"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<TesseractNegotiationDemandUpdateResponsibleMutation, TesseractNegotiationDemandUpdateResponsibleMutationVariables>;
export const SevenbridgesDocumentListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SevenbridgesDocumentList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SvbrgQueryBuilderQuery"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SvbrgDocumentListOrder"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sevenbridges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"connection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"procurementKnowledgeList","block":false}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fileId"}},{"kind":"Field","name":{"kind":"Name","value":"fileName"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"mimeType"}},{"kind":"Field","name":{"kind":"Name","value":"variant"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}}]} as unknown as DocumentNode<SevenbridgesDocumentListQuery, SevenbridgesDocumentListQueryVariables>;
export const AddProcurementKnowledgeDocumentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddProcurementKnowledgeDocument"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SvbrgDocumentUpload"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sevenbridges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upload"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProcurementKnowledgeDocument"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProcurementKnowledgeDocument"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SvbrgDocument"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fileId"}},{"kind":"Field","name":{"kind":"Name","value":"fileName"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"mimeType"}},{"kind":"Field","name":{"kind":"Name","value":"variant"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]} as unknown as DocumentNode<AddProcurementKnowledgeDocumentMutation, AddProcurementKnowledgeDocumentMutationVariables>;
export const UpdateProcurementKnowledgeDocumentMetadataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateProcurementKnowledgeDocumentMetadata"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SvbrgDocumentUpdateMetadata"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sevenbridges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateMetadata"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProcurementKnowledgeDocument"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProcurementKnowledgeDocument"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SvbrgDocument"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fileId"}},{"kind":"Field","name":{"kind":"Name","value":"fileName"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"mimeType"}},{"kind":"Field","name":{"kind":"Name","value":"variant"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]} as unknown as DocumentNode<UpdateProcurementKnowledgeDocumentMetadataMutation, UpdateProcurementKnowledgeDocumentMetadataMutationVariables>;
export const DeleteProcurementKnowledgeDocumentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteProcurementKnowledgeDocument"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"docId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sevenbridges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"docId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProcurementKnowledgeDocument"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProcurementKnowledgeDocument"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SvbrgDocument"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fileId"}},{"kind":"Field","name":{"kind":"Name","value":"fileName"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"mimeType"}},{"kind":"Field","name":{"kind":"Name","value":"variant"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]} as unknown as DocumentNode<DeleteProcurementKnowledgeDocumentMutation, DeleteProcurementKnowledgeDocumentMutationVariables>;
export const ProcurementKnowledgeDocumentDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProcurementKnowledgeDocumentDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"docId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sevenbridges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"docId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fileId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"variant"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}}]}}]}}]} as unknown as DocumentNode<ProcurementKnowledgeDocumentDetailsQuery, ProcurementKnowledgeDocumentDetailsQueryVariables>;
export const GetRuleHeaderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetRuleHeader"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rule"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]} as unknown as DocumentNode<GetRuleHeaderQuery, GetRuleHeaderQueryVariables>;
export const GetRuleVersionStatusesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetRuleVersionStatuses"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rule"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"ruleVersion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetRuleVersionStatusesQuery, GetRuleVersionStatusesQueryVariables>;
export const RuleVersionPublishDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RuleVersionPublish"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"versionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rule"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publish"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ruleVersionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"versionId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]}}]} as unknown as DocumentNode<RuleVersionPublishMutation, RuleVersionPublishMutationVariables>;
export const RuleVersionPauseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RuleVersionPause"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rule"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pause"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]}}]} as unknown as DocumentNode<RuleVersionPauseMutation, RuleVersionPauseMutationVariables>;
export const RuleVersionSaveDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RuleVersionSave"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"graph"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rule"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ruleVersion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"save"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"graph"},"value":{"kind":"Variable","name":{"kind":"Name","value":"graph"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ruleId"}},{"kind":"Field","name":{"kind":"Name","value":"graph"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<RuleVersionSaveMutation, RuleVersionSaveMutationVariables>;
export const RuleSettingsCreateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RuleSettingsCreate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TsrctRuleCreateDataInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rule"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"create"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"responsibleUsers"}}]}}]}}]}}]}}]} as unknown as DocumentNode<RuleSettingsCreateMutation, RuleSettingsCreateMutationVariables>;
export const RuleSettingsUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RuleSettingsUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TsrctRuleUpdateDataInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rule"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"responsibleUsers"}}]}}]}}]}}]}}]} as unknown as DocumentNode<RuleSettingsUpdateMutation, RuleSettingsUpdateMutationVariables>;
export const RuleSettingsDeleteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RuleSettingsDelete"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rule"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"remove"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<RuleSettingsDeleteMutation, RuleSettingsDeleteMutationVariables>;
export const GetRuleRuleBuilderBackendDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetRuleRuleBuilderBackendData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rule"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"variant"}},{"kind":"Field","name":{"kind":"Name","value":"ruleVersion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"graph"}},{"kind":"Field","name":{"kind":"Name","value":"stats"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"itemId"}},{"kind":"Field","name":{"kind":"Name","value":"hits"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"itemId"}},{"kind":"Field","name":{"kind":"Name","value":"hits"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetRuleRuleBuilderBackendDataQuery, GetRuleRuleBuilderBackendDataQueryVariables>;
export const GetRuleDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetRuleData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rule"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"responsibleUsers"}},{"kind":"Field","name":{"kind":"Name","value":"variant"}}]}}]}}]}}]} as unknown as DocumentNode<GetRuleDataQuery, GetRuleDataQueryVariables>;
export const RuleEvaluationLogDetailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RuleEvaluationLogDetail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ruleId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"evaluationLogId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rule"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ruleId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"evaluationLog"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"evaluationLogId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"ruleVersion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"graph"}},{"kind":"Field","name":{"kind":"Name","value":"stats"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"itemId"}},{"kind":"Field","name":{"kind":"Name","value":"hits"}}]}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"itemId"}},{"kind":"Field","name":{"kind":"Name","value":"hits"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<RuleEvaluationLogDetailQuery, RuleEvaluationLogDetailQueryVariables>;
export const RuleListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RuleList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TsrctQueryBuilderQuery"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TsrctRuleListSourcingOrder"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sourcing"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"variant"}},{"kind":"Field","name":{"kind":"Name","value":"sequenceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"accountingAreaIds"}},{"kind":"Field","name":{"kind":"Name","value":"commodityGroupIds"}},{"kind":"Field","name":{"kind":"Name","value":"organizationIds"}},{"kind":"Field","name":{"kind":"Name","value":"sourceSystemIds"}},{"kind":"Field","name":{"kind":"Name","value":"responsibleIds"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}}]}}]} as unknown as DocumentNode<RuleListQuery, RuleListQueryVariables>;
export const SmartLinkDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SmartLinkDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"astronaut"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<SmartLinkDetailsQuery, SmartLinkDetailsQueryVariables>;
export const TeamManagementTeamDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TeamManagementTeam"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"Pasa"},"name":{"kind":"Name","value":"pasaGraphql"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"teamId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"scopes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<TeamManagementTeamQuery, TeamManagementTeamQueryVariables>;
export const TeamManagementUpsertTeamDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TeamManagementUpsertTeam"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PasaUpsertTeamInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"Pasa"},"name":{"kind":"Name","value":"pasaGraphql"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upsertTeam"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"scopeIds"}},{"kind":"Field","name":{"kind":"Name","value":"userMemberIds"}},{"kind":"Field","name":{"kind":"Name","value":"teamMemberIds"}}]}}]}}]}}]} as unknown as DocumentNode<TeamManagementUpsertTeamMutation, TeamManagementUpsertTeamMutationVariables>;
export const TeamManagementDeleteTeamDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TeamManagementDeleteTeam"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"Pasa"},"name":{"kind":"Name","value":"pasaGraphql"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteTeam"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"teamId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<TeamManagementDeleteTeamMutation, TeamManagementDeleteTeamMutationVariables>;
export const TsrctContractDemandDetailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TsrctContractDemandDetail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contractDemand"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"sequenceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"competitiveBiddingRule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"variant"}},{"kind":"Field","name":{"kind":"Name","value":"biddingPeriodDays"}},{"kind":"Field","name":{"kind":"Name","value":"deadline"}},{"kind":"Field","name":{"kind":"Name","value":"deadlineExceeded"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"responsibleUserId"}},{"kind":"Field","name":{"kind":"Name","value":"tagIds"}},{"kind":"Field","name":{"kind":"Name","value":"demandRequest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"commodityGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"incoTermsId"}},{"kind":"Field","name":{"kind":"Name","value":"requestedAt"}},{"kind":"Field","name":{"kind":"Name","value":"totalValue"}},{"kind":"Field","name":{"kind":"Name","value":"validityPeriod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lineItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"baselinePricePerUnit"}},{"kind":"Field","name":{"kind":"Name","value":"commodityGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"commodityId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"deliveryLocationId"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"minimumOrderQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"unitId"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<TsrctContractDemandDetailQuery, TsrctContractDemandDetailQueryVariables>;
export const TsrctDeleteContractDemandDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TsrctDeleteContractDemand"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contractDemand"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete"}}]}}]}}]}}]} as unknown as DocumentNode<TsrctDeleteContractDemandMutation, TsrctDeleteContractDemandMutationVariables>;
export const TsrctCancelContractDemandDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TsrctCancelContractDemand"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TsrctContractDemandCancelInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contractDemand"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cancel"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"cancellationReason"}},{"kind":"Field","name":{"kind":"Name","value":"cancellationReasonText"}},{"kind":"Field","name":{"kind":"Name","value":"sourcingCases"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"cancellationReason"}},{"kind":"Field","name":{"kind":"Name","value":"cancellationReasonText"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"sequenceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"supplier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"supplierId"}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"internalId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"quote"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"totalValue"}},{"kind":"Field","name":{"kind":"Name","value":"totalDiscountedValue"}},{"kind":"Field","name":{"kind":"Name","value":"discount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"issues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"variant"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<TsrctCancelContractDemandMutation, TsrctCancelContractDemandMutationVariables>;
export const TesseractContractDemandCreateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TesseractContractDemandCreate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contractDemandCreate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"responsibleUserId"}},{"kind":"Field","name":{"kind":"Name","value":"sequenceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"tagIds"}},{"kind":"Field","name":{"kind":"Name","value":"demandRequest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"commodityGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"incoTermsId"}},{"kind":"Field","name":{"kind":"Name","value":"requestedAt"}},{"kind":"Field","name":{"kind":"Name","value":"totalValue"}},{"kind":"Field","name":{"kind":"Name","value":"validityPeriod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lineItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baselinePricePerUnit"}},{"kind":"Field","name":{"kind":"Name","value":"commodityGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"commodityId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"deliveryLocationId"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"minimumOrderQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"unitId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"competitiveBiddingRule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"biddingPeriodDays"}},{"kind":"Field","name":{"kind":"Name","value":"deadline"}},{"kind":"Field","name":{"kind":"Name","value":"deadlineExceeded"}},{"kind":"Field","name":{"kind":"Name","value":"variant"}}]}}]}}]}}]}}]} as unknown as DocumentNode<TesseractContractDemandCreateMutation, TesseractContractDemandCreateMutationVariables>;
export const TesseractContractDemandListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TesseractContractDemandList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TsrctQueryBuilderQuery"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TsrctContractDemandOrder"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contractDemands"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"commodityGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"responsibleUserId"}},{"kind":"Field","name":{"kind":"Name","value":"sequenceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"tagIds"}},{"kind":"Field","name":{"kind":"Name","value":"validFrom"}},{"kind":"Field","name":{"kind":"Name","value":"validTo"}},{"kind":"Field","name":{"kind":"Name","value":"totalValue"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"openCaseCount"}},{"kind":"Field","name":{"kind":"Name","value":"negotiatedCaseCount"}},{"kind":"Field","name":{"kind":"Name","value":"totalCaseCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}}]} as unknown as DocumentNode<TesseractContractDemandListQuery, TesseractContractDemandListQueryVariables>;
export const TsrctSourcingCaseDetailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TsrctSourcingCaseDetail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sourcingCase"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"sequenceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isNegotiationEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"isSupplierUploadAllowed"}},{"kind":"Field","name":{"kind":"Name","value":"issues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"variant"}}]}},{"kind":"Field","name":{"kind":"Name","value":"demand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sequenceNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"supplier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"supplierId"}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"internalId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"quote"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"supplierReference"}},{"kind":"Field","name":{"kind":"Name","value":"validFrom"}},{"kind":"Field","name":{"kind":"Name","value":"validTo"}},{"kind":"Field","name":{"kind":"Name","value":"paymentTermsId"}},{"kind":"Field","name":{"kind":"Name","value":"incoTermsId"}},{"kind":"Field","name":{"kind":"Name","value":"lineItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sequence"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"unitId"}},{"kind":"Field","name":{"kind":"Name","value":"commodityId"}},{"kind":"Field","name":{"kind":"Name","value":"deliveryLocationId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"priceUnit"}},{"kind":"Field","name":{"kind":"Name","value":"pricePerPriceUnit"}},{"kind":"Field","name":{"kind":"Name","value":"pricePerUnit"}},{"kind":"Field","name":{"kind":"Name","value":"minimumOrderQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"discountedPricePerUnit"}},{"kind":"Field","name":{"kind":"Name","value":"totalDiscountedValue"}},{"kind":"Field","name":{"kind":"Name","value":"totalValue"}},{"kind":"Field","name":{"kind":"Name","value":"demandRequestItemId"}},{"kind":"Field","name":{"kind":"Name","value":"bidDeclinedReason"}},{"kind":"Field","name":{"kind":"Name","value":"bidDeclinedReasonText"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<TsrctSourcingCaseDetailQuery, TsrctSourcingCaseDetailQueryVariables>;
export const TsrctReleaseSourcingCaseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TsrctReleaseSourcingCase"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sourcingCase"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"release"}}]}}]}}]}}]} as unknown as DocumentNode<TsrctReleaseSourcingCaseMutation, TsrctReleaseSourcingCaseMutationVariables>;
export const TsrctDeleteSourcingCaseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TsrctDeleteSourcingCase"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sourcingCase"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete"}}]}}]}}]}}]} as unknown as DocumentNode<TsrctDeleteSourcingCaseMutation, TsrctDeleteSourcingCaseMutationVariables>;
export const TsrctCancelSourcingCaseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TsrctCancelSourcingCase"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TsrctSourcingCaseCancelInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sourcingCase"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cancel"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"cancellationReason"}},{"kind":"Field","name":{"kind":"Name","value":"cancellationReasonText"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"demand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<TsrctCancelSourcingCaseMutation, TsrctCancelSourcingCaseMutationVariables>;
export const TsrctRemindSourcingCaseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TsrctRemindSourcingCase"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sourcingCase"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendReminder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<TsrctRemindSourcingCaseMutation, TsrctRemindSourcingCaseMutationVariables>;
export const TsrctResetSourcingCaseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TsrctResetSourcingCase"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tesseract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sourcingCase"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"sequenceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isNegotiationEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"issues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"variant"}}]}},{"kind":"Field","name":{"kind":"Name","value":"demand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sequenceNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"supplier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"supplierId"}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"internalId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"quote"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"supplierReference"}},{"kind":"Field","name":{"kind":"Name","value":"validFrom"}},{"kind":"Field","name":{"kind":"Name","value":"validTo"}},{"kind":"Field","name":{"kind":"Name","value":"paymentTermsId"}},{"kind":"Field","name":{"kind":"Name","value":"incoTermsId"}},{"kind":"Field","name":{"kind":"Name","value":"lineItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sequence"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"unitId"}},{"kind":"Field","name":{"kind":"Name","value":"commodityId"}},{"kind":"Field","name":{"kind":"Name","value":"deliveryLocationId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"priceUnit"}},{"kind":"Field","name":{"kind":"Name","value":"pricePerPriceUnit"}},{"kind":"Field","name":{"kind":"Name","value":"pricePerUnit"}},{"kind":"Field","name":{"kind":"Name","value":"minimumOrderQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"discountedPricePerUnit"}},{"kind":"Field","name":{"kind":"Name","value":"totalDiscountedValue"}},{"kind":"Field","name":{"kind":"Name","value":"totalValue"}},{"kind":"Field","name":{"kind":"Name","value":"demandRequestItemId"}},{"kind":"Field","name":{"kind":"Name","value":"bidDeclinedReason"}},{"kind":"Field","name":{"kind":"Name","value":"bidDeclinedReasonText"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<TsrctResetSourcingCaseMutation, TsrctResetSourcingCaseMutationVariables>;
export const ThreadListByCategoriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ThreadListByCategories"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SvbrgQueryBuilderQuery"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SvbrgThreadOrder"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"categories"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SvbrgCategoryType"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sevenbridges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"threadList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"categories"},"value":{"kind":"Variable","name":{"kind":"Name","value":"categories"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sequenceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"demandId"}},{"kind":"Field","name":{"kind":"Name","value":"demandSequenceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"demandResponsibleUsers"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"variant"}},{"kind":"Field","name":{"kind":"Name","value":"conversationSettingsEntityId"}},{"kind":"Field","name":{"kind":"Name","value":"conversationSettingsEntityVariant"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}}]} as unknown as DocumentNode<ThreadListByCategoriesQuery, ThreadListByCategoriesQueryVariables>;
export const CountryReportDetailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CountryReportDetail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cataclysm"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"countryReport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}}]} as unknown as DocumentNode<CountryReportDetailQuery, CountryReportDetailQueryVariables>;
export const RiskDetailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RiskDetail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cataclysm"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"risk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}}]} as unknown as DocumentNode<RiskDetailQuery, RiskDetailQueryVariables>;
export const RiskCountriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RiskCountries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cataclysm"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"countries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"area"}},{"kind":"Field","name":{"kind":"Name","value":"riskScores"}}]}}]}}]}}]} as unknown as DocumentNode<RiskCountriesQuery, RiskCountriesQueryVariables>;
export const CountryReportListWidgetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CountryReportListWidget"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cataclysm"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"countryReports"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"publishedAt"}}]}}]}}]}}]} as unknown as DocumentNode<CountryReportListWidgetQuery, CountryReportListWidgetQueryVariables>;
export const CountryReportTableDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CountryReportTable"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cataclysm"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"countryReport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"dimensions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dimensionId"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CountryReportTableQuery, CountryReportTableQueryVariables>;
export const SupplierListWidgetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SupplierListWidget"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cataclysm"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"risk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"suppliers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"score"}}]}}]}}]}}]}}]} as unknown as DocumentNode<SupplierListWidgetQuery, SupplierListWidgetQueryVariables>;
export const SupplierRiskCategoryScoreWidgetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SupplierRiskCategoryScoreWidget"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cataclysm"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"supplier"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"score"}},{"kind":"Field","name":{"kind":"Name","value":"categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"score"}}]}}]}}]}}]}}]} as unknown as DocumentNode<SupplierRiskCategoryScoreWidgetQuery, SupplierRiskCategoryScoreWidgetQueryVariables>;
export const SupplierRiskScoreWidgetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SupplierRiskScoreWidget"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cataclysm"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"supplier"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"score"}},{"kind":"Field","name":{"kind":"Name","value":"categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"score"}}]}}]}}]}}]}}]} as unknown as DocumentNode<SupplierRiskScoreWidgetQuery, SupplierRiskScoreWidgetQueryVariables>;
export const SupplierRisksWidgetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SupplierRisksWidget"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cataclysm"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"supplier"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"risks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"score"}},{"kind":"Field","name":{"kind":"Name","value":"riskCategoryId"}}]}}]}}]}}]}}]} as unknown as DocumentNode<SupplierRisksWidgetQuery, SupplierRisksWidgetQueryVariables>;